
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref1ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref1ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("10chm", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0baf50e8646e54e3$export$ffb0004e005737fa, (v) => $0baf50e8646e54e3$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0baf50e8646e54e3$export$34b9dba7ce09269b, (v) => $0baf50e8646e54e3$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0baf50e8646e54e3$export$25062201e9e25d76, (v) => $0baf50e8646e54e3$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0baf50e8646e54e3$export$ffb0004e005737fa;
var $0baf50e8646e54e3$export$34b9dba7ce09269b;
var $0baf50e8646e54e3$export$25062201e9e25d76;
'use strict';

var $3KGP8 = parcelRequire("3KGP8");
var $0baf50e8646e54e3$var$k = Symbol.for("react.element"), $0baf50e8646e54e3$var$l = Symbol.for("react.fragment"), $0baf50e8646e54e3$var$m = Object.prototype.hasOwnProperty, $0baf50e8646e54e3$var$n = $3KGP8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0baf50e8646e54e3$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0baf50e8646e54e3$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0baf50e8646e54e3$var$m.call(a, b) && !$0baf50e8646e54e3$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0baf50e8646e54e3$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0baf50e8646e54e3$var$n.current
    };
}
$0baf50e8646e54e3$export$ffb0004e005737fa = $0baf50e8646e54e3$var$l;
$0baf50e8646e54e3$export$34b9dba7ce09269b = $0baf50e8646e54e3$var$q;
$0baf50e8646e54e3$export$25062201e9e25d76 = $0baf50e8646e54e3$var$q;

});
parcelRegister("3KGP8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2X0L1"));

});
parcelRegister("2X0L1", function(module, exports) {

$parcel$export(module.exports, "Children", () => $2261add946680b98$export$dca3b0875bd9a954, (v) => $2261add946680b98$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $2261add946680b98$export$16fa2f45be04daa8, (v) => $2261add946680b98$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $2261add946680b98$export$ffb0004e005737fa, (v) => $2261add946680b98$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $2261add946680b98$export$e2c29f18771995cb, (v) => $2261add946680b98$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $2261add946680b98$export$221d75b3f55bb0bd, (v) => $2261add946680b98$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $2261add946680b98$export$5f8d39834fd61797, (v) => $2261add946680b98$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2261add946680b98$export$74bf444e3cd11ea5, (v) => $2261add946680b98$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2261add946680b98$export$ae55be85d98224ed, (v) => $2261add946680b98$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $2261add946680b98$export$e530037191fcd5d7, (v) => $2261add946680b98$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $2261add946680b98$export$fd42f52fd3ae1109, (v) => $2261add946680b98$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $2261add946680b98$export$c8a8987d4410bf2d, (v) => $2261add946680b98$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $2261add946680b98$export$d38cd72104c1f0e9, (v) => $2261add946680b98$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $2261add946680b98$export$7d1e3a5e95ceca43, (v) => $2261add946680b98$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $2261add946680b98$export$257a8862b851cb5b, (v) => $2261add946680b98$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $2261add946680b98$export$a8257692ac88316c, (v) => $2261add946680b98$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $2261add946680b98$export$488013bae63b21da, (v) => $2261add946680b98$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $2261add946680b98$export$7c73462e0d25e514, (v) => $2261add946680b98$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $2261add946680b98$export$7568632d0d33d16d, (v) => $2261add946680b98$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $2261add946680b98$export$88948ce120ea2619, (v) => $2261add946680b98$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $2261add946680b98$export$35808ee640e87ca7, (v) => $2261add946680b98$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $2261add946680b98$export$fae74005e78b1a27, (v) => $2261add946680b98$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $2261add946680b98$export$dc8fbce3eb94dc1e, (v) => $2261add946680b98$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $2261add946680b98$export$6a7bc4e911dc01cf, (v) => $2261add946680b98$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $2261add946680b98$export$6d9c69b0de29b591, (v) => $2261add946680b98$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $2261add946680b98$export$f680877a34711e37, (v) => $2261add946680b98$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $2261add946680b98$export$d5a552a76deda3c2, (v) => $2261add946680b98$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $2261add946680b98$export$aaabe4eda9ed9969, (v) => $2261add946680b98$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $2261add946680b98$export$e5c5a5f917a5871c, (v) => $2261add946680b98$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $2261add946680b98$export$1538c33de8887b59, (v) => $2261add946680b98$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $2261add946680b98$export$13e3392192263954, (v) => $2261add946680b98$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $2261add946680b98$export$b8f5890fc79d6aca, (v) => $2261add946680b98$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $2261add946680b98$export$60241385465d0a34, (v) => $2261add946680b98$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $2261add946680b98$export$306c0aa65ff9ec16, (v) => $2261add946680b98$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $2261add946680b98$export$7b286972b8d8ccbf, (v) => $2261add946680b98$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $2261add946680b98$export$83d89fbfd8236492, (v) => $2261add946680b98$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2261add946680b98$export$dca3b0875bd9a954;
var $2261add946680b98$export$16fa2f45be04daa8;
var $2261add946680b98$export$ffb0004e005737fa;
var $2261add946680b98$export$e2c29f18771995cb;
var $2261add946680b98$export$221d75b3f55bb0bd;
var $2261add946680b98$export$5f8d39834fd61797;
var $2261add946680b98$export$74bf444e3cd11ea5;
var $2261add946680b98$export$ae55be85d98224ed;
var $2261add946680b98$export$e530037191fcd5d7;
var $2261add946680b98$export$fd42f52fd3ae1109;
var $2261add946680b98$export$c8a8987d4410bf2d;
var $2261add946680b98$export$d38cd72104c1f0e9;
var $2261add946680b98$export$7d1e3a5e95ceca43;
var $2261add946680b98$export$257a8862b851cb5b;
var $2261add946680b98$export$a8257692ac88316c;
var $2261add946680b98$export$488013bae63b21da;
var $2261add946680b98$export$7c73462e0d25e514;
var $2261add946680b98$export$7568632d0d33d16d;
var $2261add946680b98$export$88948ce120ea2619;
var $2261add946680b98$export$35808ee640e87ca7;
var $2261add946680b98$export$fae74005e78b1a27;
var $2261add946680b98$export$dc8fbce3eb94dc1e;
var $2261add946680b98$export$6a7bc4e911dc01cf;
var $2261add946680b98$export$6d9c69b0de29b591;
var $2261add946680b98$export$f680877a34711e37;
var $2261add946680b98$export$d5a552a76deda3c2;
var $2261add946680b98$export$aaabe4eda9ed9969;
var $2261add946680b98$export$e5c5a5f917a5871c;
var $2261add946680b98$export$1538c33de8887b59;
var $2261add946680b98$export$13e3392192263954;
var $2261add946680b98$export$b8f5890fc79d6aca;
var $2261add946680b98$export$60241385465d0a34;
var $2261add946680b98$export$306c0aa65ff9ec16;
var $2261add946680b98$export$7b286972b8d8ccbf;
var $2261add946680b98$export$83d89fbfd8236492;
'use strict';
var $2261add946680b98$var$l = Symbol.for("react.element"), $2261add946680b98$var$n = Symbol.for("react.portal"), $2261add946680b98$var$p = Symbol.for("react.fragment"), $2261add946680b98$var$q = Symbol.for("react.strict_mode"), $2261add946680b98$var$r = Symbol.for("react.profiler"), $2261add946680b98$var$t = Symbol.for("react.provider"), $2261add946680b98$var$u = Symbol.for("react.context"), $2261add946680b98$var$v = Symbol.for("react.forward_ref"), $2261add946680b98$var$w = Symbol.for("react.suspense"), $2261add946680b98$var$x = Symbol.for("react.memo"), $2261add946680b98$var$y = Symbol.for("react.lazy"), $2261add946680b98$var$z = Symbol.iterator;
function $2261add946680b98$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2261add946680b98$var$z && a[$2261add946680b98$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2261add946680b98$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2261add946680b98$var$C = Object.assign, $2261add946680b98$var$D = {};
function $2261add946680b98$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $2261add946680b98$var$D;
    this.updater = e || $2261add946680b98$var$B;
}
$2261add946680b98$var$E.prototype.isReactComponent = {};
$2261add946680b98$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$2261add946680b98$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $2261add946680b98$var$F() {}
$2261add946680b98$var$F.prototype = $2261add946680b98$var$E.prototype;
function $2261add946680b98$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $2261add946680b98$var$D;
    this.updater = e || $2261add946680b98$var$B;
}
var $2261add946680b98$var$H = $2261add946680b98$var$G.prototype = new $2261add946680b98$var$F;
$2261add946680b98$var$H.constructor = $2261add946680b98$var$G;
$2261add946680b98$var$C($2261add946680b98$var$H, $2261add946680b98$var$E.prototype);
$2261add946680b98$var$H.isPureReactComponent = !0;
var $2261add946680b98$var$I = Array.isArray, $2261add946680b98$var$J = Object.prototype.hasOwnProperty, $2261add946680b98$var$K = {
    current: null
}, $2261add946680b98$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2261add946680b98$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$2261add946680b98$var$J.call(b, d) && !$2261add946680b98$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $2261add946680b98$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $2261add946680b98$var$K.current
    };
}
function $2261add946680b98$var$N(a, b) {
    return {
        $$typeof: $2261add946680b98$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $2261add946680b98$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2261add946680b98$var$l;
}
function $2261add946680b98$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $2261add946680b98$var$P = /\/+/g;
function $2261add946680b98$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $2261add946680b98$var$escape("" + a.key) : b.toString(36);
}
function $2261add946680b98$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $2261add946680b98$var$l:
                case $2261add946680b98$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $2261add946680b98$var$Q(h, 0) : d, $2261add946680b98$var$I(c) ? (e = "", null != a && (e = a.replace($2261add946680b98$var$P, "$&/") + "/"), $2261add946680b98$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($2261add946680b98$var$O(c) && (c = $2261add946680b98$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($2261add946680b98$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($2261add946680b98$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $2261add946680b98$var$Q(k, g);
        h += $2261add946680b98$var$R(k, b, e, f, c);
    }
    else if (f = $2261add946680b98$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $2261add946680b98$var$Q(k, g++), h += $2261add946680b98$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $2261add946680b98$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $2261add946680b98$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $2261add946680b98$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $2261add946680b98$var$U = {
    current: null
}, $2261add946680b98$var$V = {
    transition: null
}, $2261add946680b98$var$W = {
    ReactCurrentDispatcher: $2261add946680b98$var$U,
    ReactCurrentBatchConfig: $2261add946680b98$var$V,
    ReactCurrentOwner: $2261add946680b98$var$K
};
$2261add946680b98$export$dca3b0875bd9a954 = {
    map: $2261add946680b98$var$S,
    forEach: function(a, b, e) {
        $2261add946680b98$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $2261add946680b98$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $2261add946680b98$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$2261add946680b98$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$2261add946680b98$export$16fa2f45be04daa8 = $2261add946680b98$var$E;
$2261add946680b98$export$ffb0004e005737fa = $2261add946680b98$var$p;
$2261add946680b98$export$e2c29f18771995cb = $2261add946680b98$var$r;
$2261add946680b98$export$221d75b3f55bb0bd = $2261add946680b98$var$G;
$2261add946680b98$export$5f8d39834fd61797 = $2261add946680b98$var$q;
$2261add946680b98$export$74bf444e3cd11ea5 = $2261add946680b98$var$w;
$2261add946680b98$export$ae55be85d98224ed = $2261add946680b98$var$W;
$2261add946680b98$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $2261add946680b98$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $2261add946680b98$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$2261add946680b98$var$J.call(b, f) && !$2261add946680b98$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $2261add946680b98$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$2261add946680b98$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $2261add946680b98$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $2261add946680b98$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$2261add946680b98$export$c8a8987d4410bf2d = $2261add946680b98$var$M;
$2261add946680b98$export$d38cd72104c1f0e9 = function(a) {
    var b = $2261add946680b98$var$M.bind(null, a);
    b.type = a;
    return b;
};
$2261add946680b98$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2261add946680b98$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $2261add946680b98$var$v,
        render: a
    };
};
$2261add946680b98$export$a8257692ac88316c = $2261add946680b98$var$O;
$2261add946680b98$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $2261add946680b98$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $2261add946680b98$var$T
    };
};
$2261add946680b98$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $2261add946680b98$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$2261add946680b98$export$7568632d0d33d16d = function(a) {
    var b = $2261add946680b98$var$V.transition;
    $2261add946680b98$var$V.transition = {};
    try {
        a();
    } finally{
        $2261add946680b98$var$V.transition = b;
    }
};
$2261add946680b98$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$2261add946680b98$export$35808ee640e87ca7 = function(a, b) {
    return $2261add946680b98$var$U.current.useCallback(a, b);
};
$2261add946680b98$export$fae74005e78b1a27 = function(a) {
    return $2261add946680b98$var$U.current.useContext(a);
};
$2261add946680b98$export$dc8fbce3eb94dc1e = function() {};
$2261add946680b98$export$6a7bc4e911dc01cf = function(a) {
    return $2261add946680b98$var$U.current.useDeferredValue(a);
};
$2261add946680b98$export$6d9c69b0de29b591 = function(a, b) {
    return $2261add946680b98$var$U.current.useEffect(a, b);
};
$2261add946680b98$export$f680877a34711e37 = function() {
    return $2261add946680b98$var$U.current.useId();
};
$2261add946680b98$export$d5a552a76deda3c2 = function(a, b, e) {
    return $2261add946680b98$var$U.current.useImperativeHandle(a, b, e);
};
$2261add946680b98$export$aaabe4eda9ed9969 = function(a, b) {
    return $2261add946680b98$var$U.current.useInsertionEffect(a, b);
};
$2261add946680b98$export$e5c5a5f917a5871c = function(a, b) {
    return $2261add946680b98$var$U.current.useLayoutEffect(a, b);
};
$2261add946680b98$export$1538c33de8887b59 = function(a, b) {
    return $2261add946680b98$var$U.current.useMemo(a, b);
};
$2261add946680b98$export$13e3392192263954 = function(a, b, e) {
    return $2261add946680b98$var$U.current.useReducer(a, b, e);
};
$2261add946680b98$export$b8f5890fc79d6aca = function(a) {
    return $2261add946680b98$var$U.current.useRef(a);
};
$2261add946680b98$export$60241385465d0a34 = function(a) {
    return $2261add946680b98$var$U.current.useState(a);
};
$2261add946680b98$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $2261add946680b98$var$U.current.useSyncExternalStore(a, b, e);
};
$2261add946680b98$export$7b286972b8d8ccbf = function() {
    return $2261add946680b98$var$U.current.useTransition();
};
$2261add946680b98$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("30kIH", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $230171b9a5f53835$export$ae55be85d98224ed, (v) => $230171b9a5f53835$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $230171b9a5f53835$export$d39a5bbd09211389, (v) => $230171b9a5f53835$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $230171b9a5f53835$export$882461b6382ed46c, (v) => $230171b9a5f53835$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $230171b9a5f53835$export$466bfc07425424d5, (v) => $230171b9a5f53835$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $230171b9a5f53835$export$cd75ccfd720a3cd4, (v) => $230171b9a5f53835$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $230171b9a5f53835$export$fa8d919ba61d84db, (v) => $230171b9a5f53835$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $230171b9a5f53835$export$757ceba2d55c277e, (v) => $230171b9a5f53835$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $230171b9a5f53835$export$b3890eb0ae9dca99, (v) => $230171b9a5f53835$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $230171b9a5f53835$export$502457920280e6be, (v) => $230171b9a5f53835$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $230171b9a5f53835$export$c78a37762a8d58e1, (v) => $230171b9a5f53835$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $230171b9a5f53835$export$dc54d992c10e8a18, (v) => $230171b9a5f53835$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $230171b9a5f53835$export$83d89fbfd8236492, (v) => $230171b9a5f53835$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $230171b9a5f53835$export$ae55be85d98224ed;
var $230171b9a5f53835$export$d39a5bbd09211389;
var $230171b9a5f53835$export$882461b6382ed46c;
var $230171b9a5f53835$export$466bfc07425424d5;
var $230171b9a5f53835$export$cd75ccfd720a3cd4;
var $230171b9a5f53835$export$fa8d919ba61d84db;
var $230171b9a5f53835$export$757ceba2d55c277e;
var $230171b9a5f53835$export$b3890eb0ae9dca99;
var $230171b9a5f53835$export$502457920280e6be;
var $230171b9a5f53835$export$c78a37762a8d58e1;
var $230171b9a5f53835$export$dc54d992c10e8a18;
var $230171b9a5f53835$export$83d89fbfd8236492;
'use strict';

var $3KGP8 = parcelRequire("3KGP8");

var $fZMuI = parcelRequire("fZMuI");
function $230171b9a5f53835$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $230171b9a5f53835$var$da = new Set, $230171b9a5f53835$var$ea = {};
function $230171b9a5f53835$var$fa(a, b) {
    $230171b9a5f53835$var$ha(a, b);
    $230171b9a5f53835$var$ha(a + "Capture", b);
}
function $230171b9a5f53835$var$ha(a, b) {
    $230171b9a5f53835$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$230171b9a5f53835$var$da.add(b[a]);
}
var $230171b9a5f53835$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $230171b9a5f53835$var$ja = Object.prototype.hasOwnProperty, $230171b9a5f53835$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $230171b9a5f53835$var$la = {}, $230171b9a5f53835$var$ma = {};
function $230171b9a5f53835$var$oa(a) {
    if ($230171b9a5f53835$var$ja.call($230171b9a5f53835$var$ma, a)) return !0;
    if ($230171b9a5f53835$var$ja.call($230171b9a5f53835$var$la, a)) return !1;
    if ($230171b9a5f53835$var$ka.test(a)) return $230171b9a5f53835$var$ma[a] = !0;
    $230171b9a5f53835$var$la[a] = !0;
    return !1;
}
function $230171b9a5f53835$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $230171b9a5f53835$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $230171b9a5f53835$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $230171b9a5f53835$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $230171b9a5f53835$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $230171b9a5f53835$var$z[b] = new $230171b9a5f53835$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $230171b9a5f53835$var$ra = /[\-:]([a-z])/g;
function $230171b9a5f53835$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($230171b9a5f53835$var$ra, $230171b9a5f53835$var$sa);
    $230171b9a5f53835$var$z[b] = new $230171b9a5f53835$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($230171b9a5f53835$var$ra, $230171b9a5f53835$var$sa);
    $230171b9a5f53835$var$z[b] = new $230171b9a5f53835$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($230171b9a5f53835$var$ra, $230171b9a5f53835$var$sa);
    $230171b9a5f53835$var$z[b] = new $230171b9a5f53835$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$230171b9a5f53835$var$z.xlinkHref = new $230171b9a5f53835$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $230171b9a5f53835$var$z[a] = new $230171b9a5f53835$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $230171b9a5f53835$var$ta(a, b, c, d) {
    var e = $230171b9a5f53835$var$z.hasOwnProperty(b) ? $230171b9a5f53835$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $230171b9a5f53835$var$qa(b, c, e, d) && (c = null), d || null === e ? $230171b9a5f53835$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $230171b9a5f53835$var$ua = $3KGP8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $230171b9a5f53835$var$va = Symbol.for("react.element"), $230171b9a5f53835$var$wa = Symbol.for("react.portal"), $230171b9a5f53835$var$ya = Symbol.for("react.fragment"), $230171b9a5f53835$var$za = Symbol.for("react.strict_mode"), $230171b9a5f53835$var$Aa = Symbol.for("react.profiler"), $230171b9a5f53835$var$Ba = Symbol.for("react.provider"), $230171b9a5f53835$var$Ca = Symbol.for("react.context"), $230171b9a5f53835$var$Da = Symbol.for("react.forward_ref"), $230171b9a5f53835$var$Ea = Symbol.for("react.suspense"), $230171b9a5f53835$var$Fa = Symbol.for("react.suspense_list"), $230171b9a5f53835$var$Ga = Symbol.for("react.memo"), $230171b9a5f53835$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $230171b9a5f53835$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $230171b9a5f53835$var$Ja = Symbol.iterator;
function $230171b9a5f53835$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $230171b9a5f53835$var$Ja && a[$230171b9a5f53835$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $230171b9a5f53835$var$A = Object.assign, $230171b9a5f53835$var$La;
function $230171b9a5f53835$var$Ma(a) {
    if (void 0 === $230171b9a5f53835$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $230171b9a5f53835$var$La = b && b[1] || "";
    }
    return "\n" + $230171b9a5f53835$var$La + a;
}
var $230171b9a5f53835$var$Na = !1;
function $230171b9a5f53835$var$Oa(a, b) {
    if (!a || $230171b9a5f53835$var$Na) return "";
    $230171b9a5f53835$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $230171b9a5f53835$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $230171b9a5f53835$var$Ma(a) : "";
}
function $230171b9a5f53835$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $230171b9a5f53835$var$Ma(a.type);
        case 16:
            return $230171b9a5f53835$var$Ma("Lazy");
        case 13:
            return $230171b9a5f53835$var$Ma("Suspense");
        case 19:
            return $230171b9a5f53835$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $230171b9a5f53835$var$Oa(a.type, !1), a;
        case 11:
            return a = $230171b9a5f53835$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $230171b9a5f53835$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $230171b9a5f53835$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $230171b9a5f53835$var$ya:
            return "Fragment";
        case $230171b9a5f53835$var$wa:
            return "Portal";
        case $230171b9a5f53835$var$Aa:
            return "Profiler";
        case $230171b9a5f53835$var$za:
            return "StrictMode";
        case $230171b9a5f53835$var$Ea:
            return "Suspense";
        case $230171b9a5f53835$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $230171b9a5f53835$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $230171b9a5f53835$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $230171b9a5f53835$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $230171b9a5f53835$var$Ga:
            return b = a.displayName || null, null !== b ? b : $230171b9a5f53835$var$Qa(a.type) || "Memo";
        case $230171b9a5f53835$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $230171b9a5f53835$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $230171b9a5f53835$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $230171b9a5f53835$var$Qa(b);
        case 8:
            return b === $230171b9a5f53835$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $230171b9a5f53835$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $230171b9a5f53835$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $230171b9a5f53835$var$Ua(a) {
    var b = $230171b9a5f53835$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $230171b9a5f53835$var$Va(a) {
    a._valueTracker || (a._valueTracker = $230171b9a5f53835$var$Ua(a));
}
function $230171b9a5f53835$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $230171b9a5f53835$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $230171b9a5f53835$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $230171b9a5f53835$var$Ya(a, b) {
    var c = b.checked;
    return $230171b9a5f53835$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $230171b9a5f53835$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $230171b9a5f53835$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $230171b9a5f53835$var$ab(a, b) {
    b = b.checked;
    null != b && $230171b9a5f53835$var$ta(a, "checked", b, !1);
}
function $230171b9a5f53835$var$bb(a, b) {
    $230171b9a5f53835$var$ab(a, b);
    var c = $230171b9a5f53835$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $230171b9a5f53835$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $230171b9a5f53835$var$cb(a, b.type, $230171b9a5f53835$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $230171b9a5f53835$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $230171b9a5f53835$var$cb(a, b, c) {
    if ("number" !== b || $230171b9a5f53835$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $230171b9a5f53835$var$eb = Array.isArray;
function $230171b9a5f53835$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $230171b9a5f53835$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $230171b9a5f53835$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($230171b9a5f53835$var$p(91));
    return $230171b9a5f53835$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $230171b9a5f53835$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($230171b9a5f53835$var$p(92));
            if ($230171b9a5f53835$var$eb(c)) {
                if (1 < c.length) throw Error($230171b9a5f53835$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $230171b9a5f53835$var$Sa(c)
    };
}
function $230171b9a5f53835$var$ib(a, b) {
    var c = $230171b9a5f53835$var$Sa(b.value), d = $230171b9a5f53835$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $230171b9a5f53835$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $230171b9a5f53835$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $230171b9a5f53835$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $230171b9a5f53835$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $230171b9a5f53835$var$mb, $230171b9a5f53835$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $230171b9a5f53835$var$mb = $230171b9a5f53835$var$mb || document.createElement("div");
        $230171b9a5f53835$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $230171b9a5f53835$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $230171b9a5f53835$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $230171b9a5f53835$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $230171b9a5f53835$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($230171b9a5f53835$var$pb).forEach(function(a) {
    $230171b9a5f53835$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $230171b9a5f53835$var$pb[b] = $230171b9a5f53835$var$pb[a];
    });
});
function $230171b9a5f53835$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $230171b9a5f53835$var$pb.hasOwnProperty(a) && $230171b9a5f53835$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $230171b9a5f53835$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $230171b9a5f53835$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $230171b9a5f53835$var$tb = $230171b9a5f53835$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $230171b9a5f53835$var$ub(a, b) {
    if (b) {
        if ($230171b9a5f53835$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($230171b9a5f53835$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($230171b9a5f53835$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($230171b9a5f53835$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($230171b9a5f53835$var$p(62));
    }
}
function $230171b9a5f53835$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $230171b9a5f53835$var$wb = null;
function $230171b9a5f53835$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $230171b9a5f53835$var$yb = null, $230171b9a5f53835$var$zb = null, $230171b9a5f53835$var$Ab = null;
function $230171b9a5f53835$var$Bb(a) {
    if (a = $230171b9a5f53835$var$Cb(a)) {
        if ("function" !== typeof $230171b9a5f53835$var$yb) throw Error($230171b9a5f53835$var$p(280));
        var b = a.stateNode;
        b && (b = $230171b9a5f53835$var$Db(b), $230171b9a5f53835$var$yb(a.stateNode, a.type, b));
    }
}
function $230171b9a5f53835$var$Eb(a) {
    $230171b9a5f53835$var$zb ? $230171b9a5f53835$var$Ab ? $230171b9a5f53835$var$Ab.push(a) : $230171b9a5f53835$var$Ab = [
        a
    ] : $230171b9a5f53835$var$zb = a;
}
function $230171b9a5f53835$var$Fb() {
    if ($230171b9a5f53835$var$zb) {
        var a = $230171b9a5f53835$var$zb, b = $230171b9a5f53835$var$Ab;
        $230171b9a5f53835$var$Ab = $230171b9a5f53835$var$zb = null;
        $230171b9a5f53835$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$230171b9a5f53835$var$Bb(b[a]);
    }
}
function $230171b9a5f53835$var$Gb(a, b) {
    return a(b);
}
function $230171b9a5f53835$var$Hb() {}
var $230171b9a5f53835$var$Ib = !1;
function $230171b9a5f53835$var$Jb(a, b, c) {
    if ($230171b9a5f53835$var$Ib) return a(b, c);
    $230171b9a5f53835$var$Ib = !0;
    try {
        return $230171b9a5f53835$var$Gb(a, b, c);
    } finally{
        if ($230171b9a5f53835$var$Ib = !1, null !== $230171b9a5f53835$var$zb || null !== $230171b9a5f53835$var$Ab) $230171b9a5f53835$var$Hb(), $230171b9a5f53835$var$Fb();
    }
}
function $230171b9a5f53835$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $230171b9a5f53835$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($230171b9a5f53835$var$p(231, b, typeof c));
    return c;
}
var $230171b9a5f53835$var$Lb = !1;
if ($230171b9a5f53835$var$ia) try {
    var $230171b9a5f53835$var$Mb = {};
    Object.defineProperty($230171b9a5f53835$var$Mb, "passive", {
        get: function() {
            $230171b9a5f53835$var$Lb = !0;
        }
    });
    window.addEventListener("test", $230171b9a5f53835$var$Mb, $230171b9a5f53835$var$Mb);
    window.removeEventListener("test", $230171b9a5f53835$var$Mb, $230171b9a5f53835$var$Mb);
} catch (a) {
    $230171b9a5f53835$var$Lb = !1;
}
function $230171b9a5f53835$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $230171b9a5f53835$var$Ob = !1, $230171b9a5f53835$var$Pb = null, $230171b9a5f53835$var$Qb = !1, $230171b9a5f53835$var$Rb = null, $230171b9a5f53835$var$Sb = {
    onError: function(a) {
        $230171b9a5f53835$var$Ob = !0;
        $230171b9a5f53835$var$Pb = a;
    }
};
function $230171b9a5f53835$var$Tb(a, b, c, d, e, f, g, h, k) {
    $230171b9a5f53835$var$Ob = !1;
    $230171b9a5f53835$var$Pb = null;
    $230171b9a5f53835$var$Nb.apply($230171b9a5f53835$var$Sb, arguments);
}
function $230171b9a5f53835$var$Ub(a, b, c, d, e, f, g, h, k) {
    $230171b9a5f53835$var$Tb.apply(this, arguments);
    if ($230171b9a5f53835$var$Ob) {
        if ($230171b9a5f53835$var$Ob) {
            var l = $230171b9a5f53835$var$Pb;
            $230171b9a5f53835$var$Ob = !1;
            $230171b9a5f53835$var$Pb = null;
        } else throw Error($230171b9a5f53835$var$p(198));
        $230171b9a5f53835$var$Qb || ($230171b9a5f53835$var$Qb = !0, $230171b9a5f53835$var$Rb = l);
    }
}
function $230171b9a5f53835$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $230171b9a5f53835$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $230171b9a5f53835$var$Xb(a) {
    if ($230171b9a5f53835$var$Vb(a) !== a) throw Error($230171b9a5f53835$var$p(188));
}
function $230171b9a5f53835$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $230171b9a5f53835$var$Vb(a);
        if (null === b) throw Error($230171b9a5f53835$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $230171b9a5f53835$var$Xb(e), a;
                if (f === d) return $230171b9a5f53835$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($230171b9a5f53835$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($230171b9a5f53835$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($230171b9a5f53835$var$p(190));
    }
    if (3 !== c.tag) throw Error($230171b9a5f53835$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $230171b9a5f53835$var$Zb(a) {
    a = $230171b9a5f53835$var$Yb(a);
    return null !== a ? $230171b9a5f53835$var$$b(a) : null;
}
function $230171b9a5f53835$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $230171b9a5f53835$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $230171b9a5f53835$var$ac = $fZMuI.unstable_scheduleCallback, $230171b9a5f53835$var$bc = $fZMuI.unstable_cancelCallback, $230171b9a5f53835$var$cc = $fZMuI.unstable_shouldYield, $230171b9a5f53835$var$dc = $fZMuI.unstable_requestPaint, $230171b9a5f53835$var$B = $fZMuI.unstable_now, $230171b9a5f53835$var$ec = $fZMuI.unstable_getCurrentPriorityLevel, $230171b9a5f53835$var$fc = $fZMuI.unstable_ImmediatePriority, $230171b9a5f53835$var$gc = $fZMuI.unstable_UserBlockingPriority, $230171b9a5f53835$var$hc = $fZMuI.unstable_NormalPriority, $230171b9a5f53835$var$ic = $fZMuI.unstable_LowPriority, $230171b9a5f53835$var$jc = $fZMuI.unstable_IdlePriority, $230171b9a5f53835$var$kc = null, $230171b9a5f53835$var$lc = null;
function $230171b9a5f53835$var$mc(a) {
    if ($230171b9a5f53835$var$lc && "function" === typeof $230171b9a5f53835$var$lc.onCommitFiberRoot) try {
        $230171b9a5f53835$var$lc.onCommitFiberRoot($230171b9a5f53835$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $230171b9a5f53835$var$oc = Math.clz32 ? Math.clz32 : $230171b9a5f53835$var$nc, $230171b9a5f53835$var$pc = Math.log, $230171b9a5f53835$var$qc = Math.LN2;
function $230171b9a5f53835$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($230171b9a5f53835$var$pc(a) / $230171b9a5f53835$var$qc | 0) | 0;
}
var $230171b9a5f53835$var$rc = 64, $230171b9a5f53835$var$sc = 4194304;
function $230171b9a5f53835$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $230171b9a5f53835$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $230171b9a5f53835$var$tc(h) : (f &= g, 0 !== f && (d = $230171b9a5f53835$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $230171b9a5f53835$var$tc(g) : 0 !== f && (d = $230171b9a5f53835$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $230171b9a5f53835$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $230171b9a5f53835$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $230171b9a5f53835$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $230171b9a5f53835$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $230171b9a5f53835$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $230171b9a5f53835$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $230171b9a5f53835$var$yc() {
    var a = $230171b9a5f53835$var$rc;
    $230171b9a5f53835$var$rc <<= 1;
    0 === ($230171b9a5f53835$var$rc & 4194240) && ($230171b9a5f53835$var$rc = 64);
    return a;
}
function $230171b9a5f53835$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $230171b9a5f53835$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $230171b9a5f53835$var$oc(b);
    a[b] = c;
}
function $230171b9a5f53835$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $230171b9a5f53835$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $230171b9a5f53835$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $230171b9a5f53835$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $230171b9a5f53835$var$C = 0;
function $230171b9a5f53835$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $230171b9a5f53835$var$Ec, $230171b9a5f53835$var$Fc, $230171b9a5f53835$var$Gc, $230171b9a5f53835$var$Hc, $230171b9a5f53835$var$Ic, $230171b9a5f53835$var$Jc = !1, $230171b9a5f53835$var$Kc = [], $230171b9a5f53835$var$Lc = null, $230171b9a5f53835$var$Mc = null, $230171b9a5f53835$var$Nc = null, $230171b9a5f53835$var$Oc = new Map, $230171b9a5f53835$var$Pc = new Map, $230171b9a5f53835$var$Qc = [], $230171b9a5f53835$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $230171b9a5f53835$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $230171b9a5f53835$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $230171b9a5f53835$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $230171b9a5f53835$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $230171b9a5f53835$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $230171b9a5f53835$var$Pc.delete(b.pointerId);
    }
}
function $230171b9a5f53835$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $230171b9a5f53835$var$Cb(b), null !== b && $230171b9a5f53835$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $230171b9a5f53835$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $230171b9a5f53835$var$Lc = $230171b9a5f53835$var$Tc($230171b9a5f53835$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $230171b9a5f53835$var$Mc = $230171b9a5f53835$var$Tc($230171b9a5f53835$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $230171b9a5f53835$var$Nc = $230171b9a5f53835$var$Tc($230171b9a5f53835$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $230171b9a5f53835$var$Oc.set(f, $230171b9a5f53835$var$Tc($230171b9a5f53835$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $230171b9a5f53835$var$Pc.set(f, $230171b9a5f53835$var$Tc($230171b9a5f53835$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $230171b9a5f53835$var$Vc(a) {
    var b = $230171b9a5f53835$var$Wc(a.target);
    if (null !== b) {
        var c = $230171b9a5f53835$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $230171b9a5f53835$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $230171b9a5f53835$var$Ic(a.priority, function() {
                        $230171b9a5f53835$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $230171b9a5f53835$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $230171b9a5f53835$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $230171b9a5f53835$var$wb = d;
            c.target.dispatchEvent(d);
            $230171b9a5f53835$var$wb = null;
        } else return b = $230171b9a5f53835$var$Cb(c), null !== b && $230171b9a5f53835$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $230171b9a5f53835$var$Zc(a, b, c) {
    $230171b9a5f53835$var$Xc(a) && c.delete(b);
}
function $230171b9a5f53835$var$$c() {
    $230171b9a5f53835$var$Jc = !1;
    null !== $230171b9a5f53835$var$Lc && $230171b9a5f53835$var$Xc($230171b9a5f53835$var$Lc) && ($230171b9a5f53835$var$Lc = null);
    null !== $230171b9a5f53835$var$Mc && $230171b9a5f53835$var$Xc($230171b9a5f53835$var$Mc) && ($230171b9a5f53835$var$Mc = null);
    null !== $230171b9a5f53835$var$Nc && $230171b9a5f53835$var$Xc($230171b9a5f53835$var$Nc) && ($230171b9a5f53835$var$Nc = null);
    $230171b9a5f53835$var$Oc.forEach($230171b9a5f53835$var$Zc);
    $230171b9a5f53835$var$Pc.forEach($230171b9a5f53835$var$Zc);
}
function $230171b9a5f53835$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $230171b9a5f53835$var$Jc || ($230171b9a5f53835$var$Jc = !0, $fZMuI.unstable_scheduleCallback($fZMuI.unstable_NormalPriority, $230171b9a5f53835$var$$c)));
}
function $230171b9a5f53835$var$bd(a) {
    function b(b) {
        return $230171b9a5f53835$var$ad(b, a);
    }
    if (0 < $230171b9a5f53835$var$Kc.length) {
        $230171b9a5f53835$var$ad($230171b9a5f53835$var$Kc[0], a);
        for(var c = 1; c < $230171b9a5f53835$var$Kc.length; c++){
            var d = $230171b9a5f53835$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $230171b9a5f53835$var$Lc && $230171b9a5f53835$var$ad($230171b9a5f53835$var$Lc, a);
    null !== $230171b9a5f53835$var$Mc && $230171b9a5f53835$var$ad($230171b9a5f53835$var$Mc, a);
    null !== $230171b9a5f53835$var$Nc && $230171b9a5f53835$var$ad($230171b9a5f53835$var$Nc, a);
    $230171b9a5f53835$var$Oc.forEach(b);
    $230171b9a5f53835$var$Pc.forEach(b);
    for(c = 0; c < $230171b9a5f53835$var$Qc.length; c++)d = $230171b9a5f53835$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $230171b9a5f53835$var$Qc.length && (c = $230171b9a5f53835$var$Qc[0], null === c.blockedOn);)$230171b9a5f53835$var$Vc(c), null === c.blockedOn && $230171b9a5f53835$var$Qc.shift();
}
var $230171b9a5f53835$var$cd = $230171b9a5f53835$var$ua.ReactCurrentBatchConfig, $230171b9a5f53835$var$dd = !0;
function $230171b9a5f53835$var$ed(a, b, c, d) {
    var e = $230171b9a5f53835$var$C, f = $230171b9a5f53835$var$cd.transition;
    $230171b9a5f53835$var$cd.transition = null;
    try {
        $230171b9a5f53835$var$C = 1, $230171b9a5f53835$var$fd(a, b, c, d);
    } finally{
        $230171b9a5f53835$var$C = e, $230171b9a5f53835$var$cd.transition = f;
    }
}
function $230171b9a5f53835$var$gd(a, b, c, d) {
    var e = $230171b9a5f53835$var$C, f = $230171b9a5f53835$var$cd.transition;
    $230171b9a5f53835$var$cd.transition = null;
    try {
        $230171b9a5f53835$var$C = 4, $230171b9a5f53835$var$fd(a, b, c, d);
    } finally{
        $230171b9a5f53835$var$C = e, $230171b9a5f53835$var$cd.transition = f;
    }
}
function $230171b9a5f53835$var$fd(a, b, c, d) {
    if ($230171b9a5f53835$var$dd) {
        var e = $230171b9a5f53835$var$Yc(a, b, c, d);
        if (null === e) $230171b9a5f53835$var$hd(a, b, d, $230171b9a5f53835$var$id, c), $230171b9a5f53835$var$Sc(a, d);
        else if ($230171b9a5f53835$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($230171b9a5f53835$var$Sc(a, d), b & 4 && -1 < $230171b9a5f53835$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $230171b9a5f53835$var$Cb(e);
                null !== f && $230171b9a5f53835$var$Ec(f);
                f = $230171b9a5f53835$var$Yc(a, b, c, d);
                null === f && $230171b9a5f53835$var$hd(a, b, d, $230171b9a5f53835$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $230171b9a5f53835$var$hd(a, b, d, null, c);
    }
}
var $230171b9a5f53835$var$id = null;
function $230171b9a5f53835$var$Yc(a, b, c, d) {
    $230171b9a5f53835$var$id = null;
    a = $230171b9a5f53835$var$xb(d);
    a = $230171b9a5f53835$var$Wc(a);
    if (null !== a) {
        if (b = $230171b9a5f53835$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $230171b9a5f53835$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $230171b9a5f53835$var$id = a;
    return null;
}
function $230171b9a5f53835$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($230171b9a5f53835$var$ec()){
                case $230171b9a5f53835$var$fc:
                    return 1;
                case $230171b9a5f53835$var$gc:
                    return 4;
                case $230171b9a5f53835$var$hc:
                case $230171b9a5f53835$var$ic:
                    return 16;
                case $230171b9a5f53835$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $230171b9a5f53835$var$kd = null, $230171b9a5f53835$var$ld = null, $230171b9a5f53835$var$md = null;
function $230171b9a5f53835$var$nd() {
    if ($230171b9a5f53835$var$md) return $230171b9a5f53835$var$md;
    var a, b = $230171b9a5f53835$var$ld, c = b.length, d, e = "value" in $230171b9a5f53835$var$kd ? $230171b9a5f53835$var$kd.value : $230171b9a5f53835$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $230171b9a5f53835$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $230171b9a5f53835$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $230171b9a5f53835$var$pd() {
    return !0;
}
function $230171b9a5f53835$var$qd() {
    return !1;
}
function $230171b9a5f53835$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $230171b9a5f53835$var$pd : $230171b9a5f53835$var$qd;
        this.isPropagationStopped = $230171b9a5f53835$var$qd;
        return this;
    }
    $230171b9a5f53835$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $230171b9a5f53835$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $230171b9a5f53835$var$pd);
        },
        persist: function() {},
        isPersistent: $230171b9a5f53835$var$pd
    });
    return b;
}
var $230171b9a5f53835$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $230171b9a5f53835$var$td = $230171b9a5f53835$var$rd($230171b9a5f53835$var$sd), $230171b9a5f53835$var$ud = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$sd, {
    view: 0,
    detail: 0
}), $230171b9a5f53835$var$vd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$ud), $230171b9a5f53835$var$wd, $230171b9a5f53835$var$xd, $230171b9a5f53835$var$yd, $230171b9a5f53835$var$Ad = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $230171b9a5f53835$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $230171b9a5f53835$var$yd && ($230171b9a5f53835$var$yd && "mousemove" === a.type ? ($230171b9a5f53835$var$wd = a.screenX - $230171b9a5f53835$var$yd.screenX, $230171b9a5f53835$var$xd = a.screenY - $230171b9a5f53835$var$yd.screenY) : $230171b9a5f53835$var$xd = $230171b9a5f53835$var$wd = 0, $230171b9a5f53835$var$yd = a);
        return $230171b9a5f53835$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $230171b9a5f53835$var$xd;
    }
}), $230171b9a5f53835$var$Bd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Ad), $230171b9a5f53835$var$Cd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$Ad, {
    dataTransfer: 0
}), $230171b9a5f53835$var$Dd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Cd), $230171b9a5f53835$var$Ed = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$ud, {
    relatedTarget: 0
}), $230171b9a5f53835$var$Fd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Ed), $230171b9a5f53835$var$Gd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $230171b9a5f53835$var$Hd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Gd), $230171b9a5f53835$var$Id = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $230171b9a5f53835$var$Jd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Id), $230171b9a5f53835$var$Kd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$sd, {
    data: 0
}), $230171b9a5f53835$var$Ld = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Kd), $230171b9a5f53835$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $230171b9a5f53835$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $230171b9a5f53835$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $230171b9a5f53835$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $230171b9a5f53835$var$Od[a]) ? !!b[a] : !1;
}
function $230171b9a5f53835$var$zd() {
    return $230171b9a5f53835$var$Pd;
}
var $230171b9a5f53835$var$Qd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $230171b9a5f53835$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $230171b9a5f53835$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $230171b9a5f53835$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $230171b9a5f53835$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $230171b9a5f53835$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $230171b9a5f53835$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $230171b9a5f53835$var$Rd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Qd), $230171b9a5f53835$var$Sd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $230171b9a5f53835$var$Td = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Sd), $230171b9a5f53835$var$Ud = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $230171b9a5f53835$var$zd
}), $230171b9a5f53835$var$Vd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Ud), $230171b9a5f53835$var$Wd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $230171b9a5f53835$var$Xd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Wd), $230171b9a5f53835$var$Yd = $230171b9a5f53835$var$A({}, $230171b9a5f53835$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $230171b9a5f53835$var$Zd = $230171b9a5f53835$var$rd($230171b9a5f53835$var$Yd), $230171b9a5f53835$var$$d = [
    9,
    13,
    27,
    32
], $230171b9a5f53835$var$ae = $230171b9a5f53835$var$ia && "CompositionEvent" in window, $230171b9a5f53835$var$be = null;
$230171b9a5f53835$var$ia && "documentMode" in document && ($230171b9a5f53835$var$be = document.documentMode);
var $230171b9a5f53835$var$ce = $230171b9a5f53835$var$ia && "TextEvent" in window && !$230171b9a5f53835$var$be, $230171b9a5f53835$var$de = $230171b9a5f53835$var$ia && (!$230171b9a5f53835$var$ae || $230171b9a5f53835$var$be && 8 < $230171b9a5f53835$var$be && 11 >= $230171b9a5f53835$var$be), $230171b9a5f53835$var$ee = String.fromCharCode(32), $230171b9a5f53835$var$fe = !1;
function $230171b9a5f53835$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $230171b9a5f53835$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $230171b9a5f53835$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $230171b9a5f53835$var$ie = !1;
function $230171b9a5f53835$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $230171b9a5f53835$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $230171b9a5f53835$var$fe = !0;
            return $230171b9a5f53835$var$ee;
        case "textInput":
            return a = b.data, a === $230171b9a5f53835$var$ee && $230171b9a5f53835$var$fe ? null : a;
        default:
            return null;
    }
}
function $230171b9a5f53835$var$ke(a, b) {
    if ($230171b9a5f53835$var$ie) return "compositionend" === a || !$230171b9a5f53835$var$ae && $230171b9a5f53835$var$ge(a, b) ? (a = $230171b9a5f53835$var$nd(), $230171b9a5f53835$var$md = $230171b9a5f53835$var$ld = $230171b9a5f53835$var$kd = null, $230171b9a5f53835$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $230171b9a5f53835$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $230171b9a5f53835$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $230171b9a5f53835$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$230171b9a5f53835$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $230171b9a5f53835$var$ne(a, b, c, d) {
    $230171b9a5f53835$var$Eb(d);
    b = $230171b9a5f53835$var$oe(b, "onChange");
    0 < b.length && (c = new $230171b9a5f53835$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $230171b9a5f53835$var$pe = null, $230171b9a5f53835$var$qe = null;
function $230171b9a5f53835$var$re(a) {
    $230171b9a5f53835$var$se(a, 0);
}
function $230171b9a5f53835$var$te(a) {
    var b = $230171b9a5f53835$var$ue(a);
    if ($230171b9a5f53835$var$Wa(b)) return a;
}
function $230171b9a5f53835$var$ve(a, b) {
    if ("change" === a) return b;
}
var $230171b9a5f53835$var$we = !1;
if ($230171b9a5f53835$var$ia) {
    var $230171b9a5f53835$var$xe;
    if ($230171b9a5f53835$var$ia) {
        var $230171b9a5f53835$var$ye = "oninput" in document;
        if (!$230171b9a5f53835$var$ye) {
            var $230171b9a5f53835$var$ze = document.createElement("div");
            $230171b9a5f53835$var$ze.setAttribute("oninput", "return;");
            $230171b9a5f53835$var$ye = "function" === typeof $230171b9a5f53835$var$ze.oninput;
        }
        $230171b9a5f53835$var$xe = $230171b9a5f53835$var$ye;
    } else $230171b9a5f53835$var$xe = !1;
    $230171b9a5f53835$var$we = $230171b9a5f53835$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $230171b9a5f53835$var$Ae() {
    $230171b9a5f53835$var$pe && ($230171b9a5f53835$var$pe.detachEvent("onpropertychange", $230171b9a5f53835$var$Be), $230171b9a5f53835$var$qe = $230171b9a5f53835$var$pe = null);
}
function $230171b9a5f53835$var$Be(a) {
    if ("value" === a.propertyName && $230171b9a5f53835$var$te($230171b9a5f53835$var$qe)) {
        var b = [];
        $230171b9a5f53835$var$ne(b, $230171b9a5f53835$var$qe, a, $230171b9a5f53835$var$xb(a));
        $230171b9a5f53835$var$Jb($230171b9a5f53835$var$re, b);
    }
}
function $230171b9a5f53835$var$Ce(a, b, c) {
    "focusin" === a ? ($230171b9a5f53835$var$Ae(), $230171b9a5f53835$var$pe = b, $230171b9a5f53835$var$qe = c, $230171b9a5f53835$var$pe.attachEvent("onpropertychange", $230171b9a5f53835$var$Be)) : "focusout" === a && $230171b9a5f53835$var$Ae();
}
function $230171b9a5f53835$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $230171b9a5f53835$var$te($230171b9a5f53835$var$qe);
}
function $230171b9a5f53835$var$Ee(a, b) {
    if ("click" === a) return $230171b9a5f53835$var$te(b);
}
function $230171b9a5f53835$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $230171b9a5f53835$var$te(b);
}
function $230171b9a5f53835$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $230171b9a5f53835$var$He = "function" === typeof Object.is ? Object.is : $230171b9a5f53835$var$Ge;
function $230171b9a5f53835$var$Ie(a, b) {
    if ($230171b9a5f53835$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$230171b9a5f53835$var$ja.call(b, e) || !$230171b9a5f53835$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $230171b9a5f53835$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $230171b9a5f53835$var$Ke(a, b) {
    var c = $230171b9a5f53835$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $230171b9a5f53835$var$Je(c);
    }
}
function $230171b9a5f53835$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $230171b9a5f53835$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $230171b9a5f53835$var$Me() {
    for(var a = window, b = $230171b9a5f53835$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $230171b9a5f53835$var$Xa(a.document);
    }
    return b;
}
function $230171b9a5f53835$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $230171b9a5f53835$var$Oe(a) {
    var b = $230171b9a5f53835$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $230171b9a5f53835$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $230171b9a5f53835$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $230171b9a5f53835$var$Ke(c, f);
                var g = $230171b9a5f53835$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $230171b9a5f53835$var$Pe = $230171b9a5f53835$var$ia && "documentMode" in document && 11 >= document.documentMode, $230171b9a5f53835$var$Qe = null, $230171b9a5f53835$var$Re = null, $230171b9a5f53835$var$Se = null, $230171b9a5f53835$var$Te = !1;
function $230171b9a5f53835$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $230171b9a5f53835$var$Te || null == $230171b9a5f53835$var$Qe || $230171b9a5f53835$var$Qe !== $230171b9a5f53835$var$Xa(d) || (d = $230171b9a5f53835$var$Qe, "selectionStart" in d && $230171b9a5f53835$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $230171b9a5f53835$var$Se && $230171b9a5f53835$var$Ie($230171b9a5f53835$var$Se, d) || ($230171b9a5f53835$var$Se = d, d = $230171b9a5f53835$var$oe($230171b9a5f53835$var$Re, "onSelect"), 0 < d.length && (b = new $230171b9a5f53835$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $230171b9a5f53835$var$Qe)));
}
function $230171b9a5f53835$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $230171b9a5f53835$var$We = {
    animationend: $230171b9a5f53835$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $230171b9a5f53835$var$Ve("Animation", "AnimationIteration"),
    animationstart: $230171b9a5f53835$var$Ve("Animation", "AnimationStart"),
    transitionend: $230171b9a5f53835$var$Ve("Transition", "TransitionEnd")
}, $230171b9a5f53835$var$Xe = {}, $230171b9a5f53835$var$Ye = {};
$230171b9a5f53835$var$ia && ($230171b9a5f53835$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $230171b9a5f53835$var$We.animationend.animation, delete $230171b9a5f53835$var$We.animationiteration.animation, delete $230171b9a5f53835$var$We.animationstart.animation), "TransitionEvent" in window || delete $230171b9a5f53835$var$We.transitionend.transition);
function $230171b9a5f53835$var$Ze(a) {
    if ($230171b9a5f53835$var$Xe[a]) return $230171b9a5f53835$var$Xe[a];
    if (!$230171b9a5f53835$var$We[a]) return a;
    var b = $230171b9a5f53835$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $230171b9a5f53835$var$Ye) return $230171b9a5f53835$var$Xe[a] = b[c];
    return a;
}
var $230171b9a5f53835$var$$e = $230171b9a5f53835$var$Ze("animationend"), $230171b9a5f53835$var$af = $230171b9a5f53835$var$Ze("animationiteration"), $230171b9a5f53835$var$bf = $230171b9a5f53835$var$Ze("animationstart"), $230171b9a5f53835$var$cf = $230171b9a5f53835$var$Ze("transitionend"), $230171b9a5f53835$var$df = new Map, $230171b9a5f53835$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $230171b9a5f53835$var$ff(a, b) {
    $230171b9a5f53835$var$df.set(a, b);
    $230171b9a5f53835$var$fa(b, [
        a
    ]);
}
for(var $230171b9a5f53835$var$gf = 0; $230171b9a5f53835$var$gf < $230171b9a5f53835$var$ef.length; $230171b9a5f53835$var$gf++){
    var $230171b9a5f53835$var$hf = $230171b9a5f53835$var$ef[$230171b9a5f53835$var$gf], $230171b9a5f53835$var$jf = $230171b9a5f53835$var$hf.toLowerCase(), $230171b9a5f53835$var$kf = $230171b9a5f53835$var$hf[0].toUpperCase() + $230171b9a5f53835$var$hf.slice(1);
    $230171b9a5f53835$var$ff($230171b9a5f53835$var$jf, "on" + $230171b9a5f53835$var$kf);
}
$230171b9a5f53835$var$ff($230171b9a5f53835$var$$e, "onAnimationEnd");
$230171b9a5f53835$var$ff($230171b9a5f53835$var$af, "onAnimationIteration");
$230171b9a5f53835$var$ff($230171b9a5f53835$var$bf, "onAnimationStart");
$230171b9a5f53835$var$ff("dblclick", "onDoubleClick");
$230171b9a5f53835$var$ff("focusin", "onFocus");
$230171b9a5f53835$var$ff("focusout", "onBlur");
$230171b9a5f53835$var$ff($230171b9a5f53835$var$cf, "onTransitionEnd");
$230171b9a5f53835$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$230171b9a5f53835$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$230171b9a5f53835$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$230171b9a5f53835$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$230171b9a5f53835$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$230171b9a5f53835$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$230171b9a5f53835$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$230171b9a5f53835$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$230171b9a5f53835$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$230171b9a5f53835$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $230171b9a5f53835$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $230171b9a5f53835$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($230171b9a5f53835$var$lf));
function $230171b9a5f53835$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $230171b9a5f53835$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $230171b9a5f53835$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $230171b9a5f53835$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $230171b9a5f53835$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($230171b9a5f53835$var$Qb) throw a = $230171b9a5f53835$var$Rb, $230171b9a5f53835$var$Qb = !1, $230171b9a5f53835$var$Rb = null, a;
}
function $230171b9a5f53835$var$D(a, b) {
    var c = b[$230171b9a5f53835$var$of];
    void 0 === c && (c = b[$230171b9a5f53835$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($230171b9a5f53835$var$pf(b, a, 2, !1), c.add(d));
}
function $230171b9a5f53835$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $230171b9a5f53835$var$pf(c, a, d, b);
}
var $230171b9a5f53835$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $230171b9a5f53835$var$sf(a) {
    if (!a[$230171b9a5f53835$var$rf]) {
        a[$230171b9a5f53835$var$rf] = !0;
        $230171b9a5f53835$var$da.forEach(function(b) {
            "selectionchange" !== b && ($230171b9a5f53835$var$mf.has(b) || $230171b9a5f53835$var$qf(b, !1, a), $230171b9a5f53835$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$230171b9a5f53835$var$rf] || (b[$230171b9a5f53835$var$rf] = !0, $230171b9a5f53835$var$qf("selectionchange", !1, b));
    }
}
function $230171b9a5f53835$var$pf(a, b, c, d) {
    switch($230171b9a5f53835$var$jd(b)){
        case 1:
            var e = $230171b9a5f53835$var$ed;
            break;
        case 4:
            e = $230171b9a5f53835$var$gd;
            break;
        default:
            e = $230171b9a5f53835$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$230171b9a5f53835$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $230171b9a5f53835$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $230171b9a5f53835$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $230171b9a5f53835$var$Jb(function() {
        var d = f, e = $230171b9a5f53835$var$xb(c), g = [];
        a: {
            var h = $230171b9a5f53835$var$df.get(a);
            if (void 0 !== h) {
                var k = $230171b9a5f53835$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $230171b9a5f53835$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $230171b9a5f53835$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $230171b9a5f53835$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $230171b9a5f53835$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $230171b9a5f53835$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $230171b9a5f53835$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $230171b9a5f53835$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $230171b9a5f53835$var$Vd;
                        break;
                    case $230171b9a5f53835$var$$e:
                    case $230171b9a5f53835$var$af:
                    case $230171b9a5f53835$var$bf:
                        k = $230171b9a5f53835$var$Hd;
                        break;
                    case $230171b9a5f53835$var$cf:
                        k = $230171b9a5f53835$var$Xd;
                        break;
                    case "scroll":
                        k = $230171b9a5f53835$var$vd;
                        break;
                    case "wheel":
                        k = $230171b9a5f53835$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $230171b9a5f53835$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $230171b9a5f53835$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $230171b9a5f53835$var$Kb(w, x), null != F && t.push($230171b9a5f53835$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $230171b9a5f53835$var$wb && (n = c.relatedTarget || c.fromElement) && ($230171b9a5f53835$var$Wc(n) || n[$230171b9a5f53835$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $230171b9a5f53835$var$Wc(n) : null, null !== n && (J = $230171b9a5f53835$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $230171b9a5f53835$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $230171b9a5f53835$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $230171b9a5f53835$var$ue(k);
                        u = null == n ? h : $230171b9a5f53835$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $230171b9a5f53835$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $230171b9a5f53835$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $230171b9a5f53835$var$vf(F))u++;
                            for(; 0 < w - u;)t = $230171b9a5f53835$var$vf(t), w--;
                            for(; 0 < u - w;)x = $230171b9a5f53835$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $230171b9a5f53835$var$vf(t);
                                x = $230171b9a5f53835$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $230171b9a5f53835$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $230171b9a5f53835$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $230171b9a5f53835$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $230171b9a5f53835$var$ve;
                else if ($230171b9a5f53835$var$me(h)) {
                    if ($230171b9a5f53835$var$we) na = $230171b9a5f53835$var$Fe;
                    else {
                        na = $230171b9a5f53835$var$De;
                        var xa = $230171b9a5f53835$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $230171b9a5f53835$var$Ee);
                if (na && (na = na(a, d))) {
                    $230171b9a5f53835$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $230171b9a5f53835$var$cb(h, "number", h.value);
            }
            xa = d ? $230171b9a5f53835$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($230171b9a5f53835$var$me(xa) || "true" === xa.contentEditable) $230171b9a5f53835$var$Qe = xa, $230171b9a5f53835$var$Re = d, $230171b9a5f53835$var$Se = null;
                    break;
                case "focusout":
                    $230171b9a5f53835$var$Se = $230171b9a5f53835$var$Re = $230171b9a5f53835$var$Qe = null;
                    break;
                case "mousedown":
                    $230171b9a5f53835$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $230171b9a5f53835$var$Te = !1;
                    $230171b9a5f53835$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($230171b9a5f53835$var$Pe) break;
                case "keydown":
                case "keyup":
                    $230171b9a5f53835$var$Ue(g, c, e);
            }
            var $a;
            if ($230171b9a5f53835$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $230171b9a5f53835$var$ie ? $230171b9a5f53835$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($230171b9a5f53835$var$de && "ko" !== c.locale && ($230171b9a5f53835$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $230171b9a5f53835$var$ie && ($a = $230171b9a5f53835$var$nd()) : ($230171b9a5f53835$var$kd = e, $230171b9a5f53835$var$ld = "value" in $230171b9a5f53835$var$kd ? $230171b9a5f53835$var$kd.value : $230171b9a5f53835$var$kd.textContent, $230171b9a5f53835$var$ie = !0)), xa = $230171b9a5f53835$var$oe(d, ba), 0 < xa.length && (ba = new $230171b9a5f53835$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $230171b9a5f53835$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $230171b9a5f53835$var$ce ? $230171b9a5f53835$var$je(a, c) : $230171b9a5f53835$var$ke(a, c)) d = $230171b9a5f53835$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $230171b9a5f53835$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $230171b9a5f53835$var$se(g, b);
    });
}
function $230171b9a5f53835$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $230171b9a5f53835$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $230171b9a5f53835$var$Kb(a, c), null != f && d.unshift($230171b9a5f53835$var$tf(a, f, e)), f = $230171b9a5f53835$var$Kb(a, b), null != f && d.push($230171b9a5f53835$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $230171b9a5f53835$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $230171b9a5f53835$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $230171b9a5f53835$var$Kb(c, f), null != k && g.unshift($230171b9a5f53835$var$tf(c, k, h))) : e || (k = $230171b9a5f53835$var$Kb(c, f), null != k && g.push($230171b9a5f53835$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $230171b9a5f53835$var$xf = /\r\n?/g, $230171b9a5f53835$var$yf = /\u0000|\uFFFD/g;
function $230171b9a5f53835$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($230171b9a5f53835$var$xf, "\n").replace($230171b9a5f53835$var$yf, "");
}
function $230171b9a5f53835$var$Af(a, b, c) {
    b = $230171b9a5f53835$var$zf(b);
    if ($230171b9a5f53835$var$zf(a) !== b && c) throw Error($230171b9a5f53835$var$p(425));
}
function $230171b9a5f53835$var$Bf() {}
var $230171b9a5f53835$var$Cf = null, $230171b9a5f53835$var$Df = null;
function $230171b9a5f53835$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $230171b9a5f53835$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $230171b9a5f53835$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $230171b9a5f53835$var$Hf = "function" === typeof Promise ? Promise : void 0, $230171b9a5f53835$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $230171b9a5f53835$var$Hf ? function(a) {
    return $230171b9a5f53835$var$Hf.resolve(null).then(a).catch($230171b9a5f53835$var$If);
} : $230171b9a5f53835$var$Ff;
function $230171b9a5f53835$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $230171b9a5f53835$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $230171b9a5f53835$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $230171b9a5f53835$var$bd(b);
}
function $230171b9a5f53835$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $230171b9a5f53835$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $230171b9a5f53835$var$Nf = Math.random().toString(36).slice(2), $230171b9a5f53835$var$Of = "__reactFiber$" + $230171b9a5f53835$var$Nf, $230171b9a5f53835$var$Pf = "__reactProps$" + $230171b9a5f53835$var$Nf, $230171b9a5f53835$var$uf = "__reactContainer$" + $230171b9a5f53835$var$Nf, $230171b9a5f53835$var$of = "__reactEvents$" + $230171b9a5f53835$var$Nf, $230171b9a5f53835$var$Qf = "__reactListeners$" + $230171b9a5f53835$var$Nf, $230171b9a5f53835$var$Rf = "__reactHandles$" + $230171b9a5f53835$var$Nf;
function $230171b9a5f53835$var$Wc(a) {
    var b = a[$230171b9a5f53835$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$230171b9a5f53835$var$uf] || c[$230171b9a5f53835$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $230171b9a5f53835$var$Mf(a); null !== a;){
                if (c = a[$230171b9a5f53835$var$Of]) return c;
                a = $230171b9a5f53835$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $230171b9a5f53835$var$Cb(a) {
    a = a[$230171b9a5f53835$var$Of] || a[$230171b9a5f53835$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $230171b9a5f53835$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($230171b9a5f53835$var$p(33));
}
function $230171b9a5f53835$var$Db(a) {
    return a[$230171b9a5f53835$var$Pf] || null;
}
var $230171b9a5f53835$var$Sf = [], $230171b9a5f53835$var$Tf = -1;
function $230171b9a5f53835$var$Uf(a) {
    return {
        current: a
    };
}
function $230171b9a5f53835$var$E(a) {
    0 > $230171b9a5f53835$var$Tf || (a.current = $230171b9a5f53835$var$Sf[$230171b9a5f53835$var$Tf], $230171b9a5f53835$var$Sf[$230171b9a5f53835$var$Tf] = null, $230171b9a5f53835$var$Tf--);
}
function $230171b9a5f53835$var$G(a, b) {
    $230171b9a5f53835$var$Tf++;
    $230171b9a5f53835$var$Sf[$230171b9a5f53835$var$Tf] = a.current;
    a.current = b;
}
var $230171b9a5f53835$var$Vf = {}, $230171b9a5f53835$var$H = $230171b9a5f53835$var$Uf($230171b9a5f53835$var$Vf), $230171b9a5f53835$var$Wf = $230171b9a5f53835$var$Uf(!1), $230171b9a5f53835$var$Xf = $230171b9a5f53835$var$Vf;
function $230171b9a5f53835$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $230171b9a5f53835$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $230171b9a5f53835$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $230171b9a5f53835$var$$f() {
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf);
    $230171b9a5f53835$var$E($230171b9a5f53835$var$H);
}
function $230171b9a5f53835$var$ag(a, b, c) {
    if ($230171b9a5f53835$var$H.current !== $230171b9a5f53835$var$Vf) throw Error($230171b9a5f53835$var$p(168));
    $230171b9a5f53835$var$G($230171b9a5f53835$var$H, b);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Wf, c);
}
function $230171b9a5f53835$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($230171b9a5f53835$var$p(108, $230171b9a5f53835$var$Ra(a) || "Unknown", e));
    return $230171b9a5f53835$var$A({}, c, d);
}
function $230171b9a5f53835$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $230171b9a5f53835$var$Vf;
    $230171b9a5f53835$var$Xf = $230171b9a5f53835$var$H.current;
    $230171b9a5f53835$var$G($230171b9a5f53835$var$H, a);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Wf, $230171b9a5f53835$var$Wf.current);
    return !0;
}
function $230171b9a5f53835$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($230171b9a5f53835$var$p(169));
    c ? (a = $230171b9a5f53835$var$bg(a, b, $230171b9a5f53835$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf), $230171b9a5f53835$var$E($230171b9a5f53835$var$H), $230171b9a5f53835$var$G($230171b9a5f53835$var$H, a)) : $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Wf, c);
}
var $230171b9a5f53835$var$eg = null, $230171b9a5f53835$var$fg = !1, $230171b9a5f53835$var$gg = !1;
function $230171b9a5f53835$var$hg(a) {
    null === $230171b9a5f53835$var$eg ? $230171b9a5f53835$var$eg = [
        a
    ] : $230171b9a5f53835$var$eg.push(a);
}
function $230171b9a5f53835$var$ig(a) {
    $230171b9a5f53835$var$fg = !0;
    $230171b9a5f53835$var$hg(a);
}
function $230171b9a5f53835$var$jg() {
    if (!$230171b9a5f53835$var$gg && null !== $230171b9a5f53835$var$eg) {
        $230171b9a5f53835$var$gg = !0;
        var a = 0, b = $230171b9a5f53835$var$C;
        try {
            var c = $230171b9a5f53835$var$eg;
            for($230171b9a5f53835$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $230171b9a5f53835$var$eg = null;
            $230171b9a5f53835$var$fg = !1;
        } catch (e) {
            throw null !== $230171b9a5f53835$var$eg && ($230171b9a5f53835$var$eg = $230171b9a5f53835$var$eg.slice(a + 1)), $230171b9a5f53835$var$ac($230171b9a5f53835$var$fc, $230171b9a5f53835$var$jg), e;
        } finally{
            $230171b9a5f53835$var$C = b, $230171b9a5f53835$var$gg = !1;
        }
    }
    return null;
}
var $230171b9a5f53835$var$kg = [], $230171b9a5f53835$var$lg = 0, $230171b9a5f53835$var$mg = null, $230171b9a5f53835$var$ng = 0, $230171b9a5f53835$var$og = [], $230171b9a5f53835$var$pg = 0, $230171b9a5f53835$var$qg = null, $230171b9a5f53835$var$rg = 1, $230171b9a5f53835$var$sg = "";
function $230171b9a5f53835$var$tg(a, b) {
    $230171b9a5f53835$var$kg[$230171b9a5f53835$var$lg++] = $230171b9a5f53835$var$ng;
    $230171b9a5f53835$var$kg[$230171b9a5f53835$var$lg++] = $230171b9a5f53835$var$mg;
    $230171b9a5f53835$var$mg = a;
    $230171b9a5f53835$var$ng = b;
}
function $230171b9a5f53835$var$ug(a, b, c) {
    $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$rg;
    $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$sg;
    $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$qg;
    $230171b9a5f53835$var$qg = a;
    var d = $230171b9a5f53835$var$rg;
    a = $230171b9a5f53835$var$sg;
    var e = 32 - $230171b9a5f53835$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $230171b9a5f53835$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $230171b9a5f53835$var$rg = 1 << 32 - $230171b9a5f53835$var$oc(b) + e | c << e | d;
        $230171b9a5f53835$var$sg = f + a;
    } else $230171b9a5f53835$var$rg = 1 << f | c << e | d, $230171b9a5f53835$var$sg = a;
}
function $230171b9a5f53835$var$vg(a) {
    null !== a.return && ($230171b9a5f53835$var$tg(a, 1), $230171b9a5f53835$var$ug(a, 1, 0));
}
function $230171b9a5f53835$var$wg(a) {
    for(; a === $230171b9a5f53835$var$mg;)$230171b9a5f53835$var$mg = $230171b9a5f53835$var$kg[--$230171b9a5f53835$var$lg], $230171b9a5f53835$var$kg[$230171b9a5f53835$var$lg] = null, $230171b9a5f53835$var$ng = $230171b9a5f53835$var$kg[--$230171b9a5f53835$var$lg], $230171b9a5f53835$var$kg[$230171b9a5f53835$var$lg] = null;
    for(; a === $230171b9a5f53835$var$qg;)$230171b9a5f53835$var$qg = $230171b9a5f53835$var$og[--$230171b9a5f53835$var$pg], $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg] = null, $230171b9a5f53835$var$sg = $230171b9a5f53835$var$og[--$230171b9a5f53835$var$pg], $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg] = null, $230171b9a5f53835$var$rg = $230171b9a5f53835$var$og[--$230171b9a5f53835$var$pg], $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg] = null;
}
var $230171b9a5f53835$var$xg = null, $230171b9a5f53835$var$yg = null, $230171b9a5f53835$var$I = !1, $230171b9a5f53835$var$zg = null;
function $230171b9a5f53835$var$Ag(a, b) {
    var c = $230171b9a5f53835$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $230171b9a5f53835$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $230171b9a5f53835$var$xg = a, $230171b9a5f53835$var$yg = $230171b9a5f53835$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $230171b9a5f53835$var$xg = a, $230171b9a5f53835$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $230171b9a5f53835$var$qg ? {
                id: $230171b9a5f53835$var$rg,
                overflow: $230171b9a5f53835$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $230171b9a5f53835$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $230171b9a5f53835$var$xg = a, $230171b9a5f53835$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $230171b9a5f53835$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $230171b9a5f53835$var$Eg(a) {
    if ($230171b9a5f53835$var$I) {
        var b = $230171b9a5f53835$var$yg;
        if (b) {
            var c = b;
            if (!$230171b9a5f53835$var$Cg(a, b)) {
                if ($230171b9a5f53835$var$Dg(a)) throw Error($230171b9a5f53835$var$p(418));
                b = $230171b9a5f53835$var$Lf(c.nextSibling);
                var d = $230171b9a5f53835$var$xg;
                b && $230171b9a5f53835$var$Cg(a, b) ? $230171b9a5f53835$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $230171b9a5f53835$var$I = !1, $230171b9a5f53835$var$xg = a);
            }
        } else {
            if ($230171b9a5f53835$var$Dg(a)) throw Error($230171b9a5f53835$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $230171b9a5f53835$var$I = !1;
            $230171b9a5f53835$var$xg = a;
        }
    }
}
function $230171b9a5f53835$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $230171b9a5f53835$var$xg = a;
}
function $230171b9a5f53835$var$Gg(a) {
    if (a !== $230171b9a5f53835$var$xg) return !1;
    if (!$230171b9a5f53835$var$I) return $230171b9a5f53835$var$Fg(a), $230171b9a5f53835$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$230171b9a5f53835$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $230171b9a5f53835$var$yg)) {
        if ($230171b9a5f53835$var$Dg(a)) throw $230171b9a5f53835$var$Hg(), Error($230171b9a5f53835$var$p(418));
        for(; b;)$230171b9a5f53835$var$Ag(a, b), b = $230171b9a5f53835$var$Lf(b.nextSibling);
    }
    $230171b9a5f53835$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($230171b9a5f53835$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $230171b9a5f53835$var$yg = $230171b9a5f53835$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $230171b9a5f53835$var$yg = null;
        }
    } else $230171b9a5f53835$var$yg = $230171b9a5f53835$var$xg ? $230171b9a5f53835$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $230171b9a5f53835$var$Hg() {
    for(var a = $230171b9a5f53835$var$yg; a;)a = $230171b9a5f53835$var$Lf(a.nextSibling);
}
function $230171b9a5f53835$var$Ig() {
    $230171b9a5f53835$var$yg = $230171b9a5f53835$var$xg = null;
    $230171b9a5f53835$var$I = !1;
}
function $230171b9a5f53835$var$Jg(a) {
    null === $230171b9a5f53835$var$zg ? $230171b9a5f53835$var$zg = [
        a
    ] : $230171b9a5f53835$var$zg.push(a);
}
var $230171b9a5f53835$var$Kg = $230171b9a5f53835$var$ua.ReactCurrentBatchConfig;
function $230171b9a5f53835$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $230171b9a5f53835$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $230171b9a5f53835$var$Mg = $230171b9a5f53835$var$Uf(null), $230171b9a5f53835$var$Ng = null, $230171b9a5f53835$var$Og = null, $230171b9a5f53835$var$Pg = null;
function $230171b9a5f53835$var$Qg() {
    $230171b9a5f53835$var$Pg = $230171b9a5f53835$var$Og = $230171b9a5f53835$var$Ng = null;
}
function $230171b9a5f53835$var$Rg(a) {
    var b = $230171b9a5f53835$var$Mg.current;
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Mg);
    a._currentValue = b;
}
function $230171b9a5f53835$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $230171b9a5f53835$var$Tg(a, b) {
    $230171b9a5f53835$var$Ng = a;
    $230171b9a5f53835$var$Pg = $230171b9a5f53835$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($230171b9a5f53835$var$Ug = !0), a.firstContext = null);
}
function $230171b9a5f53835$var$Vg(a) {
    var b = a._currentValue;
    if ($230171b9a5f53835$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $230171b9a5f53835$var$Og) {
            if (null === $230171b9a5f53835$var$Ng) throw Error($230171b9a5f53835$var$p(308));
            $230171b9a5f53835$var$Og = a;
            $230171b9a5f53835$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $230171b9a5f53835$var$Og = $230171b9a5f53835$var$Og.next = a;
    }
    return b;
}
var $230171b9a5f53835$var$Wg = null;
function $230171b9a5f53835$var$Xg(a) {
    null === $230171b9a5f53835$var$Wg ? $230171b9a5f53835$var$Wg = [
        a
    ] : $230171b9a5f53835$var$Wg.push(a);
}
function $230171b9a5f53835$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $230171b9a5f53835$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $230171b9a5f53835$var$Zg(a, d);
}
function $230171b9a5f53835$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $230171b9a5f53835$var$$g = !1;
function $230171b9a5f53835$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $230171b9a5f53835$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $230171b9a5f53835$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $230171b9a5f53835$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($230171b9a5f53835$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $230171b9a5f53835$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $230171b9a5f53835$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $230171b9a5f53835$var$Zg(a, c);
}
function $230171b9a5f53835$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $230171b9a5f53835$var$Cc(a, c);
    }
}
function $230171b9a5f53835$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $230171b9a5f53835$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $230171b9a5f53835$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $230171b9a5f53835$var$A({}, q, r);
                            break a;
                        case 2:
                            $230171b9a5f53835$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $230171b9a5f53835$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $230171b9a5f53835$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($230171b9a5f53835$var$p(191, e));
            e.call(d);
        }
    }
}
var $230171b9a5f53835$var$jh = (new $3KGP8.Component).refs;
function $230171b9a5f53835$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $230171b9a5f53835$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $230171b9a5f53835$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $230171b9a5f53835$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $230171b9a5f53835$var$L(), e = $230171b9a5f53835$var$lh(a), f = $230171b9a5f53835$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $230171b9a5f53835$var$dh(a, f, e);
        null !== b && ($230171b9a5f53835$var$mh(b, a, e, d), $230171b9a5f53835$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $230171b9a5f53835$var$L(), e = $230171b9a5f53835$var$lh(a), f = $230171b9a5f53835$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $230171b9a5f53835$var$dh(a, f, e);
        null !== b && ($230171b9a5f53835$var$mh(b, a, e, d), $230171b9a5f53835$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $230171b9a5f53835$var$L(), d = $230171b9a5f53835$var$lh(a), e = $230171b9a5f53835$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $230171b9a5f53835$var$dh(a, e, d);
        null !== b && ($230171b9a5f53835$var$mh(b, a, d, c), $230171b9a5f53835$var$eh(b, a, d));
    }
};
function $230171b9a5f53835$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$230171b9a5f53835$var$Ie(c, d) || !$230171b9a5f53835$var$Ie(e, f) : !0;
}
function $230171b9a5f53835$var$ph(a, b, c) {
    var d = !1, e = $230171b9a5f53835$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $230171b9a5f53835$var$Vg(f) : (e = $230171b9a5f53835$var$Zf(b) ? $230171b9a5f53835$var$Xf : $230171b9a5f53835$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $230171b9a5f53835$var$Yf(a, e) : $230171b9a5f53835$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $230171b9a5f53835$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $230171b9a5f53835$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $230171b9a5f53835$var$nh.enqueueReplaceState(b, b.state, null);
}
function $230171b9a5f53835$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $230171b9a5f53835$var$jh;
    $230171b9a5f53835$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $230171b9a5f53835$var$Vg(f) : (f = $230171b9a5f53835$var$Zf(b) ? $230171b9a5f53835$var$Xf : $230171b9a5f53835$var$H.current, e.context = $230171b9a5f53835$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($230171b9a5f53835$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $230171b9a5f53835$var$nh.enqueueReplaceState(e, e.state, null), $230171b9a5f53835$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $230171b9a5f53835$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($230171b9a5f53835$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($230171b9a5f53835$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $230171b9a5f53835$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($230171b9a5f53835$var$p(284));
        if (!c._owner) throw Error($230171b9a5f53835$var$p(290, a));
    }
    return a;
}
function $230171b9a5f53835$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($230171b9a5f53835$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $230171b9a5f53835$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $230171b9a5f53835$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $230171b9a5f53835$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $230171b9a5f53835$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $230171b9a5f53835$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $230171b9a5f53835$var$Ha && $230171b9a5f53835$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $230171b9a5f53835$var$sh(a, b, c), d.return = a, d;
        d = $230171b9a5f53835$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $230171b9a5f53835$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $230171b9a5f53835$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $230171b9a5f53835$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $230171b9a5f53835$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $230171b9a5f53835$var$va:
                    return c = $230171b9a5f53835$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $230171b9a5f53835$var$sh(a, null, b), c.return = a, c;
                case $230171b9a5f53835$var$wa:
                    return b = $230171b9a5f53835$var$zh(b, a.mode, c), b.return = a, b;
                case $230171b9a5f53835$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($230171b9a5f53835$var$eb(b) || $230171b9a5f53835$var$Ka(b)) return b = $230171b9a5f53835$var$Ah(b, a.mode, c, null), b.return = a, b;
            $230171b9a5f53835$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $230171b9a5f53835$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $230171b9a5f53835$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $230171b9a5f53835$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($230171b9a5f53835$var$eb(c) || $230171b9a5f53835$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $230171b9a5f53835$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $230171b9a5f53835$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $230171b9a5f53835$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $230171b9a5f53835$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($230171b9a5f53835$var$eb(d) || $230171b9a5f53835$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $230171b9a5f53835$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $230171b9a5f53835$var$Ka(h);
        if ("function" !== typeof l) throw Error($230171b9a5f53835$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($230171b9a5f53835$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $230171b9a5f53835$var$I && $230171b9a5f53835$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $230171b9a5f53835$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $230171b9a5f53835$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $230171b9a5f53835$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $230171b9a5f53835$var$Ha && $230171b9a5f53835$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $230171b9a5f53835$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $230171b9a5f53835$var$ya ? (d = $230171b9a5f53835$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $230171b9a5f53835$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $230171b9a5f53835$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $230171b9a5f53835$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $230171b9a5f53835$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $230171b9a5f53835$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($230171b9a5f53835$var$eb(f)) return n(a, d, f, h);
            if ($230171b9a5f53835$var$Ka(f)) return t(a, d, f, h);
            $230171b9a5f53835$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $230171b9a5f53835$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $230171b9a5f53835$var$Bh = $230171b9a5f53835$var$vh(!0), $230171b9a5f53835$var$Ch = $230171b9a5f53835$var$vh(!1), $230171b9a5f53835$var$Dh = {}, $230171b9a5f53835$var$Eh = $230171b9a5f53835$var$Uf($230171b9a5f53835$var$Dh), $230171b9a5f53835$var$Fh = $230171b9a5f53835$var$Uf($230171b9a5f53835$var$Dh), $230171b9a5f53835$var$Gh = $230171b9a5f53835$var$Uf($230171b9a5f53835$var$Dh);
function $230171b9a5f53835$var$Hh(a) {
    if (a === $230171b9a5f53835$var$Dh) throw Error($230171b9a5f53835$var$p(174));
    return a;
}
function $230171b9a5f53835$var$Ih(a, b) {
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Gh, b);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Fh, a);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Eh, $230171b9a5f53835$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $230171b9a5f53835$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $230171b9a5f53835$var$lb(b, a);
    }
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Eh);
    $230171b9a5f53835$var$G($230171b9a5f53835$var$Eh, b);
}
function $230171b9a5f53835$var$Jh() {
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Eh);
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Fh);
    $230171b9a5f53835$var$E($230171b9a5f53835$var$Gh);
}
function $230171b9a5f53835$var$Kh(a) {
    $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Gh.current);
    var b = $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Eh.current);
    var c = $230171b9a5f53835$var$lb(b, a.type);
    b !== c && ($230171b9a5f53835$var$G($230171b9a5f53835$var$Fh, a), $230171b9a5f53835$var$G($230171b9a5f53835$var$Eh, c));
}
function $230171b9a5f53835$var$Lh(a) {
    $230171b9a5f53835$var$Fh.current === a && ($230171b9a5f53835$var$E($230171b9a5f53835$var$Eh), $230171b9a5f53835$var$E($230171b9a5f53835$var$Fh));
}
var $230171b9a5f53835$var$M = $230171b9a5f53835$var$Uf(0);
function $230171b9a5f53835$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $230171b9a5f53835$var$Nh = [];
function $230171b9a5f53835$var$Oh() {
    for(var a = 0; a < $230171b9a5f53835$var$Nh.length; a++)$230171b9a5f53835$var$Nh[a]._workInProgressVersionPrimary = null;
    $230171b9a5f53835$var$Nh.length = 0;
}
var $230171b9a5f53835$var$Ph = $230171b9a5f53835$var$ua.ReactCurrentDispatcher, $230171b9a5f53835$var$Qh = $230171b9a5f53835$var$ua.ReactCurrentBatchConfig, $230171b9a5f53835$var$Rh = 0, $230171b9a5f53835$var$N = null, $230171b9a5f53835$var$O = null, $230171b9a5f53835$var$P = null, $230171b9a5f53835$var$Sh = !1, $230171b9a5f53835$var$Th = !1, $230171b9a5f53835$var$Uh = 0, $230171b9a5f53835$var$Vh = 0;
function $230171b9a5f53835$var$Q() {
    throw Error($230171b9a5f53835$var$p(321));
}
function $230171b9a5f53835$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$230171b9a5f53835$var$He(a[c], b[c])) return !1;
    return !0;
}
function $230171b9a5f53835$var$Xh(a, b, c, d, e, f) {
    $230171b9a5f53835$var$Rh = f;
    $230171b9a5f53835$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $230171b9a5f53835$var$Ph.current = null === a || null === a.memoizedState ? $230171b9a5f53835$var$Yh : $230171b9a5f53835$var$Zh;
    a = c(d, e);
    if ($230171b9a5f53835$var$Th) {
        f = 0;
        do {
            $230171b9a5f53835$var$Th = !1;
            $230171b9a5f53835$var$Uh = 0;
            if (25 <= f) throw Error($230171b9a5f53835$var$p(301));
            f += 1;
            $230171b9a5f53835$var$P = $230171b9a5f53835$var$O = null;
            b.updateQueue = null;
            $230171b9a5f53835$var$Ph.current = $230171b9a5f53835$var$$h;
            a = c(d, e);
        }while ($230171b9a5f53835$var$Th);
    }
    $230171b9a5f53835$var$Ph.current = $230171b9a5f53835$var$ai;
    b = null !== $230171b9a5f53835$var$O && null !== $230171b9a5f53835$var$O.next;
    $230171b9a5f53835$var$Rh = 0;
    $230171b9a5f53835$var$P = $230171b9a5f53835$var$O = $230171b9a5f53835$var$N = null;
    $230171b9a5f53835$var$Sh = !1;
    if (b) throw Error($230171b9a5f53835$var$p(300));
    return a;
}
function $230171b9a5f53835$var$bi() {
    var a = 0 !== $230171b9a5f53835$var$Uh;
    $230171b9a5f53835$var$Uh = 0;
    return a;
}
function $230171b9a5f53835$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $230171b9a5f53835$var$P ? $230171b9a5f53835$var$N.memoizedState = $230171b9a5f53835$var$P = a : $230171b9a5f53835$var$P = $230171b9a5f53835$var$P.next = a;
    return $230171b9a5f53835$var$P;
}
function $230171b9a5f53835$var$di() {
    if (null === $230171b9a5f53835$var$O) {
        var a = $230171b9a5f53835$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $230171b9a5f53835$var$O.next;
    var b = null === $230171b9a5f53835$var$P ? $230171b9a5f53835$var$N.memoizedState : $230171b9a5f53835$var$P.next;
    if (null !== b) $230171b9a5f53835$var$P = b, $230171b9a5f53835$var$O = a;
    else {
        if (null === a) throw Error($230171b9a5f53835$var$p(310));
        $230171b9a5f53835$var$O = a;
        a = {
            memoizedState: $230171b9a5f53835$var$O.memoizedState,
            baseState: $230171b9a5f53835$var$O.baseState,
            baseQueue: $230171b9a5f53835$var$O.baseQueue,
            queue: $230171b9a5f53835$var$O.queue,
            next: null
        };
        null === $230171b9a5f53835$var$P ? $230171b9a5f53835$var$N.memoizedState = $230171b9a5f53835$var$P = a : $230171b9a5f53835$var$P = $230171b9a5f53835$var$P.next = a;
    }
    return $230171b9a5f53835$var$P;
}
function $230171b9a5f53835$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $230171b9a5f53835$var$fi(a) {
    var b = $230171b9a5f53835$var$di(), c = b.queue;
    if (null === c) throw Error($230171b9a5f53835$var$p(311));
    c.lastRenderedReducer = a;
    var d = $230171b9a5f53835$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($230171b9a5f53835$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $230171b9a5f53835$var$N.lanes |= m;
                $230171b9a5f53835$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $230171b9a5f53835$var$He(d, b.memoizedState) || ($230171b9a5f53835$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $230171b9a5f53835$var$N.lanes |= f, $230171b9a5f53835$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $230171b9a5f53835$var$gi(a) {
    var b = $230171b9a5f53835$var$di(), c = b.queue;
    if (null === c) throw Error($230171b9a5f53835$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $230171b9a5f53835$var$He(f, b.memoizedState) || ($230171b9a5f53835$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $230171b9a5f53835$var$hi() {}
function $230171b9a5f53835$var$ii(a, b) {
    var c = $230171b9a5f53835$var$N, d = $230171b9a5f53835$var$di(), e = b(), f = !$230171b9a5f53835$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $230171b9a5f53835$var$Ug = !0);
    d = d.queue;
    $230171b9a5f53835$var$ji($230171b9a5f53835$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $230171b9a5f53835$var$P && $230171b9a5f53835$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $230171b9a5f53835$var$li(9, $230171b9a5f53835$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $230171b9a5f53835$var$R) throw Error($230171b9a5f53835$var$p(349));
        0 !== ($230171b9a5f53835$var$Rh & 30) || $230171b9a5f53835$var$ni(c, b, e);
    }
    return e;
}
function $230171b9a5f53835$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $230171b9a5f53835$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $230171b9a5f53835$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $230171b9a5f53835$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $230171b9a5f53835$var$oi(b) && $230171b9a5f53835$var$pi(a);
}
function $230171b9a5f53835$var$ki(a, b, c) {
    return c(function() {
        $230171b9a5f53835$var$oi(b) && $230171b9a5f53835$var$pi(a);
    });
}
function $230171b9a5f53835$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$230171b9a5f53835$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $230171b9a5f53835$var$pi(a) {
    var b = $230171b9a5f53835$var$Zg(a, 1);
    null !== b && $230171b9a5f53835$var$mh(b, a, 1, -1);
}
function $230171b9a5f53835$var$qi(a) {
    var b = $230171b9a5f53835$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $230171b9a5f53835$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $230171b9a5f53835$var$ri.bind(null, $230171b9a5f53835$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $230171b9a5f53835$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $230171b9a5f53835$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $230171b9a5f53835$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $230171b9a5f53835$var$si() {
    return $230171b9a5f53835$var$di().memoizedState;
}
function $230171b9a5f53835$var$ti(a, b, c, d) {
    var e = $230171b9a5f53835$var$ci();
    $230171b9a5f53835$var$N.flags |= a;
    e.memoizedState = $230171b9a5f53835$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $230171b9a5f53835$var$ui(a, b, c, d) {
    var e = $230171b9a5f53835$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $230171b9a5f53835$var$O) {
        var g = $230171b9a5f53835$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $230171b9a5f53835$var$Wh(d, g.deps)) {
            e.memoizedState = $230171b9a5f53835$var$li(b, c, f, d);
            return;
        }
    }
    $230171b9a5f53835$var$N.flags |= a;
    e.memoizedState = $230171b9a5f53835$var$li(1 | b, c, f, d);
}
function $230171b9a5f53835$var$vi(a, b) {
    return $230171b9a5f53835$var$ti(8390656, 8, a, b);
}
function $230171b9a5f53835$var$ji(a, b) {
    return $230171b9a5f53835$var$ui(2048, 8, a, b);
}
function $230171b9a5f53835$var$wi(a, b) {
    return $230171b9a5f53835$var$ui(4, 2, a, b);
}
function $230171b9a5f53835$var$xi(a, b) {
    return $230171b9a5f53835$var$ui(4, 4, a, b);
}
function $230171b9a5f53835$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $230171b9a5f53835$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $230171b9a5f53835$var$ui(4, 4, $230171b9a5f53835$var$yi.bind(null, b, a), c);
}
function $230171b9a5f53835$var$Ai() {}
function $230171b9a5f53835$var$Bi(a, b) {
    var c = $230171b9a5f53835$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $230171b9a5f53835$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $230171b9a5f53835$var$Ci(a, b) {
    var c = $230171b9a5f53835$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $230171b9a5f53835$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $230171b9a5f53835$var$Di(a, b, c) {
    if (0 === ($230171b9a5f53835$var$Rh & 21)) return a.baseState && (a.baseState = !1, $230171b9a5f53835$var$Ug = !0), a.memoizedState = c;
    $230171b9a5f53835$var$He(c, b) || (c = $230171b9a5f53835$var$yc(), $230171b9a5f53835$var$N.lanes |= c, $230171b9a5f53835$var$hh |= c, a.baseState = !0);
    return b;
}
function $230171b9a5f53835$var$Ei(a, b) {
    var c = $230171b9a5f53835$var$C;
    $230171b9a5f53835$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $230171b9a5f53835$var$Qh.transition;
    $230171b9a5f53835$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $230171b9a5f53835$var$C = c, $230171b9a5f53835$var$Qh.transition = d;
    }
}
function $230171b9a5f53835$var$Fi() {
    return $230171b9a5f53835$var$di().memoizedState;
}
function $230171b9a5f53835$var$Gi(a, b, c) {
    var d = $230171b9a5f53835$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($230171b9a5f53835$var$Hi(a)) $230171b9a5f53835$var$Ii(b, c);
    else if (c = $230171b9a5f53835$var$Yg(a, b, c, d), null !== c) {
        var e = $230171b9a5f53835$var$L();
        $230171b9a5f53835$var$mh(c, a, d, e);
        $230171b9a5f53835$var$Ji(c, b, d);
    }
}
function $230171b9a5f53835$var$ri(a, b, c) {
    var d = $230171b9a5f53835$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($230171b9a5f53835$var$Hi(a)) $230171b9a5f53835$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($230171b9a5f53835$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $230171b9a5f53835$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $230171b9a5f53835$var$Yg(a, b, e, d);
        null !== c && (e = $230171b9a5f53835$var$L(), $230171b9a5f53835$var$mh(c, a, d, e), $230171b9a5f53835$var$Ji(c, b, d));
    }
}
function $230171b9a5f53835$var$Hi(a) {
    var b = a.alternate;
    return a === $230171b9a5f53835$var$N || null !== b && b === $230171b9a5f53835$var$N;
}
function $230171b9a5f53835$var$Ii(a, b) {
    $230171b9a5f53835$var$Th = $230171b9a5f53835$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $230171b9a5f53835$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $230171b9a5f53835$var$Cc(a, c);
    }
}
var $230171b9a5f53835$var$ai = {
    readContext: $230171b9a5f53835$var$Vg,
    useCallback: $230171b9a5f53835$var$Q,
    useContext: $230171b9a5f53835$var$Q,
    useEffect: $230171b9a5f53835$var$Q,
    useImperativeHandle: $230171b9a5f53835$var$Q,
    useInsertionEffect: $230171b9a5f53835$var$Q,
    useLayoutEffect: $230171b9a5f53835$var$Q,
    useMemo: $230171b9a5f53835$var$Q,
    useReducer: $230171b9a5f53835$var$Q,
    useRef: $230171b9a5f53835$var$Q,
    useState: $230171b9a5f53835$var$Q,
    useDebugValue: $230171b9a5f53835$var$Q,
    useDeferredValue: $230171b9a5f53835$var$Q,
    useTransition: $230171b9a5f53835$var$Q,
    useMutableSource: $230171b9a5f53835$var$Q,
    useSyncExternalStore: $230171b9a5f53835$var$Q,
    useId: $230171b9a5f53835$var$Q,
    unstable_isNewReconciler: !1
}, $230171b9a5f53835$var$Yh = {
    readContext: $230171b9a5f53835$var$Vg,
    useCallback: function(a, b) {
        $230171b9a5f53835$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $230171b9a5f53835$var$Vg,
    useEffect: $230171b9a5f53835$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $230171b9a5f53835$var$ti(4194308, 4, $230171b9a5f53835$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $230171b9a5f53835$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $230171b9a5f53835$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $230171b9a5f53835$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $230171b9a5f53835$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $230171b9a5f53835$var$Gi.bind(null, $230171b9a5f53835$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $230171b9a5f53835$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $230171b9a5f53835$var$qi,
    useDebugValue: $230171b9a5f53835$var$Ai,
    useDeferredValue: function(a) {
        return $230171b9a5f53835$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $230171b9a5f53835$var$qi(!1), b = a[0];
        a = $230171b9a5f53835$var$Ei.bind(null, a[1]);
        $230171b9a5f53835$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $230171b9a5f53835$var$N, e = $230171b9a5f53835$var$ci();
        if ($230171b9a5f53835$var$I) {
            if (void 0 === c) throw Error($230171b9a5f53835$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $230171b9a5f53835$var$R) throw Error($230171b9a5f53835$var$p(349));
            0 !== ($230171b9a5f53835$var$Rh & 30) || $230171b9a5f53835$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $230171b9a5f53835$var$vi($230171b9a5f53835$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $230171b9a5f53835$var$li(9, $230171b9a5f53835$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $230171b9a5f53835$var$ci(), b = $230171b9a5f53835$var$R.identifierPrefix;
        if ($230171b9a5f53835$var$I) {
            var c = $230171b9a5f53835$var$sg;
            var d = $230171b9a5f53835$var$rg;
            c = (d & ~(1 << 32 - $230171b9a5f53835$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $230171b9a5f53835$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $230171b9a5f53835$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $230171b9a5f53835$var$Zh = {
    readContext: $230171b9a5f53835$var$Vg,
    useCallback: $230171b9a5f53835$var$Bi,
    useContext: $230171b9a5f53835$var$Vg,
    useEffect: $230171b9a5f53835$var$ji,
    useImperativeHandle: $230171b9a5f53835$var$zi,
    useInsertionEffect: $230171b9a5f53835$var$wi,
    useLayoutEffect: $230171b9a5f53835$var$xi,
    useMemo: $230171b9a5f53835$var$Ci,
    useReducer: $230171b9a5f53835$var$fi,
    useRef: $230171b9a5f53835$var$si,
    useState: function() {
        return $230171b9a5f53835$var$fi($230171b9a5f53835$var$ei);
    },
    useDebugValue: $230171b9a5f53835$var$Ai,
    useDeferredValue: function(a) {
        var b = $230171b9a5f53835$var$di();
        return $230171b9a5f53835$var$Di(b, $230171b9a5f53835$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $230171b9a5f53835$var$fi($230171b9a5f53835$var$ei)[0], b = $230171b9a5f53835$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $230171b9a5f53835$var$hi,
    useSyncExternalStore: $230171b9a5f53835$var$ii,
    useId: $230171b9a5f53835$var$Fi,
    unstable_isNewReconciler: !1
}, $230171b9a5f53835$var$$h = {
    readContext: $230171b9a5f53835$var$Vg,
    useCallback: $230171b9a5f53835$var$Bi,
    useContext: $230171b9a5f53835$var$Vg,
    useEffect: $230171b9a5f53835$var$ji,
    useImperativeHandle: $230171b9a5f53835$var$zi,
    useInsertionEffect: $230171b9a5f53835$var$wi,
    useLayoutEffect: $230171b9a5f53835$var$xi,
    useMemo: $230171b9a5f53835$var$Ci,
    useReducer: $230171b9a5f53835$var$gi,
    useRef: $230171b9a5f53835$var$si,
    useState: function() {
        return $230171b9a5f53835$var$gi($230171b9a5f53835$var$ei);
    },
    useDebugValue: $230171b9a5f53835$var$Ai,
    useDeferredValue: function(a) {
        var b = $230171b9a5f53835$var$di();
        return null === $230171b9a5f53835$var$O ? b.memoizedState = a : $230171b9a5f53835$var$Di(b, $230171b9a5f53835$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $230171b9a5f53835$var$gi($230171b9a5f53835$var$ei)[0], b = $230171b9a5f53835$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $230171b9a5f53835$var$hi,
    useSyncExternalStore: $230171b9a5f53835$var$ii,
    useId: $230171b9a5f53835$var$Fi,
    unstable_isNewReconciler: !1
};
function $230171b9a5f53835$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $230171b9a5f53835$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $230171b9a5f53835$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $230171b9a5f53835$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $230171b9a5f53835$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $230171b9a5f53835$var$Oi(a, b, c) {
    c = $230171b9a5f53835$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $230171b9a5f53835$var$Pi || ($230171b9a5f53835$var$Pi = !0, $230171b9a5f53835$var$Qi = d);
        $230171b9a5f53835$var$Mi(a, b);
    };
    return c;
}
function $230171b9a5f53835$var$Ri(a, b, c) {
    c = $230171b9a5f53835$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $230171b9a5f53835$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $230171b9a5f53835$var$Mi(a, b);
        "function" !== typeof d && (null === $230171b9a5f53835$var$Si ? $230171b9a5f53835$var$Si = new Set([
            this
        ]) : $230171b9a5f53835$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $230171b9a5f53835$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $230171b9a5f53835$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $230171b9a5f53835$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $230171b9a5f53835$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $230171b9a5f53835$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $230171b9a5f53835$var$ch(-1, 1), b.tag = 2, $230171b9a5f53835$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $230171b9a5f53835$var$Xi = $230171b9a5f53835$var$ua.ReactCurrentOwner, $230171b9a5f53835$var$Ug = !1;
function $230171b9a5f53835$var$Yi(a, b, c, d) {
    b.child = null === a ? $230171b9a5f53835$var$Ch(b, null, c, d) : $230171b9a5f53835$var$Bh(b, a.child, c, d);
}
function $230171b9a5f53835$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $230171b9a5f53835$var$Tg(b, e);
    d = $230171b9a5f53835$var$Xh(a, b, c, d, f, e);
    c = $230171b9a5f53835$var$bi();
    if (null !== a && !$230171b9a5f53835$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $230171b9a5f53835$var$$i(a, b, e);
    $230171b9a5f53835$var$I && c && $230171b9a5f53835$var$vg(b);
    b.flags |= 1;
    $230171b9a5f53835$var$Yi(a, b, d, e);
    return b.child;
}
function $230171b9a5f53835$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$230171b9a5f53835$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $230171b9a5f53835$var$cj(a, b, f, d, e);
        a = $230171b9a5f53835$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $230171b9a5f53835$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $230171b9a5f53835$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $230171b9a5f53835$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $230171b9a5f53835$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($230171b9a5f53835$var$Ie(f, d) && a.ref === b.ref) {
            if ($230171b9a5f53835$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($230171b9a5f53835$var$Ug = !0);
            else return b.lanes = a.lanes, $230171b9a5f53835$var$$i(a, b, e);
        }
    }
    return $230171b9a5f53835$var$dj(a, b, c, d, e);
}
function $230171b9a5f53835$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $230171b9a5f53835$var$G($230171b9a5f53835$var$fj, $230171b9a5f53835$var$gj), $230171b9a5f53835$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $230171b9a5f53835$var$G($230171b9a5f53835$var$fj, $230171b9a5f53835$var$gj), $230171b9a5f53835$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $230171b9a5f53835$var$G($230171b9a5f53835$var$fj, $230171b9a5f53835$var$gj);
            $230171b9a5f53835$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $230171b9a5f53835$var$G($230171b9a5f53835$var$fj, $230171b9a5f53835$var$gj), $230171b9a5f53835$var$gj |= d;
    $230171b9a5f53835$var$Yi(a, b, e, c);
    return b.child;
}
function $230171b9a5f53835$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $230171b9a5f53835$var$dj(a, b, c, d, e) {
    var f = $230171b9a5f53835$var$Zf(c) ? $230171b9a5f53835$var$Xf : $230171b9a5f53835$var$H.current;
    f = $230171b9a5f53835$var$Yf(b, f);
    $230171b9a5f53835$var$Tg(b, e);
    c = $230171b9a5f53835$var$Xh(a, b, c, d, f, e);
    d = $230171b9a5f53835$var$bi();
    if (null !== a && !$230171b9a5f53835$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $230171b9a5f53835$var$$i(a, b, e);
    $230171b9a5f53835$var$I && d && $230171b9a5f53835$var$vg(b);
    b.flags |= 1;
    $230171b9a5f53835$var$Yi(a, b, c, e);
    return b.child;
}
function $230171b9a5f53835$var$ij(a, b, c, d, e) {
    if ($230171b9a5f53835$var$Zf(c)) {
        var f = !0;
        $230171b9a5f53835$var$cg(b);
    } else f = !1;
    $230171b9a5f53835$var$Tg(b, e);
    if (null === b.stateNode) $230171b9a5f53835$var$jj(a, b), $230171b9a5f53835$var$ph(b, c, d), $230171b9a5f53835$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $230171b9a5f53835$var$Vg(l) : (l = $230171b9a5f53835$var$Zf(c) ? $230171b9a5f53835$var$Xf : $230171b9a5f53835$var$H.current, l = $230171b9a5f53835$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $230171b9a5f53835$var$qh(b, g, d, l);
        $230171b9a5f53835$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $230171b9a5f53835$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $230171b9a5f53835$var$Wf.current || $230171b9a5f53835$var$$g ? ("function" === typeof m && ($230171b9a5f53835$var$kh(b, c, m, d), k = b.memoizedState), (h = $230171b9a5f53835$var$$g || $230171b9a5f53835$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $230171b9a5f53835$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $230171b9a5f53835$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $230171b9a5f53835$var$Vg(k) : (k = $230171b9a5f53835$var$Zf(c) ? $230171b9a5f53835$var$Xf : $230171b9a5f53835$var$H.current, k = $230171b9a5f53835$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $230171b9a5f53835$var$qh(b, g, d, k);
        $230171b9a5f53835$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $230171b9a5f53835$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $230171b9a5f53835$var$Wf.current || $230171b9a5f53835$var$$g ? ("function" === typeof y && ($230171b9a5f53835$var$kh(b, c, y, d), n = b.memoizedState), (l = $230171b9a5f53835$var$$g || $230171b9a5f53835$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $230171b9a5f53835$var$kj(a, b, c, d, f, e);
}
function $230171b9a5f53835$var$kj(a, b, c, d, e, f) {
    $230171b9a5f53835$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $230171b9a5f53835$var$dg(b, c, !1), $230171b9a5f53835$var$$i(a, b, f);
    d = b.stateNode;
    $230171b9a5f53835$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $230171b9a5f53835$var$Bh(b, a.child, null, f), b.child = $230171b9a5f53835$var$Bh(b, null, h, f)) : $230171b9a5f53835$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $230171b9a5f53835$var$dg(b, c, !0);
    return b.child;
}
function $230171b9a5f53835$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $230171b9a5f53835$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $230171b9a5f53835$var$ag(a, b.context, !1);
    $230171b9a5f53835$var$Ih(a, b.containerInfo);
}
function $230171b9a5f53835$var$mj(a, b, c, d, e) {
    $230171b9a5f53835$var$Ig();
    $230171b9a5f53835$var$Jg(e);
    b.flags |= 256;
    $230171b9a5f53835$var$Yi(a, b, c, d);
    return b.child;
}
var $230171b9a5f53835$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $230171b9a5f53835$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $230171b9a5f53835$var$pj(a, b, c) {
    var d = b.pendingProps, e = $230171b9a5f53835$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $230171b9a5f53835$var$G($230171b9a5f53835$var$M, e & 1);
    if (null === a) {
        $230171b9a5f53835$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $230171b9a5f53835$var$qj(g, d, 0, null), a = $230171b9a5f53835$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $230171b9a5f53835$var$oj(c), b.memoizedState = $230171b9a5f53835$var$nj, a) : $230171b9a5f53835$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $230171b9a5f53835$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $230171b9a5f53835$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $230171b9a5f53835$var$wh(h, f) : (f = $230171b9a5f53835$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $230171b9a5f53835$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $230171b9a5f53835$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $230171b9a5f53835$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $230171b9a5f53835$var$rj(a, b) {
    b = $230171b9a5f53835$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $230171b9a5f53835$var$tj(a, b, c, d) {
    null !== d && $230171b9a5f53835$var$Jg(d);
    $230171b9a5f53835$var$Bh(b, a.child, null, c);
    a = $230171b9a5f53835$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $230171b9a5f53835$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $230171b9a5f53835$var$Li(Error($230171b9a5f53835$var$p(422))), $230171b9a5f53835$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $230171b9a5f53835$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $230171b9a5f53835$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $230171b9a5f53835$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $230171b9a5f53835$var$oj(g);
        b.memoizedState = $230171b9a5f53835$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $230171b9a5f53835$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($230171b9a5f53835$var$p(419));
        d = $230171b9a5f53835$var$Li(f, d, void 0);
        return $230171b9a5f53835$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($230171b9a5f53835$var$Ug || h) {
        d = $230171b9a5f53835$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $230171b9a5f53835$var$Zg(a, e), $230171b9a5f53835$var$mh(d, a, e, -1));
        }
        $230171b9a5f53835$var$uj();
        d = $230171b9a5f53835$var$Li(Error($230171b9a5f53835$var$p(421)));
        return $230171b9a5f53835$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $230171b9a5f53835$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $230171b9a5f53835$var$yg = $230171b9a5f53835$var$Lf(e.nextSibling);
    $230171b9a5f53835$var$xg = b;
    $230171b9a5f53835$var$I = !0;
    $230171b9a5f53835$var$zg = null;
    null !== a && ($230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$rg, $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$sg, $230171b9a5f53835$var$og[$230171b9a5f53835$var$pg++] = $230171b9a5f53835$var$qg, $230171b9a5f53835$var$rg = a.id, $230171b9a5f53835$var$sg = a.overflow, $230171b9a5f53835$var$qg = b);
    b = $230171b9a5f53835$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $230171b9a5f53835$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $230171b9a5f53835$var$Sg(a.return, b, c);
}
function $230171b9a5f53835$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $230171b9a5f53835$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $230171b9a5f53835$var$Yi(a, b, d.children, c);
    d = $230171b9a5f53835$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $230171b9a5f53835$var$wj(a, c, b);
            else if (19 === a.tag) $230171b9a5f53835$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $230171b9a5f53835$var$G($230171b9a5f53835$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $230171b9a5f53835$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $230171b9a5f53835$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $230171b9a5f53835$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $230171b9a5f53835$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $230171b9a5f53835$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $230171b9a5f53835$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $230171b9a5f53835$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $230171b9a5f53835$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($230171b9a5f53835$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $230171b9a5f53835$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $230171b9a5f53835$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $230171b9a5f53835$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $230171b9a5f53835$var$lj(b);
            $230171b9a5f53835$var$Ig();
            break;
        case 5:
            $230171b9a5f53835$var$Kh(b);
            break;
        case 1:
            $230171b9a5f53835$var$Zf(b.type) && $230171b9a5f53835$var$cg(b);
            break;
        case 4:
            $230171b9a5f53835$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $230171b9a5f53835$var$G($230171b9a5f53835$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $230171b9a5f53835$var$G($230171b9a5f53835$var$M, $230171b9a5f53835$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $230171b9a5f53835$var$pj(a, b, c);
                $230171b9a5f53835$var$G($230171b9a5f53835$var$M, $230171b9a5f53835$var$M.current & 1);
                a = $230171b9a5f53835$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $230171b9a5f53835$var$G($230171b9a5f53835$var$M, $230171b9a5f53835$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $230171b9a5f53835$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $230171b9a5f53835$var$G($230171b9a5f53835$var$M, $230171b9a5f53835$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $230171b9a5f53835$var$ej(a, b, c);
    }
    return $230171b9a5f53835$var$$i(a, b, c);
}
var $230171b9a5f53835$var$Aj, $230171b9a5f53835$var$Bj, $230171b9a5f53835$var$Cj, $230171b9a5f53835$var$Dj;
$230171b9a5f53835$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$230171b9a5f53835$var$Bj = function() {};
$230171b9a5f53835$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $230171b9a5f53835$var$Ya(a, e);
                d = $230171b9a5f53835$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $230171b9a5f53835$var$A({}, e, {
                    value: void 0
                });
                d = $230171b9a5f53835$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $230171b9a5f53835$var$gb(a, e);
                d = $230171b9a5f53835$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $230171b9a5f53835$var$Bf);
        }
        $230171b9a5f53835$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($230171b9a5f53835$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($230171b9a5f53835$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $230171b9a5f53835$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$230171b9a5f53835$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $230171b9a5f53835$var$Ej(a, b) {
    if (!$230171b9a5f53835$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $230171b9a5f53835$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $230171b9a5f53835$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $230171b9a5f53835$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $230171b9a5f53835$var$S(b), null;
        case 1:
            return $230171b9a5f53835$var$Zf(b.type) && $230171b9a5f53835$var$$f(), $230171b9a5f53835$var$S(b), null;
        case 3:
            d = b.stateNode;
            $230171b9a5f53835$var$Jh();
            $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf);
            $230171b9a5f53835$var$E($230171b9a5f53835$var$H);
            $230171b9a5f53835$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $230171b9a5f53835$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $230171b9a5f53835$var$zg && ($230171b9a5f53835$var$Gj($230171b9a5f53835$var$zg), $230171b9a5f53835$var$zg = null));
            $230171b9a5f53835$var$Bj(a, b);
            $230171b9a5f53835$var$S(b);
            return null;
        case 5:
            $230171b9a5f53835$var$Lh(b);
            var e = $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $230171b9a5f53835$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($230171b9a5f53835$var$p(166));
                    $230171b9a5f53835$var$S(b);
                    return null;
                }
                a = $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Eh.current);
                if ($230171b9a5f53835$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$230171b9a5f53835$var$Of] = b;
                    d[$230171b9a5f53835$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $230171b9a5f53835$var$D("cancel", d);
                            $230171b9a5f53835$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $230171b9a5f53835$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $230171b9a5f53835$var$lf.length; e++)$230171b9a5f53835$var$D($230171b9a5f53835$var$lf[e], d);
                            break;
                        case "source":
                            $230171b9a5f53835$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $230171b9a5f53835$var$D("error", d);
                            $230171b9a5f53835$var$D("load", d);
                            break;
                        case "details":
                            $230171b9a5f53835$var$D("toggle", d);
                            break;
                        case "input":
                            $230171b9a5f53835$var$Za(d, f);
                            $230171b9a5f53835$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $230171b9a5f53835$var$D("invalid", d);
                            break;
                        case "textarea":
                            $230171b9a5f53835$var$hb(d, f), $230171b9a5f53835$var$D("invalid", d);
                    }
                    $230171b9a5f53835$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $230171b9a5f53835$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $230171b9a5f53835$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $230171b9a5f53835$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $230171b9a5f53835$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $230171b9a5f53835$var$Va(d);
                            $230171b9a5f53835$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $230171b9a5f53835$var$Va(d);
                            $230171b9a5f53835$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $230171b9a5f53835$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $230171b9a5f53835$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$230171b9a5f53835$var$Of] = b;
                    a[$230171b9a5f53835$var$Pf] = d;
                    $230171b9a5f53835$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $230171b9a5f53835$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $230171b9a5f53835$var$D("cancel", a);
                                $230171b9a5f53835$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $230171b9a5f53835$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $230171b9a5f53835$var$lf.length; e++)$230171b9a5f53835$var$D($230171b9a5f53835$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $230171b9a5f53835$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $230171b9a5f53835$var$D("error", a);
                                $230171b9a5f53835$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $230171b9a5f53835$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $230171b9a5f53835$var$Za(a, d);
                                e = $230171b9a5f53835$var$Ya(a, d);
                                $230171b9a5f53835$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $230171b9a5f53835$var$A({}, d, {
                                    value: void 0
                                });
                                $230171b9a5f53835$var$D("invalid", a);
                                break;
                            case "textarea":
                                $230171b9a5f53835$var$hb(a, d);
                                e = $230171b9a5f53835$var$gb(a, d);
                                $230171b9a5f53835$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $230171b9a5f53835$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $230171b9a5f53835$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $230171b9a5f53835$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $230171b9a5f53835$var$ob(a, k) : "number" === typeof k && $230171b9a5f53835$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($230171b9a5f53835$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $230171b9a5f53835$var$D("scroll", a) : null != k && $230171b9a5f53835$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $230171b9a5f53835$var$Va(a);
                                $230171b9a5f53835$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $230171b9a5f53835$var$Va(a);
                                $230171b9a5f53835$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $230171b9a5f53835$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $230171b9a5f53835$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $230171b9a5f53835$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $230171b9a5f53835$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $230171b9a5f53835$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $230171b9a5f53835$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($230171b9a5f53835$var$p(166));
                c = $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Gh.current);
                $230171b9a5f53835$var$Hh($230171b9a5f53835$var$Eh.current);
                if ($230171b9a5f53835$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$230171b9a5f53835$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $230171b9a5f53835$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $230171b9a5f53835$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $230171b9a5f53835$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$230171b9a5f53835$var$Of] = b, b.stateNode = d;
            }
            $230171b9a5f53835$var$S(b);
            return null;
        case 13:
            $230171b9a5f53835$var$E($230171b9a5f53835$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($230171b9a5f53835$var$I && null !== $230171b9a5f53835$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $230171b9a5f53835$var$Hg(), $230171b9a5f53835$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $230171b9a5f53835$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($230171b9a5f53835$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($230171b9a5f53835$var$p(317));
                        f[$230171b9a5f53835$var$Of] = b;
                    } else $230171b9a5f53835$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $230171b9a5f53835$var$S(b);
                    f = !1;
                } else null !== $230171b9a5f53835$var$zg && ($230171b9a5f53835$var$Gj($230171b9a5f53835$var$zg), $230171b9a5f53835$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($230171b9a5f53835$var$M.current & 1) ? 0 === $230171b9a5f53835$var$T && ($230171b9a5f53835$var$T = 3) : $230171b9a5f53835$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $230171b9a5f53835$var$S(b);
            return null;
        case 4:
            return $230171b9a5f53835$var$Jh(), $230171b9a5f53835$var$Bj(a, b), null === a && $230171b9a5f53835$var$sf(b.stateNode.containerInfo), $230171b9a5f53835$var$S(b), null;
        case 10:
            return $230171b9a5f53835$var$Rg(b.type._context), $230171b9a5f53835$var$S(b), null;
        case 17:
            return $230171b9a5f53835$var$Zf(b.type) && $230171b9a5f53835$var$$f(), $230171b9a5f53835$var$S(b), null;
        case 19:
            $230171b9a5f53835$var$E($230171b9a5f53835$var$M);
            f = b.memoizedState;
            if (null === f) return $230171b9a5f53835$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $230171b9a5f53835$var$Ej(f, !1);
                else {
                    if (0 !== $230171b9a5f53835$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $230171b9a5f53835$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $230171b9a5f53835$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $230171b9a5f53835$var$G($230171b9a5f53835$var$M, $230171b9a5f53835$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $230171b9a5f53835$var$B() > $230171b9a5f53835$var$Hj && (b.flags |= 128, d = !0, $230171b9a5f53835$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $230171b9a5f53835$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $230171b9a5f53835$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$230171b9a5f53835$var$I) return $230171b9a5f53835$var$S(b), null;
                    } else 2 * $230171b9a5f53835$var$B() - f.renderingStartTime > $230171b9a5f53835$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $230171b9a5f53835$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $230171b9a5f53835$var$B(), b.sibling = null, c = $230171b9a5f53835$var$M.current, $230171b9a5f53835$var$G($230171b9a5f53835$var$M, d ? c & 1 | 2 : c & 1), b;
            $230171b9a5f53835$var$S(b);
            return null;
        case 22:
        case 23:
            return $230171b9a5f53835$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($230171b9a5f53835$var$gj & 1073741824) && ($230171b9a5f53835$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $230171b9a5f53835$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($230171b9a5f53835$var$p(156, b.tag));
}
function $230171b9a5f53835$var$Jj(a, b) {
    $230171b9a5f53835$var$wg(b);
    switch(b.tag){
        case 1:
            return $230171b9a5f53835$var$Zf(b.type) && $230171b9a5f53835$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $230171b9a5f53835$var$Jh(), $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf), $230171b9a5f53835$var$E($230171b9a5f53835$var$H), $230171b9a5f53835$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $230171b9a5f53835$var$Lh(b), null;
        case 13:
            $230171b9a5f53835$var$E($230171b9a5f53835$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($230171b9a5f53835$var$p(340));
                $230171b9a5f53835$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $230171b9a5f53835$var$E($230171b9a5f53835$var$M), null;
        case 4:
            return $230171b9a5f53835$var$Jh(), null;
        case 10:
            return $230171b9a5f53835$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $230171b9a5f53835$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $230171b9a5f53835$var$Kj = !1, $230171b9a5f53835$var$U = !1, $230171b9a5f53835$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $230171b9a5f53835$var$V = null;
function $230171b9a5f53835$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $230171b9a5f53835$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $230171b9a5f53835$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $230171b9a5f53835$var$W(a, b, d);
    }
}
var $230171b9a5f53835$var$Oj = !1;
function $230171b9a5f53835$var$Pj(a, b) {
    $230171b9a5f53835$var$Cf = $230171b9a5f53835$var$dd;
    a = $230171b9a5f53835$var$Me();
    if ($230171b9a5f53835$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $230171b9a5f53835$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $230171b9a5f53835$var$dd = !1;
    for($230171b9a5f53835$var$V = b; null !== $230171b9a5f53835$var$V;)if (b = $230171b9a5f53835$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $230171b9a5f53835$var$V = a;
    else for(; null !== $230171b9a5f53835$var$V;){
        b = $230171b9a5f53835$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $230171b9a5f53835$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($230171b9a5f53835$var$p(163));
            }
        } catch (F) {
            $230171b9a5f53835$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $230171b9a5f53835$var$V = a;
            break;
        }
        $230171b9a5f53835$var$V = b.return;
    }
    n = $230171b9a5f53835$var$Oj;
    $230171b9a5f53835$var$Oj = !1;
    return n;
}
function $230171b9a5f53835$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $230171b9a5f53835$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $230171b9a5f53835$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $230171b9a5f53835$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $230171b9a5f53835$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $230171b9a5f53835$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$230171b9a5f53835$var$Of], delete b[$230171b9a5f53835$var$Pf], delete b[$230171b9a5f53835$var$of], delete b[$230171b9a5f53835$var$Qf], delete b[$230171b9a5f53835$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $230171b9a5f53835$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $230171b9a5f53835$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $230171b9a5f53835$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $230171b9a5f53835$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $230171b9a5f53835$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($230171b9a5f53835$var$Wj(a, b, c), a = a.sibling; null !== a;)$230171b9a5f53835$var$Wj(a, b, c), a = a.sibling;
}
function $230171b9a5f53835$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($230171b9a5f53835$var$Xj(a, b, c), a = a.sibling; null !== a;)$230171b9a5f53835$var$Xj(a, b, c), a = a.sibling;
}
var $230171b9a5f53835$var$X = null, $230171b9a5f53835$var$Yj = !1;
function $230171b9a5f53835$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$230171b9a5f53835$var$ak(a, b, c), c = c.sibling;
}
function $230171b9a5f53835$var$ak(a, b, c) {
    if ($230171b9a5f53835$var$lc && "function" === typeof $230171b9a5f53835$var$lc.onCommitFiberUnmount) try {
        $230171b9a5f53835$var$lc.onCommitFiberUnmount($230171b9a5f53835$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $230171b9a5f53835$var$U || $230171b9a5f53835$var$Mj(c, b);
        case 6:
            var d = $230171b9a5f53835$var$X, e = $230171b9a5f53835$var$Yj;
            $230171b9a5f53835$var$X = null;
            $230171b9a5f53835$var$Zj(a, b, c);
            $230171b9a5f53835$var$X = d;
            $230171b9a5f53835$var$Yj = e;
            null !== $230171b9a5f53835$var$X && ($230171b9a5f53835$var$Yj ? (a = $230171b9a5f53835$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $230171b9a5f53835$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $230171b9a5f53835$var$X && ($230171b9a5f53835$var$Yj ? (a = $230171b9a5f53835$var$X, c = c.stateNode, 8 === a.nodeType ? $230171b9a5f53835$var$Kf(a.parentNode, c) : 1 === a.nodeType && $230171b9a5f53835$var$Kf(a, c), $230171b9a5f53835$var$bd(a)) : $230171b9a5f53835$var$Kf($230171b9a5f53835$var$X, c.stateNode));
            break;
        case 4:
            d = $230171b9a5f53835$var$X;
            e = $230171b9a5f53835$var$Yj;
            $230171b9a5f53835$var$X = c.stateNode.containerInfo;
            $230171b9a5f53835$var$Yj = !0;
            $230171b9a5f53835$var$Zj(a, b, c);
            $230171b9a5f53835$var$X = d;
            $230171b9a5f53835$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$230171b9a5f53835$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $230171b9a5f53835$var$Nj(c, b, g) : 0 !== (f & 4) && $230171b9a5f53835$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $230171b9a5f53835$var$Zj(a, b, c);
            break;
        case 1:
            if (!$230171b9a5f53835$var$U && ($230171b9a5f53835$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $230171b9a5f53835$var$W(c, b, h);
            }
            $230171b9a5f53835$var$Zj(a, b, c);
            break;
        case 21:
            $230171b9a5f53835$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($230171b9a5f53835$var$U = (d = $230171b9a5f53835$var$U) || null !== c.memoizedState, $230171b9a5f53835$var$Zj(a, b, c), $230171b9a5f53835$var$U = d) : $230171b9a5f53835$var$Zj(a, b, c);
            break;
        default:
            $230171b9a5f53835$var$Zj(a, b, c);
    }
}
function $230171b9a5f53835$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $230171b9a5f53835$var$Lj);
        b.forEach(function(b) {
            var d = $230171b9a5f53835$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $230171b9a5f53835$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $230171b9a5f53835$var$X = h.stateNode;
                        $230171b9a5f53835$var$Yj = !1;
                        break a;
                    case 3:
                        $230171b9a5f53835$var$X = h.stateNode.containerInfo;
                        $230171b9a5f53835$var$Yj = !0;
                        break a;
                    case 4:
                        $230171b9a5f53835$var$X = h.stateNode.containerInfo;
                        $230171b9a5f53835$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $230171b9a5f53835$var$X) throw Error($230171b9a5f53835$var$p(160));
            $230171b9a5f53835$var$ak(f, g, e);
            $230171b9a5f53835$var$X = null;
            $230171b9a5f53835$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $230171b9a5f53835$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$230171b9a5f53835$var$ek(b, a), b = b.sibling;
}
function $230171b9a5f53835$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            if (d & 4) {
                try {
                    $230171b9a5f53835$var$Qj(3, a, a.return), $230171b9a5f53835$var$Rj(3, a);
                } catch (t) {
                    $230171b9a5f53835$var$W(a, a.return, t);
                }
                try {
                    $230171b9a5f53835$var$Qj(5, a, a.return);
                } catch (t) {
                    $230171b9a5f53835$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            d & 512 && null !== c && $230171b9a5f53835$var$Mj(c, c.return);
            break;
        case 5:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            d & 512 && null !== c && $230171b9a5f53835$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $230171b9a5f53835$var$ob(e, "");
                } catch (t) {
                    $230171b9a5f53835$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $230171b9a5f53835$var$ab(e, f);
                    $230171b9a5f53835$var$vb(h, g);
                    var l = $230171b9a5f53835$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $230171b9a5f53835$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $230171b9a5f53835$var$nb(e, q) : "children" === m ? $230171b9a5f53835$var$ob(e, q) : $230171b9a5f53835$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $230171b9a5f53835$var$bb(e, f);
                            break;
                        case "textarea":
                            $230171b9a5f53835$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $230171b9a5f53835$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $230171b9a5f53835$var$fb(e, !!f.multiple, f.defaultValue, !0) : $230171b9a5f53835$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$230171b9a5f53835$var$Pf] = f;
                } catch (t) {
                    $230171b9a5f53835$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($230171b9a5f53835$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $230171b9a5f53835$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $230171b9a5f53835$var$bd(b.containerInfo);
            } catch (t) {
                $230171b9a5f53835$var$W(a, a.return, t);
            }
            break;
        case 4:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            break;
        case 13:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($230171b9a5f53835$var$gk = $230171b9a5f53835$var$B()));
            d & 4 && $230171b9a5f53835$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($230171b9a5f53835$var$U = (l = $230171b9a5f53835$var$U) || m, $230171b9a5f53835$var$dk(b, a), $230171b9a5f53835$var$U = l) : $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($230171b9a5f53835$var$V = a, m = a.child; null !== m;){
                    for(q = $230171b9a5f53835$var$V = m; null !== $230171b9a5f53835$var$V;){
                        r = $230171b9a5f53835$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $230171b9a5f53835$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $230171b9a5f53835$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $230171b9a5f53835$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $230171b9a5f53835$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $230171b9a5f53835$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $230171b9a5f53835$var$V = y) : $230171b9a5f53835$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $230171b9a5f53835$var$rb("display", g));
                            } catch (t) {
                                $230171b9a5f53835$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $230171b9a5f53835$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $230171b9a5f53835$var$dk(b, a);
            $230171b9a5f53835$var$fk(a);
            d & 4 && $230171b9a5f53835$var$bk(a);
            break;
        case 21:
            break;
        default:
            $230171b9a5f53835$var$dk(b, a), $230171b9a5f53835$var$fk(a);
    }
}
function $230171b9a5f53835$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($230171b9a5f53835$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($230171b9a5f53835$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($230171b9a5f53835$var$ob(e, ""), d.flags &= -33);
                    var f = $230171b9a5f53835$var$Vj(a);
                    $230171b9a5f53835$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $230171b9a5f53835$var$Vj(a);
                    $230171b9a5f53835$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($230171b9a5f53835$var$p(161));
            }
        } catch (k) {
            $230171b9a5f53835$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $230171b9a5f53835$var$ik(a, b, c) {
    $230171b9a5f53835$var$V = a;
    $230171b9a5f53835$var$jk(a, b, c);
}
function $230171b9a5f53835$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $230171b9a5f53835$var$V;){
        var e = $230171b9a5f53835$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $230171b9a5f53835$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $230171b9a5f53835$var$U;
                h = $230171b9a5f53835$var$Kj;
                var l = $230171b9a5f53835$var$U;
                $230171b9a5f53835$var$Kj = g;
                if (($230171b9a5f53835$var$U = k) && !l) for($230171b9a5f53835$var$V = e; null !== $230171b9a5f53835$var$V;)g = $230171b9a5f53835$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $230171b9a5f53835$var$kk(e) : null !== k ? (k.return = g, $230171b9a5f53835$var$V = k) : $230171b9a5f53835$var$kk(e);
                for(; null !== f;)$230171b9a5f53835$var$V = f, $230171b9a5f53835$var$jk(f, b, c), f = f.sibling;
                $230171b9a5f53835$var$V = e;
                $230171b9a5f53835$var$Kj = h;
                $230171b9a5f53835$var$U = l;
            }
            $230171b9a5f53835$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $230171b9a5f53835$var$V = f) : $230171b9a5f53835$var$lk(a, b, c);
    }
}
function $230171b9a5f53835$var$lk(a) {
    for(; null !== $230171b9a5f53835$var$V;){
        var b = $230171b9a5f53835$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $230171b9a5f53835$var$U || $230171b9a5f53835$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$230171b9a5f53835$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $230171b9a5f53835$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $230171b9a5f53835$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $230171b9a5f53835$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $230171b9a5f53835$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($230171b9a5f53835$var$p(163));
                }
                $230171b9a5f53835$var$U || b.flags & 512 && $230171b9a5f53835$var$Sj(b);
            } catch (r) {
                $230171b9a5f53835$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $230171b9a5f53835$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $230171b9a5f53835$var$V = c;
            break;
        }
        $230171b9a5f53835$var$V = b.return;
    }
}
function $230171b9a5f53835$var$hk(a) {
    for(; null !== $230171b9a5f53835$var$V;){
        var b = $230171b9a5f53835$var$V;
        if (b === a) {
            $230171b9a5f53835$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $230171b9a5f53835$var$V = c;
            break;
        }
        $230171b9a5f53835$var$V = b.return;
    }
}
function $230171b9a5f53835$var$kk(a) {
    for(; null !== $230171b9a5f53835$var$V;){
        var b = $230171b9a5f53835$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $230171b9a5f53835$var$Rj(4, b);
                    } catch (k) {
                        $230171b9a5f53835$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $230171b9a5f53835$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $230171b9a5f53835$var$Sj(b);
                    } catch (k) {
                        $230171b9a5f53835$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $230171b9a5f53835$var$Sj(b);
                    } catch (k) {
                        $230171b9a5f53835$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $230171b9a5f53835$var$W(b, b.return, k);
        }
        if (b === a) {
            $230171b9a5f53835$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $230171b9a5f53835$var$V = h;
            break;
        }
        $230171b9a5f53835$var$V = b.return;
    }
}
var $230171b9a5f53835$var$mk = Math.ceil, $230171b9a5f53835$var$nk = $230171b9a5f53835$var$ua.ReactCurrentDispatcher, $230171b9a5f53835$var$ok = $230171b9a5f53835$var$ua.ReactCurrentOwner, $230171b9a5f53835$var$pk = $230171b9a5f53835$var$ua.ReactCurrentBatchConfig, $230171b9a5f53835$var$K = 0, $230171b9a5f53835$var$R = null, $230171b9a5f53835$var$Y = null, $230171b9a5f53835$var$Z = 0, $230171b9a5f53835$var$gj = 0, $230171b9a5f53835$var$fj = $230171b9a5f53835$var$Uf(0), $230171b9a5f53835$var$T = 0, $230171b9a5f53835$var$qk = null, $230171b9a5f53835$var$hh = 0, $230171b9a5f53835$var$rk = 0, $230171b9a5f53835$var$sk = 0, $230171b9a5f53835$var$tk = null, $230171b9a5f53835$var$uk = null, $230171b9a5f53835$var$gk = 0, $230171b9a5f53835$var$Hj = Infinity, $230171b9a5f53835$var$vk = null, $230171b9a5f53835$var$Pi = !1, $230171b9a5f53835$var$Qi = null, $230171b9a5f53835$var$Si = null, $230171b9a5f53835$var$wk = !1, $230171b9a5f53835$var$xk = null, $230171b9a5f53835$var$yk = 0, $230171b9a5f53835$var$zk = 0, $230171b9a5f53835$var$Ak = null, $230171b9a5f53835$var$Bk = -1, $230171b9a5f53835$var$Ck = 0;
function $230171b9a5f53835$var$L() {
    return 0 !== ($230171b9a5f53835$var$K & 6) ? $230171b9a5f53835$var$B() : -1 !== $230171b9a5f53835$var$Bk ? $230171b9a5f53835$var$Bk : $230171b9a5f53835$var$Bk = $230171b9a5f53835$var$B();
}
function $230171b9a5f53835$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($230171b9a5f53835$var$K & 2) && 0 !== $230171b9a5f53835$var$Z) return $230171b9a5f53835$var$Z & -$230171b9a5f53835$var$Z;
    if (null !== $230171b9a5f53835$var$Kg.transition) return 0 === $230171b9a5f53835$var$Ck && ($230171b9a5f53835$var$Ck = $230171b9a5f53835$var$yc()), $230171b9a5f53835$var$Ck;
    a = $230171b9a5f53835$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $230171b9a5f53835$var$jd(a.type);
    return a;
}
function $230171b9a5f53835$var$mh(a, b, c, d) {
    if (50 < $230171b9a5f53835$var$zk) throw $230171b9a5f53835$var$zk = 0, $230171b9a5f53835$var$Ak = null, Error($230171b9a5f53835$var$p(185));
    $230171b9a5f53835$var$Ac(a, c, d);
    if (0 === ($230171b9a5f53835$var$K & 2) || a !== $230171b9a5f53835$var$R) a === $230171b9a5f53835$var$R && (0 === ($230171b9a5f53835$var$K & 2) && ($230171b9a5f53835$var$rk |= c), 4 === $230171b9a5f53835$var$T && $230171b9a5f53835$var$Dk(a, $230171b9a5f53835$var$Z)), $230171b9a5f53835$var$Ek(a, d), 1 === c && 0 === $230171b9a5f53835$var$K && 0 === (b.mode & 1) && ($230171b9a5f53835$var$Hj = $230171b9a5f53835$var$B() + 500, $230171b9a5f53835$var$fg && $230171b9a5f53835$var$jg());
}
function $230171b9a5f53835$var$Ek(a, b) {
    var c = a.callbackNode;
    $230171b9a5f53835$var$wc(a, b);
    var d = $230171b9a5f53835$var$uc(a, a === $230171b9a5f53835$var$R ? $230171b9a5f53835$var$Z : 0);
    if (0 === d) null !== c && $230171b9a5f53835$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $230171b9a5f53835$var$bc(c);
        if (1 === b) 0 === a.tag ? $230171b9a5f53835$var$ig($230171b9a5f53835$var$Fk.bind(null, a)) : $230171b9a5f53835$var$hg($230171b9a5f53835$var$Fk.bind(null, a)), $230171b9a5f53835$var$Jf(function() {
            0 === ($230171b9a5f53835$var$K & 6) && $230171b9a5f53835$var$jg();
        }), c = null;
        else {
            switch($230171b9a5f53835$var$Dc(d)){
                case 1:
                    c = $230171b9a5f53835$var$fc;
                    break;
                case 4:
                    c = $230171b9a5f53835$var$gc;
                    break;
                case 16:
                    c = $230171b9a5f53835$var$hc;
                    break;
                case 536870912:
                    c = $230171b9a5f53835$var$jc;
                    break;
                default:
                    c = $230171b9a5f53835$var$hc;
            }
            c = $230171b9a5f53835$var$Gk(c, $230171b9a5f53835$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $230171b9a5f53835$var$Hk(a, b) {
    $230171b9a5f53835$var$Bk = -1;
    $230171b9a5f53835$var$Ck = 0;
    if (0 !== ($230171b9a5f53835$var$K & 6)) throw Error($230171b9a5f53835$var$p(327));
    var c = a.callbackNode;
    if ($230171b9a5f53835$var$Ik() && a.callbackNode !== c) return null;
    var d = $230171b9a5f53835$var$uc(a, a === $230171b9a5f53835$var$R ? $230171b9a5f53835$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $230171b9a5f53835$var$Jk(a, d);
    else {
        b = d;
        var e = $230171b9a5f53835$var$K;
        $230171b9a5f53835$var$K |= 2;
        var f = $230171b9a5f53835$var$Kk();
        if ($230171b9a5f53835$var$R !== a || $230171b9a5f53835$var$Z !== b) $230171b9a5f53835$var$vk = null, $230171b9a5f53835$var$Hj = $230171b9a5f53835$var$B() + 500, $230171b9a5f53835$var$Lk(a, b);
        for(;;)try {
            $230171b9a5f53835$var$Mk();
            break;
        } catch (h) {
            $230171b9a5f53835$var$Nk(a, h);
        }
        $230171b9a5f53835$var$Qg();
        $230171b9a5f53835$var$nk.current = f;
        $230171b9a5f53835$var$K = e;
        null !== $230171b9a5f53835$var$Y ? b = 0 : ($230171b9a5f53835$var$R = null, $230171b9a5f53835$var$Z = 0, b = $230171b9a5f53835$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $230171b9a5f53835$var$xc(a), 0 !== e && (d = e, b = $230171b9a5f53835$var$Ok(a, e)));
        if (1 === b) throw c = $230171b9a5f53835$var$qk, $230171b9a5f53835$var$Lk(a, 0), $230171b9a5f53835$var$Dk(a, d), $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B()), c;
        if (6 === b) $230171b9a5f53835$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$230171b9a5f53835$var$Pk(e) && (b = $230171b9a5f53835$var$Jk(a, d), 2 === b && (f = $230171b9a5f53835$var$xc(a), 0 !== f && (d = f, b = $230171b9a5f53835$var$Ok(a, f))), 1 === b)) throw c = $230171b9a5f53835$var$qk, $230171b9a5f53835$var$Lk(a, 0), $230171b9a5f53835$var$Dk(a, d), $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($230171b9a5f53835$var$p(345));
                case 2:
                    $230171b9a5f53835$var$Qk(a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk);
                    break;
                case 3:
                    $230171b9a5f53835$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $230171b9a5f53835$var$gk + 500 - $230171b9a5f53835$var$B(), 10 < b)) {
                        if (0 !== $230171b9a5f53835$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $230171b9a5f53835$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $230171b9a5f53835$var$Ff($230171b9a5f53835$var$Qk.bind(null, a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk), b);
                        break;
                    }
                    $230171b9a5f53835$var$Qk(a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk);
                    break;
                case 4:
                    $230171b9a5f53835$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $230171b9a5f53835$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $230171b9a5f53835$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $230171b9a5f53835$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $230171b9a5f53835$var$Ff($230171b9a5f53835$var$Qk.bind(null, a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk), d);
                        break;
                    }
                    $230171b9a5f53835$var$Qk(a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk);
                    break;
                case 5:
                    $230171b9a5f53835$var$Qk(a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk);
                    break;
                default:
                    throw Error($230171b9a5f53835$var$p(329));
            }
        }
    }
    $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B());
    return a.callbackNode === c ? $230171b9a5f53835$var$Hk.bind(null, a) : null;
}
function $230171b9a5f53835$var$Ok(a, b) {
    var c = $230171b9a5f53835$var$tk;
    a.current.memoizedState.isDehydrated && ($230171b9a5f53835$var$Lk(a, b).flags |= 256);
    a = $230171b9a5f53835$var$Jk(a, b);
    2 !== a && (b = $230171b9a5f53835$var$uk, $230171b9a5f53835$var$uk = c, null !== b && $230171b9a5f53835$var$Gj(b));
    return a;
}
function $230171b9a5f53835$var$Gj(a) {
    null === $230171b9a5f53835$var$uk ? $230171b9a5f53835$var$uk = a : $230171b9a5f53835$var$uk.push.apply($230171b9a5f53835$var$uk, a);
}
function $230171b9a5f53835$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$230171b9a5f53835$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $230171b9a5f53835$var$Dk(a, b) {
    b &= ~$230171b9a5f53835$var$sk;
    b &= ~$230171b9a5f53835$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $230171b9a5f53835$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $230171b9a5f53835$var$Fk(a) {
    if (0 !== ($230171b9a5f53835$var$K & 6)) throw Error($230171b9a5f53835$var$p(327));
    $230171b9a5f53835$var$Ik();
    var b = $230171b9a5f53835$var$uc(a, 0);
    if (0 === (b & 1)) return $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B()), null;
    var c = $230171b9a5f53835$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $230171b9a5f53835$var$xc(a);
        0 !== d && (b = d, c = $230171b9a5f53835$var$Ok(a, d));
    }
    if (1 === c) throw c = $230171b9a5f53835$var$qk, $230171b9a5f53835$var$Lk(a, 0), $230171b9a5f53835$var$Dk(a, b), $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B()), c;
    if (6 === c) throw Error($230171b9a5f53835$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $230171b9a5f53835$var$Qk(a, $230171b9a5f53835$var$uk, $230171b9a5f53835$var$vk);
    $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B());
    return null;
}
function $230171b9a5f53835$var$Rk(a, b) {
    var c = $230171b9a5f53835$var$K;
    $230171b9a5f53835$var$K |= 1;
    try {
        return a(b);
    } finally{
        $230171b9a5f53835$var$K = c, 0 === $230171b9a5f53835$var$K && ($230171b9a5f53835$var$Hj = $230171b9a5f53835$var$B() + 500, $230171b9a5f53835$var$fg && $230171b9a5f53835$var$jg());
    }
}
function $230171b9a5f53835$var$Sk(a) {
    null !== $230171b9a5f53835$var$xk && 0 === $230171b9a5f53835$var$xk.tag && 0 === ($230171b9a5f53835$var$K & 6) && $230171b9a5f53835$var$Ik();
    var b = $230171b9a5f53835$var$K;
    $230171b9a5f53835$var$K |= 1;
    var c = $230171b9a5f53835$var$pk.transition, d = $230171b9a5f53835$var$C;
    try {
        if ($230171b9a5f53835$var$pk.transition = null, $230171b9a5f53835$var$C = 1, a) return a();
    } finally{
        $230171b9a5f53835$var$C = d, $230171b9a5f53835$var$pk.transition = c, $230171b9a5f53835$var$K = b, 0 === ($230171b9a5f53835$var$K & 6) && $230171b9a5f53835$var$jg();
    }
}
function $230171b9a5f53835$var$Ij() {
    $230171b9a5f53835$var$gj = $230171b9a5f53835$var$fj.current;
    $230171b9a5f53835$var$E($230171b9a5f53835$var$fj);
}
function $230171b9a5f53835$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $230171b9a5f53835$var$Gf(c));
    if (null !== $230171b9a5f53835$var$Y) for(c = $230171b9a5f53835$var$Y.return; null !== c;){
        var d = c;
        $230171b9a5f53835$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $230171b9a5f53835$var$$f();
                break;
            case 3:
                $230171b9a5f53835$var$Jh();
                $230171b9a5f53835$var$E($230171b9a5f53835$var$Wf);
                $230171b9a5f53835$var$E($230171b9a5f53835$var$H);
                $230171b9a5f53835$var$Oh();
                break;
            case 5:
                $230171b9a5f53835$var$Lh(d);
                break;
            case 4:
                $230171b9a5f53835$var$Jh();
                break;
            case 13:
                $230171b9a5f53835$var$E($230171b9a5f53835$var$M);
                break;
            case 19:
                $230171b9a5f53835$var$E($230171b9a5f53835$var$M);
                break;
            case 10:
                $230171b9a5f53835$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $230171b9a5f53835$var$Ij();
        }
        c = c.return;
    }
    $230171b9a5f53835$var$R = a;
    $230171b9a5f53835$var$Y = a = $230171b9a5f53835$var$wh(a.current, null);
    $230171b9a5f53835$var$Z = $230171b9a5f53835$var$gj = b;
    $230171b9a5f53835$var$T = 0;
    $230171b9a5f53835$var$qk = null;
    $230171b9a5f53835$var$sk = $230171b9a5f53835$var$rk = $230171b9a5f53835$var$hh = 0;
    $230171b9a5f53835$var$uk = $230171b9a5f53835$var$tk = null;
    if (null !== $230171b9a5f53835$var$Wg) {
        for(b = 0; b < $230171b9a5f53835$var$Wg.length; b++)if (c = $230171b9a5f53835$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $230171b9a5f53835$var$Wg = null;
    }
    return a;
}
function $230171b9a5f53835$var$Nk(a, b) {
    do {
        var c = $230171b9a5f53835$var$Y;
        try {
            $230171b9a5f53835$var$Qg();
            $230171b9a5f53835$var$Ph.current = $230171b9a5f53835$var$ai;
            if ($230171b9a5f53835$var$Sh) {
                for(var d = $230171b9a5f53835$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $230171b9a5f53835$var$Sh = !1;
            }
            $230171b9a5f53835$var$Rh = 0;
            $230171b9a5f53835$var$P = $230171b9a5f53835$var$O = $230171b9a5f53835$var$N = null;
            $230171b9a5f53835$var$Th = !1;
            $230171b9a5f53835$var$Uh = 0;
            $230171b9a5f53835$var$ok.current = null;
            if (null === c || null === c.return) {
                $230171b9a5f53835$var$T = 1;
                $230171b9a5f53835$var$qk = b;
                $230171b9a5f53835$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $230171b9a5f53835$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $230171b9a5f53835$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $230171b9a5f53835$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $230171b9a5f53835$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $230171b9a5f53835$var$Ti(f, l, b);
                            $230171b9a5f53835$var$uj();
                            break a;
                        }
                        k = Error($230171b9a5f53835$var$p(426));
                    }
                } else if ($230171b9a5f53835$var$I && h.mode & 1) {
                    var J = $230171b9a5f53835$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $230171b9a5f53835$var$Wi(J, g, h, f, b);
                        $230171b9a5f53835$var$Jg($230171b9a5f53835$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $230171b9a5f53835$var$Ki(k, h);
                4 !== $230171b9a5f53835$var$T && ($230171b9a5f53835$var$T = 2);
                null === $230171b9a5f53835$var$tk ? $230171b9a5f53835$var$tk = [
                    f
                ] : $230171b9a5f53835$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $230171b9a5f53835$var$Oi(f, k, b);
                            $230171b9a5f53835$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $230171b9a5f53835$var$Si || !$230171b9a5f53835$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $230171b9a5f53835$var$Ri(f, h, b);
                                $230171b9a5f53835$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $230171b9a5f53835$var$Tk(c);
        } catch (na) {
            b = na;
            $230171b9a5f53835$var$Y === c && null !== c && ($230171b9a5f53835$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $230171b9a5f53835$var$Kk() {
    var a = $230171b9a5f53835$var$nk.current;
    $230171b9a5f53835$var$nk.current = $230171b9a5f53835$var$ai;
    return null === a ? $230171b9a5f53835$var$ai : a;
}
function $230171b9a5f53835$var$uj() {
    if (0 === $230171b9a5f53835$var$T || 3 === $230171b9a5f53835$var$T || 2 === $230171b9a5f53835$var$T) $230171b9a5f53835$var$T = 4;
    null === $230171b9a5f53835$var$R || 0 === ($230171b9a5f53835$var$hh & 268435455) && 0 === ($230171b9a5f53835$var$rk & 268435455) || $230171b9a5f53835$var$Dk($230171b9a5f53835$var$R, $230171b9a5f53835$var$Z);
}
function $230171b9a5f53835$var$Jk(a, b) {
    var c = $230171b9a5f53835$var$K;
    $230171b9a5f53835$var$K |= 2;
    var d = $230171b9a5f53835$var$Kk();
    if ($230171b9a5f53835$var$R !== a || $230171b9a5f53835$var$Z !== b) $230171b9a5f53835$var$vk = null, $230171b9a5f53835$var$Lk(a, b);
    for(;;)try {
        $230171b9a5f53835$var$Uk();
        break;
    } catch (e) {
        $230171b9a5f53835$var$Nk(a, e);
    }
    $230171b9a5f53835$var$Qg();
    $230171b9a5f53835$var$K = c;
    $230171b9a5f53835$var$nk.current = d;
    if (null !== $230171b9a5f53835$var$Y) throw Error($230171b9a5f53835$var$p(261));
    $230171b9a5f53835$var$R = null;
    $230171b9a5f53835$var$Z = 0;
    return $230171b9a5f53835$var$T;
}
function $230171b9a5f53835$var$Uk() {
    for(; null !== $230171b9a5f53835$var$Y;)$230171b9a5f53835$var$Vk($230171b9a5f53835$var$Y);
}
function $230171b9a5f53835$var$Mk() {
    for(; null !== $230171b9a5f53835$var$Y && !$230171b9a5f53835$var$cc();)$230171b9a5f53835$var$Vk($230171b9a5f53835$var$Y);
}
function $230171b9a5f53835$var$Vk(a) {
    var b = $230171b9a5f53835$var$Wk(a.alternate, a, $230171b9a5f53835$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $230171b9a5f53835$var$Tk(a) : $230171b9a5f53835$var$Y = b;
    $230171b9a5f53835$var$ok.current = null;
}
function $230171b9a5f53835$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $230171b9a5f53835$var$Fj(c, b, $230171b9a5f53835$var$gj), null !== c) {
                $230171b9a5f53835$var$Y = c;
                return;
            }
        } else {
            c = $230171b9a5f53835$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $230171b9a5f53835$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $230171b9a5f53835$var$T = 6;
                $230171b9a5f53835$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $230171b9a5f53835$var$Y = b;
            return;
        }
        $230171b9a5f53835$var$Y = b = a;
    }while (null !== b);
    0 === $230171b9a5f53835$var$T && ($230171b9a5f53835$var$T = 5);
}
function $230171b9a5f53835$var$Qk(a, b, c) {
    var d = $230171b9a5f53835$var$C, e = $230171b9a5f53835$var$pk.transition;
    try {
        $230171b9a5f53835$var$pk.transition = null, $230171b9a5f53835$var$C = 1, $230171b9a5f53835$var$Xk(a, b, c, d);
    } finally{
        $230171b9a5f53835$var$pk.transition = e, $230171b9a5f53835$var$C = d;
    }
    return null;
}
function $230171b9a5f53835$var$Xk(a, b, c, d) {
    do $230171b9a5f53835$var$Ik();
    while (null !== $230171b9a5f53835$var$xk);
    if (0 !== ($230171b9a5f53835$var$K & 6)) throw Error($230171b9a5f53835$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($230171b9a5f53835$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $230171b9a5f53835$var$Bc(a, f);
    a === $230171b9a5f53835$var$R && ($230171b9a5f53835$var$Y = $230171b9a5f53835$var$R = null, $230171b9a5f53835$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $230171b9a5f53835$var$wk || ($230171b9a5f53835$var$wk = !0, $230171b9a5f53835$var$Gk($230171b9a5f53835$var$hc, function() {
        $230171b9a5f53835$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $230171b9a5f53835$var$pk.transition;
        $230171b9a5f53835$var$pk.transition = null;
        var g = $230171b9a5f53835$var$C;
        $230171b9a5f53835$var$C = 1;
        var h = $230171b9a5f53835$var$K;
        $230171b9a5f53835$var$K |= 4;
        $230171b9a5f53835$var$ok.current = null;
        $230171b9a5f53835$var$Pj(a, c);
        $230171b9a5f53835$var$ek(c, a);
        $230171b9a5f53835$var$Oe($230171b9a5f53835$var$Df);
        $230171b9a5f53835$var$dd = !!$230171b9a5f53835$var$Cf;
        $230171b9a5f53835$var$Df = $230171b9a5f53835$var$Cf = null;
        a.current = c;
        $230171b9a5f53835$var$ik(c, a, e);
        $230171b9a5f53835$var$dc();
        $230171b9a5f53835$var$K = h;
        $230171b9a5f53835$var$C = g;
        $230171b9a5f53835$var$pk.transition = f;
    } else a.current = c;
    $230171b9a5f53835$var$wk && ($230171b9a5f53835$var$wk = !1, $230171b9a5f53835$var$xk = a, $230171b9a5f53835$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($230171b9a5f53835$var$Si = null);
    $230171b9a5f53835$var$mc(c.stateNode, d);
    $230171b9a5f53835$var$Ek(a, $230171b9a5f53835$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($230171b9a5f53835$var$Pi) throw $230171b9a5f53835$var$Pi = !1, a = $230171b9a5f53835$var$Qi, $230171b9a5f53835$var$Qi = null, a;
    0 !== ($230171b9a5f53835$var$yk & 1) && 0 !== a.tag && $230171b9a5f53835$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $230171b9a5f53835$var$Ak ? $230171b9a5f53835$var$zk++ : ($230171b9a5f53835$var$zk = 0, $230171b9a5f53835$var$Ak = a) : $230171b9a5f53835$var$zk = 0;
    $230171b9a5f53835$var$jg();
    return null;
}
function $230171b9a5f53835$var$Ik() {
    if (null !== $230171b9a5f53835$var$xk) {
        var a = $230171b9a5f53835$var$Dc($230171b9a5f53835$var$yk), b = $230171b9a5f53835$var$pk.transition, c = $230171b9a5f53835$var$C;
        try {
            $230171b9a5f53835$var$pk.transition = null;
            $230171b9a5f53835$var$C = 16 > a ? 16 : a;
            if (null === $230171b9a5f53835$var$xk) var d = !1;
            else {
                a = $230171b9a5f53835$var$xk;
                $230171b9a5f53835$var$xk = null;
                $230171b9a5f53835$var$yk = 0;
                if (0 !== ($230171b9a5f53835$var$K & 6)) throw Error($230171b9a5f53835$var$p(331));
                var e = $230171b9a5f53835$var$K;
                $230171b9a5f53835$var$K |= 4;
                for($230171b9a5f53835$var$V = a.current; null !== $230171b9a5f53835$var$V;){
                    var f = $230171b9a5f53835$var$V, g = f.child;
                    if (0 !== ($230171b9a5f53835$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($230171b9a5f53835$var$V = l; null !== $230171b9a5f53835$var$V;){
                                    var m = $230171b9a5f53835$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $230171b9a5f53835$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $230171b9a5f53835$var$V = q;
                                    else for(; null !== $230171b9a5f53835$var$V;){
                                        m = $230171b9a5f53835$var$V;
                                        var r = m.sibling, y = m.return;
                                        $230171b9a5f53835$var$Tj(m);
                                        if (m === l) {
                                            $230171b9a5f53835$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $230171b9a5f53835$var$V = r;
                                            break;
                                        }
                                        $230171b9a5f53835$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $230171b9a5f53835$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $230171b9a5f53835$var$V = g;
                    else b: for(; null !== $230171b9a5f53835$var$V;){
                        f = $230171b9a5f53835$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $230171b9a5f53835$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $230171b9a5f53835$var$V = x;
                            break b;
                        }
                        $230171b9a5f53835$var$V = f.return;
                    }
                }
                var w = a.current;
                for($230171b9a5f53835$var$V = w; null !== $230171b9a5f53835$var$V;){
                    g = $230171b9a5f53835$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $230171b9a5f53835$var$V = u;
                    else b: for(g = w; null !== $230171b9a5f53835$var$V;){
                        h = $230171b9a5f53835$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $230171b9a5f53835$var$Rj(9, h);
                            }
                        } catch (na) {
                            $230171b9a5f53835$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $230171b9a5f53835$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $230171b9a5f53835$var$V = F;
                            break b;
                        }
                        $230171b9a5f53835$var$V = h.return;
                    }
                }
                $230171b9a5f53835$var$K = e;
                $230171b9a5f53835$var$jg();
                if ($230171b9a5f53835$var$lc && "function" === typeof $230171b9a5f53835$var$lc.onPostCommitFiberRoot) try {
                    $230171b9a5f53835$var$lc.onPostCommitFiberRoot($230171b9a5f53835$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $230171b9a5f53835$var$C = c, $230171b9a5f53835$var$pk.transition = b;
        }
    }
    return !1;
}
function $230171b9a5f53835$var$Yk(a, b, c) {
    b = $230171b9a5f53835$var$Ki(c, b);
    b = $230171b9a5f53835$var$Oi(a, b, 1);
    a = $230171b9a5f53835$var$dh(a, b, 1);
    b = $230171b9a5f53835$var$L();
    null !== a && ($230171b9a5f53835$var$Ac(a, 1, b), $230171b9a5f53835$var$Ek(a, b));
}
function $230171b9a5f53835$var$W(a, b, c) {
    if (3 === a.tag) $230171b9a5f53835$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $230171b9a5f53835$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $230171b9a5f53835$var$Si || !$230171b9a5f53835$var$Si.has(d))) {
                a = $230171b9a5f53835$var$Ki(c, a);
                a = $230171b9a5f53835$var$Ri(b, a, 1);
                b = $230171b9a5f53835$var$dh(b, a, 1);
                a = $230171b9a5f53835$var$L();
                null !== b && ($230171b9a5f53835$var$Ac(b, 1, a), $230171b9a5f53835$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $230171b9a5f53835$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $230171b9a5f53835$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $230171b9a5f53835$var$R === a && ($230171b9a5f53835$var$Z & c) === c && (4 === $230171b9a5f53835$var$T || 3 === $230171b9a5f53835$var$T && ($230171b9a5f53835$var$Z & 130023424) === $230171b9a5f53835$var$Z && 500 > $230171b9a5f53835$var$B() - $230171b9a5f53835$var$gk ? $230171b9a5f53835$var$Lk(a, 0) : $230171b9a5f53835$var$sk |= c);
    $230171b9a5f53835$var$Ek(a, b);
}
function $230171b9a5f53835$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $230171b9a5f53835$var$sc, $230171b9a5f53835$var$sc <<= 1, 0 === ($230171b9a5f53835$var$sc & 130023424) && ($230171b9a5f53835$var$sc = 4194304)));
    var c = $230171b9a5f53835$var$L();
    a = $230171b9a5f53835$var$Zg(a, b);
    null !== a && ($230171b9a5f53835$var$Ac(a, b, c), $230171b9a5f53835$var$Ek(a, c));
}
function $230171b9a5f53835$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $230171b9a5f53835$var$Zk(a, c);
}
function $230171b9a5f53835$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($230171b9a5f53835$var$p(314));
    }
    null !== d && d.delete(b);
    $230171b9a5f53835$var$Zk(a, c);
}
var $230171b9a5f53835$var$Wk;
$230171b9a5f53835$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $230171b9a5f53835$var$Wf.current) $230171b9a5f53835$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $230171b9a5f53835$var$Ug = !1, $230171b9a5f53835$var$zj(a, b, c);
            $230171b9a5f53835$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $230171b9a5f53835$var$Ug = !1, $230171b9a5f53835$var$I && 0 !== (b.flags & 1048576) && $230171b9a5f53835$var$ug(b, $230171b9a5f53835$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $230171b9a5f53835$var$jj(a, b);
            a = b.pendingProps;
            var e = $230171b9a5f53835$var$Yf(b, $230171b9a5f53835$var$H.current);
            $230171b9a5f53835$var$Tg(b, c);
            e = $230171b9a5f53835$var$Xh(null, b, d, a, e, c);
            var f = $230171b9a5f53835$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $230171b9a5f53835$var$Zf(d) ? (f = !0, $230171b9a5f53835$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $230171b9a5f53835$var$ah(b), e.updater = $230171b9a5f53835$var$nh, b.stateNode = e, e._reactInternals = b, $230171b9a5f53835$var$rh(b, d, a, c), b = $230171b9a5f53835$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $230171b9a5f53835$var$I && f && $230171b9a5f53835$var$vg(b), $230171b9a5f53835$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $230171b9a5f53835$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $230171b9a5f53835$var$$k(d);
                a = $230171b9a5f53835$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $230171b9a5f53835$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $230171b9a5f53835$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $230171b9a5f53835$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $230171b9a5f53835$var$aj(null, b, d, $230171b9a5f53835$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($230171b9a5f53835$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $230171b9a5f53835$var$Lg(d, e), $230171b9a5f53835$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $230171b9a5f53835$var$Lg(d, e), $230171b9a5f53835$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $230171b9a5f53835$var$lj(b);
                if (null === a) throw Error($230171b9a5f53835$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $230171b9a5f53835$var$bh(a, b);
                $230171b9a5f53835$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $230171b9a5f53835$var$Ki(Error($230171b9a5f53835$var$p(423)), b);
                        b = $230171b9a5f53835$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $230171b9a5f53835$var$Ki(Error($230171b9a5f53835$var$p(424)), b);
                        b = $230171b9a5f53835$var$mj(a, b, d, c, e);
                        break a;
                    } else for($230171b9a5f53835$var$yg = $230171b9a5f53835$var$Lf(b.stateNode.containerInfo.firstChild), $230171b9a5f53835$var$xg = b, $230171b9a5f53835$var$I = !0, $230171b9a5f53835$var$zg = null, c = $230171b9a5f53835$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $230171b9a5f53835$var$Ig();
                    if (d === e) {
                        b = $230171b9a5f53835$var$$i(a, b, c);
                        break a;
                    }
                    $230171b9a5f53835$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $230171b9a5f53835$var$Kh(b), null === a && $230171b9a5f53835$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $230171b9a5f53835$var$Ef(d, e) ? g = null : null !== f && $230171b9a5f53835$var$Ef(d, f) && (b.flags |= 32), $230171b9a5f53835$var$hj(a, b), $230171b9a5f53835$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $230171b9a5f53835$var$Eg(b), null;
        case 13:
            return $230171b9a5f53835$var$pj(a, b, c);
        case 4:
            return $230171b9a5f53835$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $230171b9a5f53835$var$Bh(b, null, d, c) : $230171b9a5f53835$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $230171b9a5f53835$var$Lg(d, e), $230171b9a5f53835$var$Zi(a, b, d, e, c);
        case 7:
            return $230171b9a5f53835$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $230171b9a5f53835$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $230171b9a5f53835$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $230171b9a5f53835$var$G($230171b9a5f53835$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($230171b9a5f53835$var$He(f.value, g)) {
                        if (f.children === e.children && !$230171b9a5f53835$var$Wf.current) {
                            b = $230171b9a5f53835$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $230171b9a5f53835$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $230171b9a5f53835$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($230171b9a5f53835$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $230171b9a5f53835$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $230171b9a5f53835$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $230171b9a5f53835$var$Tg(b, c), e = $230171b9a5f53835$var$Vg(e), d = d(e), b.flags |= 1, $230171b9a5f53835$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $230171b9a5f53835$var$Lg(d, b.pendingProps), e = $230171b9a5f53835$var$Lg(d.type, e), $230171b9a5f53835$var$aj(a, b, d, e, c);
        case 15:
            return $230171b9a5f53835$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $230171b9a5f53835$var$Lg(d, e), $230171b9a5f53835$var$jj(a, b), b.tag = 1, $230171b9a5f53835$var$Zf(d) ? (a = !0, $230171b9a5f53835$var$cg(b)) : a = !1, $230171b9a5f53835$var$Tg(b, c), $230171b9a5f53835$var$ph(b, d, e), $230171b9a5f53835$var$rh(b, d, e, c), $230171b9a5f53835$var$kj(null, b, d, !0, a, c);
        case 19:
            return $230171b9a5f53835$var$yj(a, b, c);
        case 22:
            return $230171b9a5f53835$var$ej(a, b, c);
    }
    throw Error($230171b9a5f53835$var$p(156, b.tag));
};
function $230171b9a5f53835$var$Gk(a, b) {
    return $230171b9a5f53835$var$ac(a, b);
}
function $230171b9a5f53835$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $230171b9a5f53835$var$Bg(a, b, c, d) {
    return new $230171b9a5f53835$var$al(a, b, c, d);
}
function $230171b9a5f53835$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $230171b9a5f53835$var$$k(a) {
    if ("function" === typeof a) return $230171b9a5f53835$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $230171b9a5f53835$var$Da) return 11;
        if (a === $230171b9a5f53835$var$Ga) return 14;
    }
    return 2;
}
function $230171b9a5f53835$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $230171b9a5f53835$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $230171b9a5f53835$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $230171b9a5f53835$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $230171b9a5f53835$var$ya:
            return $230171b9a5f53835$var$Ah(c.children, e, f, b);
        case $230171b9a5f53835$var$za:
            g = 8;
            e |= 8;
            break;
        case $230171b9a5f53835$var$Aa:
            return a = $230171b9a5f53835$var$Bg(12, c, b, e | 2), a.elementType = $230171b9a5f53835$var$Aa, a.lanes = f, a;
        case $230171b9a5f53835$var$Ea:
            return a = $230171b9a5f53835$var$Bg(13, c, b, e), a.elementType = $230171b9a5f53835$var$Ea, a.lanes = f, a;
        case $230171b9a5f53835$var$Fa:
            return a = $230171b9a5f53835$var$Bg(19, c, b, e), a.elementType = $230171b9a5f53835$var$Fa, a.lanes = f, a;
        case $230171b9a5f53835$var$Ia:
            return $230171b9a5f53835$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $230171b9a5f53835$var$Ba:
                    g = 10;
                    break a;
                case $230171b9a5f53835$var$Ca:
                    g = 9;
                    break a;
                case $230171b9a5f53835$var$Da:
                    g = 11;
                    break a;
                case $230171b9a5f53835$var$Ga:
                    g = 14;
                    break a;
                case $230171b9a5f53835$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($230171b9a5f53835$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $230171b9a5f53835$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $230171b9a5f53835$var$Ah(a, b, c, d) {
    a = $230171b9a5f53835$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $230171b9a5f53835$var$qj(a, b, c, d) {
    a = $230171b9a5f53835$var$Bg(22, a, d, b);
    a.elementType = $230171b9a5f53835$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $230171b9a5f53835$var$xh(a, b, c) {
    a = $230171b9a5f53835$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $230171b9a5f53835$var$zh(a, b, c) {
    b = $230171b9a5f53835$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $230171b9a5f53835$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $230171b9a5f53835$var$zc(0);
    this.expirationTimes = $230171b9a5f53835$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $230171b9a5f53835$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $230171b9a5f53835$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $230171b9a5f53835$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $230171b9a5f53835$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $230171b9a5f53835$var$ah(f);
    return a;
}
function $230171b9a5f53835$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $230171b9a5f53835$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $230171b9a5f53835$var$el(a) {
    if (!a) return $230171b9a5f53835$var$Vf;
    a = a._reactInternals;
    a: {
        if ($230171b9a5f53835$var$Vb(a) !== a || 1 !== a.tag) throw Error($230171b9a5f53835$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($230171b9a5f53835$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($230171b9a5f53835$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($230171b9a5f53835$var$Zf(c)) return $230171b9a5f53835$var$bg(a, c, b);
    }
    return b;
}
function $230171b9a5f53835$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $230171b9a5f53835$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $230171b9a5f53835$var$el(null);
    c = a.current;
    d = $230171b9a5f53835$var$L();
    e = $230171b9a5f53835$var$lh(c);
    f = $230171b9a5f53835$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $230171b9a5f53835$var$dh(c, f, e);
    a.current.lanes = e;
    $230171b9a5f53835$var$Ac(a, e, d);
    $230171b9a5f53835$var$Ek(a, d);
    return a;
}
function $230171b9a5f53835$var$gl(a, b, c, d) {
    var e = b.current, f = $230171b9a5f53835$var$L(), g = $230171b9a5f53835$var$lh(e);
    c = $230171b9a5f53835$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $230171b9a5f53835$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $230171b9a5f53835$var$dh(e, b, g);
    null !== a && ($230171b9a5f53835$var$mh(a, e, g, f), $230171b9a5f53835$var$eh(a, e, g));
    return g;
}
function $230171b9a5f53835$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $230171b9a5f53835$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $230171b9a5f53835$var$jl(a, b) {
    $230171b9a5f53835$var$il(a, b);
    (a = a.alternate) && $230171b9a5f53835$var$il(a, b);
}
function $230171b9a5f53835$var$kl() {
    return null;
}
var $230171b9a5f53835$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $230171b9a5f53835$var$ml(a) {
    this._internalRoot = a;
}
$230171b9a5f53835$var$nl.prototype.render = $230171b9a5f53835$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($230171b9a5f53835$var$p(409));
    $230171b9a5f53835$var$gl(a, b, null, null);
};
$230171b9a5f53835$var$nl.prototype.unmount = $230171b9a5f53835$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $230171b9a5f53835$var$Sk(function() {
            $230171b9a5f53835$var$gl(null, a, null, null);
        });
        b[$230171b9a5f53835$var$uf] = null;
    }
};
function $230171b9a5f53835$var$nl(a) {
    this._internalRoot = a;
}
$230171b9a5f53835$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $230171b9a5f53835$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $230171b9a5f53835$var$Qc.length && 0 !== b && b < $230171b9a5f53835$var$Qc[c].priority; c++);
        $230171b9a5f53835$var$Qc.splice(c, 0, a);
        0 === c && $230171b9a5f53835$var$Vc(a);
    }
};
function $230171b9a5f53835$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $230171b9a5f53835$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $230171b9a5f53835$var$ql() {}
function $230171b9a5f53835$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $230171b9a5f53835$var$hl(g);
                f.call(a);
            };
        }
        var g = $230171b9a5f53835$var$fl(b, d, a, 0, null, !1, !1, "", $230171b9a5f53835$var$ql);
        a._reactRootContainer = g;
        a[$230171b9a5f53835$var$uf] = g.current;
        $230171b9a5f53835$var$sf(8 === a.nodeType ? a.parentNode : a);
        $230171b9a5f53835$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $230171b9a5f53835$var$hl(k);
            h.call(a);
        };
    }
    var k = $230171b9a5f53835$var$cl(a, 0, !1, null, null, !1, !1, "", $230171b9a5f53835$var$ql);
    a._reactRootContainer = k;
    a[$230171b9a5f53835$var$uf] = k.current;
    $230171b9a5f53835$var$sf(8 === a.nodeType ? a.parentNode : a);
    $230171b9a5f53835$var$Sk(function() {
        $230171b9a5f53835$var$gl(b, k, c, d);
    });
    return k;
}
function $230171b9a5f53835$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $230171b9a5f53835$var$hl(g);
                h.call(a);
            };
        }
        $230171b9a5f53835$var$gl(b, g, a, e);
    } else g = $230171b9a5f53835$var$rl(c, b, a, e, d);
    return $230171b9a5f53835$var$hl(g);
}
$230171b9a5f53835$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $230171b9a5f53835$var$tc(b.pendingLanes);
                0 !== c && ($230171b9a5f53835$var$Cc(b, c | 1), $230171b9a5f53835$var$Ek(b, $230171b9a5f53835$var$B()), 0 === ($230171b9a5f53835$var$K & 6) && ($230171b9a5f53835$var$Hj = $230171b9a5f53835$var$B() + 500, $230171b9a5f53835$var$jg()));
            }
            break;
        case 13:
            $230171b9a5f53835$var$Sk(function() {
                var b = $230171b9a5f53835$var$Zg(a, 1);
                if (null !== b) {
                    var c = $230171b9a5f53835$var$L();
                    $230171b9a5f53835$var$mh(b, a, 1, c);
                }
            }), $230171b9a5f53835$var$jl(a, 1);
    }
};
$230171b9a5f53835$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $230171b9a5f53835$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $230171b9a5f53835$var$L();
            $230171b9a5f53835$var$mh(b, a, 134217728, c);
        }
        $230171b9a5f53835$var$jl(a, 134217728);
    }
};
$230171b9a5f53835$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $230171b9a5f53835$var$lh(a), c = $230171b9a5f53835$var$Zg(a, b);
        if (null !== c) {
            var d = $230171b9a5f53835$var$L();
            $230171b9a5f53835$var$mh(c, a, b, d);
        }
        $230171b9a5f53835$var$jl(a, b);
    }
};
$230171b9a5f53835$var$Hc = function() {
    return $230171b9a5f53835$var$C;
};
$230171b9a5f53835$var$Ic = function(a, b) {
    var c = $230171b9a5f53835$var$C;
    try {
        return $230171b9a5f53835$var$C = a, b();
    } finally{
        $230171b9a5f53835$var$C = c;
    }
};
$230171b9a5f53835$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $230171b9a5f53835$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $230171b9a5f53835$var$Db(d);
                        if (!e) throw Error($230171b9a5f53835$var$p(90));
                        $230171b9a5f53835$var$Wa(d);
                        $230171b9a5f53835$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $230171b9a5f53835$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $230171b9a5f53835$var$fb(a, !!c.multiple, b, !1);
    }
};
$230171b9a5f53835$var$Gb = $230171b9a5f53835$var$Rk;
$230171b9a5f53835$var$Hb = $230171b9a5f53835$var$Sk;
var $230171b9a5f53835$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $230171b9a5f53835$var$Cb,
        $230171b9a5f53835$var$ue,
        $230171b9a5f53835$var$Db,
        $230171b9a5f53835$var$Eb,
        $230171b9a5f53835$var$Fb,
        $230171b9a5f53835$var$Rk
    ]
}, $230171b9a5f53835$var$ul = {
    findFiberByHostInstance: $230171b9a5f53835$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $230171b9a5f53835$var$vl = {
    bundleType: $230171b9a5f53835$var$ul.bundleType,
    version: $230171b9a5f53835$var$ul.version,
    rendererPackageName: $230171b9a5f53835$var$ul.rendererPackageName,
    rendererConfig: $230171b9a5f53835$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $230171b9a5f53835$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $230171b9a5f53835$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $230171b9a5f53835$var$ul.findFiberByHostInstance || $230171b9a5f53835$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $230171b9a5f53835$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$230171b9a5f53835$var$wl.isDisabled && $230171b9a5f53835$var$wl.supportsFiber) try {
        $230171b9a5f53835$var$kc = $230171b9a5f53835$var$wl.inject($230171b9a5f53835$var$vl), $230171b9a5f53835$var$lc = $230171b9a5f53835$var$wl;
    } catch (a) {}
}
$230171b9a5f53835$export$ae55be85d98224ed = $230171b9a5f53835$var$tl;
$230171b9a5f53835$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$230171b9a5f53835$var$ol(b)) throw Error($230171b9a5f53835$var$p(200));
    return $230171b9a5f53835$var$dl(a, b, null, c);
};
$230171b9a5f53835$export$882461b6382ed46c = function(a, b) {
    if (!$230171b9a5f53835$var$ol(a)) throw Error($230171b9a5f53835$var$p(299));
    var c = !1, d = "", e = $230171b9a5f53835$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $230171b9a5f53835$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$230171b9a5f53835$var$uf] = b.current;
    $230171b9a5f53835$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $230171b9a5f53835$var$ml(b);
};
$230171b9a5f53835$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($230171b9a5f53835$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($230171b9a5f53835$var$p(268, a));
    }
    a = $230171b9a5f53835$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$230171b9a5f53835$export$cd75ccfd720a3cd4 = function(a) {
    return $230171b9a5f53835$var$Sk(a);
};
$230171b9a5f53835$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$230171b9a5f53835$var$pl(b)) throw Error($230171b9a5f53835$var$p(200));
    return $230171b9a5f53835$var$sl(null, a, b, !0, c);
};
$230171b9a5f53835$export$757ceba2d55c277e = function(a, b, c) {
    if (!$230171b9a5f53835$var$ol(a)) throw Error($230171b9a5f53835$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $230171b9a5f53835$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $230171b9a5f53835$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$230171b9a5f53835$var$uf] = b.current;
    $230171b9a5f53835$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $230171b9a5f53835$var$nl(b);
};
$230171b9a5f53835$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$230171b9a5f53835$var$pl(b)) throw Error($230171b9a5f53835$var$p(200));
    return $230171b9a5f53835$var$sl(null, a, b, !1, c);
};
$230171b9a5f53835$export$502457920280e6be = function(a) {
    if (!$230171b9a5f53835$var$pl(a)) throw Error($230171b9a5f53835$var$p(40));
    return a._reactRootContainer ? ($230171b9a5f53835$var$Sk(function() {
        $230171b9a5f53835$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$230171b9a5f53835$var$uf] = null;
        });
    }), !0) : !1;
};
$230171b9a5f53835$export$c78a37762a8d58e1 = $230171b9a5f53835$var$Rk;
$230171b9a5f53835$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$230171b9a5f53835$var$pl(c)) throw Error($230171b9a5f53835$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($230171b9a5f53835$var$p(38));
    return $230171b9a5f53835$var$sl(a, b, c, !1, d);
};
$230171b9a5f53835$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fZMuI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2jKUG"));

});
parcelRegister("2jKUG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1b01bf19a2dd095f$export$c4744153514ff05d, (v) => $1b01bf19a2dd095f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1b01bf19a2dd095f$export$3e506c1ccc9cc1a7, (v) => $1b01bf19a2dd095f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1b01bf19a2dd095f$export$e26fe2ed2fa76875, (v) => $1b01bf19a2dd095f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1b01bf19a2dd095f$export$502329bbf4b505b1, (v) => $1b01bf19a2dd095f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1b01bf19a2dd095f$export$6e3807111c4874c4, (v) => $1b01bf19a2dd095f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1b01bf19a2dd095f$export$c27134553091fb3a, (v) => $1b01bf19a2dd095f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1b01bf19a2dd095f$export$33ee1acdc04fd2a2, (v) => $1b01bf19a2dd095f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1b01bf19a2dd095f$export$b00a404bbd5edef2, (v) => $1b01bf19a2dd095f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1b01bf19a2dd095f$export$8352ce38b91d0c62, (v) => $1b01bf19a2dd095f$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1b01bf19a2dd095f$export$d66a1c1c77bd778b, (v) => $1b01bf19a2dd095f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1b01bf19a2dd095f$export$d3dfb8e4810cb555, (v) => $1b01bf19a2dd095f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1b01bf19a2dd095f$export$839f9183b0465a69, (v) => $1b01bf19a2dd095f$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1b01bf19a2dd095f$export$72fdf0e06517287b, (v) => $1b01bf19a2dd095f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1b01bf19a2dd095f$export$4b844e58a3e414b4, (v) => $1b01bf19a2dd095f$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1b01bf19a2dd095f$export$816d2913ae6b83b1, (v) => $1b01bf19a2dd095f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1b01bf19a2dd095f$export$61bcfe829111a1d0, (v) => $1b01bf19a2dd095f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1b01bf19a2dd095f$export$7ee8c9beb337bc3f, (v) => $1b01bf19a2dd095f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1b01bf19a2dd095f$export$b5836b71941fa3ed, (v) => $1b01bf19a2dd095f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1b01bf19a2dd095f$export$cf845f2c119da08a, (v) => $1b01bf19a2dd095f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b01bf19a2dd095f$export$c4744153514ff05d;
var $1b01bf19a2dd095f$export$3e506c1ccc9cc1a7;
var $1b01bf19a2dd095f$export$e26fe2ed2fa76875;
var $1b01bf19a2dd095f$export$502329bbf4b505b1;
var $1b01bf19a2dd095f$export$6e3807111c4874c4;
var $1b01bf19a2dd095f$export$c27134553091fb3a;
var $1b01bf19a2dd095f$export$33ee1acdc04fd2a2;
var $1b01bf19a2dd095f$export$b00a404bbd5edef2;
var $1b01bf19a2dd095f$export$8352ce38b91d0c62;
var $1b01bf19a2dd095f$export$d66a1c1c77bd778b;
var $1b01bf19a2dd095f$export$d3dfb8e4810cb555;
var $1b01bf19a2dd095f$export$839f9183b0465a69;
var $1b01bf19a2dd095f$export$72fdf0e06517287b;
var $1b01bf19a2dd095f$export$4b844e58a3e414b4;
var $1b01bf19a2dd095f$export$816d2913ae6b83b1;
var $1b01bf19a2dd095f$export$61bcfe829111a1d0;
var $1b01bf19a2dd095f$export$7ee8c9beb337bc3f;
var $1b01bf19a2dd095f$export$b5836b71941fa3ed;
var $1b01bf19a2dd095f$export$cf845f2c119da08a;
'use strict';
function $1b01bf19a2dd095f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1b01bf19a2dd095f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1b01bf19a2dd095f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1b01bf19a2dd095f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1b01bf19a2dd095f$var$g(C, c)) n < e && 0 > $1b01bf19a2dd095f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1b01bf19a2dd095f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1b01bf19a2dd095f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1b01bf19a2dd095f$var$l = performance;
    $1b01bf19a2dd095f$export$c4744153514ff05d = function() {
        return $1b01bf19a2dd095f$var$l.now();
    };
} else {
    var $1b01bf19a2dd095f$var$p = Date, $1b01bf19a2dd095f$var$q = $1b01bf19a2dd095f$var$p.now();
    $1b01bf19a2dd095f$export$c4744153514ff05d = function() {
        return $1b01bf19a2dd095f$var$p.now() - $1b01bf19a2dd095f$var$q;
    };
}
var $1b01bf19a2dd095f$var$r = [], $1b01bf19a2dd095f$var$t = [], $1b01bf19a2dd095f$var$u = 1, $1b01bf19a2dd095f$var$v = null, $1b01bf19a2dd095f$var$y = 3, $1b01bf19a2dd095f$var$z = !1, $1b01bf19a2dd095f$var$A = !1, $1b01bf19a2dd095f$var$B = !1, $1b01bf19a2dd095f$var$D = "function" === typeof setTimeout ? setTimeout : null, $1b01bf19a2dd095f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1b01bf19a2dd095f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1b01bf19a2dd095f$var$G(a) {
    for(var b = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$t); null !== b;){
        if (null === b.callback) $1b01bf19a2dd095f$var$k($1b01bf19a2dd095f$var$t);
        else if (b.startTime <= a) $1b01bf19a2dd095f$var$k($1b01bf19a2dd095f$var$t), b.sortIndex = b.expirationTime, $1b01bf19a2dd095f$var$f($1b01bf19a2dd095f$var$r, b);
        else break;
        b = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$t);
    }
}
function $1b01bf19a2dd095f$var$H(a) {
    $1b01bf19a2dd095f$var$B = !1;
    $1b01bf19a2dd095f$var$G(a);
    if (!$1b01bf19a2dd095f$var$A) {
        if (null !== $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r)) $1b01bf19a2dd095f$var$A = !0, $1b01bf19a2dd095f$var$I($1b01bf19a2dd095f$var$J);
        else {
            var b = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$t);
            null !== b && $1b01bf19a2dd095f$var$K($1b01bf19a2dd095f$var$H, b.startTime - a);
        }
    }
}
function $1b01bf19a2dd095f$var$J(a, b) {
    $1b01bf19a2dd095f$var$A = !1;
    $1b01bf19a2dd095f$var$B && ($1b01bf19a2dd095f$var$B = !1, $1b01bf19a2dd095f$var$E($1b01bf19a2dd095f$var$L), $1b01bf19a2dd095f$var$L = -1);
    $1b01bf19a2dd095f$var$z = !0;
    var c = $1b01bf19a2dd095f$var$y;
    try {
        $1b01bf19a2dd095f$var$G(b);
        for($1b01bf19a2dd095f$var$v = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r); null !== $1b01bf19a2dd095f$var$v && (!($1b01bf19a2dd095f$var$v.expirationTime > b) || a && !$1b01bf19a2dd095f$var$M());){
            var d = $1b01bf19a2dd095f$var$v.callback;
            if ("function" === typeof d) {
                $1b01bf19a2dd095f$var$v.callback = null;
                $1b01bf19a2dd095f$var$y = $1b01bf19a2dd095f$var$v.priorityLevel;
                var e = d($1b01bf19a2dd095f$var$v.expirationTime <= b);
                b = $1b01bf19a2dd095f$export$c4744153514ff05d();
                "function" === typeof e ? $1b01bf19a2dd095f$var$v.callback = e : $1b01bf19a2dd095f$var$v === $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r) && $1b01bf19a2dd095f$var$k($1b01bf19a2dd095f$var$r);
                $1b01bf19a2dd095f$var$G(b);
            } else $1b01bf19a2dd095f$var$k($1b01bf19a2dd095f$var$r);
            $1b01bf19a2dd095f$var$v = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r);
        }
        if (null !== $1b01bf19a2dd095f$var$v) var w = !0;
        else {
            var m = $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$t);
            null !== m && $1b01bf19a2dd095f$var$K($1b01bf19a2dd095f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1b01bf19a2dd095f$var$v = null, $1b01bf19a2dd095f$var$y = c, $1b01bf19a2dd095f$var$z = !1;
    }
}
var $1b01bf19a2dd095f$var$N = !1, $1b01bf19a2dd095f$var$O = null, $1b01bf19a2dd095f$var$L = -1, $1b01bf19a2dd095f$var$P = 5, $1b01bf19a2dd095f$var$Q = -1;
function $1b01bf19a2dd095f$var$M() {
    return $1b01bf19a2dd095f$export$c4744153514ff05d() - $1b01bf19a2dd095f$var$Q < $1b01bf19a2dd095f$var$P ? !1 : !0;
}
function $1b01bf19a2dd095f$var$R() {
    if (null !== $1b01bf19a2dd095f$var$O) {
        var a = $1b01bf19a2dd095f$export$c4744153514ff05d();
        $1b01bf19a2dd095f$var$Q = a;
        var b = !0;
        try {
            b = $1b01bf19a2dd095f$var$O(!0, a);
        } finally{
            b ? $1b01bf19a2dd095f$var$S() : ($1b01bf19a2dd095f$var$N = !1, $1b01bf19a2dd095f$var$O = null);
        }
    } else $1b01bf19a2dd095f$var$N = !1;
}
var $1b01bf19a2dd095f$var$S;
if ("function" === typeof $1b01bf19a2dd095f$var$F) $1b01bf19a2dd095f$var$S = function() {
    $1b01bf19a2dd095f$var$F($1b01bf19a2dd095f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1b01bf19a2dd095f$var$T = new MessageChannel, $1b01bf19a2dd095f$var$U = $1b01bf19a2dd095f$var$T.port2;
    $1b01bf19a2dd095f$var$T.port1.onmessage = $1b01bf19a2dd095f$var$R;
    $1b01bf19a2dd095f$var$S = function() {
        $1b01bf19a2dd095f$var$U.postMessage(null);
    };
} else $1b01bf19a2dd095f$var$S = function() {
    $1b01bf19a2dd095f$var$D($1b01bf19a2dd095f$var$R, 0);
};
function $1b01bf19a2dd095f$var$I(a) {
    $1b01bf19a2dd095f$var$O = a;
    $1b01bf19a2dd095f$var$N || ($1b01bf19a2dd095f$var$N = !0, $1b01bf19a2dd095f$var$S());
}
function $1b01bf19a2dd095f$var$K(a, b) {
    $1b01bf19a2dd095f$var$L = $1b01bf19a2dd095f$var$D(function() {
        a($1b01bf19a2dd095f$export$c4744153514ff05d());
    }, b);
}
$1b01bf19a2dd095f$export$3e506c1ccc9cc1a7 = 5;
$1b01bf19a2dd095f$export$e26fe2ed2fa76875 = 1;
$1b01bf19a2dd095f$export$502329bbf4b505b1 = 4;
$1b01bf19a2dd095f$export$6e3807111c4874c4 = 3;
$1b01bf19a2dd095f$export$c27134553091fb3a = null;
$1b01bf19a2dd095f$export$33ee1acdc04fd2a2 = 2;
$1b01bf19a2dd095f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1b01bf19a2dd095f$export$8352ce38b91d0c62 = function() {
    $1b01bf19a2dd095f$var$A || $1b01bf19a2dd095f$var$z || ($1b01bf19a2dd095f$var$A = !0, $1b01bf19a2dd095f$var$I($1b01bf19a2dd095f$var$J));
};
$1b01bf19a2dd095f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1b01bf19a2dd095f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1b01bf19a2dd095f$export$d3dfb8e4810cb555 = function() {
    return $1b01bf19a2dd095f$var$y;
};
$1b01bf19a2dd095f$export$839f9183b0465a69 = function() {
    return $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r);
};
$1b01bf19a2dd095f$export$72fdf0e06517287b = function(a) {
    switch($1b01bf19a2dd095f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1b01bf19a2dd095f$var$y;
    }
    var c = $1b01bf19a2dd095f$var$y;
    $1b01bf19a2dd095f$var$y = b;
    try {
        return a();
    } finally{
        $1b01bf19a2dd095f$var$y = c;
    }
};
$1b01bf19a2dd095f$export$4b844e58a3e414b4 = function() {};
$1b01bf19a2dd095f$export$816d2913ae6b83b1 = function() {};
$1b01bf19a2dd095f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1b01bf19a2dd095f$var$y;
    $1b01bf19a2dd095f$var$y = a;
    try {
        return b();
    } finally{
        $1b01bf19a2dd095f$var$y = c;
    }
};
$1b01bf19a2dd095f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1b01bf19a2dd095f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1b01bf19a2dd095f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1b01bf19a2dd095f$var$f($1b01bf19a2dd095f$var$t, a), null === $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$r) && a === $1b01bf19a2dd095f$var$h($1b01bf19a2dd095f$var$t) && ($1b01bf19a2dd095f$var$B ? ($1b01bf19a2dd095f$var$E($1b01bf19a2dd095f$var$L), $1b01bf19a2dd095f$var$L = -1) : $1b01bf19a2dd095f$var$B = !0, $1b01bf19a2dd095f$var$K($1b01bf19a2dd095f$var$H, c - d))) : (a.sortIndex = e, $1b01bf19a2dd095f$var$f($1b01bf19a2dd095f$var$r, a), $1b01bf19a2dd095f$var$A || $1b01bf19a2dd095f$var$z || ($1b01bf19a2dd095f$var$A = !0, $1b01bf19a2dd095f$var$I($1b01bf19a2dd095f$var$J)));
    return a;
};
$1b01bf19a2dd095f$export$b5836b71941fa3ed = $1b01bf19a2dd095f$var$M;
$1b01bf19a2dd095f$export$cf845f2c119da08a = function(a) {
    var b = $1b01bf19a2dd095f$var$y;
    return function() {
        var c = $1b01bf19a2dd095f$var$y;
        $1b01bf19a2dd095f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1b01bf19a2dd095f$var$y = c;
        }
    };
};

});



parcelRegister("h4LgD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jj9V1 = parcelRequire("jj9V1");
function $c6e779b35cf0d670$var$emptyFunction() {}
function $c6e779b35cf0d670$var$emptyFunctionWithReset() {}
$c6e779b35cf0d670$var$emptyFunctionWithReset.resetWarningCache = $c6e779b35cf0d670$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jj9V1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c6e779b35cf0d670$var$emptyFunctionWithReset,
        resetWarningCache: $c6e779b35cf0d670$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jj9V1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $e0e77c4edcf98c9b$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $e0e77c4edcf98c9b$var$ReactPropTypesSecret;

});


parcelRegister("aJZNZ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $7d1e0c98227add78$export$2b8d127b894957b9, (v) => $7d1e0c98227add78$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $7d1e0c98227add78$export$cea3a54a6425200c, (v) => $7d1e0c98227add78$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $7d1e0c98227add78$export$a7c73072b1a182ae, (v) => $7d1e0c98227add78$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7d1e0c98227add78$export$9f27bc3417b4524d, (v) => $7d1e0c98227add78$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7d1e0c98227add78$export$db77ccec0bb4ccac, (v) => $7d1e0c98227add78$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7d1e0c98227add78$export$8392c0c9d3dcbd35, (v) => $7d1e0c98227add78$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7d1e0c98227add78$export$ffb0004e005737fa, (v) => $7d1e0c98227add78$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7d1e0c98227add78$export$b624eff549462981, (v) => $7d1e0c98227add78$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7d1e0c98227add78$export$7897aa7841a5380c, (v) => $7d1e0c98227add78$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7d1e0c98227add78$export$602eac185826482c, (v) => $7d1e0c98227add78$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7d1e0c98227add78$export$e2c29f18771995cb, (v) => $7d1e0c98227add78$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7d1e0c98227add78$export$5f8d39834fd61797, (v) => $7d1e0c98227add78$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7d1e0c98227add78$export$74bf444e3cd11ea5, (v) => $7d1e0c98227add78$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7d1e0c98227add78$export$92387174baf9b227, (v) => $7d1e0c98227add78$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7d1e0c98227add78$export$ec112efeb987d9c6, (v) => $7d1e0c98227add78$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7d1e0c98227add78$export$b706b080d889d2c9, (v) => $7d1e0c98227add78$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7d1e0c98227add78$export$5be5a87408f70ddc, (v) => $7d1e0c98227add78$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7d1e0c98227add78$export$45a5e7f76e0caa8d, (v) => $7d1e0c98227add78$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7d1e0c98227add78$export$455c2e768291efa6, (v) => $7d1e0c98227add78$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7d1e0c98227add78$export$9522e17588c12572, (v) => $7d1e0c98227add78$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7d1e0c98227add78$export$2110ac352bb060b9, (v) => $7d1e0c98227add78$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7d1e0c98227add78$export$56885ab8b9c456ab, (v) => $7d1e0c98227add78$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7d1e0c98227add78$export$d927fcb6adf8f9de, (v) => $7d1e0c98227add78$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7d1e0c98227add78$export$b82d16f27459e05a, (v) => $7d1e0c98227add78$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7d1e0c98227add78$export$522c17b4f5e123e8, (v) => $7d1e0c98227add78$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7d1e0c98227add78$export$1aabd8a0274ecfd6, (v) => $7d1e0c98227add78$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $7d1e0c98227add78$export$9b621391a187a31a, (v) => $7d1e0c98227add78$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7d1e0c98227add78$export$f5bbd400c2f4426f, (v) => $7d1e0c98227add78$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7d1e0c98227add78$export$2b8d127b894957b9;
var $7d1e0c98227add78$export$cea3a54a6425200c;
var $7d1e0c98227add78$export$a7c73072b1a182ae;
var $7d1e0c98227add78$export$9f27bc3417b4524d;
var $7d1e0c98227add78$export$db77ccec0bb4ccac;
var $7d1e0c98227add78$export$8392c0c9d3dcbd35;
var $7d1e0c98227add78$export$ffb0004e005737fa;
var $7d1e0c98227add78$export$b624eff549462981;
var $7d1e0c98227add78$export$7897aa7841a5380c;
var $7d1e0c98227add78$export$602eac185826482c;
var $7d1e0c98227add78$export$e2c29f18771995cb;
var $7d1e0c98227add78$export$5f8d39834fd61797;
var $7d1e0c98227add78$export$74bf444e3cd11ea5;
var $7d1e0c98227add78$export$92387174baf9b227;
var $7d1e0c98227add78$export$ec112efeb987d9c6;
var $7d1e0c98227add78$export$b706b080d889d2c9;
var $7d1e0c98227add78$export$5be5a87408f70ddc;
var $7d1e0c98227add78$export$45a5e7f76e0caa8d;
var $7d1e0c98227add78$export$455c2e768291efa6;
var $7d1e0c98227add78$export$9522e17588c12572;
var $7d1e0c98227add78$export$2110ac352bb060b9;
var $7d1e0c98227add78$export$56885ab8b9c456ab;
var $7d1e0c98227add78$export$d927fcb6adf8f9de;
var $7d1e0c98227add78$export$b82d16f27459e05a;
var $7d1e0c98227add78$export$522c17b4f5e123e8;
var $7d1e0c98227add78$export$1aabd8a0274ecfd6;
var $7d1e0c98227add78$export$9b621391a187a31a;
var $7d1e0c98227add78$export$f5bbd400c2f4426f;
'use strict';
var $7d1e0c98227add78$var$b = "function" === typeof Symbol && Symbol.for, $7d1e0c98227add78$var$c = $7d1e0c98227add78$var$b ? Symbol.for("react.element") : 60103, $7d1e0c98227add78$var$d = $7d1e0c98227add78$var$b ? Symbol.for("react.portal") : 60106, $7d1e0c98227add78$var$e = $7d1e0c98227add78$var$b ? Symbol.for("react.fragment") : 60107, $7d1e0c98227add78$var$f = $7d1e0c98227add78$var$b ? Symbol.for("react.strict_mode") : 60108, $7d1e0c98227add78$var$g = $7d1e0c98227add78$var$b ? Symbol.for("react.profiler") : 60114, $7d1e0c98227add78$var$h = $7d1e0c98227add78$var$b ? Symbol.for("react.provider") : 60109, $7d1e0c98227add78$var$k = $7d1e0c98227add78$var$b ? Symbol.for("react.context") : 60110, $7d1e0c98227add78$var$l = $7d1e0c98227add78$var$b ? Symbol.for("react.async_mode") : 60111, $7d1e0c98227add78$var$m = $7d1e0c98227add78$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7d1e0c98227add78$var$n = $7d1e0c98227add78$var$b ? Symbol.for("react.forward_ref") : 60112, $7d1e0c98227add78$var$p = $7d1e0c98227add78$var$b ? Symbol.for("react.suspense") : 60113, $7d1e0c98227add78$var$q = $7d1e0c98227add78$var$b ? Symbol.for("react.suspense_list") : 60120, $7d1e0c98227add78$var$r = $7d1e0c98227add78$var$b ? Symbol.for("react.memo") : 60115, $7d1e0c98227add78$var$t = $7d1e0c98227add78$var$b ? Symbol.for("react.lazy") : 60116, $7d1e0c98227add78$var$v = $7d1e0c98227add78$var$b ? Symbol.for("react.block") : 60121, $7d1e0c98227add78$var$w = $7d1e0c98227add78$var$b ? Symbol.for("react.fundamental") : 60117, $7d1e0c98227add78$var$x = $7d1e0c98227add78$var$b ? Symbol.for("react.responder") : 60118, $7d1e0c98227add78$var$y = $7d1e0c98227add78$var$b ? Symbol.for("react.scope") : 60119;
function $7d1e0c98227add78$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7d1e0c98227add78$var$c:
                switch(a = a.type, a){
                    case $7d1e0c98227add78$var$l:
                    case $7d1e0c98227add78$var$m:
                    case $7d1e0c98227add78$var$e:
                    case $7d1e0c98227add78$var$g:
                    case $7d1e0c98227add78$var$f:
                    case $7d1e0c98227add78$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7d1e0c98227add78$var$k:
                            case $7d1e0c98227add78$var$n:
                            case $7d1e0c98227add78$var$t:
                            case $7d1e0c98227add78$var$r:
                            case $7d1e0c98227add78$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7d1e0c98227add78$var$d:
                return u;
        }
    }
}
function $7d1e0c98227add78$var$A(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$m;
}
$7d1e0c98227add78$export$2b8d127b894957b9 = $7d1e0c98227add78$var$l;
$7d1e0c98227add78$export$cea3a54a6425200c = $7d1e0c98227add78$var$m;
$7d1e0c98227add78$export$a7c73072b1a182ae = $7d1e0c98227add78$var$k;
$7d1e0c98227add78$export$9f27bc3417b4524d = $7d1e0c98227add78$var$h;
$7d1e0c98227add78$export$db77ccec0bb4ccac = $7d1e0c98227add78$var$c;
$7d1e0c98227add78$export$8392c0c9d3dcbd35 = $7d1e0c98227add78$var$n;
$7d1e0c98227add78$export$ffb0004e005737fa = $7d1e0c98227add78$var$e;
$7d1e0c98227add78$export$b624eff549462981 = $7d1e0c98227add78$var$t;
$7d1e0c98227add78$export$7897aa7841a5380c = $7d1e0c98227add78$var$r;
$7d1e0c98227add78$export$602eac185826482c = $7d1e0c98227add78$var$d;
$7d1e0c98227add78$export$e2c29f18771995cb = $7d1e0c98227add78$var$g;
$7d1e0c98227add78$export$5f8d39834fd61797 = $7d1e0c98227add78$var$f;
$7d1e0c98227add78$export$74bf444e3cd11ea5 = $7d1e0c98227add78$var$p;
$7d1e0c98227add78$export$92387174baf9b227 = function(a) {
    return $7d1e0c98227add78$var$A(a) || $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$l;
};
$7d1e0c98227add78$export$ec112efeb987d9c6 = $7d1e0c98227add78$var$A;
$7d1e0c98227add78$export$b706b080d889d2c9 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$k;
};
$7d1e0c98227add78$export$5be5a87408f70ddc = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$h;
};
$7d1e0c98227add78$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7d1e0c98227add78$var$c;
};
$7d1e0c98227add78$export$455c2e768291efa6 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$n;
};
$7d1e0c98227add78$export$9522e17588c12572 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$e;
};
$7d1e0c98227add78$export$2110ac352bb060b9 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$t;
};
$7d1e0c98227add78$export$56885ab8b9c456ab = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$r;
};
$7d1e0c98227add78$export$d927fcb6adf8f9de = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$d;
};
$7d1e0c98227add78$export$b82d16f27459e05a = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$g;
};
$7d1e0c98227add78$export$522c17b4f5e123e8 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$f;
};
$7d1e0c98227add78$export$1aabd8a0274ecfd6 = function(a) {
    return $7d1e0c98227add78$var$z(a) === $7d1e0c98227add78$var$p;
};
$7d1e0c98227add78$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7d1e0c98227add78$var$e || a === $7d1e0c98227add78$var$m || a === $7d1e0c98227add78$var$g || a === $7d1e0c98227add78$var$f || a === $7d1e0c98227add78$var$p || a === $7d1e0c98227add78$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7d1e0c98227add78$var$t || a.$$typeof === $7d1e0c98227add78$var$r || a.$$typeof === $7d1e0c98227add78$var$h || a.$$typeof === $7d1e0c98227add78$var$k || a.$$typeof === $7d1e0c98227add78$var$n || a.$$typeof === $7d1e0c98227add78$var$w || a.$$typeof === $7d1e0c98227add78$var$x || a.$$typeof === $7d1e0c98227add78$var$y || a.$$typeof === $7d1e0c98227add78$var$v);
};
$7d1e0c98227add78$export$f5bbd400c2f4426f = $7d1e0c98227add78$var$z;

});

var $d70211a44dc42c3f$exports = {};
$parcel$extendImportMap({
    "5PpqL": "001-calendar.3e2ce749.svg",
    "5KJ3T": "002-presentation.7db2aa4d.svg",
    "2qdjV": "003-user.4f656df1.svg",
    "eNiNR": "004-inbox.f09a6180.svg",
    "4KxPJ": "alert.80536a36.svg",
    "GVz0W": "arrow-d-dark.56c7424b.svg",
    "9yw1U": "arrow-l-dark.ffd55121.svg",
    "aePOD": "arrow-r-dark.12e53a2d.svg",
    "grwon": "balloons.1c01cf5d.svg",
    "bAHju": "calendar2.0c958edd.svg",
    "6QEyH": "capacity.a5bde89f.svg",
    "h8Ypg": "copy.b13b892a.svg",
    "hqHc2": "defect.1d682244.svg",
    "3JXJ6": "enhancement.4da5f6ed.svg",
    "asp3k": "hourglass.5d4db48d.svg",
    "aANUR": "info.c80b3579.svg",
    "botWB": "jira.0b11140e.svg",
    "aVpIY": "logo.cbf224c1.svg",
    "6zk3I": "overflow.0f7a4219.svg",
    "7sE6R": "pocket.eef95289.svg",
    "lEhw6": "refresh.74696c23.svg",
    "8dwWM": "report.36c00ec3.svg",
    "j9JKa": "rgb.4d79b0c8.svg",
    "72yEg": "settings-circle.690a92d5.svg",
    "g2yu7": "settings.8f08a0ca.svg",
    "fsu8k": "stethoscope.712e8243.svg",
    "5Haau": "task.9beb499c.svg",
    "65HW7": "up-arrow-pink.b15d53fb.svg",
    "dSGhd": "up-arrow-yellow.c106ac18.svg",
    "dQZGC": "warning.05e6c635.svg"
});

var $4c1de7c0601f7260$exports = {};
'use strict';

$4c1de7c0601f7260$exports = (parcelRequire("10chm"));



var $3KGP8 = parcelRequire("3KGP8");
var $0e2dbbef9627a512$export$882461b6382ed46c;
var $0e2dbbef9627a512$export$757ceba2d55c277e;
'use strict';
var $03652cf8627f807b$exports = {};
'use strict';
function $03652cf8627f807b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($03652cf8627f807b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$03652cf8627f807b$var$checkDCE();

$03652cf8627f807b$exports = (parcelRequire("30kIH"));


var $0e2dbbef9627a512$var$i;
$0e2dbbef9627a512$export$882461b6382ed46c = $03652cf8627f807b$exports.createRoot;
$0e2dbbef9627a512$export$757ceba2d55c277e = $03652cf8627f807b$exports.hydrateRoot;




var $3KGP8 = parcelRequire("3KGP8");
const $78971ec0275a44e9$export$7feebea0001a7c34 = /*#__PURE__*/ (0, $3KGP8.createContext)({});
const $78971ec0275a44e9$export$e514c39bb46f1923 = ({ metas: metas, iterations: iterations, qm: qm, releases: releases, teams: teams, refresh: refresh, children: children })=>{
    const value = (0, $3KGP8.useMemo)(()=>({
            metas: metas,
            iterations: iterations,
            qm: qm,
            releases: releases,
            teams: teams,
            refresh: refresh
        }), [
        metas,
        iterations,
        qm,
        releases,
        teams,
        refresh
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($78971ec0275a44e9$export$7feebea0001a7c34.Provider, {
        value: value,
        children: children
    });
};


var $4b4b939aba8f1d15$exports = {};
'use strict';
Object.defineProperty($4b4b939aba8f1d15$exports, '__esModule', {
    value: true
});
function $4b4b939aba8f1d15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4b4b939aba8f1d15$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4b4b939aba8f1d15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4b4b939aba8f1d15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4b4b939aba8f1d15$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4b4b939aba8f1d15$var$_extends() {
    $4b4b939aba8f1d15$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4b4b939aba8f1d15$var$_extends.apply(this, arguments);
}
function $4b4b939aba8f1d15$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $4b4b939aba8f1d15$var$_setPrototypeOf(subClass, superClass);
}
function $4b4b939aba8f1d15$var$_getPrototypeOf(o) {
    $4b4b939aba8f1d15$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4b4b939aba8f1d15$var$_getPrototypeOf(o);
}
function $4b4b939aba8f1d15$var$_setPrototypeOf(o, p) {
    $4b4b939aba8f1d15$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b4b939aba8f1d15$var$_setPrototypeOf(o, p);
}
function $4b4b939aba8f1d15$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4b4b939aba8f1d15$var$_construct(Parent, args, Class) {
    if ($4b4b939aba8f1d15$var$_isNativeReflectConstruct()) $4b4b939aba8f1d15$var$_construct = Reflect.construct.bind();
    else $4b4b939aba8f1d15$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $4b4b939aba8f1d15$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $4b4b939aba8f1d15$var$_construct.apply(null, arguments);
}
function $4b4b939aba8f1d15$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $4b4b939aba8f1d15$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $4b4b939aba8f1d15$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$4b4b939aba8f1d15$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $4b4b939aba8f1d15$var$_construct(Class, arguments, $4b4b939aba8f1d15$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $4b4b939aba8f1d15$var$_setPrototypeOf(Wrapper, Class);
    };
    return $4b4b939aba8f1d15$var$_wrapNativeSuper(Class);
}
function $4b4b939aba8f1d15$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4b4b939aba8f1d15$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4b4b939aba8f1d15$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4b4b939aba8f1d15$var$_arrayLikeToArray(o, minLen);
}
function $4b4b939aba8f1d15$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4b4b939aba8f1d15$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4b4b939aba8f1d15$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4b4b939aba8f1d15$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4b4b939aba8f1d15$var$_toPropertyKey(arg) {
    var key = $4b4b939aba8f1d15$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $4b4b939aba8f1d15$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $4b4b939aba8f1d15$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $4b4b939aba8f1d15$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $4b4b939aba8f1d15$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $4b4b939aba8f1d15$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $4b4b939aba8f1d15$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($4b4b939aba8f1d15$var$LuxonError);
/**
 * @private
 */ var $4b4b939aba8f1d15$var$n = "numeric", $4b4b939aba8f1d15$var$s = "short", $4b4b939aba8f1d15$var$l = "long";
var $4b4b939aba8f1d15$var$DATE_SHORT = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$n,
    day: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATE_MED = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$s,
    day: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATE_MED_WITH_WEEKDAY = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$s,
    day: $4b4b939aba8f1d15$var$n,
    weekday: $4b4b939aba8f1d15$var$s
};
var $4b4b939aba8f1d15$var$DATE_FULL = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATE_HUGE = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n,
    weekday: $4b4b939aba8f1d15$var$l
};
var $4b4b939aba8f1d15$var$TIME_SIMPLE = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$TIME_WITH_SECONDS = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$TIME_WITH_SHORT_OFFSET = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$s
};
var $4b4b939aba8f1d15$var$TIME_WITH_LONG_OFFSET = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$l
};
var $4b4b939aba8f1d15$var$TIME_24_SIMPLE = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    hourCycle: "h23"
};
var $4b4b939aba8f1d15$var$TIME_24_WITH_SECONDS = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    hourCycle: "h23"
};
var $4b4b939aba8f1d15$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    hourCycle: "h23",
    timeZoneName: $4b4b939aba8f1d15$var$s
};
var $4b4b939aba8f1d15$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    hourCycle: "h23",
    timeZoneName: $4b4b939aba8f1d15$var$l
};
var $4b4b939aba8f1d15$var$DATETIME_SHORT = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$n,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$n,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATETIME_MED = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$s,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATETIME_MED_WITH_SECONDS = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$s,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$s,
    day: $4b4b939aba8f1d15$var$n,
    weekday: $4b4b939aba8f1d15$var$s,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n
};
var $4b4b939aba8f1d15$var$DATETIME_FULL = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$s
};
var $4b4b939aba8f1d15$var$DATETIME_FULL_WITH_SECONDS = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$s
};
var $4b4b939aba8f1d15$var$DATETIME_HUGE = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n,
    weekday: $4b4b939aba8f1d15$var$l,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$l
};
var $4b4b939aba8f1d15$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $4b4b939aba8f1d15$var$n,
    month: $4b4b939aba8f1d15$var$l,
    day: $4b4b939aba8f1d15$var$n,
    weekday: $4b4b939aba8f1d15$var$l,
    hour: $4b4b939aba8f1d15$var$n,
    minute: $4b4b939aba8f1d15$var$n,
    second: $4b4b939aba8f1d15$var$n,
    timeZoneName: $4b4b939aba8f1d15$var$l
};
/**
 * @interface
 */ var $4b4b939aba8f1d15$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
    };
    $4b4b939aba8f1d15$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $4b4b939aba8f1d15$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $4b4b939aba8f1d15$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $4b4b939aba8f1d15$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $4b4b939aba8f1d15$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $4b4b939aba8f1d15$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4b4b939aba8f1d15$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $4b4b939aba8f1d15$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($4b4b939aba8f1d15$var$singleton$1 === null) $4b4b939aba8f1d15$var$singleton$1 = new SystemZone();
                return $4b4b939aba8f1d15$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($4b4b939aba8f1d15$var$Zone);
var $4b4b939aba8f1d15$var$dtfCache = {};
function $4b4b939aba8f1d15$var$makeDTF(zone) {
    if (!$4b4b939aba8f1d15$var$dtfCache[zone]) $4b4b939aba8f1d15$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $4b4b939aba8f1d15$var$dtfCache[zone];
}
var $4b4b939aba8f1d15$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $4b4b939aba8f1d15$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $4b4b939aba8f1d15$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $4b4b939aba8f1d15$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$4b4b939aba8f1d15$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $4b4b939aba8f1d15$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $4b4b939aba8f1d15$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $4b4b939aba8f1d15$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$4b4b939aba8f1d15$var$ianaZoneCache[name]) $4b4b939aba8f1d15$var$ianaZoneCache[name] = new IANAZone(name);
        return $4b4b939aba8f1d15$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $4b4b939aba8f1d15$var$ianaZoneCache = {};
        $4b4b939aba8f1d15$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $4b4b939aba8f1d15$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4b4b939aba8f1d15$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $4b4b939aba8f1d15$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $4b4b939aba8f1d15$var$partsOffset(dtf, date) : $4b4b939aba8f1d15$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $4b4b939aba8f1d15$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $4b4b939aba8f1d15$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($4b4b939aba8f1d15$var$Zone);
var $4b4b939aba8f1d15$var$_excluded = [
    "base"
], $4b4b939aba8f1d15$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $4b4b939aba8f1d15$var$intlLFCache = {};
function $4b4b939aba8f1d15$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $4b4b939aba8f1d15$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $4b4b939aba8f1d15$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $4b4b939aba8f1d15$var$intlDTCache = {};
function $4b4b939aba8f1d15$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $4b4b939aba8f1d15$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $4b4b939aba8f1d15$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $4b4b939aba8f1d15$var$intlNumCache = {};
function $4b4b939aba8f1d15$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $4b4b939aba8f1d15$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $4b4b939aba8f1d15$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $4b4b939aba8f1d15$var$intlRelCache = {};
function $4b4b939aba8f1d15$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $4b4b939aba8f1d15$var$_objectWithoutPropertiesLoose(_opts, $4b4b939aba8f1d15$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $4b4b939aba8f1d15$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $4b4b939aba8f1d15$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $4b4b939aba8f1d15$var$sysLocaleCache = null;
function $4b4b939aba8f1d15$var$systemLocale() {
    if ($4b4b939aba8f1d15$var$sysLocaleCache) return $4b4b939aba8f1d15$var$sysLocaleCache;
    else {
        $4b4b939aba8f1d15$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $4b4b939aba8f1d15$var$sysLocaleCache;
    }
}
function $4b4b939aba8f1d15$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $4b4b939aba8f1d15$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $4b4b939aba8f1d15$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $4b4b939aba8f1d15$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $4b4b939aba8f1d15$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $4b4b939aba8f1d15$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $4b4b939aba8f1d15$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $4b4b939aba8f1d15$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $4b4b939aba8f1d15$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $4b4b939aba8f1d15$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $4b4b939aba8f1d15$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $4b4b939aba8f1d15$var$_objectWithoutPropertiesLoose(opts, $4b4b939aba8f1d15$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $4b4b939aba8f1d15$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $4b4b939aba8f1d15$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $4b4b939aba8f1d15$var$roundTo(i, 3);
            return $4b4b939aba8f1d15$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $4b4b939aba8f1d15$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $4b4b939aba8f1d15$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $4b4b939aba8f1d15$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $4b4b939aba8f1d15$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $4b4b939aba8f1d15$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $4b4b939aba8f1d15$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $4b4b939aba8f1d15$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $4b4b939aba8f1d15$var$hasRelative()) this.rtf = $4b4b939aba8f1d15$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $4b4b939aba8f1d15$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $4b4b939aba8f1d15$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $4b4b939aba8f1d15$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $4b4b939aba8f1d15$var$systemLocale());
        var numberingSystemR = numberingSystem || $4b4b939aba8f1d15$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $4b4b939aba8f1d15$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $4b4b939aba8f1d15$var$sysLocaleCache = null;
        $4b4b939aba8f1d15$var$intlDTCache = {};
        $4b4b939aba8f1d15$var$intlNumCache = {};
        $4b4b939aba8f1d15$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $4b4b939aba8f1d15$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $4b4b939aba8f1d15$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($4b4b939aba8f1d15$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($4b4b939aba8f1d15$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $4b4b939aba8f1d15$var$listStuff(this, length, defaultOK, $4b4b939aba8f1d15$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $4b4b939aba8f1d15$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this3 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $4b4b939aba8f1d15$var$listStuff(this, length, defaultOK, $4b4b939aba8f1d15$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $4b4b939aba8f1d15$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $4b4b939aba8f1d15$var$listStuff(this, undefined, defaultOK, function() {
            return $4b4b939aba8f1d15$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $4b4b939aba8f1d15$var$DateTime.utc(2016, 11, 13, 9),
                    $4b4b939aba8f1d15$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this5 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $4b4b939aba8f1d15$var$listStuff(this, length, defaultOK, $4b4b939aba8f1d15$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $4b4b939aba8f1d15$var$DateTime.utc(-40, 1, 1),
                $4b4b939aba8f1d15$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $4b4b939aba8f1d15$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $4b4b939aba8f1d15$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $4b4b939aba8f1d15$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $4b4b939aba8f1d15$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $4b4b939aba8f1d15$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $4b4b939aba8f1d15$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $4b4b939aba8f1d15$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $4b4b939aba8f1d15$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $4b4b939aba8f1d15$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($4b4b939aba8f1d15$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $4b4b939aba8f1d15$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $4b4b939aba8f1d15$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $4b4b939aba8f1d15$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $4b4b939aba8f1d15$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($4b4b939aba8f1d15$var$singleton === null) $4b4b939aba8f1d15$var$singleton = new FixedOffsetZone(0);
                return $4b4b939aba8f1d15$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($4b4b939aba8f1d15$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $4b4b939aba8f1d15$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $4b4b939aba8f1d15$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $4b4b939aba8f1d15$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($4b4b939aba8f1d15$var$Zone);
/**
 * @private
 */ function $4b4b939aba8f1d15$var$normalizeZone(input, defaultZone) {
    if ($4b4b939aba8f1d15$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $4b4b939aba8f1d15$var$Zone) return input;
    else if ($4b4b939aba8f1d15$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $4b4b939aba8f1d15$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $4b4b939aba8f1d15$var$FixedOffsetZone.utcInstance;
        else return $4b4b939aba8f1d15$var$FixedOffsetZone.parseSpecifier(lowered) || $4b4b939aba8f1d15$var$IANAZone.create(input);
    } else if ($4b4b939aba8f1d15$var$isNumber(input)) return $4b4b939aba8f1d15$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $4b4b939aba8f1d15$var$InvalidZone(input);
}
var $4b4b939aba8f1d15$var$now = function now() {
    return Date.now();
}, $4b4b939aba8f1d15$var$defaultZone = "system", $4b4b939aba8f1d15$var$defaultLocale = null, $4b4b939aba8f1d15$var$defaultNumberingSystem = null, $4b4b939aba8f1d15$var$defaultOutputCalendar = null, $4b4b939aba8f1d15$var$twoDigitCutoffYear = 60, $4b4b939aba8f1d15$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $4b4b939aba8f1d15$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $4b4b939aba8f1d15$var$Locale.resetCache();
        $4b4b939aba8f1d15$var$IANAZone.resetCache();
    };
    $4b4b939aba8f1d15$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $4b4b939aba8f1d15$var$now;
            },
            set: function set(n) {
                $4b4b939aba8f1d15$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $4b4b939aba8f1d15$var$normalizeZone($4b4b939aba8f1d15$var$defaultZone, $4b4b939aba8f1d15$var$SystemZone.instance);
            },
            set: function set(zone) {
                $4b4b939aba8f1d15$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $4b4b939aba8f1d15$var$defaultLocale;
            },
            set: function set(locale) {
                $4b4b939aba8f1d15$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $4b4b939aba8f1d15$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $4b4b939aba8f1d15$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $4b4b939aba8f1d15$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $4b4b939aba8f1d15$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $4b4b939aba8f1d15$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $4b4b939aba8f1d15$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $4b4b939aba8f1d15$var$throwOnInvalid;
            },
            set: function set(t) {
                $4b4b939aba8f1d15$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $4b4b939aba8f1d15$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $4b4b939aba8f1d15$var$isNumber(o) {
    return typeof o === "number";
}
function $4b4b939aba8f1d15$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $4b4b939aba8f1d15$var$isString(o) {
    return typeof o === "string";
}
function $4b4b939aba8f1d15$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $4b4b939aba8f1d15$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $4b4b939aba8f1d15$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $4b4b939aba8f1d15$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $4b4b939aba8f1d15$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $4b4b939aba8f1d15$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $4b4b939aba8f1d15$var$integerBetween(thing, bottom, top) {
    return $4b4b939aba8f1d15$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $4b4b939aba8f1d15$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $4b4b939aba8f1d15$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $4b4b939aba8f1d15$var$parseInteger(string) {
    if ($4b4b939aba8f1d15$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $4b4b939aba8f1d15$var$parseFloating(string) {
    if ($4b4b939aba8f1d15$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $4b4b939aba8f1d15$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($4b4b939aba8f1d15$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $4b4b939aba8f1d15$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $4b4b939aba8f1d15$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $4b4b939aba8f1d15$var$daysInYear(year) {
    return $4b4b939aba8f1d15$var$isLeapYear(year) ? 366 : 365;
}
function $4b4b939aba8f1d15$var$daysInMonth(year, month) {
    var modMonth = $4b4b939aba8f1d15$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $4b4b939aba8f1d15$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $4b4b939aba8f1d15$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $4b4b939aba8f1d15$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $4b4b939aba8f1d15$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $4b4b939aba8f1d15$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $4b4b939aba8f1d15$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $4b4b939aba8f1d15$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $4b4b939aba8f1d15$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $4b4b939aba8f1d15$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $4b4b939aba8f1d15$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($4b4b939aba8f1d15$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $4b4b939aba8f1d15$var$asNumber(v);
    }
    return normalized;
}
function $4b4b939aba8f1d15$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $4b4b939aba8f1d15$var$padStart(hours, 2) + ":" + $4b4b939aba8f1d15$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $4b4b939aba8f1d15$var$padStart(hours, 2) + $4b4b939aba8f1d15$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $4b4b939aba8f1d15$var$timeObject(obj) {
    return $4b4b939aba8f1d15$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $4b4b939aba8f1d15$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $4b4b939aba8f1d15$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $4b4b939aba8f1d15$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $4b4b939aba8f1d15$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($4b4b939aba8f1d15$var$monthsNarrow);
        case "short":
            return [].concat($4b4b939aba8f1d15$var$monthsShort);
        case "long":
            return [].concat($4b4b939aba8f1d15$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $4b4b939aba8f1d15$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $4b4b939aba8f1d15$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $4b4b939aba8f1d15$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $4b4b939aba8f1d15$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($4b4b939aba8f1d15$var$weekdaysNarrow);
        case "short":
            return [].concat($4b4b939aba8f1d15$var$weekdaysShort);
        case "long":
            return [].concat($4b4b939aba8f1d15$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $4b4b939aba8f1d15$var$meridiems = [
    "AM",
    "PM"
];
var $4b4b939aba8f1d15$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $4b4b939aba8f1d15$var$erasShort = [
    "BC",
    "AD"
];
var $4b4b939aba8f1d15$var$erasNarrow = [
    "B",
    "A"
];
function $4b4b939aba8f1d15$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($4b4b939aba8f1d15$var$erasNarrow);
        case "short":
            return [].concat($4b4b939aba8f1d15$var$erasShort);
        case "long":
            return [].concat($4b4b939aba8f1d15$var$erasLong);
        default:
            return null;
    }
}
function $4b4b939aba8f1d15$var$meridiemForDateTime(dt) {
    return $4b4b939aba8f1d15$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $4b4b939aba8f1d15$var$weekdayForDateTime(dt, length) {
    return $4b4b939aba8f1d15$var$weekdays(length)[dt.weekday - 1];
}
function $4b4b939aba8f1d15$var$monthForDateTime(dt, length) {
    return $4b4b939aba8f1d15$var$months(length)[dt.month - 1];
}
function $4b4b939aba8f1d15$var$eraForDateTime(dt, length) {
    return $4b4b939aba8f1d15$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $4b4b939aba8f1d15$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $4b4b939aba8f1d15$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $4b4b939aba8f1d15$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $4b4b939aba8f1d15$var$_macroTokenToFormatOpts = {
    D: $4b4b939aba8f1d15$var$DATE_SHORT,
    DD: $4b4b939aba8f1d15$var$DATE_MED,
    DDD: $4b4b939aba8f1d15$var$DATE_FULL,
    DDDD: $4b4b939aba8f1d15$var$DATE_HUGE,
    t: $4b4b939aba8f1d15$var$TIME_SIMPLE,
    tt: $4b4b939aba8f1d15$var$TIME_WITH_SECONDS,
    ttt: $4b4b939aba8f1d15$var$TIME_WITH_SHORT_OFFSET,
    tttt: $4b4b939aba8f1d15$var$TIME_WITH_LONG_OFFSET,
    T: $4b4b939aba8f1d15$var$TIME_24_SIMPLE,
    TT: $4b4b939aba8f1d15$var$TIME_24_WITH_SECONDS,
    TTT: $4b4b939aba8f1d15$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $4b4b939aba8f1d15$var$TIME_24_WITH_LONG_OFFSET,
    f: $4b4b939aba8f1d15$var$DATETIME_SHORT,
    ff: $4b4b939aba8f1d15$var$DATETIME_MED,
    fff: $4b4b939aba8f1d15$var$DATETIME_FULL,
    ffff: $4b4b939aba8f1d15$var$DATETIME_HUGE,
    F: $4b4b939aba8f1d15$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $4b4b939aba8f1d15$var$DATETIME_MED_WITH_SECONDS,
    FFF: $4b4b939aba8f1d15$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $4b4b939aba8f1d15$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $4b4b939aba8f1d15$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $4b4b939aba8f1d15$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $4b4b939aba8f1d15$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $4b4b939aba8f1d15$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $4b4b939aba8f1d15$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(interval.start, $4b4b939aba8f1d15$var$_extends({}, this.opts, opts));
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $4b4b939aba8f1d15$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $4b4b939aba8f1d15$var$padStart(n, p);
        var opts = $4b4b939aba8f1d15$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $4b4b939aba8f1d15$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $4b4b939aba8f1d15$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $4b4b939aba8f1d15$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $4b4b939aba8f1d15$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $4b4b939aba8f1d15$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $4b4b939aba8f1d15$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $4b4b939aba8f1d15$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $4b4b939aba8f1d15$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $4b4b939aba8f1d15$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $4b4b939aba8f1d15$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $4b4b939aba8f1d15$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $4b4b939aba8f1d15$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $4b4b939aba8f1d15$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $4b4b939aba8f1d15$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $4b4b939aba8f1d15$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $4b4b939aba8f1d15$var$isoExtendedZone = "(?:" + $4b4b939aba8f1d15$var$offsetRegex.source + "?(?:\\[(" + $4b4b939aba8f1d15$var$ianaRegex.source + ")\\])?)?";
var $4b4b939aba8f1d15$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $4b4b939aba8f1d15$var$isoTimeRegex = RegExp("" + $4b4b939aba8f1d15$var$isoTimeBaseRegex.source + $4b4b939aba8f1d15$var$isoExtendedZone);
var $4b4b939aba8f1d15$var$isoTimeExtensionRegex = RegExp("(?:T" + $4b4b939aba8f1d15$var$isoTimeRegex.source + ")?");
var $4b4b939aba8f1d15$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $4b4b939aba8f1d15$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $4b4b939aba8f1d15$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $4b4b939aba8f1d15$var$extractISOWeekData = $4b4b939aba8f1d15$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $4b4b939aba8f1d15$var$extractISOOrdinalData = $4b4b939aba8f1d15$var$simpleParse("year", "ordinal");
var $4b4b939aba8f1d15$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $4b4b939aba8f1d15$var$sqlTimeRegex = RegExp($4b4b939aba8f1d15$var$isoTimeBaseRegex.source + " ?(?:" + $4b4b939aba8f1d15$var$offsetRegex.source + "|(" + $4b4b939aba8f1d15$var$ianaRegex.source + "))?");
var $4b4b939aba8f1d15$var$sqlTimeExtensionRegex = RegExp("(?: " + $4b4b939aba8f1d15$var$sqlTimeRegex.source + ")?");
function $4b4b939aba8f1d15$var$int(match, pos, fallback) {
    var m = match[pos];
    return $4b4b939aba8f1d15$var$isUndefined(m) ? fallback : $4b4b939aba8f1d15$var$parseInteger(m);
}
function $4b4b939aba8f1d15$var$extractISOYmd(match, cursor) {
    var item = {
        year: $4b4b939aba8f1d15$var$int(match, cursor),
        month: $4b4b939aba8f1d15$var$int(match, cursor + 1, 1),
        day: $4b4b939aba8f1d15$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $4b4b939aba8f1d15$var$extractISOTime(match, cursor) {
    var item = {
        hours: $4b4b939aba8f1d15$var$int(match, cursor, 0),
        minutes: $4b4b939aba8f1d15$var$int(match, cursor + 1, 0),
        seconds: $4b4b939aba8f1d15$var$int(match, cursor + 2, 0),
        milliseconds: $4b4b939aba8f1d15$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $4b4b939aba8f1d15$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $4b4b939aba8f1d15$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $4b4b939aba8f1d15$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $4b4b939aba8f1d15$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $4b4b939aba8f1d15$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $4b4b939aba8f1d15$var$isoTimeOnly = RegExp("^T?" + $4b4b939aba8f1d15$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $4b4b939aba8f1d15$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $4b4b939aba8f1d15$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($4b4b939aba8f1d15$var$parseFloating(yearStr)),
            months: maybeNegate($4b4b939aba8f1d15$var$parseFloating(monthStr)),
            weeks: maybeNegate($4b4b939aba8f1d15$var$parseFloating(weekStr)),
            days: maybeNegate($4b4b939aba8f1d15$var$parseFloating(dayStr)),
            hours: maybeNegate($4b4b939aba8f1d15$var$parseFloating(hourStr)),
            minutes: maybeNegate($4b4b939aba8f1d15$var$parseFloating(minuteStr)),
            seconds: maybeNegate($4b4b939aba8f1d15$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($4b4b939aba8f1d15$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $4b4b939aba8f1d15$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $4b4b939aba8f1d15$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $4b4b939aba8f1d15$var$untruncateYear($4b4b939aba8f1d15$var$parseInteger(yearStr)) : $4b4b939aba8f1d15$var$parseInteger(yearStr),
        month: $4b4b939aba8f1d15$var$monthsShort.indexOf(monthStr) + 1,
        day: $4b4b939aba8f1d15$var$parseInteger(dayStr),
        hour: $4b4b939aba8f1d15$var$parseInteger(hourStr),
        minute: $4b4b939aba8f1d15$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $4b4b939aba8f1d15$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $4b4b939aba8f1d15$var$weekdaysLong.indexOf(weekdayStr) + 1 : $4b4b939aba8f1d15$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $4b4b939aba8f1d15$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $4b4b939aba8f1d15$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $4b4b939aba8f1d15$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $4b4b939aba8f1d15$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $4b4b939aba8f1d15$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $4b4b939aba8f1d15$var$FixedOffsetZone(offset)
    ];
}
function $4b4b939aba8f1d15$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $4b4b939aba8f1d15$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $4b4b939aba8f1d15$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $4b4b939aba8f1d15$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $4b4b939aba8f1d15$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $4b4b939aba8f1d15$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $4b4b939aba8f1d15$var$FixedOffsetZone.utcInstance
    ];
}
function $4b4b939aba8f1d15$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $4b4b939aba8f1d15$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $4b4b939aba8f1d15$var$FixedOffsetZone.utcInstance
    ];
}
var $4b4b939aba8f1d15$var$isoYmdWithTimeExtensionRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$isoYmdRegex, $4b4b939aba8f1d15$var$isoTimeExtensionRegex);
var $4b4b939aba8f1d15$var$isoWeekWithTimeExtensionRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$isoWeekRegex, $4b4b939aba8f1d15$var$isoTimeExtensionRegex);
var $4b4b939aba8f1d15$var$isoOrdinalWithTimeExtensionRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$isoOrdinalRegex, $4b4b939aba8f1d15$var$isoTimeExtensionRegex);
var $4b4b939aba8f1d15$var$isoTimeCombinedRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$isoTimeRegex);
var $4b4b939aba8f1d15$var$extractISOYmdTimeAndOffset = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOYmd, $4b4b939aba8f1d15$var$extractISOTime, $4b4b939aba8f1d15$var$extractISOOffset, $4b4b939aba8f1d15$var$extractIANAZone);
var $4b4b939aba8f1d15$var$extractISOWeekTimeAndOffset = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOWeekData, $4b4b939aba8f1d15$var$extractISOTime, $4b4b939aba8f1d15$var$extractISOOffset, $4b4b939aba8f1d15$var$extractIANAZone);
var $4b4b939aba8f1d15$var$extractISOOrdinalDateAndTime = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOOrdinalData, $4b4b939aba8f1d15$var$extractISOTime, $4b4b939aba8f1d15$var$extractISOOffset, $4b4b939aba8f1d15$var$extractIANAZone);
var $4b4b939aba8f1d15$var$extractISOTimeAndOffset = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOTime, $4b4b939aba8f1d15$var$extractISOOffset, $4b4b939aba8f1d15$var$extractIANAZone);
/*
 * @private
 */ function $4b4b939aba8f1d15$var$parseISODate(s) {
    return $4b4b939aba8f1d15$var$parse(s, [
        $4b4b939aba8f1d15$var$isoYmdWithTimeExtensionRegex,
        $4b4b939aba8f1d15$var$extractISOYmdTimeAndOffset
    ], [
        $4b4b939aba8f1d15$var$isoWeekWithTimeExtensionRegex,
        $4b4b939aba8f1d15$var$extractISOWeekTimeAndOffset
    ], [
        $4b4b939aba8f1d15$var$isoOrdinalWithTimeExtensionRegex,
        $4b4b939aba8f1d15$var$extractISOOrdinalDateAndTime
    ], [
        $4b4b939aba8f1d15$var$isoTimeCombinedRegex,
        $4b4b939aba8f1d15$var$extractISOTimeAndOffset
    ]);
}
function $4b4b939aba8f1d15$var$parseRFC2822Date(s) {
    return $4b4b939aba8f1d15$var$parse($4b4b939aba8f1d15$var$preprocessRFC2822(s), [
        $4b4b939aba8f1d15$var$rfc2822,
        $4b4b939aba8f1d15$var$extractRFC2822
    ]);
}
function $4b4b939aba8f1d15$var$parseHTTPDate(s) {
    return $4b4b939aba8f1d15$var$parse(s, [
        $4b4b939aba8f1d15$var$rfc1123,
        $4b4b939aba8f1d15$var$extractRFC1123Or850
    ], [
        $4b4b939aba8f1d15$var$rfc850,
        $4b4b939aba8f1d15$var$extractRFC1123Or850
    ], [
        $4b4b939aba8f1d15$var$ascii,
        $4b4b939aba8f1d15$var$extractASCII
    ]);
}
function $4b4b939aba8f1d15$var$parseISODuration(s) {
    return $4b4b939aba8f1d15$var$parse(s, [
        $4b4b939aba8f1d15$var$isoDuration,
        $4b4b939aba8f1d15$var$extractISODuration
    ]);
}
var $4b4b939aba8f1d15$var$extractISOTimeOnly = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOTime);
function $4b4b939aba8f1d15$var$parseISOTimeOnly(s) {
    return $4b4b939aba8f1d15$var$parse(s, [
        $4b4b939aba8f1d15$var$isoTimeOnly,
        $4b4b939aba8f1d15$var$extractISOTimeOnly
    ]);
}
var $4b4b939aba8f1d15$var$sqlYmdWithTimeExtensionRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$sqlYmdRegex, $4b4b939aba8f1d15$var$sqlTimeExtensionRegex);
var $4b4b939aba8f1d15$var$sqlTimeCombinedRegex = $4b4b939aba8f1d15$var$combineRegexes($4b4b939aba8f1d15$var$sqlTimeRegex);
var $4b4b939aba8f1d15$var$extractISOTimeOffsetAndIANAZone = $4b4b939aba8f1d15$var$combineExtractors($4b4b939aba8f1d15$var$extractISOTime, $4b4b939aba8f1d15$var$extractISOOffset, $4b4b939aba8f1d15$var$extractIANAZone);
function $4b4b939aba8f1d15$var$parseSQL(s) {
    return $4b4b939aba8f1d15$var$parse(s, [
        $4b4b939aba8f1d15$var$sqlYmdWithTimeExtensionRegex,
        $4b4b939aba8f1d15$var$extractISOYmdTimeAndOffset
    ], [
        $4b4b939aba8f1d15$var$sqlTimeCombinedRegex,
        $4b4b939aba8f1d15$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $4b4b939aba8f1d15$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $4b4b939aba8f1d15$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $4b4b939aba8f1d15$var$casualMatrix = $4b4b939aba8f1d15$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $4b4b939aba8f1d15$var$lowOrderMatrix), $4b4b939aba8f1d15$var$daysInYearAccurate = 365.2425, $4b4b939aba8f1d15$var$daysInMonthAccurate = 30.436875, $4b4b939aba8f1d15$var$accurateMatrix = $4b4b939aba8f1d15$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $4b4b939aba8f1d15$var$daysInYearAccurate / 7,
        days: $4b4b939aba8f1d15$var$daysInYearAccurate,
        hours: $4b4b939aba8f1d15$var$daysInYearAccurate * 24,
        minutes: $4b4b939aba8f1d15$var$daysInYearAccurate * 1440,
        seconds: $4b4b939aba8f1d15$var$daysInYearAccurate * 86400,
        milliseconds: $4b4b939aba8f1d15$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $4b4b939aba8f1d15$var$daysInYearAccurate / 28,
        days: $4b4b939aba8f1d15$var$daysInYearAccurate / 4,
        hours: $4b4b939aba8f1d15$var$daysInYearAccurate * 24 / 4,
        minutes: $4b4b939aba8f1d15$var$daysInYearAccurate * 1440 / 4,
        seconds: $4b4b939aba8f1d15$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $4b4b939aba8f1d15$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $4b4b939aba8f1d15$var$daysInMonthAccurate / 7,
        days: $4b4b939aba8f1d15$var$daysInMonthAccurate,
        hours: $4b4b939aba8f1d15$var$daysInMonthAccurate * 24,
        minutes: $4b4b939aba8f1d15$var$daysInMonthAccurate * 1440,
        seconds: $4b4b939aba8f1d15$var$daysInMonthAccurate * 86400,
        milliseconds: $4b4b939aba8f1d15$var$daysInMonthAccurate * 86400000
    }
}, $4b4b939aba8f1d15$var$lowOrderMatrix);
// units ordered by size
var $4b4b939aba8f1d15$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $4b4b939aba8f1d15$var$reverseUnits = $4b4b939aba8f1d15$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $4b4b939aba8f1d15$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $4b4b939aba8f1d15$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $4b4b939aba8f1d15$var$Duration(conf);
}
function $4b4b939aba8f1d15$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
}
// NB: mutates parameters
function $4b4b939aba8f1d15$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $4b4b939aba8f1d15$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
}
// NB: mutates parameters
function $4b4b939aba8f1d15$var$normalizeValues(matrix, vals) {
    $4b4b939aba8f1d15$var$reverseUnits.reduce(function(previous, current) {
        if (!$4b4b939aba8f1d15$var$isUndefined(vals[current])) {
            if (previous) $4b4b939aba8f1d15$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $4b4b939aba8f1d15$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $4b4b939aba8f1d15$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $4b4b939aba8f1d15$var$accurateMatrix : $4b4b939aba8f1d15$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $4b4b939aba8f1d15$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $4b4b939aba8f1d15$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $4b4b939aba8f1d15$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $4b4b939aba8f1d15$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($4b4b939aba8f1d15$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $4b4b939aba8f1d15$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $4b4b939aba8f1d15$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $4b4b939aba8f1d15$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $4b4b939aba8f1d15$var$Invalid ? reason : new $4b4b939aba8f1d15$var$Invalid(reason, explanation);
        if ($4b4b939aba8f1d15$var$Settings.throwOnInvalid) throw new $4b4b939aba8f1d15$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $4b4b939aba8f1d15$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $4b4b939aba8f1d15$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $4b4b939aba8f1d15$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $4b4b939aba8f1d15$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $4b4b939aba8f1d15$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($4b4b939aba8f1d15$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($4b4b939aba8f1d15$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($4b4b939aba8f1d15$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $4b4b939aba8f1d15$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $4b4b939aba8f1d15$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $4b4b939aba8f1d15$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $4b4b939aba8f1d15$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($4b4b939aba8f1d15$var$hasOwnProperty(dur.values, k) || $4b4b939aba8f1d15$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $4b4b939aba8f1d15$var$asNumber(fn(this.values[k], k));
        }
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $4b4b939aba8f1d15$var$_extends({}, this.values, $4b4b939aba8f1d15$var$normalizeObject(values, Duration.normalizeUnit));
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $4b4b939aba8f1d15$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $4b4b939aba8f1d15$var$normalizeValues(this.matrix, vals);
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $4b4b939aba8f1d15$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $4b4b939aba8f1d15$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($4b4b939aba8f1d15$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
                // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($4b4b939aba8f1d15$var$orderedUnits$1.indexOf(down) > $4b4b939aba8f1d15$var$orderedUnits$1.indexOf(k)) $4b4b939aba8f1d15$var$convert(this.matrix, vals, down, built, k);
            // otherwise, keep it in the wings to boil it later
            } else if ($4b4b939aba8f1d15$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: built
        }, true).normalize();
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $4b4b939aba8f1d15$var$clone$1(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $4b4b939aba8f1d15$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $4b4b939aba8f1d15$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $4b4b939aba8f1d15$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $4b4b939aba8f1d15$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $4b4b939aba8f1d15$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $4b4b939aba8f1d15$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $4b4b939aba8f1d15$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $4b4b939aba8f1d15$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $4b4b939aba8f1d15$var$Invalid ? reason : new $4b4b939aba8f1d15$var$Invalid(reason, explanation);
        if ($4b4b939aba8f1d15$var$Settings.throwOnInvalid) throw new $4b4b939aba8f1d15$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $4b4b939aba8f1d15$var$friendlyDateTime(start), builtEnd = $4b4b939aba8f1d15$var$friendlyDateTime(end);
        var validateError = $4b4b939aba8f1d15$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $4b4b939aba8f1d15$var$Duration.fromDurationLike(duration), dt = $4b4b939aba8f1d15$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $4b4b939aba8f1d15$var$Duration.fromDurationLike(duration), dt = $4b4b939aba8f1d15$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $4b4b939aba8f1d15$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $4b4b939aba8f1d15$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $4b4b939aba8f1d15$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $4b4b939aba8f1d15$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($4b4b939aba8f1d15$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $4b4b939aba8f1d15$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $4b4b939aba8f1d15$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $4b4b939aba8f1d15$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $4b4b939aba8f1d15$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $4b4b939aba8f1d15$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $4b4b939aba8f1d15$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $4b4b939aba8f1d15$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $4b4b939aba8f1d15$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $4b4b939aba8f1d15$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $4b4b939aba8f1d15$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $4b4b939aba8f1d15$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $4b4b939aba8f1d15$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $4b4b939aba8f1d15$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $4b4b939aba8f1d15$var$Settings.defaultZone;
        var proto = $4b4b939aba8f1d15$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $4b4b939aba8f1d15$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $4b4b939aba8f1d15$var$normalizeZone(input, $4b4b939aba8f1d15$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $4b4b939aba8f1d15$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $4b4b939aba8f1d15$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $4b4b939aba8f1d15$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $4b4b939aba8f1d15$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $4b4b939aba8f1d15$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $4b4b939aba8f1d15$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $4b4b939aba8f1d15$var$hasRelative()
        };
    };
    return Info;
}();
function $4b4b939aba8f1d15$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($4b4b939aba8f1d15$var$Duration.fromMillis(ms).as("days"));
}
function $4b4b939aba8f1d15$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $4b4b939aba8f1d15$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $4b4b939aba8f1d15$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                results[unit]--;
                cursor = earlier.plus(results);
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $4b4b939aba8f1d15$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $4b4b939aba8f1d15$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $4b4b939aba8f1d15$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $4b4b939aba8f1d15$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $4b4b939aba8f1d15$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $4b4b939aba8f1d15$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $4b4b939aba8f1d15$var$hanidecChars = $4b4b939aba8f1d15$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $4b4b939aba8f1d15$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($4b4b939aba8f1d15$var$numberingSystems.hanidec) !== -1) value += $4b4b939aba8f1d15$var$hanidecChars.indexOf(str[i]);
            else for(var key in $4b4b939aba8f1d15$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $4b4b939aba8f1d15$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $4b4b939aba8f1d15$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $4b4b939aba8f1d15$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $4b4b939aba8f1d15$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $4b4b939aba8f1d15$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($4b4b939aba8f1d15$var$parseDigits(s));
        }
    };
}
var $4b4b939aba8f1d15$var$NBSP = String.fromCharCode(160);
var $4b4b939aba8f1d15$var$spaceOrNBSP = "[ " + $4b4b939aba8f1d15$var$NBSP + "]";
var $4b4b939aba8f1d15$var$spaceOrNBSPRegExp = new RegExp($4b4b939aba8f1d15$var$spaceOrNBSP, "g");
function $4b4b939aba8f1d15$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($4b4b939aba8f1d15$var$spaceOrNBSPRegExp, $4b4b939aba8f1d15$var$spaceOrNBSP);
}
function $4b4b939aba8f1d15$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($4b4b939aba8f1d15$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $4b4b939aba8f1d15$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($4b4b939aba8f1d15$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $4b4b939aba8f1d15$var$stripInsensitivities(s) === $4b4b939aba8f1d15$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $4b4b939aba8f1d15$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $4b4b939aba8f1d15$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $4b4b939aba8f1d15$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $4b4b939aba8f1d15$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $4b4b939aba8f1d15$var$unitForToken(token, loc) {
    var one = $4b4b939aba8f1d15$var$digitRegex(loc), two = $4b4b939aba8f1d15$var$digitRegex(loc, "{2}"), three = $4b4b939aba8f1d15$var$digitRegex(loc, "{3}"), four = $4b4b939aba8f1d15$var$digitRegex(loc, "{4}"), six = $4b4b939aba8f1d15$var$digitRegex(loc, "{6}"), oneOrTwo = $4b4b939aba8f1d15$var$digitRegex(loc, "{1,2}"), oneToThree = $4b4b939aba8f1d15$var$digitRegex(loc, "{1,3}"), oneToSix = $4b4b939aba8f1d15$var$digitRegex(loc, "{1,6}"), oneToNine = $4b4b939aba8f1d15$var$digitRegex(loc, "{1,9}"), twoToFour = $4b4b939aba8f1d15$var$digitRegex(loc, "{2,4}"), fourToSix = $4b4b939aba8f1d15$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($4b4b939aba8f1d15$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $4b4b939aba8f1d15$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $4b4b939aba8f1d15$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $4b4b939aba8f1d15$var$intUnit(oneToSix);
            case "yy":
                return $4b4b939aba8f1d15$var$intUnit(twoToFour, $4b4b939aba8f1d15$var$untruncateYear);
            case "yyyy":
                return $4b4b939aba8f1d15$var$intUnit(four);
            case "yyyyy":
                return $4b4b939aba8f1d15$var$intUnit(fourToSix);
            case "yyyyyy":
                return $4b4b939aba8f1d15$var$intUnit(six);
            // months
            case "M":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "MM":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "MMM":
                return $4b4b939aba8f1d15$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $4b4b939aba8f1d15$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "LL":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "LLL":
                return $4b4b939aba8f1d15$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $4b4b939aba8f1d15$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "dd":
                return $4b4b939aba8f1d15$var$intUnit(two);
            // ordinals
            case "o":
                return $4b4b939aba8f1d15$var$intUnit(oneToThree);
            case "ooo":
                return $4b4b939aba8f1d15$var$intUnit(three);
            // time
            case "HH":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "H":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "hh":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "h":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "mm":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "m":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "q":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "qq":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "s":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "ss":
                return $4b4b939aba8f1d15$var$intUnit(two);
            case "S":
                return $4b4b939aba8f1d15$var$intUnit(oneToThree);
            case "SSS":
                return $4b4b939aba8f1d15$var$intUnit(three);
            case "u":
                return $4b4b939aba8f1d15$var$simple(oneToNine);
            case "uu":
                return $4b4b939aba8f1d15$var$simple(oneOrTwo);
            case "uuu":
                return $4b4b939aba8f1d15$var$intUnit(one);
            // meridiem
            case "a":
                return $4b4b939aba8f1d15$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $4b4b939aba8f1d15$var$intUnit(four);
            case "kk":
                return $4b4b939aba8f1d15$var$intUnit(twoToFour, $4b4b939aba8f1d15$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $4b4b939aba8f1d15$var$intUnit(oneOrTwo);
            case "WW":
                return $4b4b939aba8f1d15$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $4b4b939aba8f1d15$var$intUnit(one);
            case "EEE":
                return $4b4b939aba8f1d15$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $4b4b939aba8f1d15$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $4b4b939aba8f1d15$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $4b4b939aba8f1d15$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $4b4b939aba8f1d15$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $4b4b939aba8f1d15$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $4b4b939aba8f1d15$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $4b4b939aba8f1d15$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $4b4b939aba8f1d15$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $4b4b939aba8f1d15$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $4b4b939aba8f1d15$var$tokenForPart(part, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    var val = $4b4b939aba8f1d15$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $4b4b939aba8f1d15$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $4b4b939aba8f1d15$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($4b4b939aba8f1d15$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $4b4b939aba8f1d15$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$4b4b939aba8f1d15$var$isUndefined(matches.z)) zone = $4b4b939aba8f1d15$var$IANAZone.create(matches.z);
    if (!$4b4b939aba8f1d15$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $4b4b939aba8f1d15$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$4b4b939aba8f1d15$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$4b4b939aba8f1d15$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$4b4b939aba8f1d15$var$isUndefined(matches.u)) matches.S = $4b4b939aba8f1d15$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $4b4b939aba8f1d15$var$dummyDateTimeCache = null;
function $4b4b939aba8f1d15$var$getDummyDateTime() {
    if (!$4b4b939aba8f1d15$var$dummyDateTimeCache) $4b4b939aba8f1d15$var$dummyDateTimeCache = $4b4b939aba8f1d15$var$DateTime.fromMillis(1555555555555);
    return $4b4b939aba8f1d15$var$dummyDateTimeCache;
}
function $4b4b939aba8f1d15$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $4b4b939aba8f1d15$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $4b4b939aba8f1d15$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $4b4b939aba8f1d15$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $4b4b939aba8f1d15$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $4b4b939aba8f1d15$var$explainFromTokens(locale, input, format) {
    var tokens = $4b4b939aba8f1d15$var$expandMacroTokens($4b4b939aba8f1d15$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $4b4b939aba8f1d15$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $4b4b939aba8f1d15$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $4b4b939aba8f1d15$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $4b4b939aba8f1d15$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($4b4b939aba8f1d15$var$hasOwnProperty(matches, "a") && $4b4b939aba8f1d15$var$hasOwnProperty(matches, "H")) throw new $4b4b939aba8f1d15$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $4b4b939aba8f1d15$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $4b4b939aba8f1d15$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $4b4b939aba8f1d15$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $4b4b939aba8f1d15$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($4b4b939aba8f1d15$var$getDummyDateTime());
    return parts.map(function(p) {
        return $4b4b939aba8f1d15$var$tokenForPart(p, formatOpts);
    });
}
var $4b4b939aba8f1d15$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $4b4b939aba8f1d15$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $4b4b939aba8f1d15$var$unitOutOfRange(unit, value) {
    return new $4b4b939aba8f1d15$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $4b4b939aba8f1d15$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $4b4b939aba8f1d15$var$computeOrdinal(year, month, day) {
    return day + ($4b4b939aba8f1d15$var$isLeapYear(year) ? $4b4b939aba8f1d15$var$leapLadder : $4b4b939aba8f1d15$var$nonLeapLadder)[month - 1];
}
function $4b4b939aba8f1d15$var$uncomputeOrdinal(year, ordinal) {
    var table = $4b4b939aba8f1d15$var$isLeapYear(year) ? $4b4b939aba8f1d15$var$leapLadder : $4b4b939aba8f1d15$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $4b4b939aba8f1d15$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $4b4b939aba8f1d15$var$computeOrdinal(year, month, day), weekday = $4b4b939aba8f1d15$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $4b4b939aba8f1d15$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $4b4b939aba8f1d15$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $4b4b939aba8f1d15$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $4b4b939aba8f1d15$var$timeObject(gregObj));
}
function $4b4b939aba8f1d15$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $4b4b939aba8f1d15$var$dayOfWeek(weekYear, 1, 4), yearInDays = $4b4b939aba8f1d15$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $4b4b939aba8f1d15$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $4b4b939aba8f1d15$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $4b4b939aba8f1d15$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $4b4b939aba8f1d15$var$_extends({
        year: year,
        month: month,
        day: day
    }, $4b4b939aba8f1d15$var$timeObject(weekData));
}
function $4b4b939aba8f1d15$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $4b4b939aba8f1d15$var$computeOrdinal(year, month, day);
    return $4b4b939aba8f1d15$var$_extends({
        year: year,
        ordinal: ordinal
    }, $4b4b939aba8f1d15$var$timeObject(gregData));
}
function $4b4b939aba8f1d15$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $4b4b939aba8f1d15$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $4b4b939aba8f1d15$var$_extends({
        year: year,
        month: month,
        day: day
    }, $4b4b939aba8f1d15$var$timeObject(ordinalData));
}
function $4b4b939aba8f1d15$var$hasInvalidWeekData(obj) {
    var validYear = $4b4b939aba8f1d15$var$isInteger(obj.weekYear), validWeek = $4b4b939aba8f1d15$var$integerBetween(obj.weekNumber, 1, $4b4b939aba8f1d15$var$weeksInWeekYear(obj.weekYear)), validWeekday = $4b4b939aba8f1d15$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $4b4b939aba8f1d15$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $4b4b939aba8f1d15$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $4b4b939aba8f1d15$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $4b4b939aba8f1d15$var$hasInvalidOrdinalData(obj) {
    var validYear = $4b4b939aba8f1d15$var$isInteger(obj.year), validOrdinal = $4b4b939aba8f1d15$var$integerBetween(obj.ordinal, 1, $4b4b939aba8f1d15$var$daysInYear(obj.year));
    if (!validYear) return $4b4b939aba8f1d15$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $4b4b939aba8f1d15$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $4b4b939aba8f1d15$var$hasInvalidGregorianData(obj) {
    var validYear = $4b4b939aba8f1d15$var$isInteger(obj.year), validMonth = $4b4b939aba8f1d15$var$integerBetween(obj.month, 1, 12), validDay = $4b4b939aba8f1d15$var$integerBetween(obj.day, 1, $4b4b939aba8f1d15$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $4b4b939aba8f1d15$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $4b4b939aba8f1d15$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $4b4b939aba8f1d15$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $4b4b939aba8f1d15$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $4b4b939aba8f1d15$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $4b4b939aba8f1d15$var$integerBetween(minute, 0, 59), validSecond = $4b4b939aba8f1d15$var$integerBetween(second, 0, 59), validMillisecond = $4b4b939aba8f1d15$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $4b4b939aba8f1d15$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $4b4b939aba8f1d15$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $4b4b939aba8f1d15$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $4b4b939aba8f1d15$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $4b4b939aba8f1d15$var$INVALID = "Invalid DateTime";
var $4b4b939aba8f1d15$var$MAX_DATE = 8.64e15;
function $4b4b939aba8f1d15$var$unsupportedZone(zone) {
    return new $4b4b939aba8f1d15$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
function $4b4b939aba8f1d15$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $4b4b939aba8f1d15$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $4b4b939aba8f1d15$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $4b4b939aba8f1d15$var$DateTime($4b4b939aba8f1d15$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $4b4b939aba8f1d15$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $4b4b939aba8f1d15$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $4b4b939aba8f1d15$var$objToTS(obj, offset, zone) {
    return $4b4b939aba8f1d15$var$fixOffset($4b4b939aba8f1d15$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $4b4b939aba8f1d15$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $4b4b939aba8f1d15$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $4b4b939aba8f1d15$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $4b4b939aba8f1d15$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $4b4b939aba8f1d15$var$objToLocalTS(c);
    var _fixOffset = $4b4b939aba8f1d15$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $4b4b939aba8f1d15$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $4b4b939aba8f1d15$var$DateTime.fromObject(parsed, $4b4b939aba8f1d15$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $4b4b939aba8f1d15$var$DateTime.invalid(new $4b4b939aba8f1d15$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $4b4b939aba8f1d15$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $4b4b939aba8f1d15$var$Formatter.create($4b4b939aba8f1d15$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $4b4b939aba8f1d15$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $4b4b939aba8f1d15$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $4b4b939aba8f1d15$var$padStart(o.c.month);
        c += "-";
        c += $4b4b939aba8f1d15$var$padStart(o.c.day);
    } else {
        c += $4b4b939aba8f1d15$var$padStart(o.c.month);
        c += $4b4b939aba8f1d15$var$padStart(o.c.day);
    }
    return c;
}
function $4b4b939aba8f1d15$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $4b4b939aba8f1d15$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $4b4b939aba8f1d15$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $4b4b939aba8f1d15$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $4b4b939aba8f1d15$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $4b4b939aba8f1d15$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $4b4b939aba8f1d15$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $4b4b939aba8f1d15$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $4b4b939aba8f1d15$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $4b4b939aba8f1d15$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $4b4b939aba8f1d15$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $4b4b939aba8f1d15$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $4b4b939aba8f1d15$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $4b4b939aba8f1d15$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $4b4b939aba8f1d15$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $4b4b939aba8f1d15$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $4b4b939aba8f1d15$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $4b4b939aba8f1d15$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $4b4b939aba8f1d15$var$quickDT(obj, opts) {
    var zone = $4b4b939aba8f1d15$var$normalizeZone(opts.zone, $4b4b939aba8f1d15$var$Settings.defaultZone), loc = $4b4b939aba8f1d15$var$Locale.fromObject(opts), tsNow = $4b4b939aba8f1d15$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$4b4b939aba8f1d15$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $4b4b939aba8f1d15$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($4b4b939aba8f1d15$var$isUndefined(obj[u])) obj[u] = $4b4b939aba8f1d15$var$defaultUnitValues[u];
        }
        var invalid = $4b4b939aba8f1d15$var$hasInvalidGregorianData(obj) || $4b4b939aba8f1d15$var$hasInvalidTimeData(obj);
        if (invalid) return $4b4b939aba8f1d15$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $4b4b939aba8f1d15$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $4b4b939aba8f1d15$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $4b4b939aba8f1d15$var$diffRelative(start, end, opts) {
    var round = $4b4b939aba8f1d15$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $4b4b939aba8f1d15$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $4b4b939aba8f1d15$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $4b4b939aba8f1d15$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $4b4b939aba8f1d15$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $4b4b939aba8f1d15$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $4b4b939aba8f1d15$var$Invalid("invalid input") : null) || (!zone.isValid ? $4b4b939aba8f1d15$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $4b4b939aba8f1d15$var$isUndefined(config.ts) ? $4b4b939aba8f1d15$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $4b4b939aba8f1d15$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $4b4b939aba8f1d15$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $4b4b939aba8f1d15$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $4b4b939aba8f1d15$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $4b4b939aba8f1d15$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $4b4b939aba8f1d15$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $4b4b939aba8f1d15$var$FixedOffsetZone.utcInstance;
        return $4b4b939aba8f1d15$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $4b4b939aba8f1d15$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $4b4b939aba8f1d15$var$normalizeZone(options.zone, $4b4b939aba8f1d15$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($4b4b939aba8f1d15$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $4b4b939aba8f1d15$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$4b4b939aba8f1d15$var$isNumber(milliseconds)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$4b4b939aba8f1d15$var$MAX_DATE || milliseconds > $4b4b939aba8f1d15$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $4b4b939aba8f1d15$var$normalizeZone(options.zone, $4b4b939aba8f1d15$var$Settings.defaultZone),
            loc: $4b4b939aba8f1d15$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$4b4b939aba8f1d15$var$isNumber(seconds)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $4b4b939aba8f1d15$var$normalizeZone(options.zone, $4b4b939aba8f1d15$var$Settings.defaultZone),
            loc: $4b4b939aba8f1d15$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $4b4b939aba8f1d15$var$normalizeZone(opts.zone, $4b4b939aba8f1d15$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($4b4b939aba8f1d15$var$unsupportedZone(zoneToUse));
        var tsNow = $4b4b939aba8f1d15$var$Settings.now(), offsetProvis = !$4b4b939aba8f1d15$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $4b4b939aba8f1d15$var$normalizeObject(obj, $4b4b939aba8f1d15$var$normalizeUnit), containsOrdinal = !$4b4b939aba8f1d15$var$isUndefined(normalized.ordinal), containsGregorYear = !$4b4b939aba8f1d15$var$isUndefined(normalized.year), containsGregorMD = !$4b4b939aba8f1d15$var$isUndefined(normalized.month) || !$4b4b939aba8f1d15$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $4b4b939aba8f1d15$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $4b4b939aba8f1d15$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $4b4b939aba8f1d15$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $4b4b939aba8f1d15$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $4b4b939aba8f1d15$var$orderedWeekUnits;
            defaultValues = $4b4b939aba8f1d15$var$defaultWeekUnitValues;
            objNow = $4b4b939aba8f1d15$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $4b4b939aba8f1d15$var$orderedOrdinalUnits;
            defaultValues = $4b4b939aba8f1d15$var$defaultOrdinalUnitValues;
            objNow = $4b4b939aba8f1d15$var$gregorianToOrdinal(objNow);
        } else {
            units = $4b4b939aba8f1d15$var$orderedUnits;
            defaultValues = $4b4b939aba8f1d15$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $4b4b939aba8f1d15$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$4b4b939aba8f1d15$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $4b4b939aba8f1d15$var$hasInvalidWeekData(normalized) : containsOrdinal ? $4b4b939aba8f1d15$var$hasInvalidOrdinalData(normalized) : $4b4b939aba8f1d15$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $4b4b939aba8f1d15$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $4b4b939aba8f1d15$var$weekToGregorian(normalized) : containsOrdinal ? $4b4b939aba8f1d15$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $4b4b939aba8f1d15$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $4b4b939aba8f1d15$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $4b4b939aba8f1d15$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $4b4b939aba8f1d15$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $4b4b939aba8f1d15$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $4b4b939aba8f1d15$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $4b4b939aba8f1d15$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($4b4b939aba8f1d15$var$isUndefined(text) || $4b4b939aba8f1d15$var$isUndefined(fmt)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $4b4b939aba8f1d15$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $4b4b939aba8f1d15$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $4b4b939aba8f1d15$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $4b4b939aba8f1d15$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $4b4b939aba8f1d15$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $4b4b939aba8f1d15$var$Invalid ? reason : new $4b4b939aba8f1d15$var$Invalid(reason, explanation);
        if ($4b4b939aba8f1d15$var$Settings.throwOnInvalid) throw new $4b4b939aba8f1d15$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $4b4b939aba8f1d15$var$formatOptsToTokens(formatOpts, $4b4b939aba8f1d15$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $4b4b939aba8f1d15$var$expandMacroTokens($4b4b939aba8f1d15$var$Formatter.parseFormat(fmt), $4b4b939aba8f1d15$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $4b4b939aba8f1d15$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($4b4b939aba8f1d15$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($4b4b939aba8f1d15$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $4b4b939aba8f1d15$var$normalizeZone(zone, $4b4b939aba8f1d15$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($4b4b939aba8f1d15$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $4b4b939aba8f1d15$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $4b4b939aba8f1d15$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $4b4b939aba8f1d15$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $4b4b939aba8f1d15$var$normalizeObject(values, $4b4b939aba8f1d15$var$normalizeUnit), settingWeekStuff = !$4b4b939aba8f1d15$var$isUndefined(normalized.weekYear) || !$4b4b939aba8f1d15$var$isUndefined(normalized.weekNumber) || !$4b4b939aba8f1d15$var$isUndefined(normalized.weekday), containsOrdinal = !$4b4b939aba8f1d15$var$isUndefined(normalized.ordinal), containsGregorYear = !$4b4b939aba8f1d15$var$isUndefined(normalized.year), containsGregorMD = !$4b4b939aba8f1d15$var$isUndefined(normalized.month) || !$4b4b939aba8f1d15$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $4b4b939aba8f1d15$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $4b4b939aba8f1d15$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $4b4b939aba8f1d15$var$weekToGregorian($4b4b939aba8f1d15$var$_extends({}, $4b4b939aba8f1d15$var$gregorianToWeek(this.c), normalized));
        else if (!$4b4b939aba8f1d15$var$isUndefined(normalized.ordinal)) mixed = $4b4b939aba8f1d15$var$ordinalToGregorian($4b4b939aba8f1d15$var$_extends({}, $4b4b939aba8f1d15$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $4b4b939aba8f1d15$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($4b4b939aba8f1d15$var$isUndefined(normalized.day)) mixed.day = Math.min($4b4b939aba8f1d15$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $4b4b939aba8f1d15$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $4b4b939aba8f1d15$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $4b4b939aba8f1d15$var$Duration.fromDurationLike(duration);
        return $4b4b939aba8f1d15$var$clone(this, $4b4b939aba8f1d15$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $4b4b939aba8f1d15$var$Duration.fromDurationLike(duration).negate();
        return $4b4b939aba8f1d15$var$clone(this, $4b4b939aba8f1d15$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $4b4b939aba8f1d15$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $4b4b939aba8f1d15$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $4b4b939aba8f1d15$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $4b4b939aba8f1d15$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $4b4b939aba8f1d15$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $4b4b939aba8f1d15$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $4b4b939aba8f1d15$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $4b4b939aba8f1d15$var$_toISODate(this, ext);
        c += "T";
        c += $4b4b939aba8f1d15$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    };
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $4b4b939aba8f1d15$var$_toISODate(this, format === "extended");
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $4b4b939aba8f1d15$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $4b4b939aba8f1d15$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $4b4b939aba8f1d15$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $4b4b939aba8f1d15$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $4b4b939aba8f1d15$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $4b4b939aba8f1d15$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $4b4b939aba8f1d15$var$INVALID;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $4b4b939aba8f1d15$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $4b4b939aba8f1d15$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $4b4b939aba8f1d15$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $4b4b939aba8f1d15$var$maybeArray(unit).map($4b4b939aba8f1d15$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $4b4b939aba8f1d15$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $4b4b939aba8f1d15$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $4b4b939aba8f1d15$var$diffRelative(base, this.plus(padding), $4b4b939aba8f1d15$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $4b4b939aba8f1d15$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $4b4b939aba8f1d15$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $4b4b939aba8f1d15$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $4b4b939aba8f1d15$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $4b4b939aba8f1d15$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $4b4b939aba8f1d15$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $4b4b939aba8f1d15$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    $4b4b939aba8f1d15$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $4b4b939aba8f1d15$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $4b4b939aba8f1d15$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $4b4b939aba8f1d15$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $4b4b939aba8f1d15$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $4b4b939aba8f1d15$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $4b4b939aba8f1d15$var$friendlyDateTime(dateTimeish) {
    if ($4b4b939aba8f1d15$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $4b4b939aba8f1d15$var$isNumber(dateTimeish.valueOf())) return $4b4b939aba8f1d15$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $4b4b939aba8f1d15$var$DateTime.fromObject(dateTimeish);
    else throw new $4b4b939aba8f1d15$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $4b4b939aba8f1d15$var$VERSION = "3.3.0";
$4b4b939aba8f1d15$exports.DateTime = $4b4b939aba8f1d15$var$DateTime;
$4b4b939aba8f1d15$exports.Duration = $4b4b939aba8f1d15$var$Duration;
$4b4b939aba8f1d15$exports.FixedOffsetZone = $4b4b939aba8f1d15$var$FixedOffsetZone;
$4b4b939aba8f1d15$exports.IANAZone = $4b4b939aba8f1d15$var$IANAZone;
$4b4b939aba8f1d15$exports.Info = $4b4b939aba8f1d15$var$Info;
$4b4b939aba8f1d15$exports.Interval = $4b4b939aba8f1d15$var$Interval;
$4b4b939aba8f1d15$exports.InvalidZone = $4b4b939aba8f1d15$var$InvalidZone;
$4b4b939aba8f1d15$exports.Settings = $4b4b939aba8f1d15$var$Settings;
$4b4b939aba8f1d15$exports.SystemZone = $4b4b939aba8f1d15$var$SystemZone;
$4b4b939aba8f1d15$exports.VERSION = $4b4b939aba8f1d15$var$VERSION;
$4b4b939aba8f1d15$exports.Zone = $4b4b939aba8f1d15$var$Zone;


/**
 * Manual overrides for the iteration lookup below. This can be used to fix
 * erroneous iteration numbers and date ranges on Bugzilla. It can't be used to
 * add new iterations, since that would require sorting, which is slow.
 * @example { iteration: "66.1", range: "Dec 10 - 23" }
 * @example { iteration: "66.2", range: null } // use null to exclude iterations
 */ const $a2dbb61dc7ec7558$var$ITERATION_OVERRIDES = [];
function $a2dbb61dc7ec7558$export$509d7d0b8be56458(iterations, releases = []) {
    const lookup = {
        byVersionString: {},
        orderedVersionStrings: []
    };
    const rangesByIteration = new Map();
    const STARTING_VERSION = 111;
    const TWO_WEEK_CADENCE_TRANSITION = 155;
    for (const value of iterations){
        const match = value.match(/(\d+)\.(\d+) - (.*)/);
        if (match) {
            const version = parseInt(match[1], 10);
            // Ignore iterations before 111 or after 155
            if (version < STARTING_VERSION || version > TWO_WEEK_CADENCE_TRANSITION) continue;
            const iterationString = `${match[1]}.${match[2]}`;
            // match[1].match[2] is the iteration number like 155.1, and match[3] is
            // the date range like "Aug 28 - Sept 8"
            rangesByIteration.set(iterationString, match[3]);
        }
    }
    // Add manual overrides
    for (const { iteration: iteration, range: range } of $a2dbb61dc7ec7558$var$ITERATION_OVERRIDES)if (range) rangesByIteration.set(iteration, range);
    else rangesByIteration.delete(iteration);
    // In order to generate actual dates, we need to infer the year, since
    // iterations aren't stored with years. We do this by using the starting
    // version date as the epoch, and incrementing the year by one each time we
    // see an iteration's start date has a month before the previous iteration's
    // start date month.
    let lastDate = null;
    let lastMonth = -1;
    let year = 2022;
    for (const [iteration, range] of rangesByIteration){
        // We can handle dates of the forms "July 3 - 14" and "Aug 28 - Sept 8"
        // (where the end date falls in a different month than the start date).
        const match = range.match(/(\w+) (\d+) ?- ?(?:(\w+) )?(\d+)/);
        if (match) {
            const startMonth = $a2dbb61dc7ec7558$var$normalizeMonthString(match[1]);
            const endMonth = match[3] ? $a2dbb61dc7ec7558$var$normalizeMonthString(match[3]) : startMonth;
            let startDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromFormat(`${startMonth} ${match[2]} ${year}`, "LLL d y", {
                locale: "en-US"
            });
            if (startDate.month < lastMonth) year += 1;
            startDate = startDate.set({
                year: year
            }).startOf("week");
            lastMonth = startDate.month;
            while(lastDate && startDate < lastDate)// This iteration starts before the previous iteration ended. That means
            // we actually want it to start on the first Monday after the start.
            startDate = startDate.plus({
                weeks: 1
            });
            const startDateTime = startDate.startOf("day").toISO();
            let endDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromFormat(`${endMonth} ${match[4]} ${year}`, "LLL d y", {
                locale: "en-US"
            });
            if (endDate.month < lastMonth) year += 1;
            // If the end date is a Monday, set it to the previous Sunday.
            if (endDate.weekday === 1) endDate = endDate.minus({
                days: 1
            });
            // Otherwise, set it to the next Sunday.
            endDate = endDate.set({
                year: year
            }).endOf("week");
            lastDate = endDate;
            lastMonth = lastDate.month;
            const endDateTime = endDate.startOf("day").toISO();
            const weeks = Math.ceil(endDate.diff(startDate, "days").days / 7);
            if (startDateTime && endDateTime && weeks) {
                lookup.byVersionString[iteration] = {
                    startDate: startDateTime,
                    weeks: weeks,
                    endDate: endDateTime
                };
                lookup.orderedVersionStrings.push(iteration);
            }
        }
    }
    // now we need to add the releases to the lookup. they have a different shape
    // that's more straightforward:
    // {
    //   version: 156,
    //   start: "2026-08-13 00:00:00+00:00",
    //   end: "2026-08-27 16:00:00+00:00",
    // }
    // but these start and end on thursdays, whereas iterations are supposed to
    // start on mondays and end on sundays. so we need to adjust the dates to jam
    // them into the iteration lookup. we also need to run the above process in
    // reverse to get a date range string like "Aug 13 - 23", since releases don't
    // have that information. we can do this by using the start and end dates to
    // get the month and day, and then formatting them into a string. those get
    // added to orderedVersionStrings and byVersionString. trying to fit these
    // nice dates onto the janky iteration lookup table is pretty silly, but it
    // would be more effort to update everything else.
    for (const release of releases){
        const { version: version, start: start, end: end } = release;
        const startDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromSQL(start, {
            setZone: true
        });
        const endDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromSQL(end, {
            setZone: true
        });
        const startDateTime = startDate.startOf("day").toISO();
        const endDateTime = endDate.startOf("day").toISO();
        if (startDateTime && endDateTime) {
            const iterationString = version.toString();
            const weeks = Math.ceil(endDate.diff(startDate, "days").days / 7);
            lookup.byVersionString[iterationString] = {
                startDate: startDateTime,
                weeks: weeks,
                endDate: endDateTime
            };
            lookup.orderedVersionStrings.push(iterationString);
        }
    }
    return lookup;
}
/**
 * Convert a month string to a 3-letter abbreviation. Some month strings from
 * Bugzilla iterations are full month strings or 4-letter abbreviations like
 * "Sept", so we need to convert them to abbreviations that luxon can parse.
 * @param {string} month
 * @returns {string}
 * @example "September" => "Sep"
 * @example "Sept" => "Sep"
 * @example "AUG" => "Aug"
 */ function $a2dbb61dc7ec7558$var$normalizeMonthString(month) {
    return month.slice(0, 3).toLowerCase().replace(/^./, (c)=>c.toUpperCase());
}
function $a2dbb61dc7ec7558$export$9ccfa5e1ff0207b4(date) {
    if (typeof date === "string") date = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(date);
    if (date instanceof Date) date = (0, $4b4b939aba8f1d15$exports.DateTime).fromJSDate(date);
    const { weekday: weekday } = date;
    if (weekday === 1) return date;
    return date.minus({
        days: weekday - 1
    });
}
function $a2dbb61dc7ec7558$export$fffdcd8709803332(startDate, endDate) {
    const [start, end] = [
        startDate,
        endDate
    ].map((raw)=>{
        if (raw instanceof Date) return (0, $4b4b939aba8f1d15$exports.DateTime).fromJSDate(raw);
        return (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(raw);
    });
    const startWeekDay = start.weekday;
    const endWeekDay = end.weekday;
    const DAYS_PER_WEEK = 5;
    const weeksBetween = end.startOf("week").diff(start.startOf("week"), "weeks").toObject().weeks || 0;
    let days = weeksBetween * DAYS_PER_WEEK;
    const extraDays = Math.min(startWeekDay, 6) - 1;
    const missingDays = Math.min(endWeekDay, 5);
    // Remove/add extra days
    days = days - extraDays + missingDays;
    return days;
}
class $a2dbb61dc7ec7558$export$8fbbba99755ddad {
    byVersionString = {};
    orderedVersionStrings = [];
    constructor(iterationLookup){
        Object.assign(this, iterationLookup);
    }
    /**
   * For a given date (or no date for today), return the iteration/release whose
   * date range contains that date. If a date falls on the transition between two
   * overlapping ranges (like the edge between releases), the later iteration is
   * returned. If no range contains the date, the closest iteration is returned.
   * @param {string|DateTime} [dateString] defaults to today
   * @returns {LegacyIteration}
   */ getIteration(dateString) {
        if (!dateString) dateString = (0, $4b4b939aba8f1d15$exports.DateTime).utc();
        const date = typeof dateString === "string" ? (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(dateString) : dateString;
        // Search through iterations in reverse (latest first) so that overlapping
        // date ranges prefer the later iteration
        for(let i = this.orderedVersionStrings.length - 1; i >= 0; i--){
            const iterationString = this.orderedVersionStrings[i];
            const iteration = this.byVersionString[iterationString];
            const startDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iteration.startDate);
            const endDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iteration.endDate);
            if (date >= startDate && date <= endDate) return {
                number: iterationString,
                start: iteration.startDate,
                due: iteration.endDate
            };
        }
        // Date doesn't fall within any range, find the closest iteration
        let closestIteration = this.orderedVersionStrings[0];
        let closestDistance = Infinity;
        for (const iterationString of this.orderedVersionStrings){
            const iteration = this.byVersionString[iterationString];
            const startDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iteration.startDate);
            const endDate = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iteration.endDate);
            let distance;
            if (date < startDate) distance = startDate.diff(date, "days").days;
            else distance = date.diff(endDate, "days").days;
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIteration = iterationString;
            }
        }
        const iteration = this.byVersionString[closestIteration];
        return {
            number: closestIteration,
            start: iteration.startDate,
            due: iteration.endDate
        };
    }
    /**
   * Find an upcoming or previous iteration, computed relative to the given date
   * (or today if no date is given).
   * @param {number} diff n for upcoming iterations, -n for previous iterations
   * @param {string} [baseIterationString] the iteration number to start from.
   *                                       defaults to the current iteration.
   * @returns {LegacyIteration|null} null if there is no adjacent iteration
   */ getAdjacentIteration(diff, baseIterationString) {
        if (!baseIterationString) baseIterationString = this.getIteration().number;
        const index = this.orderedVersionStrings.indexOf(baseIterationString);
        if (index === -1) throw new Error("Invalid base iteration string");
        const iterationString = this.orderedVersionStrings[index + diff];
        if (!iterationString) return null;
        const iteration = this.byVersionString[iterationString];
        return {
            number: iterationString,
            start: iteration && iteration.startDate,
            due: iteration && iteration.endDate
        };
    }
    /**
   * Get the start and due dates for a given iteration string.
   * @param {string} iteration e.g. "110.1"
   * @returns {IterationDates}
   */ getDatesForIteration(iteration) {
        const iterationData = this.byVersionString[iteration];
        return {
            start: (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iterationData.startDate),
            due: (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(iterationData.endDate)
        };
    }
}


const $043b576a557bdebf$var$prefDefaults = {
    // The user's bugzilla email
    bugzilla_email: "",
    // Disable all client-side network requests
    offline_debug: false,
    // Disable the user cache for bug views
    disable_cache: false,
    // Keep priority guide open on start
    priority_guide_open: true
};
class $043b576a557bdebf$var$Store {
    get(pref, def) {
        let storedValue = globalThis.localStorage?.getItem(pref);
        let value;
        try {
            value = JSON.parse(storedValue ?? "null");
        } catch (error) {
            // If the stored value is not valid JSON, try to fix it.
            switch(typeof (def ?? $043b576a557bdebf$var$prefDefaults[pref])){
                case "boolean":
                    value = storedValue === "true";
                    break;
                case "number":
                    value = Number(storedValue);
                    break;
                default:
                    value = storedValue;
            }
            if (storedValue) this.set(pref, value ?? def ?? $043b576a557bdebf$var$prefDefaults[pref]);
        }
        return value ?? def ?? $043b576a557bdebf$var$prefDefaults[pref];
    }
    set(key, value) {
        globalThis.localStorage?.setItem(key, JSON.stringify(value));
    }
    delete(key) {
        globalThis.localStorage?.removeItem(key);
    }
    has(key) {
        return globalThis.localStorage?.getItem(key) !== null;
    }
}
class $043b576a557bdebf$var$Prefs {
    constructor({ store: store, defaults: defaults = $043b576a557bdebf$var$prefDefaults }){
        this._store = store;
        this._defaults = defaults;
    }
    get(name) {
        return this._store.get(name, this._defaults[name]);
    }
    set(name, value) {
        const oldValue = this.get(name);
        if (oldValue !== value) {
            this._store.set(name, value);
            this._emit(name, oldValue, value);
        }
    }
    reset(name) {
        const oldValue = this.get(name);
        const newValue = this._defaults[name];
        this._store.delete(name);
        if (oldValue !== newValue) this._emit(name, oldValue, newValue);
    }
    isUserSet(name) {
        return this._store.has(name);
    }
    on(name, listener) {
        if (!this._listeners) this._listeners = new Map();
        if (!this._listeners.has(name)) this._listeners.set(name, new Set());
        this._listeners.get(name).add(listener);
    }
    once(name, listener) {
        const handler = (...args)=>{
            this.off(name, handler);
            this._apply(listener, ...args);
        };
        handler._originalListener = listener;
        this.on(name, handler);
    }
    off(name, listener) {
        if (this._listeners?.has(name)) {
            const listeners = this._listeners.get(name);
            if (listeners) {
                let deleted = listeners.delete(listener);
                if (!deleted) {
                    // If the listener was wrapped in a once() handler, try to remove the
                    // original listener instead.
                    for (const l of listeners)if (l._originalListener === listener) {
                        listeners.delete(l);
                        break;
                    }
                }
            }
        }
    }
    _emit(name, oldValue, newValue) {
        if (this._listeners?.has(name)) for (const listener of this._listeners.get(name))this._apply(listener, {
            name: name,
            oldValue: oldValue,
            newValue: newValue
        });
    }
    _apply(listener, data) {
        if (typeof listener === "function") listener(data);
        else if (listener?.onPrefChange) listener.onPrefChange(data);
        else if (listener) console.error("Invalid pref listener", listener);
        else console.error("Missing pref listener");
    }
}
const $043b576a557bdebf$export$7c82f09cb4abb8e8 = new $043b576a557bdebf$var$Prefs({
    store: new $043b576a557bdebf$var$Store()
});



class $1d01fe5220047a71$var$BugsCache {
    constructor({ version: version } = {}){
        if (!version) throw new Error("Cache version is required");
        this._opened = false;
        this._version = version;
    }
    _open() {
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")) return null;
        try {
            const cache = window.caches.open(this._version);
            if (!this._opened) {
                this.update();
                this._opened = true;
            }
            return cache;
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
    async get(request) {
        try {
            const cache = await this._open();
            return cache.match(request.asGet);
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
    async set(request, response) {
        if (!response) return null;
        try {
            const cache = await this._open();
            return cache.put(request.asGet, response.clone());
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
    async delete(request, options) {
        try {
            const cache = await this._open();
            return cache.delete(request.asGet, options);
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
    async purge() {
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")) return null;
        try {
            const keys = await window.caches.keys();
            return Promise.all(keys.map((key)=>window.caches.delete(key)));
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
    async update() {
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")) return null;
        try {
            // Remove caches for old versions
            const keys = await window.caches.keys();
            const toDelete = keys.filter((key)=>key !== this._version);
            return Promise.all(toDelete.map((key)=>window.caches.delete(key)));
        } catch (error) {
            console.debug("Error accessing cache :>> ", error);
            return null;
        }
    }
}
class $1d01fe5220047a71$export$7fa5336c4d5a1e42 extends Request {
    /**
   * Same as `new Request(input, options)` but with a method to convert to GET.
   * @param {string|Request} input e.g. "/api/bugs"
   * @param {object} options RequestInit options - important ones:
   * @param {HeadersInit} [options.headers] Headers for the request
   * @param {BodyInit} [options.body] e.g. a JSON string
   * @param {string} [options.method] e.g. "POST"
   */ constructor(input, { body: body, method: method = "POST", headers: headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
    }, ...options } = {}){
        super(input, {
            ...options,
            body: body,
            method: method,
            headers: headers
        });
        this.path = input;
        this.body = body;
    }
    /**
   * Return this request, converted to a fake GET request, so it can be cached
   * (returns itself if it's already a GET request).
   * @returns {Request|this} A GET request with the same path as the original
   *                         request, but with the body converted to a query
   * @example $ new CacheableRequest("/api/bugs", { body: { id: 1 } }).asGet;
   *          > new Request(`/api/bugs?fakebody={"id":1}`);
   */ get asGet() {
        if (this.method === "GET") return this;
        return new Request(`${this.path}?fakebody=${this.body}`);
    }
}
const $1d01fe5220047a71$export$69a3209f1a06c04d = new $1d01fe5220047a71$var$BugsCache({
    version: "4"
});


const $0b7e4383cbab5ef0$var$FAKE_TIME = new Date().toISOString();
const $0b7e4383cbab5ef0$var$FAKE_BUGS = [
    {
        id: 1441984,
        whiteboard: "[Message Center]",
        summary: "Add section reordering, snippets IndexedDB, strings, bug fixes to a Activity Stream",
        assigned_to: "khudson@mozilla.com",
        priority: "P1",
        last_change_time: $0b7e4383cbab5ef0$var$FAKE_TIME,
        status: "RESOLVED"
    },
    {
        id: 1384094,
        whiteboard: "[Perf]",
        summary: "High CPU. network traffic and memory usage when open Newtab page if you have opened / bookmarked a problematic/ huge game page in the past",
        assigned_to: "khudson@mozilla.com",
        priority: "P1",
        last_change_time: $0b7e4383cbab5ef0$var$FAKE_TIME,
        status: "ASSIGNED"
    },
    {
        id: 1421682,
        whiteboard: "",
        summary: "Activity Streams exhausts file descriptors capturing screenshots when large numbers of bookmarks are added at once",
        assigned_to: "khudson@mozilla.com",
        priority: "P1",
        last_change_time: $0b7e4383cbab5ef0$var$FAKE_TIME,
        status: "ASSIGNED"
    }
];
class $0b7e4383cbab5ef0$export$adb12731677def63 extends (0, $1d01fe5220047a71$export$7fa5336c4d5a1e42) {
    constructor(query){
        super("/api/bugs", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(query),
            method: "POST"
        });
    }
}
class $0b7e4383cbab5ef0$export$b986383a50b53ea4 {
    constructor({ postProcessFn: postProcessFn = (data)=>data } = {}){
        this._postProcess = postProcessFn;
        for (const key of [
            "runQuery",
            "runQueries",
            "matchQuery",
            "matchQueries",
            "runCachedQueries"
        ])this[key] = this[key].bind(this);
    }
    async runQuery(query) {
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("offline_debug")) return $0b7e4383cbab5ef0$var$FAKE_BUGS;
        let data = {};
        let request = new $0b7e4383cbab5ef0$export$adb12731677def63(query);
        let resp = await fetch(request);
        await (0, $1d01fe5220047a71$export$69a3209f1a06c04d).set(request, resp);
        try {
            data = await resp.json();
        } catch (e) {
            console.log(resp); // eslint-disable-line
            console.log(query); // eslint-disable-line
            console.error(e); // eslint-disable-line
        }
        return this._postProcess(data);
    }
    runQueries(queries) {
        return Array.isArray(queries) ? Promise.all(queries.map(this.runQuery)) : this.runQuery(queries);
    }
    async matchQuery(query) {
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("offline_debug")) return $0b7e4383cbab5ef0$var$FAKE_BUGS;
        if ((0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")) throw new Error("Cache disabled");
        let data;
        const response = await (0, $1d01fe5220047a71$export$69a3209f1a06c04d).get(new $0b7e4383cbab5ef0$export$adb12731677def63(query));
        if (response) {
            try {
                data = await response.json();
            } catch (e) {
                console.log("Error parsing cached response :>> ", response); // eslint-disable-line
                console.log(query); // eslint-disable-line
                console.error(e); // eslint-disable-line
            }
            if (data) return this._postProcess(data);
        }
        throw new Error("No cached response");
    }
    matchQueries(queries) {
        return Array.isArray(queries) ? Promise.all(queries.map(this.matchQuery)) : this.matchQuery(queries);
    }
    /**
   * @typedef {import("../hooks/useBugFetcher").BugQuery} BugQuery
   * @typedef {import("../hooks/useBugFetcher").BugQueryReturn} BugQueryReturn
   * @typedef {import("../hooks/useBugFetcher").BugQueriesReturn} BugQueriesReturn
   * @typedef {function(BugQueryReturn|BugQueriesReturn)} BugQueryCallback
   * @typedef {function()} BugQueryPredicate
   */ /**
   * For a given query or array of queries, return the results from the cache if
   * available and execute a passed callback. Then fetch fresh results from the
   * server, cache them, and execute the callback again. This allows us to render
   * cached data while waiting for new data from the network.
   * @param {BugQuery|BugQuery[]} queries query/queries to match and run
   * @param {BugQueryPredicate} predicate return true if the callback should run
   * @param {BugQueryCallback} cb callback to run if the predicate returns true
   */ async runCachedQueries(queries, predicate, cb) {
        try {
            // Try to get a cached response that matches the query
            const rsp = await this.matchQueries(queries);
            if (cb && predicate()) await cb({
                rsp: rsp,
                awaitingNetwork: true
            });
        } catch (e) {}
        // Now get fresh data from network
        const rsp = await this.runQueries(queries);
        if (cb && predicate()) await cb({
            rsp: rsp,
            awaitingNetwork: false
        });
    }
}
function $0b7e4383cbab5ef0$export$fd24cdb006c73fde(bug) {
    return [
        "RESOLVED",
        "VERIFIED",
        "CLOSED"
    ].includes(bug.status);
}
function $0b7e4383cbab5ef0$export$e85e3b969cd106bb(bug) {
    return [
        "RESOLVED",
        "VERIFIED",
        "CLOSED"
    ].includes(bug.status) || bug.keywords && bug.keywords.includes("github-merged");
}
function $0b7e4383cbab5ef0$export$2cdf1b96a9f86d16(string) {
    // From https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    // Must be triggered by a user action in order to work
    const el = document.createElement("textarea");
    el.value = string;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
}




var $3KGP8 = parcelRequire("3KGP8");
var $27babc10f87d9603$exports = {};

$parcel$export($27babc10f87d9603$exports, "active", () => $27babc10f87d9603$export$89da14300d534261, (v) => $27babc10f87d9603$export$89da14300d534261 = v);
$parcel$export($27babc10f87d9603$exports, "aside", () => $27babc10f87d9603$export$64a02cd6422b91be, (v) => $27babc10f87d9603$export$64a02cd6422b91be = v);
$parcel$export($27babc10f87d9603$exports, "header", () => $27babc10f87d9603$export$38e42c68cf43b5d4, (v) => $27babc10f87d9603$export$38e42c68cf43b5d4 = v);
$parcel$export($27babc10f87d9603$exports, "icon", () => $27babc10f87d9603$export$1ca1ec8b29a4ce27, (v) => $27babc10f87d9603$export$1ca1ec8b29a4ce27 = v);
$parcel$export($27babc10f87d9603$exports, "icon-alert", () => $27babc10f87d9603$export$1e76b82691fa5701, (v) => $27babc10f87d9603$export$1e76b82691fa5701 = v);
$parcel$export($27babc10f87d9603$exports, "icon-balloons", () => $27babc10f87d9603$export$e4b22fea14cefd06, (v) => $27babc10f87d9603$export$e4b22fea14cefd06 = v);
$parcel$export($27babc10f87d9603$exports, "icon-calendar", () => $27babc10f87d9603$export$e623ff535fb49f1b, (v) => $27babc10f87d9603$export$e623ff535fb49f1b = v);
$parcel$export($27babc10f87d9603$exports, "icon-calendar2", () => $27babc10f87d9603$export$c9fa641591b4ca04, (v) => $27babc10f87d9603$export$c9fa641591b4ca04 = v);
$parcel$export($27babc10f87d9603$exports, "icon-capacity", () => $27babc10f87d9603$export$36604849cbc05779, (v) => $27babc10f87d9603$export$36604849cbc05779 = v);
$parcel$export($27babc10f87d9603$exports, "icon-graph", () => $27babc10f87d9603$export$f2c647bcb4d6efa5, (v) => $27babc10f87d9603$export$f2c647bcb4d6efa5 = v);
$parcel$export($27babc10f87d9603$exports, "icon-hourglass", () => $27babc10f87d9603$export$1f4249c1ca45e867, (v) => $27babc10f87d9603$export$1f4249c1ca45e867 = v);
$parcel$export($27babc10f87d9603$exports, "icon-inbox", () => $27babc10f87d9603$export$ed2b3a29e10c479f, (v) => $27babc10f87d9603$export$ed2b3a29e10c479f = v);
$parcel$export($27babc10f87d9603$exports, "icon-info", () => $27babc10f87d9603$export$7fdab38ec047cfcb, (v) => $27babc10f87d9603$export$7fdab38ec047cfcb = v);
$parcel$export($27babc10f87d9603$exports, "icon-jira", () => $27babc10f87d9603$export$4bd2b69444735c5, (v) => $27babc10f87d9603$export$4bd2b69444735c5 = v);
$parcel$export($27babc10f87d9603$exports, "icon-logo", () => $27babc10f87d9603$export$238ebfe039ac3799, (v) => $27babc10f87d9603$export$238ebfe039ac3799 = v);
$parcel$export($27babc10f87d9603$exports, "icon-pocket", () => $27babc10f87d9603$export$4b21ec921354f860, (v) => $27babc10f87d9603$export$4b21ec921354f860 = v);
$parcel$export($27babc10f87d9603$exports, "icon-refresh", () => $27babc10f87d9603$export$d6f69525709d394f, (v) => $27babc10f87d9603$export$d6f69525709d394f = v);
$parcel$export($27babc10f87d9603$exports, "icon-report", () => $27babc10f87d9603$export$8b50f98995d9832f, (v) => $27babc10f87d9603$export$8b50f98995d9832f = v);
$parcel$export($27babc10f87d9603$exports, "icon-rgb", () => $27babc10f87d9603$export$84a489ca6b13c7fe, (v) => $27babc10f87d9603$export$84a489ca6b13c7fe = v);
$parcel$export($27babc10f87d9603$exports, "icon-settings", () => $27babc10f87d9603$export$6ab74376d03c96ee, (v) => $27babc10f87d9603$export$6ab74376d03c96ee = v);
$parcel$export($27babc10f87d9603$exports, "icon-settings-circle", () => $27babc10f87d9603$export$3d3c995a3583b0be, (v) => $27babc10f87d9603$export$3d3c995a3583b0be = v);
$parcel$export($27babc10f87d9603$exports, "icon-stethoscope", () => $27babc10f87d9603$export$53cb0936b9d25daa, (v) => $27babc10f87d9603$export$53cb0936b9d25daa = v);
$parcel$export($27babc10f87d9603$exports, "icon-up-arrow", () => $27babc10f87d9603$export$a95963e1f1ea5af8, (v) => $27babc10f87d9603$export$a95963e1f1ea5af8 = v);
$parcel$export($27babc10f87d9603$exports, "icon-up-arrow-yellow", () => $27babc10f87d9603$export$627e027518a53525, (v) => $27babc10f87d9603$export$627e027518a53525 = v);
$parcel$export($27babc10f87d9603$exports, "icon-user", () => $27babc10f87d9603$export$a45d1ae9bc118765, (v) => $27babc10f87d9603$export$a45d1ae9bc118765 = v);
$parcel$export($27babc10f87d9603$exports, "icon-warning", () => $27babc10f87d9603$export$9d3806d5e4707619, (v) => $27babc10f87d9603$export$9d3806d5e4707619 = v);
$parcel$export($27babc10f87d9603$exports, "logo", () => $27babc10f87d9603$export$db3c28d99448dcff, (v) => $27babc10f87d9603$export$db3c28d99448dcff = v);
$parcel$export($27babc10f87d9603$exports, "main", () => $27babc10f87d9603$export$f22da7240b7add18, (v) => $27babc10f87d9603$export$f22da7240b7add18 = v);
$parcel$export($27babc10f87d9603$exports, "navLink", () => $27babc10f87d9603$export$6ee01cf16d42268d, (v) => $27babc10f87d9603$export$6ee01cf16d42268d = v);
$parcel$export($27babc10f87d9603$exports, "spacer", () => $27babc10f87d9603$export$8cc075c801fd6817, (v) => $27babc10f87d9603$export$8cc075c801fd6817 = v);
var $27babc10f87d9603$export$89da14300d534261;
var $27babc10f87d9603$export$64a02cd6422b91be;
var $27babc10f87d9603$export$38e42c68cf43b5d4;
var $27babc10f87d9603$export$1ca1ec8b29a4ce27;
var $27babc10f87d9603$export$1e76b82691fa5701;
var $27babc10f87d9603$export$e4b22fea14cefd06;
var $27babc10f87d9603$export$e623ff535fb49f1b;
var $27babc10f87d9603$export$c9fa641591b4ca04;
var $27babc10f87d9603$export$36604849cbc05779;
var $27babc10f87d9603$export$f2c647bcb4d6efa5;
var $27babc10f87d9603$export$1f4249c1ca45e867;
var $27babc10f87d9603$export$ed2b3a29e10c479f;
var $27babc10f87d9603$export$7fdab38ec047cfcb;
var $27babc10f87d9603$export$4bd2b69444735c5;
var $27babc10f87d9603$export$238ebfe039ac3799;
var $27babc10f87d9603$export$4b21ec921354f860;
var $27babc10f87d9603$export$d6f69525709d394f;
var $27babc10f87d9603$export$8b50f98995d9832f;
var $27babc10f87d9603$export$84a489ca6b13c7fe;
var $27babc10f87d9603$export$6ab74376d03c96ee;
var $27babc10f87d9603$export$3d3c995a3583b0be;
var $27babc10f87d9603$export$53cb0936b9d25daa;
var $27babc10f87d9603$export$a95963e1f1ea5af8;
var $27babc10f87d9603$export$627e027518a53525;
var $27babc10f87d9603$export$a45d1ae9bc118765;
var $27babc10f87d9603$export$9d3806d5e4707619;
var $27babc10f87d9603$export$db3c28d99448dcff;
var $27babc10f87d9603$export$f22da7240b7add18;
var $27babc10f87d9603$export$6ee01cf16d42268d;
var $27babc10f87d9603$export$8cc075c801fd6817;
$27babc10f87d9603$export$89da14300d534261 = `UpqqYa_active`;
$27babc10f87d9603$export$64a02cd6422b91be = `UpqqYa_aside`;
$27babc10f87d9603$export$38e42c68cf43b5d4 = `UpqqYa_header`;
$27babc10f87d9603$export$1ca1ec8b29a4ce27 = `UpqqYa_icon`;
$27babc10f87d9603$export$1e76b82691fa5701 = `UpqqYa_icon-alert`;
$27babc10f87d9603$export$e4b22fea14cefd06 = `UpqqYa_icon-balloons`;
$27babc10f87d9603$export$e623ff535fb49f1b = `UpqqYa_icon-calendar`;
$27babc10f87d9603$export$c9fa641591b4ca04 = `UpqqYa_icon-calendar2`;
$27babc10f87d9603$export$36604849cbc05779 = `UpqqYa_icon-capacity`;
$27babc10f87d9603$export$f2c647bcb4d6efa5 = `UpqqYa_icon-graph`;
$27babc10f87d9603$export$1f4249c1ca45e867 = `UpqqYa_icon-hourglass`;
$27babc10f87d9603$export$ed2b3a29e10c479f = `UpqqYa_icon-inbox`;
$27babc10f87d9603$export$7fdab38ec047cfcb = `UpqqYa_icon-info`;
$27babc10f87d9603$export$4bd2b69444735c5 = `UpqqYa_icon-jira`;
$27babc10f87d9603$export$238ebfe039ac3799 = `UpqqYa_icon-logo`;
$27babc10f87d9603$export$4b21ec921354f860 = `UpqqYa_icon-pocket`;
$27babc10f87d9603$export$d6f69525709d394f = `UpqqYa_icon-refresh`;
$27babc10f87d9603$export$8b50f98995d9832f = `UpqqYa_icon-report`;
$27babc10f87d9603$export$84a489ca6b13c7fe = `UpqqYa_icon-rgb`;
$27babc10f87d9603$export$6ab74376d03c96ee = `UpqqYa_icon-settings`;
$27babc10f87d9603$export$3d3c995a3583b0be = `UpqqYa_icon-settings-circle`;
$27babc10f87d9603$export$53cb0936b9d25daa = `UpqqYa_icon-stethoscope`;
$27babc10f87d9603$export$a95963e1f1ea5af8 = `UpqqYa_icon-up-arrow`;
$27babc10f87d9603$export$627e027518a53525 = `UpqqYa_icon-up-arrow-yellow`;
$27babc10f87d9603$export$a45d1ae9bc118765 = `UpqqYa_icon-user`;
$27babc10f87d9603$export$9d3806d5e4707619 = `UpqqYa_icon-warning`;
$27babc10f87d9603$export$db3c28d99448dcff = `UpqqYa_logo`;
$27babc10f87d9603$export$f22da7240b7add18 = `UpqqYa_main`;
$27babc10f87d9603$export$6ee01cf16d42268d = `UpqqYa_navLink`;
$27babc10f87d9603$export$8cc075c801fd6817 = `UpqqYa_spacer`;




var $3KGP8 = parcelRequire("3KGP8");



var $3KGP8 = parcelRequire("3KGP8");
var $2c8085794fda339d$exports = {};

$parcel$export($2c8085794fda339d$exports, "bugTable", () => $2c8085794fda339d$export$34ab1e5de3ef3b7f, (v) => $2c8085794fda339d$export$34ab1e5de3ef3b7f = v);
$parcel$export($2c8085794fda339d$exports, "bulkColumn", () => $2c8085794fda339d$export$885caa94eb312dab, (v) => $2c8085794fda339d$export$885caa94eb312dab = v);
$parcel$export($2c8085794fda339d$exports, "editor", () => $2c8085794fda339d$export$b5d042d2b680aed6, (v) => $2c8085794fda339d$export$b5d042d2b680aed6 = v);
$parcel$export($2c8085794fda339d$exports, "editorCompact", () => $2c8085794fda339d$export$cfb53d8154525dd0, (v) => $2c8085794fda339d$export$cfb53d8154525dd0 = v);
$parcel$export($2c8085794fda339d$exports, "editorGroup", () => $2c8085794fda339d$export$2c3ff18fd789500f, (v) => $2c8085794fda339d$export$2c3ff18fd789500f = v);
$parcel$export($2c8085794fda339d$exports, "editorType", () => $2c8085794fda339d$export$f3c959b5bbc134aa, (v) => $2c8085794fda339d$export$f3c959b5bbc134aa = v);
$parcel$export($2c8085794fda339d$exports, "emptyState", () => $2c8085794fda339d$export$252465da46a2ae40, (v) => $2c8085794fda339d$export$252465da46a2ae40 = v);
$parcel$export($2c8085794fda339d$exports, "idColumn", () => $2c8085794fda339d$export$108c17e5c52b7df8, (v) => $2c8085794fda339d$export$108c17e5c52b7df8 = v);
$parcel$export($2c8085794fda339d$exports, "idSpacer", () => $2c8085794fda339d$export$ce931af6d57b2b66, (v) => $2c8085794fda339d$export$ce931af6d57b2b66 = v);
$parcel$export($2c8085794fda339d$exports, "labels", () => $2c8085794fda339d$export$a238cb463698c900, (v) => $2c8085794fda339d$export$a238cb463698c900 = v);
$parcel$export($2c8085794fda339d$exports, "last_change_timeColumn", () => $2c8085794fda339d$export$c7d92b03a43b0b22, (v) => $2c8085794fda339d$export$c7d92b03a43b0b22 = v);
$parcel$export($2c8085794fda339d$exports, "leftEditorGroup", () => $2c8085794fda339d$export$d5a773c20c1db078, (v) => $2c8085794fda339d$export$d5a773c20c1db078 = v);
$parcel$export($2c8085794fda339d$exports, "mine", () => $2c8085794fda339d$export$25c810edd2c6953a, (v) => $2c8085794fda339d$export$25c810edd2c6953a = v);
$parcel$export($2c8085794fda339d$exports, "resolved", () => $2c8085794fda339d$export$d06d16b20ced9190, (v) => $2c8085794fda339d$export$d06d16b20ced9190 = v);
$parcel$export($2c8085794fda339d$exports, "status-verified", () => $2c8085794fda339d$export$2eee1dc764de810f, (v) => $2c8085794fda339d$export$2eee1dc764de810f = v);
$parcel$export($2c8085794fda339d$exports, "statusLabel", () => $2c8085794fda339d$export$a954299e2515e375, (v) => $2c8085794fda339d$export$a954299e2515e375 = v);
$parcel$export($2c8085794fda339d$exports, "summaryColumn", () => $2c8085794fda339d$export$d82a8851d4c92c9d, (v) => $2c8085794fda339d$export$d82a8851d4c92c9d = v);
$parcel$export($2c8085794fda339d$exports, "tagList", () => $2c8085794fda339d$export$b14b250ba4569a7e, (v) => $2c8085794fda339d$export$b14b250ba4569a7e = v);
$parcel$export($2c8085794fda339d$exports, "td", () => $2c8085794fda339d$export$2beef8af2014e5c6, (v) => $2c8085794fda339d$export$2beef8af2014e5c6 = v);
$parcel$export($2c8085794fda339d$exports, "th", () => $2c8085794fda339d$export$d657bc098992a431, (v) => $2c8085794fda339d$export$d657bc098992a431 = v);
$parcel$export($2c8085794fda339d$exports, "warning", () => $2c8085794fda339d$export$491112666e282270, (v) => $2c8085794fda339d$export$491112666e282270 = v);
var $2c8085794fda339d$export$34ab1e5de3ef3b7f;
var $2c8085794fda339d$export$885caa94eb312dab;
var $2c8085794fda339d$export$b5d042d2b680aed6;
var $2c8085794fda339d$export$cfb53d8154525dd0;
var $2c8085794fda339d$export$2c3ff18fd789500f;
var $2c8085794fda339d$export$f3c959b5bbc134aa;
var $2c8085794fda339d$export$252465da46a2ae40;
var $2c8085794fda339d$export$108c17e5c52b7df8;
var $2c8085794fda339d$export$ce931af6d57b2b66;
var $2c8085794fda339d$export$a238cb463698c900;
var $2c8085794fda339d$export$c7d92b03a43b0b22;
var $2c8085794fda339d$export$d5a773c20c1db078;
var $2c8085794fda339d$export$25c810edd2c6953a;
var $2c8085794fda339d$export$d06d16b20ced9190;
var $2c8085794fda339d$export$2eee1dc764de810f;
var $2c8085794fda339d$export$a954299e2515e375;
var $2c8085794fda339d$export$d82a8851d4c92c9d;
var $2c8085794fda339d$export$b14b250ba4569a7e;
var $2c8085794fda339d$export$2beef8af2014e5c6;
var $2c8085794fda339d$export$d657bc098992a431;
var $2c8085794fda339d$export$491112666e282270;
$2c8085794fda339d$export$34ab1e5de3ef3b7f = `NHld3G_bugTable`;
$2c8085794fda339d$export$885caa94eb312dab = `NHld3G_bulkColumn`;
$2c8085794fda339d$export$b5d042d2b680aed6 = `NHld3G_editor`;
$2c8085794fda339d$export$cfb53d8154525dd0 = `NHld3G_editorCompact`;
$2c8085794fda339d$export$2c3ff18fd789500f = `NHld3G_editorGroup`;
$2c8085794fda339d$export$f3c959b5bbc134aa = `NHld3G_editorType`;
$2c8085794fda339d$export$252465da46a2ae40 = `NHld3G_emptyState`;
$2c8085794fda339d$export$108c17e5c52b7df8 = `NHld3G_idColumn`;
$2c8085794fda339d$export$ce931af6d57b2b66 = `NHld3G_idSpacer`;
$2c8085794fda339d$export$a238cb463698c900 = `NHld3G_labels`;
$2c8085794fda339d$export$c7d92b03a43b0b22 = `NHld3G_last_change_timeColumn`;
$2c8085794fda339d$export$d5a773c20c1db078 = `NHld3G_leftEditorGroup`;
$2c8085794fda339d$export$25c810edd2c6953a = `NHld3G_mine`;
$2c8085794fda339d$export$d06d16b20ced9190 = `NHld3G_resolved`;
$2c8085794fda339d$export$2eee1dc764de810f = `NHld3G_status-verified`;
$2c8085794fda339d$export$a954299e2515e375 = `NHld3G_statusLabel`;
$2c8085794fda339d$export$d82a8851d4c92c9d = `NHld3G_summaryColumn`;
$2c8085794fda339d$export$b14b250ba4569a7e = `NHld3G_tagList`;
$2c8085794fda339d$export$2beef8af2014e5c6 = `NHld3G_td`;
$2c8085794fda339d$export$d657bc098992a431 = `NHld3G_th`;
$2c8085794fda339d$export$491112666e282270 = `NHld3G_warning`;


var $1d79b97a34537ccf$export$69d3062bf43b7417;
var $1d79b97a34537ccf$export$9e9706b9843a7198;
var $1d79b97a34537ccf$export$c69aea64b8d954e7;
var $1d79b97a34537ccf$export$41c1085b355ecc97;
var $1d79b97a34537ccf$export$4622d93046d5fd3d;
$1d79b97a34537ccf$export$69d3062bf43b7417 = `Ip1fSG_codeSnippet`;
$1d79b97a34537ccf$export$9e9706b9843a7198 = `Ip1fSG_headerButton`;
$1d79b97a34537ccf$export$c69aea64b8d954e7 = `Ip1fSG_plainLink`;
$1d79b97a34537ccf$export$41c1085b355ecc97 = `Ip1fSG_primaryButton`;
$1d79b97a34537ccf$export$4622d93046d5fd3d = `Ip1fSG_smallInput`;


// see https://bmo.readthedocs.io/en/latest/api/core/v1/bug.html#get-bug
const $7f99eab969191513$export$d79264f26953ec1 = {
    id: {
        displayName: "Bug",
        description: "The bug number",
        type: "integer",
        examples: [
            1421682
        ]
    },
    summary: {
        displayName: "Title",
        description: "The bug title ",
        type: "string",
        examples: [
            "Add title to activitystream.html"
        ]
    },
    status: {
        displayName: "Status",
        description: "Whether a bug is new, assigned, resolved, closed, etc.",
        type: {
            oneOf: [
                "UNCONFIRMED",
                "NEW",
                "ASSIGNED",
                "REOPENED",
                "RESOLVED",
                "REOPENED",
                "VERIFIED",
                "CLOSED"
            ]
        },
        examples: [
            "NEW",
            "VERIFIED"
        ]
    },
    type: {
        displayName: "",
        description: "Whether a bug is a task, enhancement or defect",
        type: {
            oneOf: [
                "task",
                "enhancement",
                "defect"
            ]
        },
        example: [
            "defect"
        ]
    },
    resolution: {
        displayName: "Resolution",
        description: "How was the bug resolved?",
        type: {
            oneOf: [
                "",
                "FIXED",
                "INVALID",
                "WONTFIX",
                "DUPLICATE",
                "WORKSFORME",
                "INCOMPLETE",
                "SUPPORT",
                "EXPIRED",
                "MOVED"
            ]
        },
        examples: [
            "",
            "FIXED"
        ]
    },
    priority: {
        displayName: "Priority",
        description: "The priority of the bug",
        examples: [
            "",
            "P2"
        ]
    },
    severity: {
        displayName: "Severity",
        description: "The severity of the defect"
    },
    whiteboard: {
        displayName: "Whiteboard",
        description: "Freeform tags surrounded by square brackets",
        type: "string",
        examples: [
            "",
            "[foo]",
            "[AS60MVP] [foo]"
        ]
    },
    assigned_to: {
        displayName: "Assignee",
        description: "Email of assignee or nobody@mozilla.org if not assigned. Note: a assigned_to_detail field will also be returned",
        type: "string",
        examples: [
            "foo@bar.com",
            "nobody@mozilla.org"
        ]
    },
    cf_fx_iteration: {
        displayName: "Iteration",
        description: "The iteration in which the bug should be completed",
        type: "string",
        examples: [
            "60.2 - Feb 12"
        ]
    },
    component: {
        displayName: "Component",
        description: "The Bugzilla Component",
        type: "string",
        examples: [
            "Activity Streams: Application Servers"
        ]
    },
    cc: {
        displayName: "CC'd",
        description: "Bugs on which a given email is cc'd",
        type: "email",
        examples: [
            "foobar@foobar.com"
        ]
    },
    blocked: {
        displayName: "Blocked by",
        description: "Bugs that block a given bug number",
        type: "integer",
        examples: [
            1421682
        ]
    },
    dependson: {
        displayName: "Depends on",
        description: "Bugs that depend on a given bug number",
        type: "integer",
        examples: [
            1421682
        ]
    },
    creation_ts: {
        displayName: "Creation date",
        description: "Date bug was filed",
        type: "datestring",
        examples: "2018-03-01"
    },
    "attachments.mimetype": {
        displayName: "Attachment mime type",
        description: "Has an attachment with the specified mime type",
        type: "string",
        examples: [
            "github",
            "review-board-request"
        ]
    },
    last_change_time: {
        displayName: "Last Updated",
        description: "When the bug was last updated",
        type: "date",
        examples: [
            "2018-03-05T17:18:57Z"
        ]
    },
    target_milestone: {
        displayName: "Target milestone",
        description: "The target release",
        type: "number",
        example: [
            60,
            61
        ]
    },
    "flagtypes.name": {
        displayName: "Flags",
        description: "Name of flags set on a bug",
        type: "string",
        example: [
            "needinfo"
        ]
    },
    "requestees.login_name": {
        displayName: "Flagged",
        description: "Email of someone who has been flagged on a bug",
        type: "string",
        examples: [
            "foo@boo.com"
        ]
    },
    "setters.login_name": {
        displayName: "Flagged by",
        description: "Email of someone who has requested a flag",
        type: "string",
        examples: [
            "foo@boo.com"
        ]
    },
    keywords: {
        displayName: "Keywords",
        description: "Array of keywords",
        type: "Array",
        examples: [
            "uineeded"
        ]
    },
    j_top: {
        displayName: "Custom search AND/OR",
        description: "How should custom searches be combined? Note: default is AND",
        type: {
            oneOf: [
                "",
                "OR",
                "AND_G"
            ]
        },
        examples: [
            "OR"
        ]
    },
    cf_fx_points: {
        displayName: "Size",
        description: "An estimation of effort"
    },
    ticket: {
        displayName: "Ticket",
        description: "The Jira ticket in the bug's See Also field"
    },
    // THESE ARE SPECIAL created by post processing
    cf_status_nightly: {
        displayName: "Nightly",
        type: "string",
        examples: [
            "affected",
            "fixed"
        ]
    },
    cf_status_beta: {
        displayName: "Beta",
        type: "string",
        examples: [
            "affected",
            "fixed"
        ]
    },
    cf_tracking_beta: {
        displayName: "Beta:tracking",
        type: "string",
        examples: [
            "+",
            "?"
        ]
    },
    cf_last_resolved: {
        displayName: "Resolved on",
        type: "date"
    }
};
const $7f99eab969191513$export$d74d3e5a5cfc6435 = [
    "id",
    "summary",
    "keywords",
    "status",
    "resolution",
    "priority",
    "whiteboard",
    "assigned_to",
    "cf_fx_iteration",
    "component",
    "type",
    "last_change_time",
    "cf_last_resolved",
    "depends_on",
    "blocks",
    "flags"
];
const $7f99eab969191513$export$db75785c07e702d1 = [
    "component",
    "status",
    "resolution",
    "id",
    "priority"
];
const $7f99eab969191513$export$3f8e998372083bd = [
    "cf_fx_iteration",
    "assigned_to",
    "cc",
    "blocked",
    "dependson",
    "whiteboard",
    "creation_ts",
    "type",
    "attachments.mimetype",
    "target_milestone",
    "flagtypes.name",
    "requestees.login_name",
    "setters.login_name"
];
const $7f99eab969191513$export$a31ae3176ccd8dd0 = {
    equals: {
        displayName: "is"
    },
    notequals: {
        displayName: "is not"
    },
    anyexact: {
        displayName: "is any of"
    },
    anywordssubstr: {
        displayName: "contains any of"
    },
    nowordssubstr: {
        displayName: "does not contain any of"
    },
    substring: {
        displayName: "contains"
    },
    notsubstring: {
        displayName: "does not contain"
    },
    casesubstring: {
        displayName: "contains (matching case)"
    },
    lessthan: {
        displayName: "is less than"
    },
    lessthaneq: {
        displayName: "is less than or equal to"
    },
    greaterthan: {
        displayName: "is greater than"
    },
    greaterthaneq: {
        displayName: "is greater than or equal to"
    }
};
const $7f99eab969191513$export$fbb76f27d3c1493f = [
    "changeddate",
    "bug_id",
    "priority",
    "assigned_to",
    "bug_status",
    "Resolution",
    "cf_last_resolved"
];




var $3KGP8 = parcelRequire("3KGP8");
const $9e3325dd32f85aba$export$3e4ea77b8bea417 = {
    "elee@mozilla.com": "ed",
    "dmose@mozilla.org": "dmose",
    "dmosedale@mozilla.com": "dmose",
    "pdahiya@mozilla.com": "punam",
    "emcminn@mozilla.com": "emily",
    "shughes@mozilla.com": "aminomancer",
    "vtay@mozilla.com": "venetia",
    "halemu@mozilla.com": "hanna",
    "jprickett@mozilla.com": "jason",
    "mjung@mozilla.com": "mimi",
    "sachung@mozilla.com": "sarah",
    "mviar@mozilla.com": "meg"
};
const $9e3325dd32f85aba$export$c957e9dafc0b7f8f = {
    omc: [
        "dmosedale@mozilla.com",
        "emcminn@mozilla.com",
        "halemu@mozilla.com",
        "jprickett@mozilla.com",
        "mjung@mozilla.com",
        "shughes@mozilla.com",
        "sachung@mozilla.com",
        "mviar@mozilla.com"
    ]
};


// const EPIC_BUG_ID = 1433315;
var $8489bb4934f95969$export$2e2bcd8739ae039 = {
    defect: {
        style: {
            color: "var(--red-50)",
            fontWeight: "bold"
        },
        label: "defect"
    },
    enhancement: {
        style: {
            color: "var(--green-50)",
            fontWeight: "bold"
        },
        label: "enhancement"
    },
    needinfo: {
        style: {
            color: "var(--gray-90)",
            fontWeight: "bold"
        },
        label: "\uD83E\uDD14 needinfo"
    },
    "ni?": {
        style: {
            color: "var(--gray-90)",
            fontWeight: "bold"
        },
        label: "\uD83E\uDD14 ni?%s"
    },
    regression: {
        style: {
            backgroundColor: "var(--red-50)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        },
        label: "\uD83D\uDE22 regression"
    },
    "has-pr": {
        style: {
            backgroundColor: "var(--green-50)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        },
        label: "has PR"
    },
    "strings needed": {
        label: "strings needed",
        style: {
            backgroundColor: "var(--teal-60)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        }
    },
    "strings landed": {
        label: "strings landed",
        style: {
            color: "var(--teal-60)"
        }
    },
    "strings m-c needed": {
        label: "strings m-c needed",
        style: {
            backgroundColor: "var(--teal-80)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        }
    },
    task: {
        label: "chore",
        style: {
            backgroundColor: "var(--purple-60)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        }
    },
    "cosmic rays": {
        label: "\u2604\uFE0F cosmic rays",
        style: {
            backgroundColor: "var(--magenta-80)",
            color: "white",
            border: 0,
            fontWeight: "bold"
        }
    }
};



var $7999b6d38c1a5546$exports = {};

$parcel$export($7999b6d38c1a5546$exports, "--", () => $7999b6d38c1a5546$export$543ee11515b2af11, (v) => $7999b6d38c1a5546$export$543ee11515b2af11 = v);
$parcel$export($7999b6d38c1a5546$exports, "containerClosed", () => $7999b6d38c1a5546$export$1e3e5379691483e7, (v) => $7999b6d38c1a5546$export$1e3e5379691483e7 = v);
$parcel$export($7999b6d38c1a5546$exports, "containerOpen", () => $7999b6d38c1a5546$export$7d47ec3dc429821, (v) => $7999b6d38c1a5546$export$7d47ec3dc429821 = v);
$parcel$export($7999b6d38c1a5546$exports, "iconArrowhead", () => $7999b6d38c1a5546$export$2402f41b6d6f4b49, (v) => $7999b6d38c1a5546$export$2402f41b6d6f4b49 = v);
$parcel$export($7999b6d38c1a5546$exports, "iconOverflow", () => $7999b6d38c1a5546$export$d20729ef1932bfeb, (v) => $7999b6d38c1a5546$export$d20729ef1932bfeb = v);
$parcel$export($7999b6d38c1a5546$exports, "innerBox", () => $7999b6d38c1a5546$export$3733ca50504b91b1, (v) => $7999b6d38c1a5546$export$3733ca50504b91b1 = v);
$parcel$export($7999b6d38c1a5546$exports, "legendButton", () => $7999b6d38c1a5546$export$39f706edf254b3b8, (v) => $7999b6d38c1a5546$export$39f706edf254b3b8 = v);
$parcel$export($7999b6d38c1a5546$exports, "lg", () => $7999b6d38c1a5546$export$27ac7b32bf0e709e, (v) => $7999b6d38c1a5546$export$27ac7b32bf0e709e = v);
$parcel$export($7999b6d38c1a5546$exports, "md", () => $7999b6d38c1a5546$export$f4de1c043ce6927, (v) => $7999b6d38c1a5546$export$f4de1c043ce6927 = v);
$parcel$export($7999b6d38c1a5546$exports, "n/a", () => $7999b6d38c1a5546$export$62070dfd506c2bdf, (v) => $7999b6d38c1a5546$export$62070dfd506c2bdf = v);
$parcel$export($7999b6d38c1a5546$exports, "p1", () => $7999b6d38c1a5546$export$10b86557377497c4, (v) => $7999b6d38c1a5546$export$10b86557377497c4 = v);
$parcel$export($7999b6d38c1a5546$exports, "p2", () => $7999b6d38c1a5546$export$9ede1655fa63ee0d, (v) => $7999b6d38c1a5546$export$9ede1655fa63ee0d = v);
$parcel$export($7999b6d38c1a5546$exports, "p3", () => $7999b6d38c1a5546$export$9ab2405854d25601, (v) => $7999b6d38c1a5546$export$9ab2405854d25601 = v);
$parcel$export($7999b6d38c1a5546$exports, "p4", () => $7999b6d38c1a5546$export$5e8e9074022ed083, (v) => $7999b6d38c1a5546$export$5e8e9074022ed083 = v);
$parcel$export($7999b6d38c1a5546$exports, "p5", () => $7999b6d38c1a5546$export$feb62dfdf81bc282, (v) => $7999b6d38c1a5546$export$feb62dfdf81bc282 = v);
$parcel$export($7999b6d38c1a5546$exports, "s1", () => $7999b6d38c1a5546$export$ede8042ddbb20f54, (v) => $7999b6d38c1a5546$export$ede8042ddbb20f54 = v);
$parcel$export($7999b6d38c1a5546$exports, "s2", () => $7999b6d38c1a5546$export$88872d1f97e13ba9, (v) => $7999b6d38c1a5546$export$88872d1f97e13ba9 = v);
$parcel$export($7999b6d38c1a5546$exports, "s3", () => $7999b6d38c1a5546$export$dc9368c5558c5766, (v) => $7999b6d38c1a5546$export$dc9368c5558c5766 = v);
$parcel$export($7999b6d38c1a5546$exports, "s4", () => $7999b6d38c1a5546$export$fba4cbb73d5fdb07, (v) => $7999b6d38c1a5546$export$fba4cbb73d5fdb07 = v);
$parcel$export($7999b6d38c1a5546$exports, "s5", () => $7999b6d38c1a5546$export$cc9fc94495f9bd7c, (v) => $7999b6d38c1a5546$export$cc9fc94495f9bd7c = v);
$parcel$export($7999b6d38c1a5546$exports, "scrollbox", () => $7999b6d38c1a5546$export$746dd974202ffffe, (v) => $7999b6d38c1a5546$export$746dd974202ffffe = v);
$parcel$export($7999b6d38c1a5546$exports, "sidebarToggle", () => $7999b6d38c1a5546$export$eade479634cb5dc5, (v) => $7999b6d38c1a5546$export$eade479634cb5dc5 = v);
$parcel$export($7999b6d38c1a5546$exports, "sm", () => $7999b6d38c1a5546$export$92d98d0701d4531a, (v) => $7999b6d38c1a5546$export$92d98d0701d4531a = v);
$parcel$export($7999b6d38c1a5546$exports, "title", () => $7999b6d38c1a5546$export$fb184b623420d9be, (v) => $7999b6d38c1a5546$export$fb184b623420d9be = v);
$parcel$export($7999b6d38c1a5546$exports, "total", () => $7999b6d38c1a5546$export$9086bb9c16b2b5b, (v) => $7999b6d38c1a5546$export$9086bb9c16b2b5b = v);
$parcel$export($7999b6d38c1a5546$exports, "xl", () => $7999b6d38c1a5546$export$abb3878d4b973569, (v) => $7999b6d38c1a5546$export$abb3878d4b973569 = v);
var $7999b6d38c1a5546$export$543ee11515b2af11;
var $7999b6d38c1a5546$export$1e3e5379691483e7;
var $7999b6d38c1a5546$export$7d47ec3dc429821;
var $7999b6d38c1a5546$export$2402f41b6d6f4b49;
var $7999b6d38c1a5546$export$d20729ef1932bfeb;
var $7999b6d38c1a5546$export$3733ca50504b91b1;
var $7999b6d38c1a5546$export$39f706edf254b3b8;
var $7999b6d38c1a5546$export$27ac7b32bf0e709e;
var $7999b6d38c1a5546$export$f4de1c043ce6927;
var $7999b6d38c1a5546$export$62070dfd506c2bdf;
var $7999b6d38c1a5546$export$10b86557377497c4;
var $7999b6d38c1a5546$export$9ede1655fa63ee0d;
var $7999b6d38c1a5546$export$9ab2405854d25601;
var $7999b6d38c1a5546$export$5e8e9074022ed083;
var $7999b6d38c1a5546$export$feb62dfdf81bc282;
var $7999b6d38c1a5546$export$ede8042ddbb20f54;
var $7999b6d38c1a5546$export$88872d1f97e13ba9;
var $7999b6d38c1a5546$export$dc9368c5558c5766;
var $7999b6d38c1a5546$export$fba4cbb73d5fdb07;
var $7999b6d38c1a5546$export$cc9fc94495f9bd7c;
var $7999b6d38c1a5546$export$746dd974202ffffe;
var $7999b6d38c1a5546$export$eade479634cb5dc5;
var $7999b6d38c1a5546$export$92d98d0701d4531a;
var $7999b6d38c1a5546$export$fb184b623420d9be;
var $7999b6d38c1a5546$export$9086bb9c16b2b5b;
var $7999b6d38c1a5546$export$abb3878d4b973569;
$7999b6d38c1a5546$export$543ee11515b2af11 = `iiPXuq_--`;
$7999b6d38c1a5546$export$1e3e5379691483e7 = `iiPXuq_containerClosed`;
$7999b6d38c1a5546$export$7d47ec3dc429821 = `iiPXuq_containerOpen`;
$7999b6d38c1a5546$export$2402f41b6d6f4b49 = `iiPXuq_iconArrowhead`;
$7999b6d38c1a5546$export$d20729ef1932bfeb = `iiPXuq_iconOverflow`;
$7999b6d38c1a5546$export$3733ca50504b91b1 = `iiPXuq_innerBox`;
$7999b6d38c1a5546$export$39f706edf254b3b8 = `iiPXuq_legendButton`;
$7999b6d38c1a5546$export$27ac7b32bf0e709e = `iiPXuq_lg`;
$7999b6d38c1a5546$export$f4de1c043ce6927 = `iiPXuq_md`;
$7999b6d38c1a5546$export$62070dfd506c2bdf = `iiPXuq_n/a`;
$7999b6d38c1a5546$export$10b86557377497c4 = `iiPXuq_p1`;
$7999b6d38c1a5546$export$9ede1655fa63ee0d = `iiPXuq_p2`;
$7999b6d38c1a5546$export$9ab2405854d25601 = `iiPXuq_p3`;
$7999b6d38c1a5546$export$5e8e9074022ed083 = `iiPXuq_p4`;
$7999b6d38c1a5546$export$feb62dfdf81bc282 = `iiPXuq_p5`;
$7999b6d38c1a5546$export$ede8042ddbb20f54 = `iiPXuq_s1`;
$7999b6d38c1a5546$export$88872d1f97e13ba9 = `iiPXuq_s2`;
$7999b6d38c1a5546$export$dc9368c5558c5766 = `iiPXuq_s3`;
$7999b6d38c1a5546$export$fba4cbb73d5fdb07 = `iiPXuq_s4`;
$7999b6d38c1a5546$export$cc9fc94495f9bd7c = `iiPXuq_s5`;
$7999b6d38c1a5546$export$746dd974202ffffe = `iiPXuq_scrollbox`;
$7999b6d38c1a5546$export$eade479634cb5dc5 = `iiPXuq_sidebarToggle`;
$7999b6d38c1a5546$export$92d98d0701d4531a = `iiPXuq_sm`;
$7999b6d38c1a5546$export$fb184b623420d9be = `iiPXuq_title`;
$7999b6d38c1a5546$export$9086bb9c16b2b5b = `iiPXuq_total`;
$7999b6d38c1a5546$export$abb3878d4b973569 = `iiPXuq_xl`;




var $5b0b7cb6915e7718$exports = {};






























$5b0b7cb6915e7718$exports = {
    "001-calendar": {},
    "002-presentation": {},
    "003-user": {},
    "004-inbox": {},
    "alert": {},
    "arrow-d-dark": {},
    "arrow-l-dark": {},
    "arrow-r-dark": {},
    "balloons": {},
    "calendar2": {},
    "capacity": {},
    "copy": {},
    "defect": {},
    "enhancement": {},
    "hourglass": {},
    "info": {},
    "jira": {},
    "logo": {},
    "overflow": {},
    "pocket": {},
    "refresh": {},
    "report": {},
    "rgb": {},
    "settings-circle": {},
    "settings": {},
    "stethoscope": {},
    "task": {},
    "up-arrow-pink": {},
    "up-arrow-yellow": {},
    "warning": {}
};


const $0fdb1d7dc66d0718$var$OPEN_BUG_URL = "https://bugzilla.mozilla.org/show_bug.cgi?id=";
const $0fdb1d7dc66d0718$var$TICKET_URL = "https://mozilla-hub.atlassian.net/browse/";
const $0fdb1d7dc66d0718$var$numberWithSpaces = (n)=>{
    const letters = n.toString().split("");
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                children: letters.slice(0, -3).join("")
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                className: $2c8085794fda339d$exports.idSpacer,
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                children: letters.slice(-3).join("")
            })
        ]
    });
};
function $0fdb1d7dc66d0718$var$formatDate(value, monthAndYear = false) {
    const now = (0, $4b4b939aba8f1d15$exports.DateTime).local();
    const t = (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(value).setZone();
    if (monthAndYear) return t.toFormat("MMM yyyy");
    if (t.hasSame(now, "day")) return t.toFormat("t");
    if (!t.hasSame(now, "year")) return t.toFormat("MMM d yyyy");
    return t.toFormat("ccc MMM d");
}
function $0fdb1d7dc66d0718$var$getShortName(email) {
    if (email === "nobody@mozilla.org") return "";
    return (0, $9e3325dd32f85aba$export$3e4ea77b8bea417)[email] || email;
}
function $0fdb1d7dc66d0718$export$381585b42c5efa(iterationString) {
    const result = iterationString.match(/\d+\.\d+/);
    return result ? result[0] : "";
}
function $0fdb1d7dc66d0718$export$76862570d6daff1a(flags) {
    const now = Date.now();
    const needinfos = [];
    for (const flag of flags)if (flag.name === "needinfo") {
        flag.epoch = Date.parse(flag.creation_date);
        flag.age = Math.ceil((now - flag.epoch) / 86400000);
        if (flag.setter !== flag.requestee) needinfos.push(flag);
    }
    // sort oldest needinfos first
    needinfos.sort((a, b)=>a.epoch - b.epoch);
    const [ni] = needinfos;
    if (ni) return (0, $9e3325dd32f85aba$export$3e4ea77b8bea417)[ni.requestee] || ni.requestee.split("@")[0];
    return null;
}
function $0fdb1d7dc66d0718$var$parseTags({ whiteboard: whiteboard, keywords: keywords, hasPR: hasPR, flags: flags, needinfo_nick: needinfo_nick }) {
    const regex = /\[(.+?)\]/g;
    let matches = [];
    let tags = [];
    if (keywords) tags = tags.concat(keywords);
    while(matches = regex.exec(whiteboard))// eslint-disable-line no-cond-assign
    tags.push(matches[1]);
    if (hasPR) tags.push("has-pr");
    if (needinfo_nick) tags.push(`ni?${needinfo_nick}`);
    else if (flags && flags.find((flag)=>flag.name === "needinfo")) {
        let parsedNick = $0fdb1d7dc66d0718$export$76862570d6daff1a(flags);
        if (parsedNick) tags.push(`ni?${parsedNick}`);
        else tags.push("needinfo");
    }
    return tags;
}
function $0fdb1d7dc66d0718$var$renderWhiteboard(bug) {
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("ul", {
        className: $2c8085794fda339d$exports.tagList,
        children: $0fdb1d7dc66d0718$var$parseTags(bug).map((tag)=>{
            // Filter out tags that aren't added to the config
            // if (!tagConfig[tag]) return;
            let style = {};
            let label = tag;
            if ((0, $8489bb4934f95969$export$2e2bcd8739ae039)[tag]) {
                style = (0, $8489bb4934f95969$export$2e2bcd8739ae039)[tag].style;
                label = (0, $8489bb4934f95969$export$2e2bcd8739ae039)[tag].label;
            }
            if (tag.startsWith("ni?")) {
                style = (0, $8489bb4934f95969$export$2e2bcd8739ae039)["ni?"].style;
                label = (0, $8489bb4934f95969$export$2e2bcd8739ae039)["ni?"].label.replace("%s", tag.slice(3));
            }
            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
                style: style,
                children: label
            }, tag);
        }).filter((t)=>t)
    });
}
function $0fdb1d7dc66d0718$var$openPriorityGuide() {
    (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set("priority_guide_open", true);
}
const $0fdb1d7dc66d0718$export$ad1734e9af69f92a = {
    id (value, bug, props) {
        if (!value) return "";
        let postfix;
        // If the whiteboard has the [omc] tag, it means this bug is directly synced
        // with the Jira ticket. Comments in the bug will be mirrored in the Jira
        // ticket. So if your ticket has multiple child bugs, you don't want to sync
        // them directly with the ticket. You just want to add them to See Also.
        // That means if a bug lacks the [omc] tag, it's probably one of multiple
        // child bugs belonging to that ticket. This allows us to add an emoji to
        // the ticket label, indicating that the ticket has multiple child bugs.
        if (bug.ticket && !$0fdb1d7dc66d0718$var$parseTags(bug).includes("omc")) // add an icon indicating that this ticket has multiple child bugs
        postfix = /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
            title: `This bug is not synced with its ticket, so it may be one of multiple child bugs.\nIf this is the ticket's only bug, add [omc] to the bug's whiteboard.`,
            role: "img",
            style: {
                cursor: "help"
            },
            children: "\uD83E\uDDE9"
        });
        let className;
        let title;
        if (props.getBugWarning instanceof Function) {
            let { type: type, message: message } = props.getBugWarning(bug);
            if (type) className = [
                $2c8085794fda339d$exports.warning,
                $2c8085794fda339d$exports[type]
            ].filter(Boolean).join(" ");
            title = message;
        }
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                    target: "_blank",
                    href: $0fdb1d7dc66d0718$var$OPEN_BUG_URL + value,
                    rel: "noopener noreferrer",
                    className: className,
                    title: title,
                    children: $0fdb1d7dc66d0718$var$numberWithSpaces(value)
                }),
                postfix
            ]
        });
    },
    summary (value, bug, props) {
        const tags = !!props.tags && $0fdb1d7dc66d0718$var$renderWhiteboard(bug);
        const flags = $0fdb1d7dc66d0718$var$renderWhiteboard({
            flags: bug.flags
        });
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
            children: [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).isValidElement(value) ? value : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: $0fdb1d7dc66d0718$var$OPEN_BUG_URL + bug.id,
                    children: value
                }),
                tags || flags
            ]
        });
    },
    assigned_to (value) {
        return $0fdb1d7dc66d0718$var$getShortName(value);
    },
    type (value) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5b0b7cb6915e7718$exports)))[value],
            alt: value,
            title: value
        });
    },
    ticket (value) {
        return value ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: $0fdb1d7dc66d0718$var$TICKET_URL + value,
            children: value
        }) : "";
    },
    cf_fx_points (value) {
        const hasPoints = value && value !== "---";
        if (!hasPoints) return "";
        let tShirtSize;
        let points = parseInt(value, 10);
        if (points < 3) tShirtSize = "SM";
        else if (points < 8) tShirtSize = "MD";
        else if (points < 15) tShirtSize = "LG";
        else tShirtSize = "XL";
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
            className: $7999b6d38c1a5546$exports[tShirtSize.toLowerCase()],
            onClick: $0fdb1d7dc66d0718$var$openPriorityGuide,
            tabIndex: "-1",
            title: `${points} points`,
            children: tShirtSize
        });
    },
    cf_fx_iteration (value) {
        return $0fdb1d7dc66d0718$export$381585b42c5efa(value) || "--";
    },
    _custom_release (_, bug) {
        return $0fdb1d7dc66d0718$export$381585b42c5efa(bug.cf_fx_iteration).split(".")[0];
    },
    cf_last_resolved (value) {
        if (!value) return "";
        return $0fdb1d7dc66d0718$var$formatDate(value);
    },
    last_change_time (value) {
        return $0fdb1d7dc66d0718$var$formatDate(value, true);
    },
    priority (priority) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
            className: $7999b6d38c1a5546$exports[priority.toLowerCase()],
            onClick: priority == "--" ? null : $0fdb1d7dc66d0718$var$openPriorityGuide,
            tabIndex: "-1",
            children: priority
        });
    },
    severity (severity) {
        const label = severity.toUpperCase();
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
            className: $7999b6d38c1a5546$exports[severity.toLowerCase()],
            onClick: [
                "--",
                "N/A"
            ].includes(label) ? null : $0fdb1d7dc66d0718$var$openPriorityGuide,
            tabIndex: "-1",
            children: label
        });
    },
    status (_, bug) {
        let text = bug.status.toLowerCase();
        const isGitHubMerged = bug.keywords && bug.keywords.includes("github-merged") && bug.status !== "RESOLVED";
        const isNew = [
            "NEW",
            "ASSIGNED",
            "REOPENED"
        ].includes(bug.status);
        if (isGitHubMerged) text = "github-merged";
        else if (isNew) text = "";
        const labelStyle = $2c8085794fda339d$exports[`status-${text}`];
        return text ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
            className: $2c8085794fda339d$exports.statusLabel + (labelStyle ? ` ${labelStyle}` : ""),
            children: text
        }) : "";
    }
};





parcelRequire("3KGP8");

// The bugzilla product bugs are found in
const $513e68b890b7ecb5$export$2d6d1795a622852b = "Firefox";
const $513e68b890b7ecb5$export$602c648fbe26557c = [
    "Messaging System"
];
const $513e68b890b7ecb5$export$8527a940d2ac3f5 = [
    {
        product: "Firefox",
        component: "General"
    },
    {
        product: "Toolkit",
        component: "General"
    }
];
const $513e68b890b7ecb5$export$b30aba3873b6ee58 = "1534999";
const $513e68b890b7ecb5$export$bef5e81cca5b5fd3 = "Messaging System";
const $513e68b890b7ecb5$export$a4a067e700bf40e1 = "https://docs.google.com/spreadsheets/d/1OTNN20IhUm_sPq6awL6cqFTShi4kqCGn6IRvQBL-bcQ";


const $dce846c101d17da1$export$52d880933fb3945a = (props)=>{
    const url = `https://bugzilla.mozilla.org/enter_bug.cgi?${props.params}&product=${(0, $513e68b890b7ecb5$export$2d6d1795a622852b)}`;
    let className = props.unstyled ? "" : $1d79b97a34537ccf$export$41c1085b355ecc97;
    if (props.className) className += ` ${props.className}`;
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        href: url,
        children: "File new bug"
    });
};


function $ac4eab3948a5d97f$var$getDisplayName(id) {
    return (0, $7f99eab969191513$export$d79264f26953ec1)[id] ? (0, $7f99eab969191513$export$d79264f26953ec1)[id].displayName : id;
}
const $ac4eab3948a5d97f$var$EditorGroup = (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
        className: $2c8085794fda339d$exports.editorGroup,
        children: props.children
    });
class $ac4eab3948a5d97f$export$d5b411913e724a3 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            selectedBugs: {},
            showResolved: props.showResolved
        };
        this.onCheck = this.onCheck.bind(this);
        this.onAllSelectedCheck = this.onAllSelectedCheck.bind(this);
        this.onCheckShowResolved = this.onCheckShowResolved.bind(this);
    }
    getRowClassName(bug) {
        const classNames = [];
        if (this.props.crossOutResolved && (0, $0b7e4383cbab5ef0$export$e85e3b969cd106bb)(bug)) classNames.push($2c8085794fda339d$exports.resolved);
        else if (bug.assigned_to === "nobody@mozilla.org") classNames.push($2c8085794fda339d$exports.unassigned);
        else {
            let email = (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("bugzilla_email");
            if (email && bug.assigned_to === email) classNames.push($2c8085794fda339d$exports.mine);
        }
        return classNames.join(" ");
    }
    renderColumn(columnId, bug) {
        const columnTransform = this.props.columnTransforms[columnId] || (0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a)[columnId];
        const value = columnTransform ? columnTransform(bug[columnId], bug, this.props) : bug[columnId];
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
            className: `${$2c8085794fda339d$exports.td} ${$2c8085794fda339d$exports[`${columnId}Column`]}`,
            children: value
        }, columnId);
    }
    onAllSelectedCheck(e) {
        if (e.target.checked) {
            const selectedBugs = {};
            this.filterResolved().forEach((bug)=>{
                selectedBugs[bug.id] = true;
            });
            this.setState({
                selectedBugs: selectedBugs
            });
            return;
        }
        this.setState({
            selectedBugs: {}
        });
    }
    onCheck(e) {
        const { checked: checked, value: value } = e.target;
        this.setState((prevState)=>{
            const newState = Object.assign({}, prevState.selectedBugs);
            if (checked) newState[value] = true;
            else delete newState[value];
            return {
                selectedBugs: newState
            };
        });
    }
    onCheckShowResolved(e) {
        this.setState({
            showResolved: e.target.checked
        });
    }
    getBulkEditLink(bugs) {
        return `https://bugzilla.mozilla.org/buglist.cgi?bug_id=${bugs.join(",")}&order=bug_id&tweak=1`;
    }
    renderFilters() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($ac4eab3948a5d97f$var$EditorGroup, {
            children: this.props.showResolvedOption ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                        type: "checkbox",
                        onChange: this.onCheckShowResolved,
                        checked: this.state.showResolved
                    }),
                    " ",
                    "Show Resolved"
                ]
            }) : null
        });
    }
    renderBulkEdit(selectedBugs) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($ac4eab3948a5d97f$var$EditorGroup, {
                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                    className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                    href: this.getBulkEditLink(selectedBugs),
                    children: "Edit in Bugzilla"
                })
            })
        });
    }
    filterResolved() {
        const { bugs: bugs } = this.props;
        if (this.state.showResolved) return bugs;
        return bugs.filter((bug)=>!(0, $0b7e4383cbab5ef0$export$e85e3b969cd106bb)(bug));
    }
    _renderSubtitle() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                    children: this.props.meta ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("a", {
                        className: $1d79b97a34537ccf$export$c69aea64b8d954e7,
                        href: `https://bugzilla.mozilla.org/show_bug.cgi?id=${this.props.meta}`,
                        children: [
                            this.props.subtitle,
                            " - Bug ",
                            this.props.meta
                        ]
                    }) : this.props.subtitle
                }),
                " ",
                "|",
                " "
            ]
        });
    }
    _renderSectionBugSelection(selectedBugs, totalBugs) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $2c8085794fda339d$exports.editorType,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                    className: $2c8085794fda339d$exports.leftEditorGroup,
                    children: [
                        this.props.subtitle ? this._renderSubtitle() : null,
                        selectedBugs.length ? `${selectedBugs.length} bugs selected` : `${totalBugs.length} bugs`,
                        this.props.tickets ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                            children: [
                                " ",
                                "|",
                                " ",
                                totalBugs.reduce((a, b)=>{
                                    if (b.ticket && !a.includes(b.ticket)) a.push(b.ticket);
                                    return a;
                                }, []).length.toString(),
                                " ",
                                "tickets"
                            ]
                        }) : null,
                        this.props.points ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                            children: [
                                " ",
                                "|",
                                " ",
                                totalBugs.reduce((a, b)=>a + (parseInt(b.cf_fx_points) || 0), 0).toString(),
                                " ",
                                "points"
                            ]
                        }) : null,
                        this.props.fileNew ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                            children: [
                                " ",
                                "| ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $dce846c101d17da1$export$52d880933fb3945a), {
                                    unstyled: true,
                                    params: this.props.fileNew
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    children: selectedBugs.length ? this.renderBulkEdit(selectedBugs) : this.renderFilters()
                })
            ]
        });
    }
    renderTable() {
        const { props: props } = this;
        const totalBugs = this.filterResolved();
        const selectedBugs = Object.keys(this.state.selectedBugs);
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("table", {
            className: $2c8085794fda339d$exports.bugTable,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("thead", {
                    children: [
                        props.showSummaryBar ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                            className: props.compact ? $2c8085794fda339d$exports.editorCompact : $2c8085794fda339d$exports.editor,
                            children: [
                                this.props.bulkEdit ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                    className: `${$2c8085794fda339d$exports.th} ${$2c8085794fda339d$exports.bulkColumn}`,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                        type: "checkbox",
                                        value: "all",
                                        checked: totalBugs.length > 0 && selectedBugs.length === totalBugs.length,
                                        onChange: this.onAllSelectedCheck
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                    className: $2c8085794fda339d$exports.th,
                                    colSpan: props.columns.length,
                                    children: this._renderSectionBugSelection(selectedBugs, totalBugs)
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                            className: $2c8085794fda339d$exports.labels,
                            children: [
                                this.props.bulkEdit ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                    className: $2c8085794fda339d$exports.th
                                }) : null,
                                props.columns.map((id)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                        className: $2c8085794fda339d$exports.th,
                                        children: $ac4eab3948a5d97f$var$getDisplayName(id)
                                    }, id))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("tbody", {
                    children: totalBugs.map((bug)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                            className: this.getRowClassName(bug),
                            children: [
                                this.props.bulkEdit ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                    className: `${$2c8085794fda339d$exports.td} ${$2c8085794fda339d$exports.bulkColumn}`,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                        type: "checkbox",
                                        value: bug.id,
                                        "data-bug-id": bug.id,
                                        checked: !!this.state.selectedBugs[bug.id],
                                        onChange: this.onCheck
                                    })
                                }) : null,
                                props.columns.map((columnId)=>this.renderColumn(columnId, bug))
                            ]
                        }, bug.id))
                })
            ]
        });
    }
    render() {
        const { props: props } = this;
        if (props.visibleIfEmpty || this.filterResolved().length) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
            children: [
                props.title ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                        style: {
                            cursor: props.titleTooltip ? "help" : null
                        },
                        title: props.titleTooltip,
                        children: props.title
                    })
                }) : null,
                this.filterResolved().length || props.showHeaderIfEmpty ? this.renderTable() : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $2c8085794fda339d$exports.emptyState,
                    children: "No bugs found."
                })
            ]
        });
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $4c1de7c0601f7260$exports.Fragment), {});
    }
}
$ac4eab3948a5d97f$export$d5b411913e724a3.defaultProps = {
    bugs: [],
    columns: [
        "id",
        "summary",
        "assigned_to",
        "priority",
        "status"
    ],
    columnTransforms: $0fdb1d7dc66d0718$export$ad1734e9af69f92a,
    tags: false,
    showHeaderIfEmpty: false,
    showSummaryBar: true,
    showResolvedOption: true,
    crossOutResolved: true,
    showResolved: true,
    visibleIfEmpty: true
};



var $637c5e000d0c3d84$export$6afc3304cb6a2eb0;
var $637c5e000d0c3d84$export$34d2c1d96cf4c07;
var $637c5e000d0c3d84$export$f4c5de44377d2946;
var $637c5e000d0c3d84$export$f9f0aa96487d9fcb;
$637c5e000d0c3d84$export$6afc3304cb6a2eb0 = `NULwtW_fadein1`;
$637c5e000d0c3d84$export$6afc3304cb6a2eb0;
$637c5e000d0c3d84$export$34d2c1d96cf4c07 = `NULwtW_load1`;
$637c5e000d0c3d84$export$34d2c1d96cf4c07;
$637c5e000d0c3d84$export$f4c5de44377d2946 = `NULwtW_loader`;
$637c5e000d0c3d84$export$f9f0aa96487d9fcb = `NULwtW_loaderContainer`;


var $74698c3e01d12939$export$f0a6a20d51f8c14;
var $74698c3e01d12939$export$77f0afce2f595943;
var $74698c3e01d12939$export$86d678294f6e86d9;
$74698c3e01d12939$export$f0a6a20d51f8c14 = `hiscFG_miniLoader`;
$74698c3e01d12939$export$77f0afce2f595943 = `hiscFG_miniLoader-1`;
$74698c3e01d12939$export$77f0afce2f595943;
$74698c3e01d12939$export$86d678294f6e86d9 = `hiscFG_miniLoader-2`;
$74698c3e01d12939$export$86d678294f6e86d9;



var $3KGP8 = parcelRequire("3KGP8");
const $33e4d48c124e59db$export$3b0d6d7590275603 = ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
        className: $637c5e000d0c3d84$export$f9f0aa96487d9fcb,
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
            className: $637c5e000d0c3d84$export$f4c5de44377d2946,
            children: "Loading\u2026"
        })
    });
const $33e4d48c124e59db$export$39671f92c3fd7ff9 = (props)=>{
    const [stopped, setStopped] = (0, $3KGP8.useState)(null);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
        className: $74698c3e01d12939$export$f0a6a20d51f8c14,
        hidden: props.hidden,
        stopped: stopped,
        onTransitionEnd: ()=>setStopped(""),
        title: "Checking for new bugs\u2026",
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
            children: "Refreshing\u2026"
        })
    });
};




var $3KGP8 = parcelRequire("3KGP8");
var $9212115cdcc419c9$export$34e0f9847d4c02dd;
var $9212115cdcc419c9$export$46e4a324ac90507f;
var $9212115cdcc419c9$export$628dc1c0324367d;
$9212115cdcc419c9$export$34e0f9847d4c02dd = `Q--aCq_container`;
$9212115cdcc419c9$export$46e4a324ac90507f = `Q--aCq_heading`;
$9212115cdcc419c9$export$628dc1c0324367d = `Q--aCq_subHeading`;





const $0ed3e0ab6aeadd3d$export$42a852a2b6b56249 = ({ heading: heading, title: title, subHeading: subHeading, loaded: loaded, render: render, children: children, fileBug: fileBug })=>{
    // Update the page's title for this container
    (0, $3KGP8.useEffect)(()=>{
        const prefix = `${typeof heading == "string" ? heading : title} \u{2013} `;
        const originalTitle = document.title;
        document.title = prefix + document.title;
        return ()=>{
            document.title = originalTitle;
        };
    }, [
        heading,
        title
    ]);
    const getContent = (0, $3KGP8.useCallback)(()=>{
        if (!loaded) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$3b0d6d7590275603), {});
        if (render) return render();
        return children;
    }, [
        loaded,
        children,
        render
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
        className: $9212115cdcc419c9$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("header", {
                className: $9212115cdcc419c9$export$46e4a324ac90507f,
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h1", {
                        children: [
                            heading,
                            " ",
                            fileBug ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $dce846c101d17da1$export$52d880933fb3945a), {
                                className: $1d79b97a34537ccf$export$9e9706b9843a7198,
                                params: fileBug
                            }) : ""
                        ]
                    }),
                    subHeading ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                        className: $9212115cdcc419c9$export$628dc1c0324367d,
                        children: subHeading
                    }) : ""
                ]
            }),
            getContent()
        ]
    });
};


class $35982a04b075b92b$export$71a7b6ab8397c50f extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    static defaultProps = {
        columns: [
            "id",
            "summary",
            "last_change_time",
            "cf_fx_iteration"
        ]
    };
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            bugs: [],
            query: {},
            uri: ""
        };
    }
    async componentWillMount() {
        this._isMounted = true;
        const BASE_QUERY = {
            include_fields: this.props.columns.concat([
                "whiteboard",
                "keywords",
                "type",
                "resolution",
                "status",
                "component"
            ]),
            resolution: [
                "---",
                "FIXED"
            ]
        };
        await this.context.qm.runCachedQueries(Object.assign({}, BASE_QUERY, this.props.query), ()=>this._isMounted, ({ rsp: { bugs: bugs, query: query, uri: uri }, awaitingNetwork: awaitingNetwork })=>{
            if (this.props.map) bugs = bugs.map(this.props.map);
            if (this.props.filter) bugs = bugs.filter(this.props.filter);
            if (this.props.sort) bugs.sort(this.props.sort);
            return this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                bugs: bugs,
                query: query,
                uri: uri
            });
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: this.props.title,
            subHeading: this.props.description,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    compact: true,
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs,
                    columns: this.props.columns,
                    getBugWarning: this.props.getBugWarning
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}


function $0af70e7ac28e0ae3$export$2e2bcd8739ae039(o, p) {
    $0af70e7ac28e0ae3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0af70e7ac28e0ae3$export$2e2bcd8739ae039(o, p);
}


function $1468f020b726df1e$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0af70e7ac28e0ae3$export$2e2bcd8739ae039)(subClass, superClass);
}



var $3KGP8 = parcelRequire("3KGP8");
var $b150101a55bbd264$exports = {};
'use strict';
$b150101a55bbd264$exports.__esModule = true;

var $3KGP8 = parcelRequire("3KGP8");
var $b150101a55bbd264$var$_react2 = $b150101a55bbd264$var$_interopRequireDefault($3KGP8);
var $213dc784eadaea29$exports = {};
'use strict';
$213dc784eadaea29$exports.__esModule = true;

var $3KGP8 = parcelRequire("3KGP8");
var $213dc784eadaea29$var$_react2 = $213dc784eadaea29$var$_interopRequireDefault($3KGP8);
var $01430642f7b27fb7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $01430642f7b27fb7$var$ReactIs, $01430642f7b27fb7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$01430642f7b27fb7$exports = (parcelRequire("h4LgD"))();


var $213dc784eadaea29$var$_propTypes2 = $213dc784eadaea29$var$_interopRequireDefault($01430642f7b27fb7$exports);
var $7a70251da93f455c$exports = {};
// @flow
'use strict';
var $7a70251da93f455c$var$key = '__global_unique_id__';
$7a70251da93f455c$exports = function() {
    return $parcel$global[$7a70251da93f455c$var$key] = ($parcel$global[$7a70251da93f455c$var$key] || 0) + 1;
};


var $213dc784eadaea29$var$_gud2 = $213dc784eadaea29$var$_interopRequireDefault($7a70251da93f455c$exports);
var $f02b8b8a321954ee$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';
var $37e08dab187f91ba$exports = {};
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $37e08dab187f91ba$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $37e08dab187f91ba$var$emptyFunction = function emptyFunction() {};
$37e08dab187f91ba$var$emptyFunction.thatReturns = $37e08dab187f91ba$var$makeEmptyFunction;
$37e08dab187f91ba$var$emptyFunction.thatReturnsFalse = $37e08dab187f91ba$var$makeEmptyFunction(false);
$37e08dab187f91ba$var$emptyFunction.thatReturnsTrue = $37e08dab187f91ba$var$makeEmptyFunction(true);
$37e08dab187f91ba$var$emptyFunction.thatReturnsNull = $37e08dab187f91ba$var$makeEmptyFunction(null);
$37e08dab187f91ba$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$37e08dab187f91ba$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
$37e08dab187f91ba$exports = $37e08dab187f91ba$var$emptyFunction;


/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $f02b8b8a321954ee$var$warning = $37e08dab187f91ba$exports;
var $f02b8b8a321954ee$var$printWarning;
$f02b8b8a321954ee$exports = $f02b8b8a321954ee$var$warning;


var $213dc784eadaea29$var$_warning2 = $213dc784eadaea29$var$_interopRequireDefault($f02b8b8a321954ee$exports);
function $213dc784eadaea29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $213dc784eadaea29$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $213dc784eadaea29$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $213dc784eadaea29$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $213dc784eadaea29$var$MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $213dc784eadaea29$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $213dc784eadaea29$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $213dc784eadaea29$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $213dc784eadaea29$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, $213dc784eadaea29$var$_gud2.default)() + '__';
    var Provider = function(_Component) {
        $213dc784eadaea29$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $213dc784eadaea29$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $213dc784eadaea29$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $213dc784eadaea29$var$createEventEmitter(_this.props.value), _temp), $213dc784eadaea29$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if ($213dc784eadaea29$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $213dc784eadaea29$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($3KGP8.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $213dc784eadaea29$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $213dc784eadaea29$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $213dc784eadaea29$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $213dc784eadaea29$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $213dc784eadaea29$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $213dc784eadaea29$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $213dc784eadaea29$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $213dc784eadaea29$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($3KGP8.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $213dc784eadaea29$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
$213dc784eadaea29$exports.default = $213dc784eadaea29$var$createReactContext;
$213dc784eadaea29$exports = $213dc784eadaea29$exports['default'];


var $b150101a55bbd264$var$_implementation2 = $b150101a55bbd264$var$_interopRequireDefault($213dc784eadaea29$exports);
function $b150101a55bbd264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b150101a55bbd264$exports.default = $b150101a55bbd264$var$_react2.default.createContext || $b150101a55bbd264$var$_implementation2.default;
$b150101a55bbd264$exports = $b150101a55bbd264$exports['default'];




var $3KGP8 = parcelRequire("3KGP8");


function $1313c398ccc2c3ba$export$2e2bcd8739ae039() {
    $1313c398ccc2c3ba$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1313c398ccc2c3ba$export$2e2bcd8739ae039.apply(this, arguments);
}


function $c1877458c43f96e7$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $c1877458c43f96e7$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $c1877458c43f96e7$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $c1877458c43f96e7$var$isAbsolute(to);
    var isFromAbs = from && $c1877458c43f96e7$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $c1877458c43f96e7$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $c1877458c43f96e7$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $c1877458c43f96e7$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $c1877458c43f96e7$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$c1877458c43f96e7$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $c1877458c43f96e7$export$2e2bcd8739ae039 = $c1877458c43f96e7$var$resolvePathname;


function $d3e0c245314a45ba$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $d3e0c245314a45ba$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $d3e0c245314a45ba$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $d3e0c245314a45ba$var$valueOf(a);
        var bValue = $d3e0c245314a45ba$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $d3e0c245314a45ba$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $d3e0c245314a45ba$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $d3e0c245314a45ba$export$2e2bcd8739ae039 = $d3e0c245314a45ba$var$valueEqual;



var $a8469ee08c8977af$var$isProduction = true;
var $a8469ee08c8977af$var$prefix = 'Invariant failed';
function $a8469ee08c8977af$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($a8469ee08c8977af$var$isProduction) throw new Error($a8469ee08c8977af$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($a8469ee08c8977af$var$prefix, ": ").concat(provided) : $a8469ee08c8977af$var$prefix;
    throw new Error(value);
}


function $b94f54dc5b4e0263$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $b94f54dc5b4e0263$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $b94f54dc5b4e0263$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $b94f54dc5b4e0263$var$stripBasename(path, prefix) {
    return $b94f54dc5b4e0263$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $b94f54dc5b4e0263$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $b94f54dc5b4e0263$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $b94f54dc5b4e0263$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $b94f54dc5b4e0263$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $c1877458c43f96e7$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $b94f54dc5b4e0263$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d3e0c245314a45ba$export$2e2bcd8739ae039)(a.state, b.state);
}
function $b94f54dc5b4e0263$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $b94f54dc5b4e0263$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b94f54dc5b4e0263$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $b94f54dc5b4e0263$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $b94f54dc5b4e0263$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $b94f54dc5b4e0263$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $b94f54dc5b4e0263$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $b94f54dc5b4e0263$var$PopStateEvent = 'popstate';
var $b94f54dc5b4e0263$var$HashChangeEvent = 'hashchange';
function $b94f54dc5b4e0263$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $b94f54dc5b4e0263$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$b94f54dc5b4e0263$var$canUseDOM && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $b94f54dc5b4e0263$var$supportsHistory();
    var needsHashChangeListener = !$b94f54dc5b4e0263$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b94f54dc5b4e0263$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $b94f54dc5b4e0263$var$stripTrailingSlash($b94f54dc5b4e0263$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $b94f54dc5b4e0263$var$stripBasename(path, basename);
        return $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $b94f54dc5b4e0263$var$createTransitionManager();
    function setState(nextState) {
        (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($b94f54dc5b4e0263$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($b94f54dc5b4e0263$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($b94f54dc5b4e0263$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $b94f54dc5b4e0263$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($b94f54dc5b4e0263$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($b94f54dc5b4e0263$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($b94f54dc5b4e0263$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($b94f54dc5b4e0263$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $b94f54dc5b4e0263$var$HashChangeEvent$1 = 'hashchange';
var $b94f54dc5b4e0263$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $b94f54dc5b4e0263$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $b94f54dc5b4e0263$var$stripLeadingSlash,
        decodePath: $b94f54dc5b4e0263$var$addLeadingSlash
    },
    slash: {
        encodePath: $b94f54dc5b4e0263$var$addLeadingSlash,
        decodePath: $b94f54dc5b4e0263$var$addLeadingSlash
    }
};
function $b94f54dc5b4e0263$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $b94f54dc5b4e0263$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $b94f54dc5b4e0263$var$pushHashPath(path) {
    window.location.hash = path;
}
function $b94f54dc5b4e0263$var$replaceHashPath(path) {
    window.location.replace($b94f54dc5b4e0263$var$stripHash(window.location.href) + '#' + path);
}
function $b94f54dc5b4e0263$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$b94f54dc5b4e0263$var$canUseDOM && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $b94f54dc5b4e0263$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b94f54dc5b4e0263$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $b94f54dc5b4e0263$var$stripTrailingSlash($b94f54dc5b4e0263$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $b94f54dc5b4e0263$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($b94f54dc5b4e0263$var$getHashPath());
        if (basename) path = $b94f54dc5b4e0263$var$stripBasename(path, basename);
        return $b94f54dc5b4e0263$export$90c043f1c57770b8(path);
    }
    var transitionManager = $b94f54dc5b4e0263$var$createTransitionManager();
    function setState(nextState) {
        (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $b94f54dc5b4e0263$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $b94f54dc5b4e0263$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $b94f54dc5b4e0263$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($b94f54dc5b4e0263$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($b94f54dc5b4e0263$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $b94f54dc5b4e0263$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $b94f54dc5b4e0263$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $b94f54dc5b4e0263$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $b94f54dc5b4e0263$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $b94f54dc5b4e0263$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b94f54dc5b4e0263$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b94f54dc5b4e0263$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b94f54dc5b4e0263$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($b94f54dc5b4e0263$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b94f54dc5b4e0263$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b94f54dc5b4e0263$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b94f54dc5b4e0263$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($b94f54dc5b4e0263$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($b94f54dc5b4e0263$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($b94f54dc5b4e0263$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $b94f54dc5b4e0263$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $b94f54dc5b4e0263$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $b94f54dc5b4e0263$var$createTransitionManager();
    function setState(nextState) {
        (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $b94f54dc5b4e0263$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $b94f54dc5b4e0263$export$90c043f1c57770b8(entry, undefined, createKey()) : $b94f54dc5b4e0263$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $b94f54dc5b4e0263$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b94f54dc5b4e0263$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $b94f54dc5b4e0263$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}



var $e87adc2e059edfcc$exports = {};
var $5c1790e9f29f8026$exports = {};
$5c1790e9f29f8026$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $e87adc2e059edfcc$exports = $e87adc2e059edfcc$var$pathToRegexp;
$e87adc2e059edfcc$exports.parse = $e87adc2e059edfcc$var$parse;
$e87adc2e059edfcc$exports.compile = $e87adc2e059edfcc$var$compile;
$e87adc2e059edfcc$exports.tokensToFunction = $e87adc2e059edfcc$var$tokensToFunction;
$e87adc2e059edfcc$exports.tokensToRegExp = $e87adc2e059edfcc$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $e87adc2e059edfcc$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $e87adc2e059edfcc$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $e87adc2e059edfcc$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $e87adc2e059edfcc$var$escapeGroup(pattern) : asterisk ? '.*' : '[^' + $e87adc2e059edfcc$var$escapeString(delimiter) + ']+?'
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $e87adc2e059edfcc$var$compile(str, options) {
    return $e87adc2e059edfcc$var$tokensToFunction($e87adc2e059edfcc$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $e87adc2e059edfcc$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $e87adc2e059edfcc$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $e87adc2e059edfcc$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $e87adc2e059edfcc$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $e87adc2e059edfcc$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($5c1790e9f29f8026$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $e87adc2e059edfcc$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $e87adc2e059edfcc$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $e87adc2e059edfcc$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $e87adc2e059edfcc$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $e87adc2e059edfcc$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($e87adc2e059edfcc$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $e87adc2e059edfcc$var$flags(options));
    return $e87adc2e059edfcc$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$stringToRegexp(path, keys, options) {
    return $e87adc2e059edfcc$var$tokensToRegExp($e87adc2e059edfcc$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$tokensToRegExp(tokens, keys, options) {
    if (!$5c1790e9f29f8026$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $e87adc2e059edfcc$var$escapeString(token);
        else {
            var prefix = $e87adc2e059edfcc$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $e87adc2e059edfcc$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $e87adc2e059edfcc$var$attachKeys(new RegExp('^' + route, $e87adc2e059edfcc$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $e87adc2e059edfcc$var$pathToRegexp(path, keys, options) {
    if (!$5c1790e9f29f8026$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $e87adc2e059edfcc$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($5c1790e9f29f8026$exports(path)) return $e87adc2e059edfcc$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $e87adc2e059edfcc$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}



var $7a08b5268b6db632$exports = {};
'use strict';

$7a08b5268b6db632$exports = (parcelRequire("aJZNZ"));


function $459e61a6c17190dc$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $ba696a2641e01881$exports = {};
'use strict';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ba696a2641e01881$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ba696a2641e01881$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ba696a2641e01881$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ba696a2641e01881$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ba696a2641e01881$var$TYPE_STATICS = {};
$ba696a2641e01881$var$TYPE_STATICS[$7a08b5268b6db632$exports.ForwardRef] = $ba696a2641e01881$var$FORWARD_REF_STATICS;
$ba696a2641e01881$var$TYPE_STATICS[$7a08b5268b6db632$exports.Memo] = $ba696a2641e01881$var$MEMO_STATICS;
function $ba696a2641e01881$var$getStatics(component) {
    // React v16.11 and below
    if ($7a08b5268b6db632$exports.isMemo(component)) return $ba696a2641e01881$var$MEMO_STATICS;
     // React v16.12 and above
    return $ba696a2641e01881$var$TYPE_STATICS[component['$$typeof']] || $ba696a2641e01881$var$REACT_STATICS;
}
var $ba696a2641e01881$var$defineProperty = Object.defineProperty;
var $ba696a2641e01881$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ba696a2641e01881$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ba696a2641e01881$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ba696a2641e01881$var$getPrototypeOf = Object.getPrototypeOf;
var $ba696a2641e01881$var$objectPrototype = Object.prototype;
function $ba696a2641e01881$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ba696a2641e01881$var$objectPrototype) {
            var inheritedComponent = $ba696a2641e01881$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ba696a2641e01881$var$objectPrototype) $ba696a2641e01881$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ba696a2641e01881$var$getOwnPropertyNames(sourceComponent);
        if ($ba696a2641e01881$var$getOwnPropertySymbols) keys = keys.concat($ba696a2641e01881$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ba696a2641e01881$var$getStatics(targetComponent);
        var sourceStatics = $ba696a2641e01881$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ba696a2641e01881$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ba696a2641e01881$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ba696a2641e01881$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$ba696a2641e01881$exports = $ba696a2641e01881$var$hoistNonReactStatics;


// TODO: Replace with React.createContext once we can assume React 16+
var $9e524724cfec6cf5$var$createNamedContext = function createNamedContext(name) {
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($b150101a55bbd264$exports)))();
    context.Provider.displayName = name + ".Provider";
    context.Consumer.displayName = name + ".Consumer";
    return context;
};
var $9e524724cfec6cf5$export$63baa8ccbe60bb07 = /*#__PURE__*/ $9e524724cfec6cf5$var$createNamedContext('Router');
/**
 * The public API for putting history on context.
 */ var $9e524724cfec6cf5$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Provider, {
            children: this.props.children || null,
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        });
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $9e524724cfec6cf5$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b94f54dc5b4e0263$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
var $9e524724cfec6cf5$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $9e524724cfec6cf5$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
        !context$$1 && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
        if (!when || context$$1.staticContext) return null;
        var method = context$$1.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $9e524724cfec6cf5$var$messageType;
var $9e524724cfec6cf5$var$cache = {};
var $9e524724cfec6cf5$var$cacheLimit = 10000;
var $9e524724cfec6cf5$var$cacheCount = 0;
function $9e524724cfec6cf5$var$compilePath(path) {
    if ($9e524724cfec6cf5$var$cache[path]) return $9e524724cfec6cf5$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($e87adc2e059edfcc$exports))).compile(path);
    if ($9e524724cfec6cf5$var$cacheCount < $9e524724cfec6cf5$var$cacheLimit) {
        $9e524724cfec6cf5$var$cache[path] = generator;
        $9e524724cfec6cf5$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $9e524724cfec6cf5$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $9e524724cfec6cf5$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $9e524724cfec6cf5$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
        !context$$1 && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
        var history = context$$1.history, staticContext = context$$1.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $b94f54dc5b4e0263$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $9e524724cfec6cf5$export$82476f982757e71e(to, computedMatch.params) : (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, to, {
            pathname: $9e524724cfec6cf5$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (!(0, $b94f54dc5b4e0263$export$c3e8bb440bd55b18)(prevProps.to, location)) method(location);
            },
            to: to
        });
    });
}
var $9e524724cfec6cf5$var$cache$1 = {};
var $9e524724cfec6cf5$var$cacheLimit$1 = 10000;
var $9e524724cfec6cf5$var$cacheCount$1 = 0;
function $9e524724cfec6cf5$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $9e524724cfec6cf5$var$cache$1[cacheKey] || ($9e524724cfec6cf5$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($e87adc2e059edfcc$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($9e524724cfec6cf5$var$cacheCount$1 < $9e524724cfec6cf5$var$cacheLimit$1) {
        pathCache[path] = result;
        $9e524724cfec6cf5$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $9e524724cfec6cf5$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (matched) return matched;
        var _compilePath = $9e524724cfec6cf5$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $9e524724cfec6cf5$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */ var $9e524724cfec6cf5$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
            !context$$1 && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $9e524724cfec6cf5$export$81336c211d5ff295(location.pathname, _this.props) : context$$1.match;
            var props = (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, context$$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            if (typeof children === "function") {
                children = children(props);
                if (children === undefined) {
                    var path;
                    children = null;
                }
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, children && !$9e524724cfec6cf5$var$isEmptyChildren(children) ? children : props.match ? component ? (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement(component, props) : render ? render(props) : null : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
function $9e524724cfec6cf5$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $9e524724cfec6cf5$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, location, {
        pathname: $9e524724cfec6cf5$var$addLeadingSlash(basename) + location.pathname
    });
}
function $9e524724cfec6cf5$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $9e524724cfec6cf5$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $9e524724cfec6cf5$var$createURL(location) {
    return typeof location === "string" ? location : (0, $b94f54dc5b4e0263$export$fe53371bee54353d)(location);
}
function $9e524724cfec6cf5$var$staticHandler(methodName) {
    return function() {
        (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
    };
}
function $9e524724cfec6cf5$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $9e524724cfec6cf5$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $9e524724cfec6cf5$var$noop;
        };
        _this.handleBlock = function() {
            return $9e524724cfec6cf5$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, context = _this$props.context;
        context.action = action;
        context.location = $9e524724cfec6cf5$var$addBasename(basename, (0, $b94f54dc5b4e0263$export$90c043f1c57770b8)(location));
        context.url = $9e524724cfec6cf5$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $459e61a6c17190dc$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $9e524724cfec6cf5$var$addLeadingSlash(basename + $9e524724cfec6cf5$var$createURL(path));
            },
            action: "POP",
            location: $9e524724cfec6cf5$var$stripBasename(basename, (0, $b94f54dc5b4e0263$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $9e524724cfec6cf5$var$staticHandler("go"),
            goBack: $9e524724cfec6cf5$var$staticHandler("goBack"),
            goForward: $9e524724cfec6cf5$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$55185c17a0fcbe46, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $9e524724cfec6cf5$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$63baa8ccbe60bb07.Consumer, null, function(context$$1) {
            !context$$1 && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$$1.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $9e524724cfec6cf5$export$81336c211d5ff295(location.pathname, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context$$1.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $9e524724cfec6cf5$export$369b6b2b30582e8e(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $459e61a6c17190dc$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($9e524724cfec6cf5$export$e7b0ac011bb776c6, {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement(Component, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ba696a2641e01881$exports)))(C, Component);
}
var $9e524724cfec6cf5$var$global, $9e524724cfec6cf5$var$key, $9e524724cfec6cf5$var$buildNames, $9e524724cfec6cf5$var$initialBuildName, $9e524724cfec6cf5$var$secondaryBuildName;








/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $853ab30cd4ee4807$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b94f54dc5b4e0263$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement((0, $9e524724cfec6cf5$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $853ab30cd4ee4807$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $b94f54dc5b4e0263$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement((0, $9e524724cfec6cf5$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
function $853ab30cd4ee4807$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ var $853ab30cd4ee4807$export$a6c7ac8248d6e38a = /*#__PURE__*/ function(_React$Component) {
    (0, $1468f020b726df1e$export$2e2bcd8739ae039)(Link, _React$Component);
    function Link() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Link.prototype;
    _proto.handleClick = function handleClick(event, history) {
        if (this.props.onClick) this.props.onClick(event);
        if (!event.defaultPrevented && // onClick prevented default
        event.button === 0 && (!this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
        !$853ab30cd4ee4807$var$isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            var method = this.props.replace ? history.replace : history.push;
            method(this.props.to);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, innerRef = _this$props.innerRef, replace = _this$props.replace, to = _this$props.to, rest = (0, $459e61a6c17190dc$export$2e2bcd8739ae039)(_this$props, [
            "innerRef",
            "replace",
            "to"
        ]); // eslint-disable-line no-unused-vars
        return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement((0, $9e524724cfec6cf5$export$63baa8ccbe60bb07).Consumer, null, function(context) {
            !context && (0, $a8469ee08c8977af$export$2e2bcd8739ae039)(false);
            var location = typeof to === "string" ? (0, $b94f54dc5b4e0263$export$90c043f1c57770b8)(to, null, null, context.location) : to;
            var href = location ? context.history.createHref(location) : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement("a", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, rest, {
                onClick: function onClick(event) {
                    return _this.handleClick(event, context.history);
                },
                href: href,
                ref: innerRef
            }));
        });
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Component);
var $853ab30cd4ee4807$var$toType, $853ab30cd4ee4807$var$innerRefType;
function $853ab30cd4ee4807$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ function $853ab30cd4ee4807$export$b0d92dbee9b5b60d(_ref) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, location = _ref.location, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, rest = (0, $459e61a6c17190dc$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "strict",
        "style",
        "to"
    ]);
    var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
        path: escapedPath,
        exact: exact,
        strict: strict,
        location: location,
        children: function children(_ref2) {
            var location = _ref2.location, match = _ref2.match;
            var isActive = !!(isActiveProp ? isActiveProp(match, location) : match);
            var className = isActive ? $853ab30cd4ee4807$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
            var style = isActive ? (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, styleProp, activeStyle) : styleProp;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).createElement($853ab30cd4ee4807$export$a6c7ac8248d6e38a, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
                "aria-current": isActive && ariaCurrent || null,
                className: className,
                style: style,
                to: to
            }, rest));
        }
    });
}
var $853ab30cd4ee4807$var$ariaCurrentType;






var $3KGP8 = parcelRequire("3KGP8");




var $3KGP8 = parcelRequire("3KGP8");
function $2c41d67d00e46649$export$4cf511b178cc2057(options) {
    const { query: query, updateOn: updateOn, transformBugs: transformBugs, qm: qm } = options;
    const initialState = {
        bugs: [],
        status: "",
        awaitingNetwork: false
    };
    const [state, setState] = (0, $3KGP8.useState)(initialState);
    (0, $3KGP8.useEffect)(()=>{
        let isMounted = true;
        setState({
            bugs: [],
            status: "loading",
            awaitingNetwork: false
        });
        qm.runCachedQueries(query, ()=>isMounted, ({ rsp: { bugs: bugs }, awaitingNetwork: awaitingNetwork })=>setState({
                bugs: transformBugs ? transformBugs(bugs) : bugs,
                status: "loaded",
                awaitingNetwork: awaitingNetwork
            }));
        return ()=>{
            isMounted = false;
        };
    }, updateOn || [
        query
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return state;
}





parcelRequire("3KGP8");
var $76309e141d92f73e$exports = {};

$parcel$export($76309e141d92f73e$exports, "ahead", () => $76309e141d92f73e$export$56f868e84016d1d1, (v) => $76309e141d92f73e$export$56f868e84016d1d1 = v);
$parcel$export($76309e141d92f73e$exports, "assignedLabel", () => $76309e141d92f73e$export$d61212c6bc78ed55, (v) => $76309e141d92f73e$export$d61212c6bc78ed55 = v);
$parcel$export($76309e141d92f73e$exports, "behind", () => $76309e141d92f73e$export$521399346c5da8, (v) => $76309e141d92f73e$export$521399346c5da8 = v);
$parcel$export($76309e141d92f73e$exports, "bottom", () => $76309e141d92f73e$export$40e543e69a8b3fbb, (v) => $76309e141d92f73e$export$40e543e69a8b3fbb = v);
$parcel$export($76309e141d92f73e$exports, "bugsBar", () => $76309e141d92f73e$export$ed1ca5217c0d5797, (v) => $76309e141d92f73e$export$ed1ca5217c0d5797 = v);
$parcel$export($76309e141d92f73e$exports, "completionBar", () => $76309e141d92f73e$export$397c051c0d42ac96, (v) => $76309e141d92f73e$export$397c051c0d42ac96 = v);
$parcel$export($76309e141d92f73e$exports, "container", () => $76309e141d92f73e$export$34e0f9847d4c02dd, (v) => $76309e141d92f73e$export$34e0f9847d4c02dd = v);
$parcel$export($76309e141d92f73e$exports, "dateBar", () => $76309e141d92f73e$export$fdfdc3994c45fa45, (v) => $76309e141d92f73e$export$fdfdc3994c45fa45 = v);
$parcel$export($76309e141d92f73e$exports, "dateLine", () => $76309e141d92f73e$export$30eef69158bf6f81, (v) => $76309e141d92f73e$export$30eef69158bf6f81 = v);
$parcel$export($76309e141d92f73e$exports, "innerWrapper", () => $76309e141d92f73e$export$81d7888dbe9f6490, (v) => $76309e141d92f73e$export$81d7888dbe9f6490 = v);
$parcel$export($76309e141d92f73e$exports, "marker", () => $76309e141d92f73e$export$ffc4d0086f1a4c9, (v) => $76309e141d92f73e$export$ffc4d0086f1a4c9 = v);
$parcel$export($76309e141d92f73e$exports, "resolvedLabel", () => $76309e141d92f73e$export$353e2d2226f5f48f, (v) => $76309e141d92f73e$export$353e2d2226f5f48f = v);
$parcel$export($76309e141d92f73e$exports, "top", () => $76309e141d92f73e$export$1e95b668f3b82d, (v) => $76309e141d92f73e$export$1e95b668f3b82d = v);
$parcel$export($76309e141d92f73e$exports, "unpaddedContainer", () => $76309e141d92f73e$export$1b023aa98e0b428d, (v) => $76309e141d92f73e$export$1b023aa98e0b428d = v);
var $76309e141d92f73e$export$56f868e84016d1d1;
var $76309e141d92f73e$export$d61212c6bc78ed55;
var $76309e141d92f73e$export$521399346c5da8;
var $76309e141d92f73e$export$40e543e69a8b3fbb;
var $76309e141d92f73e$export$ed1ca5217c0d5797;
var $76309e141d92f73e$export$397c051c0d42ac96;
var $76309e141d92f73e$export$34e0f9847d4c02dd;
var $76309e141d92f73e$export$fdfdc3994c45fa45;
var $76309e141d92f73e$export$30eef69158bf6f81;
var $76309e141d92f73e$export$81d7888dbe9f6490;
var $76309e141d92f73e$export$ffc4d0086f1a4c9;
var $76309e141d92f73e$export$353e2d2226f5f48f;
var $76309e141d92f73e$export$1e95b668f3b82d;
var $76309e141d92f73e$export$1b023aa98e0b428d;
$76309e141d92f73e$export$56f868e84016d1d1 = `HCdSIq_ahead`;
$76309e141d92f73e$export$d61212c6bc78ed55 = `HCdSIq_assignedLabel`;
$76309e141d92f73e$export$521399346c5da8 = `HCdSIq_behind`;
$76309e141d92f73e$export$40e543e69a8b3fbb = `HCdSIq_bottom`;
$76309e141d92f73e$export$ed1ca5217c0d5797 = `HCdSIq_bugsBar`;
$76309e141d92f73e$export$397c051c0d42ac96 = `HCdSIq_completionBar`;
$76309e141d92f73e$export$34e0f9847d4c02dd = `HCdSIq_container`;
$76309e141d92f73e$export$fdfdc3994c45fa45 = `HCdSIq_dateBar`;
$76309e141d92f73e$export$30eef69158bf6f81 = `HCdSIq_dateLine`;
$76309e141d92f73e$export$81d7888dbe9f6490 = `HCdSIq_innerWrapper`;
$76309e141d92f73e$export$ffc4d0086f1a4c9 = `HCdSIq_marker`;
$76309e141d92f73e$export$353e2d2226f5f48f = `HCdSIq_resolvedLabel`;
$76309e141d92f73e$export$1e95b668f3b82d = `HCdSIq_top`;
$76309e141d92f73e$export$1b023aa98e0b428d = `HCdSIq_unpaddedContainer`;




const $c8445d06c2f62860$var$Marker = (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
        className: `${$76309e141d92f73e$exports.marker} ${$76309e141d92f73e$exports[props.position || "top"]}`,
        style: {
            left: `${props.percentage}%`
        },
        children: props.children
    });
const $c8445d06c2f62860$export$b0164dcf0f54812 = (props)=>{
    const currentDate = props.currentDate || new Date();
    const totalWorkDays = (0, $a2dbb61dc7ec7558$export$fffdcd8709803332)(props.startDate, props.endDate);
    const completedWorkDays = (0, $a2dbb61dc7ec7558$export$fffdcd8709803332)(props.startDate, currentDate);
    const daysPercentage = completedWorkDays / totalWorkDays * 100;
    const totalBugs = props.bugs.length;
    const completedBugs = props.bugs.filter((bug)=>(0, $0b7e4383cbab5ef0$export$e85e3b969cd106bb)(bug)).length;
    const bugsPercentage = completedBugs / totalBugs * 100;
    const aheadOfSchedule = daysPercentage < bugsPercentage;
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
        className: props.startDate ? $76309e141d92f73e$exports.container : $76309e141d92f73e$exports.unpaddedContainer,
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $76309e141d92f73e$exports.innerWrapper,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                    className: $76309e141d92f73e$exports.completionBar,
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                            className: `${$76309e141d92f73e$exports.dateBar} ${aheadOfSchedule ? $76309e141d92f73e$exports.ahead : $76309e141d92f73e$exports.behind}`,
                            style: {
                                width: `${daysPercentage}%`
                            }
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                            className: $76309e141d92f73e$exports.bugsBar,
                            style: {
                                width: `${bugsPercentage}%`
                            }
                        })
                    ]
                }),
                props.startDate ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $76309e141d92f73e$exports.dateLine,
                    style: {
                        left: `${daysPercentage}%`
                    }
                }) : "",
                props.startDate ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($c8445d06c2f62860$var$Marker, {
                    position: "bottom",
                    percentage: daysPercentage,
                    children: "Today"
                }) : "",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)($c8445d06c2f62860$var$Marker, {
                    percentage: bugsPercentage,
                    children: [
                        completedBugs,
                        "/",
                        totalBugs,
                        " done"
                    ]
                })
            ]
        })
    });
};





var $3ffda7d78a1bd5d6$export$e69c7579d4c7d4bf;
var $3ffda7d78a1bd5d6$export$8db0d200f6bd6323;
var $3ffda7d78a1bd5d6$export$873a618fdaf6698f;
$3ffda7d78a1bd5d6$export$e69c7579d4c7d4bf = `l5fAAG_iterationArrow`;
$3ffda7d78a1bd5d6$export$8db0d200f6bd6323 = `l5fAAG_iterationHeading`;
$3ffda7d78a1bd5d6$export$873a618fdaf6698f = `l5fAAG_iterationSpacer`;



const $3df9deaf5e6870b1$var$COLUMNS = [
    "id",
    "type",
    "summary",
    "assigned_to",
    "priority",
    "cf_fx_points"
];
const $3df9deaf5e6870b1$var$getQuery = (options)=>({
        include_fields: [
            "id",
            "summary",
            "assigned_to",
            "priority",
            "status",
            "whiteboard",
            "keywords",
            "type",
            "flags",
            "blocks",
            "component",
            "cf_fx_points",
            "resolution"
        ],
        rules: [
            {
                key: "cf_fx_iteration",
                operator: "substring",
                value: options.iteration
            },
            {
                operator: "OR",
                rules: [
                    {
                        key: "blocked",
                        operator: "anywordssubstr",
                        value: options.metas.filter((m)=>(0, $513e68b890b7ecb5$export$602c648fbe26557c).includes(m.component)).map((m)=>m.id).join(",")
                    },
                    {
                        key: "component",
                        operator: "anyexact",
                        value: (0, $513e68b890b7ecb5$export$602c648fbe26557c).join(",")
                    }
                ]
            }
        ]
    });
function $3df9deaf5e6870b1$var$sortByMeta(allMetas, bugs) {
    let bugsByMeta = {};
    bugs?.forEach((bug)=>{
        const metas = allMetas.filter((meta)=>meta.priority === "P1" && bug.blocks.includes(meta.id));
        if (!metas.length) metas.push({
            id: "other",
            displayName: "Other"
        });
        metas.forEach((meta)=>{
            if (!bugsByMeta[meta.id]) bugsByMeta[meta.id] = {
                meta: meta,
                bugs: []
            };
            bugsByMeta[meta.id].bugs.push(bug);
        });
    });
    return bugsByMeta;
}
const $3df9deaf5e6870b1$export$6fc755757341c0b2 = (props)=>{
    const isCurrent = props.iteration === props.currentIteration.number;
    const { metas: metas, qm: qm, teams: teams, iterations: iterations } = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useContext((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useMemo(()=>$3df9deaf5e6870b1$var$getQuery({
            ...props,
            metas: metas
        }), [
        metas,
        props
    ]);
    const state = (0, $2c41d67d00e46649$export$4cf511b178cc2057)({
        query: query,
        qm: qm
    });
    const bugsByMeta = $3df9deaf5e6870b1$var$sortByMeta(metas, state.bugs);
    const isLoaded = state.status === "loaded";
    const maybeAddPoints = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback((bug, rv)=>{
        const email = !bug.assigned_to || bug.assigned_to === "nobody@mozilla.org" ? "unassigned" : bug.assigned_to;
        if (!(0, $9e3325dd32f85aba$export$c957e9dafc0b7f8f).omc.includes(email)) return;
        if (!rv[email]) rv[email] = {
            bugs: 0,
            points: 0,
            user: teams.omc.find((e)=>[
                    e.name,
                    e.email
                ].includes(email))
        };
        rv[email].bugs++;
        rv.total.bugs++;
        const points = Number(bug.cf_fx_points);
        if (points > 0) {
            rv[email].points += points;
            rv.total.points += points;
        }
    }, [
        teams.omc
    ]);
    const pointLists = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useMemo(()=>{
        let rv = {
            remainingPoints: {
                total: {
                    bugs: 0,
                    points: 0
                }
            },
            finishedPoints: {
                total: {
                    bugs: 0,
                    points: 0
                }
            }
        };
        for (let bug of state.bugs){
            if (!(0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(bug)) maybeAddPoints(bug, rv.remainingPoints);
            else if (bug.resolution === "FIXED") maybeAddPoints(bug, rv.finishedPoints);
        }
        return rv;
    }, [
        maybeAddPoints,
        state.bugs
    ]);
    const formatPointsFor = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback(({ bugs: bugs, points: points, user: { real_name: real_name, nick: nick }, email: email })=>{
        let tShirtSize;
        if (points < 3) tShirtSize = "SM";
        else if (points < 8) tShirtSize = "MD";
        else if (points < 15) tShirtSize = "LG";
        else tShirtSize = "XL";
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("li", {
            children: [
                real_name || nick || email,
                ": ",
                bugs,
                " ",
                bugs === 1 ? "bug" : "bugs",
                points ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                            className: $7999b6d38c1a5546$exports[tShirtSize.toLowerCase()],
                            children: [
                                points,
                                " ",
                                points === 1 ? "pt" : "pts"
                            ]
                        })
                    ]
                }) : null
            ]
        }, email);
    }, []);
    const formatPointsList = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback((list)=>{
        let items = Object.keys(list).map((email)=>email === "total" ? null : formatPointsFor({
                ...list[email],
                email: email
            })).filter(Boolean);
        if (items.length) return items;
        return null;
    }, [
        formatPointsFor
    ]);
    const formatPointsTitle = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback(({ title: title, bugs: bugs, points: points })=>{
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
            children: [
                title,
                bugs > 0 ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                    children: [
                        ": ",
                        bugs,
                        " ",
                        bugs === 1 ? "bug" : "bugs",
                        points ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
                                    className: $7999b6d38c1a5546$exports.total,
                                    children: [
                                        points,
                                        " ",
                                        points === 1 ? "pt" : "pts"
                                    ]
                                })
                            ]
                        }) : null
                    ]
                }) : null
            ]
        });
    }, []);
    const getBugWarning = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback((bug)=>{
        if (!metas.some((m)=>bug.blocks?.includes(m.id))) return {
            type: "no-meta",
            message: "This bug is not blocking any meta bug in Messaging System. Please add a meta bug!"
        };
        return {};
    }, [
        metas
    ]);
    const heading = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useMemo(()=>{
        const nextIteration = iterations.getAdjacentIteration(1, props.iteration);
        const prevIteration = iterations.getAdjacentIteration(-1, props.iteration);
        let headingString = isCurrent ? `Current Iteration (${props.iteration})` : `Iteration ${props.iteration}`;
        return {
            title: headingString,
            heading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                className: $3ffda7d78a1bd5d6$export$8db0d200f6bd6323,
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                        className: $3ffda7d78a1bd5d6$export$873a618fdaf6698f,
                        children: prevIteration ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                            className: $3ffda7d78a1bd5d6$export$e69c7579d4c7d4bf,
                            to: `/iteration/${prevIteration.number}`,
                            "aria-label": `Previous iteration: ${prevIteration.number}`,
                            children: "\u25C0"
                        }) : null
                    }),
                    headingString,
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                        className: $3ffda7d78a1bd5d6$export$873a618fdaf6698f,
                        children: nextIteration ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                            className: $3ffda7d78a1bd5d6$export$e69c7579d4c7d4bf,
                            to: `/iteration/${nextIteration.number}`,
                            "aria-label": `Next iteration: ${nextIteration.number}`,
                            children: "\u25B6"
                        }) : null
                    })
                ]
            })
        };
    }, [
        isCurrent,
        iterations,
        props.iteration
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
        loaded: isLoaded,
        heading: heading.heading,
        title: heading.title,
        children: [
            isCurrent ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $c8445d06c2f62860$export$b0164dcf0f54812), {
                startDate: props.currentIteration.start,
                endDate: props.currentIteration.due,
                bugs: state.bugs
            }) : null,
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                style: {
                    marginTop: "20px"
                },
                children: Object.keys(bugsByMeta).map((id)=>{
                    const { meta: meta, bugs: bugs } = bugsByMeta[id];
                    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                        compact: true,
                        subtitle: meta.displayName,
                        tags: true,
                        bulkEdit: true,
                        showHeaderIfEmpty: true,
                        bugs: bugs,
                        columns: $3df9deaf5e6870b1$var$COLUMNS,
                        getBugWarning: getBugWarning
                    }, meta.id);
                })
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexFlow: "row nowrap",
                    fontSize: "14px"
                },
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("ul", {
                        style: {
                            marginTop: "0",
                            paddingInline: "20px",
                            lineHeight: "22px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h4", {
                                style: {
                                    marginBottom: "0",
                                    marginInlineStart: "-1em"
                                },
                                children: formatPointsTitle({
                                    title: "Remaining work",
                                    ...pointLists.remainingPoints.total
                                })
                            }),
                            formatPointsList(pointLists.remainingPoints) ?? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                style: {
                                    marginBottom: "0",
                                    marginInlineStart: "-1em"
                                },
                                children: "No remaining work"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("ul", {
                        style: {
                            marginTop: "0",
                            paddingInline: "20px",
                            lineHeight: "22px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h4", {
                                style: {
                                    marginBottom: "0",
                                    marginInlineStart: "-1em"
                                },
                                children: formatPointsTitle({
                                    title: "Finished work",
                                    ...pointLists.finishedPoints.total
                                })
                            }),
                            formatPointsList(pointLists.finishedPoints) ?? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                style: {
                                    marginBottom: "0",
                                    marginInlineStart: "-1em"
                                },
                                children: "No finished work"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                hidden: !state.awaitingNetwork
            })
        ]
    });
};




var $3KGP8 = parcelRequire("3KGP8");
var $8fbf2e2acf0e5178$export$34e0f9847d4c02dd;
var $8fbf2e2acf0e5178$export$9fdf7094580cf00;
var $8fbf2e2acf0e5178$export$1ee19be03e1f9a1c;
var $8fbf2e2acf0e5178$export$e3f17872540962e4;
var $8fbf2e2acf0e5178$export$e014d8ef45a0015b;
var $8fbf2e2acf0e5178$export$cc74dcc53cfce4eb;
$8fbf2e2acf0e5178$export$34e0f9847d4c02dd = `oRfxTW_container`;
$8fbf2e2acf0e5178$export$9fdf7094580cf00 = `oRfxTW_mainColumn`;
$8fbf2e2acf0e5178$export$1ee19be03e1f9a1c = `oRfxTW_settingSection`;
$8fbf2e2acf0e5178$export$e3f17872540962e4 = `oRfxTW_settingsBtn`;
$8fbf2e2acf0e5178$export$e014d8ef45a0015b = `oRfxTW_sideColumn`;
$8fbf2e2acf0e5178$export$cc74dcc53cfce4eb = `oRfxTW_wrapper`;







const $7090c432f17fd21a$var$columns = [
    "id",
    "summary",
    "last_change_time",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points"
];
const $7090c432f17fd21a$var$include_fields = $7090c432f17fd21a$var$columns.concat([
    "whiteboard",
    "keywords",
    "type",
    "status",
    "flags"
]);
class $7090c432f17fd21a$export$2ea4ef6422f3fce1 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            bugsAssigned: [],
            bugsFlags: [],
            bugsComments: [],
            bugsClosed: [],
            loaded: false,
            awaitingNetwork: false,
            email: null,
            showSettings: false,
            emailWasChanged: false
        };
        this.onPrefChange = this.onPrefChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onEmailSubmit = this.onEmailSubmit.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).on("bugzilla_email", this.onPrefChange);
    }
    async refresh() {
        this.setState({
            loaded: false
        });
        const newState = {
            emailWasChanged: false,
            loaded: true,
            awaitingNetwork: false,
            bugsAssigned: [],
            bugsFlags: [],
            bugsComments: [],
            bugsClosed: []
        };
        if (this.state.email) {
            await this.context.qm.runCachedQueries([
                {
                    include_fields: $7090c432f17fd21a$var$include_fields,
                    resolution: "---",
                    order: "changeddate DESC",
                    custom: {
                        assigned_to: {
                            equals: this.state.email
                        }
                    }
                },
                {
                    include_fields: $7090c432f17fd21a$var$include_fields,
                    resolution: "---",
                    order: "changeddate DESC",
                    custom: {
                        "requestees.login_name": {
                            equals: this.state.email
                        }
                    }
                },
                {
                    include_fields: $7090c432f17fd21a$var$include_fields,
                    order: "changeddate DESC",
                    limit: 30,
                    custom: {
                        commenter: {
                            equals: this.state.email
                        }
                    }
                },
                {
                    include_fields: $7090c432f17fd21a$var$include_fields,
                    order: "changeddate DESC",
                    limit: 50,
                    resolution: "FIXED",
                    custom: {
                        assigned_to: {
                            equals: this.state.email
                        }
                    }
                }
            ], ()=>this._isMounted, ({ rsp: [{ bugs: bugsAssigned }, { bugs: bugsFlags }, { bugs: bugsComments }, { bugs: bugsClosed }], awaitingNetwork: awaitingNetwork })=>{
                newState.bugsAssigned = bugsAssigned;
                newState.bugsFlags = bugsFlags;
                newState.bugsComments = bugsComments;
                newState.bugsClosed = bugsClosed;
                newState.awaitingNetwork = awaitingNetwork;
                this.setState(newState);
            });
            return;
        }
        this.setState(newState);
    }
    componentWillMount() {
        this._isMounted = true;
        const email = (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("bugzilla_email");
        this.setState({
            email: email,
            showSettings: !email
        }, this.refresh);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    onEmailChange(e) {
        this.setState({
            email: e.target.value,
            emailWasChanged: true
        });
    }
    onEmailSubmit(e) {
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set("bugzilla_email", this.state.email);
        e.preventDefault();
    }
    onPrefChange({ name: name, oldValue: oldValue, newValue: newValue } = {}) {
        if (name === "bugzilla_email") {
            const emailWasChanged = oldValue !== newValue;
            this.setState({
                email: newValue,
                emailWasChanged: emailWasChanged
            }, emailWasChanged ? this.refresh : null);
        }
    }
    toggleSettings() {
        this.setState((state)=>({
                showSettings: !state.showSettings
            }));
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $8fbf2e2acf0e5178$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h1", {
                    children: [
                        "My Bugs",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                            onClick: this.toggleSettings,
                            className: $8fbf2e2acf0e5178$export$e3f17872540962e4,
                            title: "settings"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    hidden: !this.state.showSettings,
                    className: $8fbf2e2acf0e5178$export$1ee19be03e1f9a1c,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("form", {
                        onSubmit: this.onEmailSubmit,
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("label", {
                                children: "Bugzilla Email "
                            }),
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                className: $1d79b97a34537ccf$export$4622d93046d5fd3d,
                                type: "text",
                                value: this.state.email,
                                onChange: this.onEmailChange
                            }),
                            this.state.loaded && this.state.emailWasChanged ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                                className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                                type: "submit",
                                children: "Save"
                            }) : null
                        ]
                    })
                }),
                this.state.loaded ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                    className: $8fbf2e2acf0e5178$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                            className: $8fbf2e2acf0e5178$export$9fdf7094580cf00,
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                                        showSummaryBar: false,
                                        title: "Assigned to me",
                                        bugs: this.state.bugsAssigned,
                                        columns: $7090c432f17fd21a$var$columns
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                                        showSummaryBar: false,
                                        title: "Recently Closed",
                                        bugs: this.state.bugsClosed,
                                        columns: $7090c432f17fd21a$var$columns,
                                        crossOutResolved: false
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                            className: $8fbf2e2acf0e5178$export$e014d8ef45a0015b,
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                                        showSummaryBar: false,
                                        title: "Flags",
                                        bugs: this.state.bugsFlags,
                                        columns: [
                                            "id",
                                            "summary",
                                            "last_change_time",
                                            "priority",
                                            "cf_fx_points"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                                        showSummaryBar: false,
                                        title: "Recently commented on",
                                        bugs: this.state.bugsComments,
                                        columns: [
                                            "id",
                                            "summary",
                                            "last_change_time",
                                            "priority",
                                            "cf_fx_points"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                            hidden: !this.state.awaitingNetwork
                        })
                    ]
                }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$3b0d6d7590275603), {})
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");
var $1032058226ef86a6$export$34e0f9847d4c02dd;
$1032058226ef86a6$export$34e0f9847d4c02dd = `aC9jWq_container`;


class $4029e431cd9d99ab$export$1eb1323c9a3751ef extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $1032058226ef86a6$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h1", {
                    children: "About"
                }),
                "Bugzy is a dashboard for tracking specific Bugzilla bugs. It's designed to be used by teams that want to track bugs in a specific iteration, or bugs that are blocking a specific bug.",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: "https://github.com/mozilla/bugzy",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Repository"
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: "https://github.com/mozilla/bugzy/issues",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Issues"
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                    children: "Credits"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                    children: [
                        "Icons are designed by",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: "https://smashicons.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Smashicons"
                        }),
                        ",",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: "https://www.freepik.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Freepik"
                        }),
                        ", and",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: "https://roundicons.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Roundicons"
                        }),
                        " ",
                        "from",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: "https://www.flaticon.com",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "flaticon.com"
                        })
                    ]
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");



var $3KGP8 = parcelRequire("3KGP8");
var $92159d687d2a66ba$export$2ba01fb71ed41cb6;
var $92159d687d2a66ba$export$fcdf03c31cfbd14;
var $92159d687d2a66ba$export$57bf213be019eeb0;
$92159d687d2a66ba$export$2ba01fb71ed41cb6 = `_682VWG_button`;
$92159d687d2a66ba$export$fcdf03c31cfbd14 = `_682VWG_copiedText`;
$92159d687d2a66ba$export$57bf213be019eeb0 = `_682VWG_show`;



const $7a8fc547fc7ccbbd$var$DISPLAY_COPIED_TEXT_MS = 2500;
class $7a8fc547fc7ccbbd$export$4f2558dd25106ae2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            copied: false
        };
        this.copyText = this.copyText.bind(this);
    }
    copyText() {
        clearTimeout(this.timeoutId); // A no-op if timeoutId invalid
        (0, $0b7e4383cbab5ef0$export$2cdf1b96a9f86d16)(this.props.text);
        this.setState({
            copied: true
        });
        this.timeoutId = setTimeout(()=>this.setState({
                copied: false
            }), $7a8fc547fc7ccbbd$var$DISPLAY_COPIED_TEXT_MS);
    }
    componentWillReceiveProps() {
        // Remove the span if the `text` prop gets updated
        this.setState({
            copied: false
        });
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId); // A no-op if timeoutId invalid
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                    className: $92159d687d2a66ba$export$2ba01fb71ed41cb6,
                    onClick: this.copyText,
                    title: this.props.title
                }),
                " ",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                    className: `${$92159d687d2a66ba$export$fcdf03c31cfbd14} ${this.state.copied ? $92159d687d2a66ba$export$57bf213be019eeb0 : ""}`,
                    children: "Copied!"
                })
            ]
        });
    }
}







var $3KGP8 = parcelRequire("3KGP8");
var $3c560a760783d35b$export$9f2575a093d7aa7b;
var $3c560a760783d35b$export$cb33e49628b60250;
var $3c560a760783d35b$export$8cc075c801fd6817;
var $3c560a760783d35b$export$1f9169f556c5cb13;
$3c560a760783d35b$export$9f2575a093d7aa7b = `cF9sAq_activeTab`;
$3c560a760783d35b$export$cb33e49628b60250 = `cF9sAq_noTopPadding`;
$3c560a760783d35b$export$8cc075c801fd6817 = `cF9sAq_spacer`;
$3c560a760783d35b$export$1f9169f556c5cb13 = `cF9sAq_tabsContainer`;



class $ab5c293cf1af135b$export$b2539bed5023c21c extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    constructor(props){
        super(props);
        this.renderTabLink = this.renderTabLink.bind(this);
        this.renderTabRoute = this.renderTabRoute.bind(this);
        this.state = {
            bugs: [],
            loaded: false
        };
    }
    renderTabLink(tabInfo, i) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$b0d92dbee9b5b60d), {
                exact: true,
                activeClassName: $3c560a760783d35b$export$9f2575a093d7aa7b,
                to: this.props.baseUrl + tabInfo.path,
                children: tabInfo.label
            })
        }, i);
    }
    renderTabRoute(config, i) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
            exact: true,
            path: this.props.baseUrl + config.path,
            render: config.render
        }, i); // eslint-disable-line
    }
    render() {
        const { config: config } = this.props;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $3c560a760783d35b$export$1f9169f556c5cb13 + (this.props.noTopPadding ? ` ${$3c560a760783d35b$export$cb33e49628b60250}` : ""),
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("ul", {
                        children: [
                            config.map(this.renderTabLink),
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
                                className: $3c560a760783d35b$export$8cc075c801fd6817
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$b5d5cf8927ab7262), {
                    children: config.map(this.renderTabRoute)
                })
            ]
        });
    }
}



/** Removes the [meta]/[META] label from a bug title  */ const $418e2a80c8ccbbe6$var$META_REGEX = /^\[\s*meta\s*\]\s*/i;
const $418e2a80c8ccbbe6$var$FX_VERSION_REGEX = /\s(in\s|-\s)*(firefox|fx)\s*\d+/i;
function $418e2a80c8ccbbe6$export$775faba1c97e7d6d(summary) {
    return summary.replace($418e2a80c8ccbbe6$var$META_REGEX, "").replace($418e2a80c8ccbbe6$var$FX_VERSION_REGEX, "");
}



const $1536f61a4f9de922$var$displayColumns = [
    "id",
    "type",
    "summary",
    "assigned_to",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points"
];
function $1536f61a4f9de922$var$sortOpen(a, b) {
    const a1 = a.assigned_to;
    const a2 = b.assigned_to;
    const isAUnassigned = a.cf_fx_iteration === "---";
    const isBUnassigned = b.cf_fx_iteration === "---";
    if (a.priority < b.priority) return -1;
    if (a.priority > b.priority) return 1;
    // Sort unassigned to the bottom
    if (isAUnassigned && !isBUnassigned) return 1;
    if (!isAUnassigned && isBUnassigned) return -1;
    if (a.cf_fx_iteration < b.cf_fx_iteration) return -1;
    if (a.cf_fx_iteration > b.cf_fx_iteration) return 1;
    if (a1 < a2) return -1;
    if (a1 > a2) return 1;
    return 0;
}
function $1536f61a4f9de922$var$bulkEditAll() {
    let items = [
        ...document.querySelectorAll("input[data-bug-id]")
    ];
    let checkedItems = items.filter((i)=>i.checked);
    if (checkedItems.length) items = checkedItems;
    const bugIds = items.map((i)=>i.value).filter((v)=>parseInt(v, 10));
    let url = `https://bugzilla.mozilla.org/buglist.cgi?bug_id=${bugIds.join(",")}&order=bug_id&tweak=1`;
    window.open(url, "_blank");
}
const $1536f61a4f9de922$var$FeatureBugList = ({ visibleIfEmpty: visibleIfEmpty = false, bugs: bugs, title: title, columns: columns = $1536f61a4f9de922$var$displayColumns, ...restProps })=>{
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
            title: title,
            compact: true,
            showResolvedOption: false,
            bulkEdit: true,
            tags: true,
            bugs: bugs,
            columns: columns,
            visibleIfEmpty: visibleIfEmpty,
            ...restProps
        })
    });
};
const $1536f61a4f9de922$var$OpenView = ({ id: id, parentMeta: parentMeta, component: component, currentRelease: currentRelease, nextRelease: nextRelease, includeFields: includeFields })=>{
    const { qm: qm } = (0, $3KGP8.useContext)((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const [loaded, setLoaded] = (0, $3KGP8.useState)(false);
    const [awaitingNetwork, setAwaitingNetwork] = (0, $3KGP8.useState)(false);
    const [bugs, setBugs] = (0, $3KGP8.useState)({
        untriaged: [],
        current: [],
        currentBySubMeta: {},
        next: [],
        nextBySubMeta: {},
        backlog: [],
        backlogBySubMeta: {},
        uplift: []
    });
    const [subMetas, setSubMetas] = (0, $3KGP8.useState)([]);
    (0, $3KGP8.useEffect)(()=>{
        if (!id) return;
        let isMounted = true;
        setLoaded(false);
        setAwaitingNetwork(false);
        setBugs({
            untriaged: [],
            current: [],
            currentBySubMeta: {},
            next: [],
            nextBySubMeta: {},
            backlog: [],
            backlogBySubMeta: {},
            uplift: []
        });
        setSubMetas([]);
        const subMetaQuery = {
            include_fields: includeFields,
            resolution: "---",
            rules: [
                {
                    key: "blocked",
                    operator: "equals",
                    value: id
                },
                {
                    key: "keywords",
                    operator: "anyexact",
                    value: "meta"
                }
            ]
        };
        const allBugsQuery = (subMetas)=>{
            return {
                include_fields: includeFields,
                resolution: "---",
                rules: [
                    {
                        key: "blocked",
                        operator: "anywordssubstr",
                        value: [
                            ...subMetas.map((m)=>m.id),
                            id
                        ].join(",")
                    },
                    {
                        key: "keywords",
                        operator: "nowordssubstr",
                        value: "meta"
                    }
                ]
            };
        };
        const predicate = ()=>isMounted;
        qm.runCachedQueries(subMetaQuery, predicate, ({ rsp: { bugs: subMetas } })=>qm.runCachedQueries(allBugsQuery(subMetas), predicate, ({ rsp: { bugs: bugs }, awaitingNetwork: newAwaitingNetwork })=>{
                const result = {
                    untriaged: [],
                    current: [],
                    currentBySubMeta: {},
                    next: [],
                    nextBySubMeta: {},
                    backlog: [],
                    backlogBySubMeta: {},
                    uplift: []
                };
                if (subMetas.length) subMetas.forEach((b)=>{
                    result.currentBySubMeta[b.id] = [];
                    result.nextBySubMeta[b.id] = [];
                    result.backlogBySubMeta[b.id] = [];
                });
                for (const bug of bugs){
                    if ([
                        "?",
                        "+",
                        "blocking"
                    ].includes(bug.cf_tracking_beta) && ![
                        "fixed",
                        "verified"
                    ].includes(bug.cf_status_beta)) result.uplift.push(bug);
                    else if (bug.priority === "P1") {
                        // For now, we're only sorting bugs by meta that are P1 and unresolved.
                        if (subMetas.length) {
                            let subMetaMatch = subMetas.filter((m)=>bug.blocks.includes(m.id));
                            if (subMetaMatch.length) subMetaMatch.forEach((m)=>result.currentBySubMeta[m.id].push(bug));
                            else result.current.push(bug);
                        } else result.current.push(bug);
                    } else if (bug.priority === "P2") {
                        // Adding in meta sorting for P2
                        if (subMetas.length) {
                            let subMetaMatch = subMetas.filter((m)=>bug.blocks.includes(m.id));
                            if (subMetaMatch.length) subMetaMatch.forEach((m)=>result.nextBySubMeta[m.id].push(bug));
                            else result.next.push(bug);
                        } else result.next.push(bug);
                    } else if (bug.priority === "--") result.untriaged.push(bug);
                    else // Adding in meta sorting for Backlog
                    // eslint-disable-next-line no-lonely-if
                    if (subMetas.length) {
                        let subMetaMatch = subMetas.filter((m)=>bug.blocks.includes(m.id));
                        if (subMetaMatch.length) subMetaMatch.forEach((m)=>result.backlogBySubMeta[m.id].push(bug));
                        else result.backlog.push(bug);
                    } else result.backlog.push(bug);
                }
                result.uplift.sort($1536f61a4f9de922$var$sortOpen);
                result.current.sort($1536f61a4f9de922$var$sortOpen);
                Object.keys(result.currentBySubMeta).forEach((id)=>result.currentBySubMeta[id].sort($1536f61a4f9de922$var$sortOpen));
                result.next.sort($1536f61a4f9de922$var$sortOpen);
                Object.keys(result.nextBySubMeta).forEach((id)=>result.nextBySubMeta[id].sort($1536f61a4f9de922$var$sortOpen));
                result.backlog.sort($1536f61a4f9de922$var$sortOpen);
                Object.keys(result.backlogBySubMeta).forEach((id)=>result.backlogBySubMeta[id].sort($1536f61a4f9de922$var$sortOpen));
                setLoaded(true);
                setAwaitingNetwork(newAwaitingNetwork);
                setBugs(result);
                setSubMetas(subMetas);
            }));
        return ()=>{
            isMounted = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return loaded ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Untriaged bugs",
                bugs: bugs.untriaged
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Uplift candidates",
                bugs: bugs.uplift,
                columns: [
                    ...$1536f61a4f9de922$var$displayColumns,
                    "cf_status_nightly",
                    "cf_status_beta"
                ]
            }),
            subMetas.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    [
                        ...Object.values(bugs.currentBySubMeta),
                        bugs.current
                    ].some((bugs)=>bugs.length) ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                        children: [
                            "Required for Current Release (Firefox ",
                            currentRelease,
                            ")"
                        ]
                    }) : null,
                    [
                        ...Object.keys(bugs.currentBySubMeta).map((id)=>{
                            const meta = subMetas.find((m)=>String(m.id) === id);
                            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                                subtitle: (0, $418e2a80c8ccbbe6$export$775faba1c97e7d6d)(meta.summary),
                                meta: meta.id,
                                fileNew: `blocked=${meta.id},${parentMeta}&component=${component}`,
                                bugs: bugs.currentBySubMeta[meta.id]
                            }, meta.id);
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                            subtitle: "Other",
                            bugs: bugs.current
                        }, "other")
                    ]
                ]
            }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    bugs.current.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                        children: [
                            "Required for Current Release (Firefox ",
                            currentRelease,
                            ")"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                        bugs: bugs.current
                    })
                ]
            }),
            subMetas.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    [
                        ...Object.values(bugs.nextBySubMeta),
                        bugs.next
                    ].some((bugs)=>bugs.length) ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                        children: [
                            "Required for Next Release (Firefox ",
                            nextRelease,
                            ")"
                        ]
                    }) : null,
                    [
                        ...Object.keys(bugs.nextBySubMeta).map((id)=>{
                            const meta = subMetas.find((m)=>String(m.id) === id);
                            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                                subtitle: (0, $418e2a80c8ccbbe6$export$775faba1c97e7d6d)(meta.summary),
                                meta: meta.id,
                                fileNew: `blocked=${meta.id},${parentMeta}&component=${component}`,
                                bugs: bugs.nextBySubMeta[meta.id]
                            }, meta.id);
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                            subtitle: "Other",
                            bugs: bugs.next
                        }, "other")
                    ]
                ]
            }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    bugs.next.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                        children: [
                            "Required for Next Release (Firefox ",
                            nextRelease,
                            ")"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                        bugs: bugs.next
                    })
                ]
            }),
            subMetas.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    [
                        ...Object.values(bugs.backlogBySubMeta),
                        bugs.backlog
                    ].some((bugs)=>bugs.length) ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                        children: "Backlog"
                    }) : null,
                    [
                        ...Object.keys(bugs.backlogBySubMeta).map((id)=>{
                            const meta = subMetas.find((m)=>String(m.id) === id);
                            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                                subtitle: (0, $418e2a80c8ccbbe6$export$775faba1c97e7d6d)(meta.summary),
                                meta: meta.id,
                                fileNew: `blocked=${meta.id},${parentMeta}&component=${component}`,
                                bugs: bugs.backlogBySubMeta[meta.id]
                            }, meta.id);
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                            subtitle: "Other",
                            bugs: bugs.backlog
                        }, "other")
                    ]
                ]
            }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                children: [
                    bugs.backlog.length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                        children: "Backlog"
                    }) : null,
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                        bugs: bugs.backlog
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                    className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                    onClick: $1536f61a4f9de922$var$bulkEditAll,
                    children: "Edit all in Bugzilla"
                })
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                hidden: !awaitingNetwork
            })
        ]
    }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$3b0d6d7590275603), {});
};
const $1536f61a4f9de922$var$ResolvedView = ({ id: id, includeFields: includeFields })=>{
    const { qm: qm } = (0, $3KGP8.useContext)((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const [loaded, setLoaded] = (0, $3KGP8.useState)(false);
    const [awaitingNetwork, setAwaitingNetwork] = (0, $3KGP8.useState)(false);
    const [bugs, setBugs] = (0, $3KGP8.useState)({
        nightlyResolved: [],
        betaResolved: [],
        releaseResolved: [],
        resolved: []
    });
    const resolvedIncludeFields = (0, $3KGP8.useMemo)(()=>includeFields.filter((f)=>![
                "cf_fx_points"
            ].includes(f)), [
        includeFields
    ]);
    (0, $3KGP8.useEffect)(()=>{
        if (!id) return;
        let isMounted = true;
        setLoaded(false);
        setAwaitingNetwork(false);
        setBugs({
            nightlyResolved: [],
            betaResolved: [],
            releaseResolved: [],
            resolved: []
        });
        const subMetaQuery = {
            include_fields: resolvedIncludeFields,
            resolution: [
                "---",
                "FIXED"
            ],
            rules: [
                {
                    key: "blocked",
                    operator: "equals",
                    value: id
                },
                {
                    key: "keywords",
                    operator: "anyexact",
                    value: "meta"
                }
            ]
        };
        const allBugsQuery = (subMetas)=>{
            return {
                include_fields: resolvedIncludeFields,
                resolution: "FIXED",
                order: "cf_last_resolved DESC",
                rules: [
                    {
                        key: "blocked",
                        operator: "anywordssubstr",
                        value: [
                            ...subMetas.map((m)=>m.id),
                            id
                        ].join(",")
                    },
                    {
                        key: "keywords",
                        operator: "nowordssubstr",
                        value: "meta"
                    }
                ]
            };
        };
        const predicate = ()=>isMounted;
        qm.runCachedQueries(subMetaQuery, predicate, ({ rsp: { bugs: subMetas } })=>qm.runCachedQueries(allBugsQuery(subMetas), predicate, ({ rsp: { bugs: bugs }, awaitingNetwork: newAwaitingNetwork })=>{
                const result = {
                    nightlyResolved: [],
                    betaResolved: [],
                    releaseResolved: [],
                    resolved: []
                };
                for (const bug of bugs)if ((0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(bug)) {
                    if ([
                        "fixed",
                        "verified"
                    ].includes(bug.cf_status_beta)) result.betaResolved.push(bug);
                    else if ([
                        "fixed",
                        "verified"
                    ].includes(bug.cf_status_nightly)) result.nightlyResolved.push(bug);
                    else if ("---" === bug.target_milestone) result.resolved.push(bug);
                    else result.releaseResolved.push(bug);
                }
                setLoaded(true);
                setAwaitingNetwork(newAwaitingNetwork);
                setBugs(result);
            }));
        return ()=>{
            isMounted = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return loaded ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Resolved in Nightly",
                crossOutResolved: false,
                bugs: bugs.nightlyResolved,
                columns: [
                    "id",
                    "type",
                    "summary",
                    "assigned_to",
                    "cf_status_nightly",
                    "cf_status_beta",
                    "priority"
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Resolved in Beta",
                crossOutResolved: false,
                bugs: bugs.betaResolved,
                columns: [
                    "id",
                    "type",
                    "summary",
                    "assigned_to",
                    "cf_status_nightly",
                    "cf_status_beta",
                    "priority"
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Resolved in Release",
                crossOutResolved: false,
                bugs: bugs.releaseResolved,
                columns: [
                    "id",
                    "type",
                    "summary",
                    "assigned_to",
                    "target_milestone",
                    "priority"
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$FeatureBugList, {
                title: "Other",
                crossOutResolved: false,
                bugs: bugs.resolved,
                columns: [
                    "id",
                    "type",
                    "summary",
                    "assigned_to",
                    "cf_fx_iteration",
                    "priority"
                ]
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                    className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                    onClick: $1536f61a4f9de922$var$bulkEditAll,
                    children: "Edit all in Bugzilla"
                })
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                hidden: !awaitingNetwork
            })
        ]
    }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$3b0d6d7590275603), {});
};
const $1536f61a4f9de922$export$dd5fc6b424a32445 = ({ id: id, url: url, displayName: displayName, component: component })=>{
    const { iterations: iterations } = (0, $3KGP8.useContext)((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const currentRelease = (0, $3KGP8.useMemo)(()=>iterations.getIteration().number.split(".")[0], [
        iterations
    ]);
    const prevRelease = (0, $3KGP8.useMemo)(()=>parseInt(currentRelease, 10) - 1, [
        currentRelease
    ]);
    const nextRelease = (0, $3KGP8.useMemo)(()=>parseInt(currentRelease, 10) + 1, [
        currentRelease
    ]);
    const upliftTrackingField = (0, $3KGP8.useMemo)(()=>`cf_tracking_firefox${prevRelease}`, [
        prevRelease
    ]);
    const includeFields = (0, $3KGP8.useMemo)(()=>$1536f61a4f9de922$var$displayColumns.concat([
            "target_milestone",
            "status",
            "resolution",
            "last_change_time",
            "whiteboard",
            "keywords",
            "flags",
            "blocks",
            "type",
            "cf_fx_points",
            upliftTrackingField,
            `cf_status_firefox${prevRelease}`,
            `cf_status_firefox${currentRelease}`,
            "cf_last_resolved"
        ]), [
        currentRelease,
        prevRelease,
        upliftTrackingField
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
        loaded: true,
        heading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
            href: `https://bugzilla.mozilla.org/show_bug.cgi?id=${id}`,
            children: displayName
        }),
        fileBug: `blocked=${id}&component=${component}`,
        subHeading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
            children: [
                "This list includes bugs in any component blocking meta bug",
                " ",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("a", {
                    href: `https://bugzilla.mozilla.org/show_bug.cgi?id=${id}`,
                    children: [
                        " ",
                        id
                    ]
                }),
                " ",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $7a8fc547fc7ccbbd$export$4f2558dd25106ae2), {
                    text: id,
                    title: "Copy bug number"
                })
            ]
        }),
        title: displayName,
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ab5c293cf1af135b$export$b2539bed5023c21c), {
            baseUrl: url,
            config: [
                {
                    path: "",
                    label: "Open",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$OpenView, {
                            ...props,
                            id: id,
                            component: component,
                            parentMeta: id,
                            currentRelease: currentRelease,
                            nextRelease: nextRelease,
                            includeFields: includeFields
                        })
                },
                {
                    path: "/resolved",
                    label: "Resolved",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($1536f61a4f9de922$var$ResolvedView, {
                            ...props,
                            id: id,
                            includeFields: includeFields
                        })
                }
            ]
        })
    }, id);
};




var $3KGP8 = parcelRequire("3KGP8");





const $3dd8fa1ec54c5e13$var$COLUMNS = [
    "id",
    "summary",
    "priority",
    "last_change_time"
];
const $3dd8fa1ec54c5e13$var$getQuery = (options)=>({
        include_fields: [
            "id",
            "summary",
            "priority",
            "status",
            "whiteboard",
            "keywords",
            "type",
            "blocks",
            "cf_fx_iteration",
            "last_change_time"
        ],
        component: options.components,
        resolution: "---",
        order: "changeddate DESC",
        rules: [
            {
                key: "blocked",
                operator: "nowordssubstr",
                value: options.metas.filter((meta)=>meta.priority === "P1").map((m)=>m.id).join(",")
            },
            {
                key: "keywords",
                operator: "nowordssubstr",
                value: "meta"
            },
            {
                key: "priority",
                operator: "notequals",
                value: "--"
            }
        ]
    });
const $3dd8fa1ec54c5e13$var$sortBugs = (a, b)=>{
    if (a.priority < b.priority) return -1;
    if (a.priority > b.priority) return 1;
    return 0;
};
const $3dd8fa1ec54c5e13$export$65ff8390fe1d61cb = ({ components: components })=>{
    const { metas: metas, qm: qm } = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useContext((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useMemo(()=>$3dd8fa1ec54c5e13$var$getQuery({
            metas: metas,
            components: components
        }), [
        metas,
        components
    ]);
    const { status: status, bugs: bugs, awaitingNetwork: awaitingNetwork } = (0, $2c41d67d00e46649$export$4cf511b178cc2057)({
        query: query,
        qm: qm,
        transformBugs: (bugs)=>bugs.sort($3dd8fa1ec54c5e13$var$sortBugs)
    });
    const getBugWarning = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useCallback((bug)=>{
        if (!metas.some((m)=>bug.blocks?.includes(m.id))) return {
            type: "no-meta",
            message: "This bug is not blocking any meta bug in Messaging System. Please add a meta bug!"
        };
        return {};
    }, [
        metas
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
        loaded: status === "loaded",
        heading: "Other bugs",
        subHeading: `This list includes bugs in the ${components.join(", ")} components that are not blocked by a P1 meta bug.`,
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                compact: true,
                tags: true,
                bulkEdit: true,
                showHeaderIfEmpty: true,
                bugs: bugs,
                columns: $3dd8fa1ec54c5e13$var$COLUMNS,
                getBugWarning: getBugWarning
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                hidden: !awaitingNetwork
            })
        ]
    });
};




var $3KGP8 = parcelRequire("3KGP8");






const $d6a74a25ebf7ed06$var$prevColumns = [
    "id",
    "summary",
    "assigned_to",
    "priority",
    "blocks",
    "component"
];
const $d6a74a25ebf7ed06$var$columns = [
    "id",
    "summary",
    "last_change_time",
    "blocks",
    "component"
];
const $d6a74a25ebf7ed06$var$prevColumnsDisplay = [
    "id",
    "summary",
    "assigned_to",
    "priority"
];
const $d6a74a25ebf7ed06$var$columnsDisplay = [
    "id",
    "summary",
    "last_change_time"
];
function $d6a74a25ebf7ed06$var$isNeedInfo(bug) {
    return bug.flags && bug.flags.some((flag)=>flag.name === "needinfo");
}
class $d6a74a25ebf7ed06$export$6658bd3e05b5e915 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            bugs: [],
            needinfoBugs: [],
            untriagedBugs: [],
            previousIterationBugs: [],
            prevIteration: null,
            triageOwner: null
        };
        this.getBugWarning = this.getBugWarning.bind(this);
    }
    async componentWillMount() {
        this._isMounted = true;
        const prevIteration = this.context.iterations.getAdjacentIteration(-1).number;
        this.setState({
            triageOwner: this.context.teams.omc.find((user)=>user.is_triage_owner)
        });
        await this.context.qm.runCachedQueries([
            {
                include_fields: $d6a74a25ebf7ed06$var$prevColumns.concat([
                    "whiteboard",
                    "type"
                ]),
                resolution: "---",
                rules: [
                    {
                        key: "keywords",
                        operator: "notequals",
                        value: "github-merged"
                    },
                    {
                        key: "cf_fx_iteration",
                        operator: "substring",
                        value: prevIteration
                    },
                    {
                        operator: "OR",
                        rules: [
                            {
                                key: "blocked",
                                operator: "anywordssubstr",
                                value: this.context.metas.map((m)=>m.id).join(",")
                            },
                            {
                                key: "component",
                                operator: "anyexact",
                                value: (0, $513e68b890b7ecb5$export$602c648fbe26557c).join(",")
                            }
                        ]
                    }
                ]
            },
            {
                include_fields: $d6a74a25ebf7ed06$var$columns.concat([
                    "whiteboard",
                    "type",
                    "flags"
                ]),
                resolution: "---",
                priority: "--",
                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                order: "changeddate DESC",
                rules: [
                    {
                        key: "keywords",
                        operator: "nowords",
                        value: "meta"
                    },
                    {
                        key: "status_whiteboard",
                        operator: "notsubstring",
                        value: "[blocked]"
                    }
                ]
            }
        ], ()=>this._isMounted, ({ rsp: [{ bugs: previousIterationBugs }, { bugs: bugs }], awaitingNetwork: awaitingNetwork })=>{
            let needinfoBugs = [];
            let untriagedBugs = [];
            for (let b of bugs)if ($d6a74a25ebf7ed06$var$isNeedInfo(b)) needinfoBugs.push(b);
            else untriagedBugs.push(b);
            this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                bugs: bugs,
                needinfoBugs: needinfoBugs,
                untriagedBugs: untriagedBugs,
                previousIterationBugs: previousIterationBugs,
                prevIteration: prevIteration
            });
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    getBugWarning(bug) {
        if (!this.context.metas.some((m)=>bug.blocks?.includes(m.id))) return {
            type: "no-meta",
            message: "This bug is not blocking any meta bug in Messaging System. Please add a meta bug!"
        };
        return {};
    }
    getSubHeading() {
        let { triageOwner: triageOwner } = this.state;
        if (!triageOwner) return null;
        let { real_name: real_name, nick: nick, email: email } = triageOwner;
        let startDate = (0, $4b4b939aba8f1d15$exports.DateTime).utc().set({
            weekday: 1,
            hour: 12,
            minute: 30,
            second: 0,
            millisecond: 0
        }).toLocal();
        let endDate = startDate.plus({
            days: 4
        });
        let dateString = startDate.toLocaleString({
            month: "long",
            day: "numeric"
        });
        if (startDate.month !== endDate.month) dateString += ` - ${endDate.toLocaleString({
            month: "long",
            day: "numeric"
        })}`;
        else dateString += `-${endDate.toLocaleString({
            day: "numeric"
        })}`;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("span", {
            title: "Triage ownership alternates every Monday at 12:30 UTC.",
            style: {
                cursor: "help",
                "text-decoration": "underline .05em dotted"
            },
            children: [
                "Owner: ",
                nick || real_name || email,
                " (",
                dateString,
                ")"
            ]
        });
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: "Triage",
            subHeading: this.getSubHeading(),
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                    children: [
                        "Previous Iteration (",
                        this.state.prevIteration,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    compact: true,
                    showResolvedOption: false,
                    showHeaderIfEmpty: true,
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.previousIterationBugs,
                    columns: $d6a74a25ebf7ed06$var$prevColumnsDisplay,
                    getBugWarning: this.getBugWarning
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                    children: "Untriaged Bugs"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    compact: true,
                    showResolvedOption: false,
                    showHeaderIfEmpty: true,
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.untriagedBugs,
                    columns: $d6a74a25ebf7ed06$var$columnsDisplay,
                    getBugWarning: this.getBugWarning
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                    children: "Bugs with needinfo"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    compact: true,
                    bulkEdit: true,
                    showResolvedOption: false,
                    tags: true,
                    bugs: this.state.needinfoBugs,
                    columns: $d6a74a25ebf7ed06$var$columnsDisplay,
                    getBugWarning: this.getBugWarning
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");
var $bcdd7dd3f2c614af$export$252465da46a2ae40;
$bcdd7dd3f2c614af$export$252465da46a2ae40 = `yXC4HW_emptyState`;







const $991c4555a0213f8e$var$generalTriageColumns = [
    "id",
    "type",
    "summary",
    "last_change_time",
    "priority",
    "severity"
];
const $991c4555a0213f8e$var$triageNeededColumns = [
    "id",
    "type",
    "summary",
    "last_change_time",
    "priority"
];
const $991c4555a0213f8e$var$unassignedColumns = $991c4555a0213f8e$var$triageNeededColumns;
const $991c4555a0213f8e$var$includeFields = $991c4555a0213f8e$var$generalTriageColumns.concat([
    "assigned_to",
    "component",
    "creation_time",
    "creator",
    "flags",
    "groups",
    "keywords",
    "triage_owner"
]);
const $991c4555a0213f8e$var$generalTriageComponentsRule = {
    operator: "OR",
    rules: (0, $513e68b890b7ecb5$export$8527a940d2ac3f5).map(({ product: product, component: component })=>({
            rules: [
                {
                    key: "product",
                    operator: "equals",
                    value: product
                },
                {
                    key: "component",
                    operator: "equals",
                    value: component
                }
            ]
        }))
};
function $991c4555a0213f8e$var$addNeedinfoDetails(bug, ni) {
    bug.needinfo_nick = ni.requestee.split("@")[0];
    bug.needinfo_epoch = ni.epoch;
    return bug;
}
class $991c4555a0213f8e$export$fb975117edc21014 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            bugs: {
                triageNeeded: [],
                recentRegression: [],
                needinfoEscalated: [],
                needinfoStale: [],
                unassignedS1: [],
                unassignedS2: []
            }
        };
    }
    getQueries() {
        return [
            // Triage Needed
            {
                email1: "wptsync@mozilla.bugs",
                emailreporter1: "1",
                emailtype1: "notequals",
                include_fields: $991c4555a0213f8e$var$includeFields,
                keywords: "intermittent_failure",
                keywords_type: "nowords",
                resolution: "---",
                rules: [
                    {
                        key: "bug_type",
                        operator: "equals",
                        value: "defect"
                    },
                    {
                        key: "flagtypes.name",
                        operator: "notsubstring",
                        value: "needinfo"
                    },
                    {
                        key: "bug_severity",
                        operator: "anyexact",
                        value: "--, n/a"
                    },
                    {
                        key: "keywords",
                        operator: "notsubstring",
                        value: "meta"
                    },
                    $991c4555a0213f8e$var$generalTriageComponentsRule
                ]
            },
            // Recent Regressions
            {
                chfield: "[Bug creation]",
                chfieldfrom: this.context.releases.beta.date,
                chfieldto: "Now",
                include_fields: $991c4555a0213f8e$var$includeFields,
                keywords: "regression",
                keywords_type: "allwords",
                resolution: "---",
                rules: [
                    {
                        key: "priority",
                        operator: "nowords",
                        value: "S1,S2"
                    },
                    {
                        key: "flagtypes.name",
                        operator: "notsubstring",
                        value: "needinfo"
                    },
                    {
                        operator: "OR",
                        rules: [
                            {
                                key: `cf_status_firefox${this.context.releases.release.version}`,
                                operator: "nowords",
                                value: "affected,unaffected,fixed,verified,disabled,verified disabled,wontfix,fix-optional"
                            },
                            {
                                key: `cf_status_firefox${this.context.releases.beta.version}`,
                                operator: "nowords",
                                value: "affected,unaffected,fixed,verified,disabled,verified disabled,wontfix,fix-optional"
                            }
                        ]
                    },
                    $991c4555a0213f8e$var$generalTriageComponentsRule
                ]
            },
            // NI? Escalations & NI? > 14 days
            {
                include_fields: $991c4555a0213f8e$var$includeFields,
                resolution: "---",
                rules: [
                    {
                        key: "flagtypes.name",
                        operator: "substring",
                        value: "needinfo"
                    },
                    $991c4555a0213f8e$var$generalTriageComponentsRule
                ]
            },
            // Unassigned S1 Defects & Unassigned S2 Defects
            {
                include_fields: $991c4555a0213f8e$var$includeFields,
                resolution: "---",
                rules: [
                    {
                        key: "bug_severity",
                        operator: "anyexact",
                        value: "s1,blocker,s2,critical"
                    },
                    {
                        key: "assigned_to",
                        operator: "equals",
                        value: "nobody@mozilla.org"
                    },
                    {
                        key: "flagtypes.name",
                        operator: "notsubstring",
                        value: "needinfo"
                    },
                    {
                        key: "cf_status_firefox_nightly",
                        operator: "nowords",
                        value: "fixed,verified,wontfix,disabled,unaffected"
                    },
                    {
                        key: "keywords",
                        operator: "notsubstring",
                        value: "stalled"
                    },
                    $991c4555a0213f8e$var$generalTriageComponentsRule
                ]
            }
        ];
    }
    async componentWillMount() {
        this._isMounted = true;
        await this.context.qm.runCachedQueries(this.getQueries(), ()=>this._isMounted, ({ rsp: [{ bugs: triageNeededBugs }, { bugs: recentRegressionBugs }, { bugs: needinfoBugs }, { bugs: unassignedBugs }], awaitingNetwork: awaitingNetwork })=>{
            const now = Date.now();
            const needinfoEscalatedBugs = [];
            const needinfoStaleBugs = [];
            for (const bug of needinfoBugs){
                const needinfos = [];
                for (const flag of bug.flags)if (flag.name === "needinfo") {
                    flag.epoch = Date.parse(flag.creation_date);
                    flag.age = Math.ceil((now - flag.epoch) / 86400000);
                    needinfos.push(flag);
                }
                bug.needinfos = needinfos.sort((a, b)=>b.age - a.age);
                const relManNI = bug.needinfos.find((ni)=>ni.setter === "release-mgmt-account-bot@mozilla.tld");
                const staleNI = bug.needinfos.find((ni)=>ni.setter !== ni.requestee && ni.age > 14);
                if (relManNI) needinfoEscalatedBugs.push($991c4555a0213f8e$var$addNeedinfoDetails(bug, relManNI));
                else if (staleNI) needinfoStaleBugs.push($991c4555a0213f8e$var$addNeedinfoDetails(bug, staleNI));
            }
            for (const set of [
                needinfoEscalatedBugs,
                needinfoStaleBugs
            ])set.sort((a, b)=>a.needinfo_epoch - b.needinfo_epoch);
            const unassignedS1Bugs = [];
            const unassignedS2Bugs = [];
            for (const bug of unassignedBugs)switch(bug.severity.toLowerCase()){
                case "s1":
                case "blocker":
                    unassignedS1Bugs.push(bug);
                    break;
                case "s2":
                case "critical":
                    unassignedS2Bugs.push(bug);
                    break;
            }
            this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                bugs: {
                    triageNeeded: triageNeededBugs,
                    recentRegression: recentRegressionBugs,
                    needinfoEscalated: needinfoEscalatedBugs,
                    needinfoStale: needinfoStaleBugs,
                    unassignedS1: unassignedS1Bugs,
                    unassignedS2: unassignedS2Bugs
                }
            });
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: "General Triage",
            subHeading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
                children: [
                    "This list includes untriaged bugs in",
                    " ",
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: "https://bugzilla.mozilla.org/buglist.cgi?product=Firefox&component=General&resolution=---",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Firefox::General"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: "https://bugzilla.mozilla.org/buglist.cgi?product=Toolkit&component=General&resolution=---",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Toolkit::General"
                    }),
                    ".",
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("br", {}),
                    "Firefox Desktop engineers share responsibility for these components on a",
                    " ",
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: "https://docs.google.com/document/d/1_r8lKtJg1FXeY9R3mufsQKI3ylXiIrrLgsb3DqC0EoA/edit?usp=sharing",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "rotating basis"
                    }),
                    "."
                ]
            }),
            children: [
                Object.values(this.state.bugs).flat().length ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $4c1de7c0601f7260$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Triage Needed",
                            titleTooltip: `Bugs that have not been triaged (without a severity). Bugs with the meta keyword are ignored and open needinfo requests are ignored.`,
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: true,
                            bugs: this.state.bugs.triageNeeded,
                            columns: $991c4555a0213f8e$var$triageNeededColumns
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Important Recent Regressions",
                            titleTooltip: `Bugs with a regression keyword created since the start of the current Beta cycle (${this.context.releases.beta.date}) that do not have both status-firefox${this.context.releases.beta.version} and status-firefox${this.context.releases.release.version} set. Bugs with an open needinfo request are ignored.\n`,
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: false,
                            bugs: this.state.bugs.recentRegression,
                            columns: $991c4555a0213f8e$var$generalTriageColumns
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Needinfo Escalations",
                            titleTooltip: "Needinfo requests generated by the escalation system.",
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: true,
                            bugs: this.state.bugs.needinfoEscalated,
                            columns: $991c4555a0213f8e$var$generalTriageColumns
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Needinfo > 14 days",
                            titleTooltip: "Needinfo requests older than 14 days, excluding self-needinfos and bugs with the stalled keyword.",
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: true,
                            bugs: this.state.bugs.needinfoStale,
                            columns: $991c4555a0213f8e$var$generalTriageColumns
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Unassigned S1 Defects",
                            titleTooltip: "Catastrophic (S1) defects without an assignee and no pending needinfos, excluding bugs with the stalled keyword.",
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: true,
                            bugs: this.state.bugs.unassignedS1,
                            columns: $991c4555a0213f8e$var$unassignedColumns
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                            title: "Unassigned S2 Defects",
                            titleTooltip: "Serious (S2) defects without an assignee and no pending needinfos, excluding bugs with the stalled keyword.",
                            compact: true,
                            showResolvedOption: false,
                            visibleIfEmpty: false,
                            bulkEdit: false,
                            tags: true,
                            bugs: this.state.bugs.unassignedS2,
                            columns: $991c4555a0213f8e$var$unassignedColumns
                        })
                    ]
                }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $bcdd7dd3f2c614af$export$252465da46a2ae40,
                    children: "No bugs found."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");





const $8dd9d99f7bbdb9e4$var$columns = [
    "id",
    "summary",
    "last_change_time",
    "priority"
];
const $8dd9d99f7bbdb9e4$var$displayColumns = [
    ...$8dd9d99f7bbdb9e4$var$columns,
    "cf_status_nightly",
    "cf_status_beta"
];
class $8dd9d99f7bbdb9e4$export$b56cde744afe1c2f extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            bugs: []
        };
    }
    async componentWillMount() {
        this._isMounted = true;
        const trackingField = `cf_tracking_firefox${this.props.prevRelease}`;
        const statusField = `cf_status_firefox${this.props.prevRelease}`;
        const statusNightly = `cf_status_firefox${this.props.release}`;
        const prevRelease = this.props.prevRelease;
        function getFlagQuery(type) {
            return {
                include_fields: $8dd9d99f7bbdb9e4$var$columns.concat([
                    trackingField,
                    statusField,
                    statusNightly
                ]),
                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                target_milestone: [
                    "---",
                    `firefox ${prevRelease + 1}`
                ],
                order: "changeddate DESC",
                custom: {
                    "flagtypes.name": {
                        substring: `approval-mozilla-beta${type}`
                    }
                }
            };
        }
        const betakey = `cf_tracking_firefox${prevRelease}`;
        await this.context.qm.runCachedQueries([
            getFlagQuery("?"),
            getFlagQuery("-"),
            getFlagQuery("+"),
            {
                include_fields: $8dd9d99f7bbdb9e4$var$columns.concat([
                    trackingField,
                    statusField,
                    statusNightly
                ]),
                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                order: "changeddate DESC",
                custom: {
                    [betakey]: {
                        anyexact: [
                            "?",
                            "+",
                            "blocking"
                        ]
                    },
                    "flagtypes.name": {
                        notsubstring: `approval-mozilla-beta`
                    }
                }
            }
        ], ()=>this._isMounted, ({ rsp: [{ bugs: upliftRequested }, { bugs: upliftDenied }, { bugs: upliftComplete }, { bugs: tracking }], awaitingNetwork: awaitingNetwork })=>this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                bugs: {
                    tracking: tracking,
                    upliftRequested: upliftRequested,
                    upliftApproved: upliftComplete.filter((b)=>b.cf_tracking_beta === "+" && ![
                            "verified",
                            "fixed"
                        ].includes(b.cf_status_beta)),
                    upliftDenied: upliftDenied.filter((b)=>b.cf_tracking_beta === "+" && ![
                            "verified",
                            "fixed"
                        ].includes(b.cf_status_beta)),
                    upliftComplete: upliftComplete.filter((b)=>b.cf_tracking_beta === "+" && [
                            "verified",
                            "fixed"
                        ].includes(b.cf_status_beta))
                }
            }));
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: `Uplift to Firefox ${this.props.prevRelease}`,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                    children: "Tracking for uplift with no patch yet"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: "These bugs have been flagged for uplift but do not have a request open on a patch."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs.tracking,
                    columns: $8dd9d99f7bbdb9e4$var$displayColumns
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                    children: "Requested"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: "These bugs have a request for uplift open on a patch."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs.upliftRequested,
                    columns: $8dd9d99f7bbdb9e4$var$displayColumns
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                    children: "Denied"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: "These bugs have a patch that was denied for uplift."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs.upliftDenied,
                    columns: $8dd9d99f7bbdb9e4$var$displayColumns
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                    children: "Approved"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: "These bugs have a patch that was approved for uplift."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs.upliftApproved,
                    columns: $8dd9d99f7bbdb9e4$var$displayColumns
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                    children: "Landed"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: "These bugs have been merged to beta."
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    bulkEdit: true,
                    tags: true,
                    bugs: this.state.bugs.upliftComplete,
                    columns: $8dd9d99f7bbdb9e4$var$displayColumns
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");

var $5b24808912dae2d0$export$34e0f9847d4c02dd;
var $5b24808912dae2d0$export$d59512521ad6afef;
var $5b24808912dae2d0$export$252465da46a2ae40;
var $5b24808912dae2d0$export$18bbf1981e5a987c;
var $5b24808912dae2d0$export$9e9706b9843a7198;
var $5b24808912dae2d0$export$108c17e5c52b7df8;
var $5b24808912dae2d0$export$a238cb463698c900;
var $5b24808912dae2d0$export$d06d16b20ced9190;
var $5b24808912dae2d0$export$eeb03afd9378c335;
$5b24808912dae2d0$export$34e0f9847d4c02dd = `T95HFW_container`;
$5b24808912dae2d0$export$d59512521ad6afef = `T95HFW_displayNameColumn`;
$5b24808912dae2d0$export$252465da46a2ae40 = `T95HFW_emptyState`;
$5b24808912dae2d0$export$18bbf1981e5a987c = `T95HFW_featureTable`;
$5b24808912dae2d0$export$9e9706b9843a7198 = `T95HFW_headerButton`;
$5b24808912dae2d0$export$108c17e5c52b7df8 = `T95HFW_idColumn`;
$5b24808912dae2d0$export$a238cb463698c900 = `T95HFW_labels`;
$5b24808912dae2d0$export$d06d16b20ced9190 = `T95HFW_resolved`;
$5b24808912dae2d0$export$eeb03afd9378c335 = `T95HFW_subheading`;






const $4d45092a02c25e1e$var$OPEN_BUG_URL = "https://bugzilla.mozilla.org/show_bug.cgi?id=";
class $4d45092a02c25e1e$export$aa18130def4b6cb4 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    componentWillMount() {
        this.metas = this.context.metas.sort((a, b)=>{
            if ((0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(a) && !(0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(b)) return 1;
            else if (!(0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(a) && (0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(b)) return -1;
            return a.displayName.localeCompare(b.displayName);
        });
    }
    renderAddNewFeature() {
        const url = `https://bugzilla.mozilla.org/enter_bug.cgi?blocked=${(0, $513e68b890b7ecb5$export$b30aba3873b6ee58)}&product=${(0, $513e68b890b7ecb5$export$2d6d1795a622852b)}&component=${(0, $513e68b890b7ecb5$export$bef5e81cca5b5fd3)}&keywords=meta`;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            className: `${$1d79b97a34537ccf$export$41c1085b355ecc97} ${$5b24808912dae2d0$export$9e9706b9843a7198}`,
            href: url,
            children: "Add new feature"
        });
    }
    renderTableHead(idLabel, featureLabel) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("thead", {
            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                className: $5b24808912dae2d0$export$a238cb463698c900,
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                        className: $5b24808912dae2d0$export$108c17e5c52b7df8,
                        children: idLabel
                    }),
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                        className: $5b24808912dae2d0$export$d59512521ad6afef,
                        children: featureLabel
                    })
                ]
            })
        });
    }
    renderTableBody(bugs) {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("tbody", {
            children: bugs.map(({ id: id, displayName: displayName, status: status })=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                    className: (0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)({
                        status: status
                    }) ? $5b24808912dae2d0$export$d06d16b20ced9190 : "",
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                            className: $5b24808912dae2d0$export$108c17e5c52b7df8,
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                                target: "_blank",
                                href: $4d45092a02c25e1e$var$OPEN_BUG_URL + id,
                                rel: "noopener noreferrer",
                                children: id
                            })
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                            className: $5b24808912dae2d0$export$d59512521ad6afef,
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                                to: `/feature/${id}`,
                                children: displayName
                            })
                        })
                    ]
                }, id))
        });
    }
    sortMetas(bugs) {
        const result = {
            now: [],
            next: [],
            backlog: [],
            resolved: []
        };
        bugs.forEach((bug)=>{
            if ((0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(bug)) result.resolved.push(bug);
            else if (bug.priority === "P1") result.now.push(bug);
            else if (bug.priority === "P2") result.next.push(bug);
            else result.backlog.push(bug);
        });
        return result;
    }
    render() {
        const release = Number(this.context.iterations.getIteration().number.split(".")[0]);
        const empty = this.metas.length === 0;
        const bugs = this.sortMetas(this.context.metas);
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $5b24808912dae2d0$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h1", {
                    children: [
                        "Feature List ",
                        this.renderAddNewFeature()
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                    className: $5b24808912dae2d0$export$eeb03afd9378c335,
                    children: [
                        "Note: To add a feature to sidebar, set the priority of the meta bug to",
                        " ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                            children: "P1"
                        }),
                        ".",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("br", {}),
                        "Setting your feature to ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                            children: "P1"
                        }),
                        " will prioritize it for the current release and ",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                            children: "P2"
                        }),
                        " for the next."
                    ]
                }),
                !empty ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("table", {
                    className: $5b24808912dae2d0$export$18bbf1981e5a987c,
                    children: [
                        this.renderTableHead("Meta Bug", `Prioritized for Firefox ${release}`),
                        this.renderTableBody(bugs.now),
                        this.renderTableHead("", `Prioritized for Firefox ${release + 1}`),
                        this.renderTableBody(bugs.next),
                        this.renderTableHead("", "Other features"),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("tbody", {
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        className: $5b24808912dae2d0$export$108c17e5c52b7df8
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("td", {
                                        className: $5b24808912dae2d0$export$d59512521ad6afef,
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                                                to: "/no-feature",
                                                children: "[No feature]"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        this.renderTableBody(bugs.backlog),
                        this.renderTableBody(bugs.resolved)
                    ]
                }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $5b24808912dae2d0$export$252465da46a2ae40,
                    children: "No features found."
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");
var $ba53bc9f95bb8c3b$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $01f2eef3bb83b639$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $ffbae2bef57cfa98$exports = {};

$parcel$export($ffbae2bef57cfa98$exports, "ArrayLiteral", () => $ffbae2bef57cfa98$export$2477073908a0de26, (v) => $ffbae2bef57cfa98$export$2477073908a0de26 = v);
$parcel$export($ffbae2bef57cfa98$exports, "BinaryExpression", () => $ffbae2bef57cfa98$export$5351bc98fa48e09c, (v) => $ffbae2bef57cfa98$export$5351bc98fa48e09c = v);
$parcel$export($ffbae2bef57cfa98$exports, "ConditionalExpression", () => $ffbae2bef57cfa98$export$12447f42bd680fc8, (v) => $ffbae2bef57cfa98$export$12447f42bd680fc8 = v);
$parcel$export($ffbae2bef57cfa98$exports, "FilterExpression", () => $ffbae2bef57cfa98$export$6b8d6da04b395169, (v) => $ffbae2bef57cfa98$export$6b8d6da04b395169 = v);
$parcel$export($ffbae2bef57cfa98$exports, "Identifier", () => $ffbae2bef57cfa98$export$989167234458594d, (v) => $ffbae2bef57cfa98$export$989167234458594d = v);
$parcel$export($ffbae2bef57cfa98$exports, "Literal", () => $ffbae2bef57cfa98$export$e175ae9e414693bc, (v) => $ffbae2bef57cfa98$export$e175ae9e414693bc = v);
$parcel$export($ffbae2bef57cfa98$exports, "ObjectLiteral", () => $ffbae2bef57cfa98$export$4c0cd5cfd47f57a6, (v) => $ffbae2bef57cfa98$export$4c0cd5cfd47f57a6 = v);
$parcel$export($ffbae2bef57cfa98$exports, "Transform", () => $ffbae2bef57cfa98$export$563a914cafbdc389, (v) => $ffbae2bef57cfa98$export$563a914cafbdc389 = v);
$parcel$export($ffbae2bef57cfa98$exports, "UnaryExpression", () => $ffbae2bef57cfa98$export$b832e164a8af4bc7, (v) => $ffbae2bef57cfa98$export$b832e164a8af4bc7 = v);
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * Evaluates an ArrayLiteral by returning its value, with each element
 * independently run through the evaluator.
 * @param {{type: 'ObjectLiteral', value: <{}>}} ast An expression tree with an
 *      ObjectLiteral as the top node
 * @returns {Promise.<[]>} resolves to a map contained evaluated values.
 * @private
 */ var $ffbae2bef57cfa98$export$2477073908a0de26;
/**
 * Evaluates a BinaryExpression node by running the Grammar's evaluator for
 * the given operator.
 * @param {{type: 'BinaryExpression', operator: <string>, left: {},
 *      right: {}}} ast An expression tree with a BinaryExpression as the top
 *      node
 * @returns {Promise<*>} resolves with the value of the BinaryExpression.
 * @private
 */ var $ffbae2bef57cfa98$export$5351bc98fa48e09c;
/**
 * Evaluates a ConditionalExpression node by first evaluating its test branch,
 * and resolving with the consequent branch if the test is truthy, or the
 * alternate branch if it is not. If there is no consequent branch, the test
 * result will be used instead.
 * @param {{type: 'ConditionalExpression', test: {}, consequent: {},
 *      alternate: {}}} ast An expression tree with a ConditionalExpression as
 *      the top node
 * @private
 */ var $ffbae2bef57cfa98$export$12447f42bd680fc8;
/**
 * Evaluates a FilterExpression by applying it to the subject value.
 * @param {{type: 'FilterExpression', relative: <boolean>, expr: {},
 *      subject: {}}} ast An expression tree with a FilterExpression as the top
 *      node
 * @returns {Promise<*>} resolves with the value of the FilterExpression.
 * @private
 */ var $ffbae2bef57cfa98$export$6b8d6da04b395169;
/**
 * Evaluates an Identifier by either stemming from the evaluated 'from'
 * expression tree or accessing the context provided when this Evaluator was
 * constructed.
 * @param {{type: 'Identifier', value: <string>, [from]: {}}} ast An expression
 *      tree with an Identifier as the top node
 * @returns {Promise<*>|*} either the identifier's value, or a Promise that
 *      will resolve with the identifier's value.
 * @private
 */ var $ffbae2bef57cfa98$export$989167234458594d;
/**
 * Evaluates a Literal by returning its value property.
 * @param {{type: 'Literal', value: <string|number|boolean>}} ast An expression
 *      tree with a Literal as its only node
 * @returns {string|number|boolean} The value of the Literal node
 * @private
 */ var $ffbae2bef57cfa98$export$e175ae9e414693bc;
/**
 * Evaluates an ObjectLiteral by returning its value, with each key
 * independently run through the evaluator.
 * @param {{type: 'ObjectLiteral', value: <{}>}} ast An expression tree with an
 *      ObjectLiteral as the top node
 * @returns {Promise<{}>} resolves to a map contained evaluated values.
 * @private
 */ var $ffbae2bef57cfa98$export$4c0cd5cfd47f57a6;
/**
 * Evaluates a Transform node by applying a function from the transforms map
 * to the subject value.
 * @param {{type: 'Transform', name: <string>, subject: {}}} ast An
 *      expression tree with a Transform as the top node
 * @returns {Promise<*>|*} the value of the transformation, or a Promise that
 *      will resolve with the transformed value.
 * @private
 */ var $ffbae2bef57cfa98$export$563a914cafbdc389;
/**
 * Evaluates a Unary expression by passing the right side through the
 * operator's eval function.
 * @param {{type: 'UnaryExpression', operator: <string>, right: {}}} ast An
 *      expression tree with a UnaryExpression as the top node
 * @returns {Promise<*>} resolves with the value of the UnaryExpression.
 * @constructor
 */ var $ffbae2bef57cfa98$export$b832e164a8af4bc7;
$ffbae2bef57cfa98$export$2477073908a0de26 = function(ast) {
    return this.evalArray(ast.value);
};
$ffbae2bef57cfa98$export$5351bc98fa48e09c = function(ast) {
    var self = this;
    return Promise.all([
        this.eval(ast.left),
        this.eval(ast.right)
    ]).then(function(arr) {
        return self._grammar[ast.operator].eval(arr[0], arr[1]);
    });
};
$ffbae2bef57cfa98$export$12447f42bd680fc8 = function(ast) {
    var self = this;
    return this.eval(ast.test).then(function(res) {
        if (res) {
            if (ast.consequent) return self.eval(ast.consequent);
            return res;
        }
        return self.eval(ast.alternate);
    });
};
$ffbae2bef57cfa98$export$6b8d6da04b395169 = function(ast) {
    var self = this;
    return this.eval(ast.subject).then(function(subject) {
        if (ast.relative) return self._filterRelative(subject, ast.expr);
        return self._filterStatic(subject, ast.expr);
    });
};
$ffbae2bef57cfa98$export$989167234458594d = function(ast) {
    if (ast.from) return this.eval(ast.from).then(function(context) {
        if (context === undefined) return undefined;
        if (Array.isArray(context)) context = context[0];
        return context[ast.value];
    });
    else return ast.relative ? this._relContext[ast.value] : this._context[ast.value];
};
$ffbae2bef57cfa98$export$e175ae9e414693bc = function(ast) {
    return ast.value;
};
$ffbae2bef57cfa98$export$4c0cd5cfd47f57a6 = function(ast) {
    return this.evalMap(ast.value);
};
$ffbae2bef57cfa98$export$563a914cafbdc389 = function(ast) {
    var transform = this._transforms[ast.name];
    if (!transform) throw new Error("Transform '" + ast.name + "' is not defined.");
    return Promise.all([
        this.eval(ast.subject),
        this.evalArray(ast.args || [])
    ]).then(function(arr) {
        return transform.apply(null, [
            arr[0]
        ].concat(arr[1]));
    });
};
$ffbae2bef57cfa98$export$b832e164a8af4bc7 = function(ast) {
    var self = this;
    return this.eval(ast.right).then(function(right) {
        return self._grammar[ast.operator].eval(right);
    });
};


/**
 * The Evaluator takes a Jexl expression tree as generated by the
 * {@link Parser} and calculates its value within a given context. The
 * collection of transforms, context, and a relative context to be used as the
 * root for relative identifiers, are all specific to an Evaluator instance.
 * When any of these things change, a new instance is required.  However, a
 * single instance can be used to simultaneously evaluate many different
 * expressions, and does not have to be reinstantiated for each.
 * @param {{}} grammar A grammar map against which to evaluate the expression
 *      tree
 * @param {{}} [transforms] A map of transform names to transform functions. A
 *      transform function takes two arguments:
 *          - {*} val: A value to be transformed
 *          - {{}} args: A map of argument keys to their evaluated values, as
 *              specified in the expression string
 *      The transform function should return either the transformed value, or
 *      a Promises/A+ Promise object that resolves with the value and rejects
 *      or throws only when an unrecoverable error occurs. Transforms should
 *      generally return undefined when they don't make sense to be used on the
 *      given value type, rather than throw/reject. An error is only
 *      appropriate when the transform would normally return a value, but
 *      cannot due to some other failure.
 * @param {{}} [context] A map of variable keys to their values. This will be
 *      accessed to resolve the value of each non-relative identifier. Any
 *      Promise values will be passed to the expression as their resolved
 *      value.
 * @param {{}|Array<{}|Array>} [relativeContext] A map or array to be accessed
 *      to resolve the value of a relative identifier.
 * @constructor
 */ var $01f2eef3bb83b639$var$Evaluator = function(grammar, transforms, context, relativeContext) {
    this._grammar = grammar;
    this._transforms = transforms || {};
    this._context = context || {};
    this._relContext = relativeContext || this._context;
};
/**
 * Evaluates an expression tree within the configured context.
 * @param {{}} ast An expression tree object
 * @returns {Promise<*>} resolves with the resulting value of the expression.
 */ $01f2eef3bb83b639$var$Evaluator.prototype.eval = function(ast) {
    var self = this;
    return Promise.resolve().then(function() {
        return $ffbae2bef57cfa98$exports[ast.type].call(self, ast);
    });
};
/**
 * Simultaneously evaluates each expression within an array, and delivers the
 * response as an array with the resulting values at the same indexes as their
 * originating expressions.
 * @param {Array<string>} arr An array of expression strings to be evaluated
 * @returns {Promise<Array<{}>>} resolves with the result array
 */ $01f2eef3bb83b639$var$Evaluator.prototype.evalArray = function(arr) {
    return Promise.all(arr.map(function(elem) {
        return this.eval(elem);
    }, this));
};
/**
 * Simultaneously evaluates each expression within a map, and delivers the
 * response as a map with the same keys, but with the evaluated result for each
 * as their value.
 * @param {{}} map A map of expression names to expression trees to be
 *      evaluated
 * @returns {Promise<{}>} resolves with the result map.
 */ $01f2eef3bb83b639$var$Evaluator.prototype.evalMap = function(map) {
    var keys = Object.keys(map), result = {};
    var asts = keys.map(function(key) {
        return this.eval(map[key]);
    }, this);
    return Promise.all(asts).then(function(vals) {
        vals.forEach(function(val, idx) {
            result[keys[idx]] = val;
        });
        return result;
    });
};
/**
 * Applies a filter expression with relative identifier elements to a subject.
 * The intent is for the subject to be an array of subjects that will be
 * individually used as the relative context against the provided expression
 * tree. Only the elements whose expressions result in a truthy value will be
 * included in the resulting array.
 *
 * If the subject is not an array of values, it will be converted to a single-
 * element array before running the filter.
 * @param {*} subject The value to be filtered; usually an array. If this value is
 *      not an array, it will be converted to an array with this value as the
 *      only element.
 * @param {{}} expr The expression tree to run against each subject. If the
 *      tree evaluates to a truthy result, then the value will be included in
 *      the returned array; otherwise, it will be eliminated.
 * @returns {Promise<Array>} resolves with an array of values that passed the
 *      expression filter.
 * @private
 */ $01f2eef3bb83b639$var$Evaluator.prototype._filterRelative = function(subject, expr) {
    if (subject === undefined) return undefined;
    var promises = [];
    if (!Array.isArray(subject)) subject = [
        subject
    ];
    subject.forEach(function(elem) {
        var evalInst = new $01f2eef3bb83b639$var$Evaluator(this._grammar, this._transforms, this._context, elem);
        promises.push(evalInst.eval(expr));
    }, this);
    return Promise.all(promises).then(function(values) {
        var results = [];
        values.forEach(function(value, idx) {
            if (value) results.push(subject[idx]);
        });
        return results;
    });
};
/**
 * Applies a static filter expression to a subject value.  If the filter
 * expression evaluates to boolean true, the subject is returned; if false,
 * undefined.
 *
 * For any other resulting value of the expression, this function will attempt
 * to respond with the property at that name or index of the subject.
 * @param {*} subject The value to be filtered.  Usually an Array (for which
 *      the expression would generally resolve to a numeric index) or an
 *      Object (for which the expression would generally resolve to a string
 *      indicating a property name)
 * @param {{}} expr The expression tree to run against the subject
 * @returns {Promise<*>} resolves with the value of the drill-down.
 * @private
 */ $01f2eef3bb83b639$var$Evaluator.prototype._filterStatic = function(subject, expr) {
    return this.eval(expr).then(function(res) {
        if (typeof res === 'boolean') return res ? subject : undefined;
        if (subject === undefined) return undefined;
        return subject[res];
    });
};
$01f2eef3bb83b639$exports = $01f2eef3bb83b639$var$Evaluator;


var $5091fb442f2170a1$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $5091fb442f2170a1$var$numericRegex = /^-?(?:(?:[0-9]*\.[0-9]+)|[0-9]+)$/, $5091fb442f2170a1$var$identRegex = /^[a-zA-Z_\$][a-zA-Z0-9_\$]*$/, $5091fb442f2170a1$var$escEscRegex = /\\\\/, $5091fb442f2170a1$var$preOpRegexElems = [
    // Strings
    "'(?:(?:\\\\')?[^'])*'",
    '"(?:(?:\\\\")?[^"])*"',
    // Whitespace
    '\\s+',
    // Booleans
    '\\btrue\\b',
    '\\bfalse\\b',
    // Octothorpe comments
    '#.*[\\n\\4]?'
], $5091fb442f2170a1$var$postOpRegexElems = [
    // Identifiers
    '\\b[a-zA-Z_\\$][a-zA-Z0-9_\\$]*\\b',
    // Numerics (without negative symbol)
    '(?:(?:[0-9]*\\.[0-9]+)|[0-9]+)'
], $5091fb442f2170a1$var$minusNegatesAfter = [
    'binaryOp',
    'unaryOp',
    'openParen',
    'openBracket',
    'question',
    'colon'
];
/**
 * Lexer is a collection of stateless, statically-accessed functions for the
 * lexical parsing of a Jexl string.  Its responsibility is to identify the
 * "parts of speech" of a Jexl expression, and tokenize and label each, but
 * to do only the most minimal syntax checking; the only errors the Lexer
 * should be concerned with are if it's unable to identify the utility of
 * any of its tokens.  Errors stemming from these tokens not being in a
 * sensible configuration should be left for the Parser to handle.
 * @type {{}}
 */ function $5091fb442f2170a1$var$Lexer(grammar) {
    this._grammar = grammar;
}
/**
 * Splits a Jexl expression string into an array of expression elements.
 * @param {string} str A Jexl expression string
 * @returns {Array<string>} An array of substrings defining the functional
 *      elements of the expression.
 */ $5091fb442f2170a1$var$Lexer.prototype.getElements = function(str) {
    var regex = this._getSplitRegex();
    return str.split(regex).filter(function(elem) {
        // Remove empty strings
        return elem;
    });
};
/**
 * Converts an array of expression elements into an array of tokens.  Note that
 * the resulting array may not equal the element array in length, as any
 * elements that consist only of whitespace get appended to the previous
 * token's "raw" property.  For the structure of a token object, please see
 * {@link Lexer#tokenize}.
 * @param {Array<string>} elements An array of Jexl expression elements to be
 *      converted to tokens
 * @returns {Array<{type, value, raw}>} an array of token objects.
 */ $5091fb442f2170a1$var$Lexer.prototype.getTokens = function(elements) {
    var tokens = [], negate = false;
    for(var i = 0; i < elements.length; i++){
        if (this._isWhitespace(elements[i])) {
            if (tokens.length) tokens[tokens.length - 1].raw += elements[i];
        } else if (this._isComment(elements[i])) continue;
        else if (elements[i] === '-' && this._isNegative(tokens)) negate = true;
        else {
            if (negate) {
                elements[i] = '-' + elements[i];
                negate = false;
            }
            tokens.push(this._createToken(elements[i]));
        }
    }
    // Catch a - at the end of the string. Let the parser handle that issue.
    if (negate) tokens.push(this._createToken('-'));
    return tokens;
};
/**
 * Converts a Jexl string into an array of tokens.  Each token is an object
 * in the following format:
 *
 *     {
 *         type: <string>,
 *         [name]: <string>,
 *         value: <boolean|number|string>,
 *         raw: <string>
 *     }
 *
 * Type is one of the following:
 *
 *      literal, identifier, binaryOp, unaryOp
 *
 * OR, if the token is a control character its type is the name of the element
 * defined in the Grammar.
 *
 * Name appears only if the token is a control string found in
 * {@link grammar#elements}, and is set to the name of the element.
 *
 * Value is the value of the token in the correct type (boolean or numeric as
 * appropriate). Raw is the string representation of this value taken directly
 * from the expression string, including any trailing spaces.
 * @param {string} str The Jexl string to be tokenized
 * @returns {Array<{type, value, raw}>} an array of token objects.
 * @throws {Error} if the provided string contains an invalid token.
 */ $5091fb442f2170a1$var$Lexer.prototype.tokenize = function(str) {
    var elements = this.getElements(str);
    return this.getTokens(elements);
};
/**
 * Creates a new token object from an element of a Jexl string. See
 * {@link Lexer#tokenize} for a description of the token object.
 * @param {string} element The element from which a token should be made
 * @returns {{value: number|boolean|string, [name]: string, type: string,
 *      raw: string}} a token object describing the provided element.
 * @throws {Error} if the provided string is not a valid expression element.
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._createToken = function(element) {
    var token = {
        type: 'literal',
        value: element,
        raw: element
    };
    if (element[0] == '"' || element[0] == "'") token.value = this._unquote(element);
    else if (element.match($5091fb442f2170a1$var$numericRegex)) token.value = parseFloat(element);
    else if (element === 'true' || element === 'false') token.value = element === 'true';
    else if (this._grammar[element]) token.type = this._grammar[element].type;
    else if (element.match($5091fb442f2170a1$var$identRegex)) token.type = 'identifier';
    else throw new Error("Invalid expression token: " + element);
    return token;
};
/**
 * Escapes a string so that it can be treated as a string literal within a
 * regular expression.
 * @param {string} str The string to be escaped
 * @returns {string} the RegExp-escaped string.
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._escapeRegExp = function(str) {
    str = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    if (str.match($5091fb442f2170a1$var$identRegex)) str = '\\b' + str + '\\b';
    return str;
};
/**
 * Gets a RegEx object appropriate for splitting a Jexl string into its core
 * elements.
 * @returns {RegExp} An element-splitting RegExp object
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._getSplitRegex = function() {
    if (!this._splitRegex) {
        var elemArray = Object.keys(this._grammar);
        // Sort by most characters to least, then regex escape each
        elemArray = elemArray.sort(function(a, b) {
            return b.length - a.length;
        }).map(function(elem) {
            return this._escapeRegExp(elem);
        }, this);
        this._splitRegex = new RegExp('(' + [
            $5091fb442f2170a1$var$preOpRegexElems.join('|'),
            elemArray.join('|'),
            $5091fb442f2170a1$var$postOpRegexElems.join('|')
        ].join('|') + ')');
    }
    return this._splitRegex;
};
/**
 * Determines whether the addition of a '-' token should be interpreted as a
 * negative symbol for an upcoming number, given an array of tokens already
 * processed.
 * @param {Array<Object>} tokens An array of tokens already processed
 * @returns {boolean} true if adding a '-' should be considered a negative
 *      symbol; false otherwise
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._isNegative = function(tokens) {
    if (!tokens.length) return true;
    return $5091fb442f2170a1$var$minusNegatesAfter.some(function(type) {
        return type === tokens[tokens.length - 1].type;
    });
};
/**
 * A utility function to determine if a string consists of only space
 * characters.
 * @param {string} str A string to be tested
 * @returns {boolean} true if the string is empty or consists of only whitespace;
 *      false otherwise.
 * @private
 */ var $5091fb442f2170a1$var$_whitespaceRegex = /^\s*$/;
$5091fb442f2170a1$var$Lexer.prototype._isWhitespace = function(str) {
    return $5091fb442f2170a1$var$_whitespaceRegex.test(str);
};
/**
 * A utility function to determine if a string is an octothorpe comment
 * @param {string} str A string to be tested
 * @returns {boolean} true if the string is a comment, false otherwise.
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._isComment = function(str) {
    return str.startsWith('#');
};
/**
 * Removes the beginning and trailing quotes from a string, unescapes any
 * escaped quotes on its interior, and unescapes any escaped escape characters.
 * Note that this function is not defensive; it assumes that the provided
 * string is not empty, and that its first and last characters are actually
 * quotes.
 * @param {string} str A string whose first and last characters are quotes
 * @returns {string} a string with the surrounding quotes stripped and escapes
 *      properly processed.
 * @private
 */ $5091fb442f2170a1$var$Lexer.prototype._unquote = function(str) {
    var quote = str[0], escQuoteRegex = new RegExp('\\\\' + quote, 'g');
    return str.substr(1, str.length - 2).replace(escQuoteRegex, quote).replace($5091fb442f2170a1$var$escEscRegex, '\\');
};
$5091fb442f2170a1$exports = $5091fb442f2170a1$var$Lexer;


var $29a0fbc74ee80fde$exports = {};
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ var $838c7be357d8dcc3$exports = {};

$parcel$export($838c7be357d8dcc3$exports, "argVal", () => $838c7be357d8dcc3$export$bf99ae2731a267af, (v) => $838c7be357d8dcc3$export$bf99ae2731a267af = v);
$parcel$export($838c7be357d8dcc3$exports, "arrayStart", () => $838c7be357d8dcc3$export$dbbb5fc86f066522, (v) => $838c7be357d8dcc3$export$dbbb5fc86f066522 = v);
$parcel$export($838c7be357d8dcc3$exports, "arrayVal", () => $838c7be357d8dcc3$export$56baa95599a4a114, (v) => $838c7be357d8dcc3$export$56baa95599a4a114 = v);
$parcel$export($838c7be357d8dcc3$exports, "binaryOp", () => $838c7be357d8dcc3$export$bf7110d4c5a71b17, (v) => $838c7be357d8dcc3$export$bf7110d4c5a71b17 = v);
$parcel$export($838c7be357d8dcc3$exports, "dot", () => $838c7be357d8dcc3$export$94132a0e348806d4, (v) => $838c7be357d8dcc3$export$94132a0e348806d4 = v);
$parcel$export($838c7be357d8dcc3$exports, "filter", () => $838c7be357d8dcc3$export$3dea766d36a8935f, (v) => $838c7be357d8dcc3$export$3dea766d36a8935f = v);
$parcel$export($838c7be357d8dcc3$exports, "identifier", () => $838c7be357d8dcc3$export$c2ab62c7bf24634, (v) => $838c7be357d8dcc3$export$c2ab62c7bf24634 = v);
$parcel$export($838c7be357d8dcc3$exports, "literal", () => $838c7be357d8dcc3$export$c8ec6e1ec9fefcb0, (v) => $838c7be357d8dcc3$export$c8ec6e1ec9fefcb0 = v);
$parcel$export($838c7be357d8dcc3$exports, "objKey", () => $838c7be357d8dcc3$export$a7e3a597b5fb619, (v) => $838c7be357d8dcc3$export$a7e3a597b5fb619 = v);
$parcel$export($838c7be357d8dcc3$exports, "objStart", () => $838c7be357d8dcc3$export$ae43e9a7db1a053e, (v) => $838c7be357d8dcc3$export$ae43e9a7db1a053e = v);
$parcel$export($838c7be357d8dcc3$exports, "objVal", () => $838c7be357d8dcc3$export$316663dec3b13f08, (v) => $838c7be357d8dcc3$export$316663dec3b13f08 = v);
$parcel$export($838c7be357d8dcc3$exports, "subExpression", () => $838c7be357d8dcc3$export$64f55baf472b5db, (v) => $838c7be357d8dcc3$export$64f55baf472b5db = v);
$parcel$export($838c7be357d8dcc3$exports, "ternaryEnd", () => $838c7be357d8dcc3$export$4747a6a8ead63555, (v) => $838c7be357d8dcc3$export$4747a6a8ead63555 = v);
$parcel$export($838c7be357d8dcc3$exports, "ternaryMid", () => $838c7be357d8dcc3$export$b9522f35ae4fd641, (v) => $838c7be357d8dcc3$export$b9522f35ae4fd641 = v);
$parcel$export($838c7be357d8dcc3$exports, "ternaryStart", () => $838c7be357d8dcc3$export$193e5ad6f5c47f1, (v) => $838c7be357d8dcc3$export$193e5ad6f5c47f1 = v);
$parcel$export($838c7be357d8dcc3$exports, "transform", () => $838c7be357d8dcc3$export$51186ad6e864892a, (v) => $838c7be357d8dcc3$export$51186ad6e864892a = v);
$parcel$export($838c7be357d8dcc3$exports, "unaryOp", () => $838c7be357d8dcc3$export$a47f90b6064508f9, (v) => $838c7be357d8dcc3$export$a47f90b6064508f9 = v);
/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * Handles a subexpression that's used to define a transform argument's value.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$bf99ae2731a267af;
/**
 * Handles new array literals by adding them as a new node in the AST,
 * initialized with an empty array.
 */ var $838c7be357d8dcc3$export$dbbb5fc86f066522;
/**
 * Handles a subexpression representing an element of an array literal.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$56baa95599a4a114;
/**
 * Handles tokens of type 'binaryOp', indicating an operation that has two
 * inputs: a left side and a right side.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$bf7110d4c5a71b17;
/**
 * Handles successive nodes in an identifier chain.  More specifically, it
 * sets values that determine how the following identifier gets placed in the
 * AST.
 */ var $838c7be357d8dcc3$export$94132a0e348806d4;
/**
 * Handles a subexpression used for filtering an array returned by an
 * identifier chain.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$3dea766d36a8935f;
/**
 * Handles identifier tokens by adding them as a new node in the AST.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$c2ab62c7bf24634;
/**
 * Handles literal values, such as strings, booleans, and numerics, by adding
 * them as a new node in the AST.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$c8ec6e1ec9fefcb0;
/**
 * Queues a new object literal key to be written once a value is collected.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$a7e3a597b5fb619;
/**
 * Handles new object literals by adding them as a new node in the AST,
 * initialized with an empty object.
 */ var $838c7be357d8dcc3$export$ae43e9a7db1a053e;
/**
 * Handles an object value by adding its AST to the queued key on the object
 * literal node currently at the cursor.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$316663dec3b13f08;
/**
 * Handles traditional subexpressions, delineated with the groupStart and
 * groupEnd elements.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$64f55baf472b5db;
/**
 * Handles a completed alternate subexpression of a ternary operator.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$4747a6a8ead63555;
/**
 * Handles a completed consequent subexpression of a ternary operator.
 * @param {{type: <string>}} ast The subexpression tree
 */ var $838c7be357d8dcc3$export$b9522f35ae4fd641;
/**
 * Handles the start of a new ternary expression by encapsulating the entire
 * AST in a ConditionalExpression node, and using the existing tree as the
 * test element.
 */ var $838c7be357d8dcc3$export$193e5ad6f5c47f1;
/**
 * Handles identifier tokens when used to indicate the name of a transform to
 * be applied.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$51186ad6e864892a;
/**
 * Handles token of type 'unaryOp', indicating that the operation has only
 * one input: a right side.
 * @param {{type: <string>}} token A token object
 */ var $838c7be357d8dcc3$export$a47f90b6064508f9;
$838c7be357d8dcc3$export$bf99ae2731a267af = function(ast) {
    this._cursor.args.push(ast);
};
$838c7be357d8dcc3$export$dbbb5fc86f066522 = function() {
    this._placeAtCursor({
        type: 'ArrayLiteral',
        value: []
    });
};
$838c7be357d8dcc3$export$56baa95599a4a114 = function(ast) {
    if (ast) this._cursor.value.push(ast);
};
$838c7be357d8dcc3$export$bf7110d4c5a71b17 = function(token) {
    var precedence = this._grammar[token.value].precedence || 0, parent = this._cursor._parent;
    while(parent && parent.operator && this._grammar[parent.operator].precedence >= precedence){
        this._cursor = parent;
        parent = parent._parent;
    }
    var node = {
        type: 'BinaryExpression',
        operator: token.value,
        left: this._cursor
    };
    this._setParent(this._cursor, node);
    this._cursor = parent;
    this._placeAtCursor(node);
};
$838c7be357d8dcc3$export$94132a0e348806d4 = function() {
    this._nextIdentEncapsulate = this._cursor && (this._cursor.type != 'BinaryExpression' || this._cursor.type == 'BinaryExpression' && this._cursor.right) && this._cursor.type != 'UnaryExpression';
    this._nextIdentRelative = !this._cursor || this._cursor && !this._nextIdentEncapsulate;
    if (this._nextIdentRelative) this._relative = true;
};
$838c7be357d8dcc3$export$3dea766d36a8935f = function(ast) {
    this._placeBeforeCursor({
        type: 'FilterExpression',
        expr: ast,
        relative: this._subParser.isRelative(),
        subject: this._cursor
    });
};
$838c7be357d8dcc3$export$c2ab62c7bf24634 = function(token) {
    var node = {
        type: 'Identifier',
        value: token.value
    };
    if (this._nextIdentEncapsulate) {
        node.from = this._cursor;
        this._placeBeforeCursor(node);
        this._nextIdentEncapsulate = false;
    } else {
        if (this._nextIdentRelative) node.relative = true;
        this._placeAtCursor(node);
    }
};
$838c7be357d8dcc3$export$c8ec6e1ec9fefcb0 = function(token) {
    this._placeAtCursor({
        type: 'Literal',
        value: token.value
    });
};
$838c7be357d8dcc3$export$a7e3a597b5fb619 = function(token) {
    this._curObjKey = token.value;
};
$838c7be357d8dcc3$export$ae43e9a7db1a053e = function() {
    this._placeAtCursor({
        type: 'ObjectLiteral',
        value: {}
    });
};
$838c7be357d8dcc3$export$316663dec3b13f08 = function(ast) {
    this._cursor.value[this._curObjKey] = ast;
};
$838c7be357d8dcc3$export$64f55baf472b5db = function(ast) {
    this._placeAtCursor(ast);
};
$838c7be357d8dcc3$export$4747a6a8ead63555 = function(ast) {
    this._cursor.alternate = ast;
};
$838c7be357d8dcc3$export$b9522f35ae4fd641 = function(ast) {
    this._cursor.consequent = ast;
};
$838c7be357d8dcc3$export$193e5ad6f5c47f1 = function() {
    this._tree = {
        type: 'ConditionalExpression',
        test: this._tree
    };
    this._cursor = this._tree;
};
$838c7be357d8dcc3$export$51186ad6e864892a = function(token) {
    this._placeBeforeCursor({
        type: 'Transform',
        name: token.value,
        args: [],
        subject: this._cursor
    });
};
$838c7be357d8dcc3$export$a47f90b6064508f9 = function(token) {
    this._placeAtCursor({
        type: 'UnaryExpression',
        operator: token.value
    });
};


/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * A mapping of all states in the finite state machine to a set of instructions
 * for handling or transitioning into other states. Each state can be handled
 * in one of two schemes: a tokenType map, or a subHandler.
 *
 * Standard expression elements are handled through the tokenType object. This
 * is an object map of all legal token types to encounter in this state (and
 * any unexpected token types will generate a thrown error) to an options
 * object that defines how they're handled.  The available options are:
 *
 *      {string} toState: The name of the state to which to transition
 *          immediately after handling this token
 *      {string} handler: The handler function to call when this token type is
 *          encountered in this state.  If omitted, the default handler
 *          matching the token's "type" property will be called. If the handler
 *          function does not exist, no call will be made and no error will be
 *          generated.  This is useful for tokens whose sole purpose is to
 *          transition to other states.
 *
 * States that consume a subexpression should define a subHandler, the
 * function to be called with an expression tree argument when the
 * subexpression is complete. Completeness is determined through the
 * endStates object, which maps tokens on which an expression should end to the
 * state to which to transition once the subHandler function has been called.
 *
 * Additionally, any state in which it is legal to mark the AST as completed
 * should have a 'completable' property set to boolean true.  Attempting to
 * call {@link Parser#complete} in any state without this property will result
 * in a thrown Error.
 *
 * @type {{}}
 */ var $efb0b3ce4057bb54$export$b782dad1d219cf26;

$efb0b3ce4057bb54$export$b782dad1d219cf26 = {
    expectOperand: {
        tokenTypes: {
            literal: {
                toState: 'expectBinOp'
            },
            identifier: {
                toState: 'identifier'
            },
            unaryOp: {},
            openParen: {
                toState: 'subExpression'
            },
            openCurl: {
                toState: 'expectObjKey',
                handler: $838c7be357d8dcc3$export$ae43e9a7db1a053e
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'arrayVal',
                handler: $838c7be357d8dcc3$export$dbbb5fc86f066522
            }
        }
    },
    expectBinOp: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            pipe: {
                toState: 'expectTransform'
            },
            dot: {
                toState: 'traverse'
            },
            question: {
                toState: 'ternaryMid',
                handler: $838c7be357d8dcc3$export$193e5ad6f5c47f1
            }
        },
        completable: true
    },
    expectTransform: {
        tokenTypes: {
            identifier: {
                toState: 'postTransform',
                handler: $838c7be357d8dcc3$export$51186ad6e864892a
            }
        }
    },
    expectObjKey: {
        tokenTypes: {
            identifier: {
                toState: 'expectKeyValSep',
                handler: $838c7be357d8dcc3$export$a7e3a597b5fb619
            },
            closeCurl: {
                toState: 'expectBinOp'
            }
        }
    },
    expectKeyValSep: {
        tokenTypes: {
            colon: {
                toState: 'objVal'
            }
        }
    },
    postTransform: {
        tokenTypes: {
            openParen: {
                toState: 'argVal'
            },
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            }
        },
        completable: true
    },
    postTransformArgs: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            }
        },
        completable: true
    },
    identifier: {
        tokenTypes: {
            binaryOp: {
                toState: 'expectOperand'
            },
            dot: {
                toState: 'traverse'
            },
            openBracket: {
                toState: 'filter'
            },
            pipe: {
                toState: 'expectTransform'
            },
            question: {
                toState: 'ternaryMid',
                handler: $838c7be357d8dcc3$export$193e5ad6f5c47f1
            }
        },
        completable: true
    },
    traverse: {
        tokenTypes: {
            'identifier': {
                toState: 'identifier'
            }
        }
    },
    filter: {
        subHandler: $838c7be357d8dcc3$export$3dea766d36a8935f,
        endStates: {
            closeBracket: 'identifier'
        }
    },
    subExpression: {
        subHandler: $838c7be357d8dcc3$export$64f55baf472b5db,
        endStates: {
            closeParen: 'expectBinOp'
        }
    },
    argVal: {
        subHandler: $838c7be357d8dcc3$export$bf99ae2731a267af,
        endStates: {
            comma: 'argVal',
            closeParen: 'postTransformArgs'
        }
    },
    objVal: {
        subHandler: $838c7be357d8dcc3$export$316663dec3b13f08,
        endStates: {
            comma: 'expectObjKey',
            closeCurl: 'expectBinOp'
        }
    },
    arrayVal: {
        subHandler: $838c7be357d8dcc3$export$56baa95599a4a114,
        endStates: {
            comma: 'arrayVal',
            closeBracket: 'expectBinOp'
        }
    },
    ternaryMid: {
        subHandler: $838c7be357d8dcc3$export$b9522f35ae4fd641,
        endStates: {
            colon: 'ternaryEnd'
        }
    },
    ternaryEnd: {
        subHandler: $838c7be357d8dcc3$export$4747a6a8ead63555,
        completable: true
    }
};


var $29a0fbc74ee80fde$require$states = $efb0b3ce4057bb54$export$b782dad1d219cf26;
/**
 * The Parser is a state machine that converts tokens from the {@link Lexer}
 * into an Abstract Syntax Tree (AST), capable of being evaluated in any
 * context by the {@link Evaluator}.  The Parser expects that all tokens
 * provided to it are legal and typed properly according to the grammar, but
 * accepts that the tokens may still be in an invalid order or in some other
 * unparsable configuration that requires it to throw an Error.
 * @param {{}} grammar The grammar map to use to parse Jexl strings
 * @param {string} [prefix] A string prefix to prepend to the expression string
 *      for error messaging purposes.  This is useful for when a new Parser is
 *      instantiated to parse an subexpression, as the parent Parser's
 *      expression string thus far can be passed for a more user-friendly
 *      error message.
 * @param {{}} [stopMap] A mapping of token types to any truthy value. When the
 *      token type is encountered, the parser will return the mapped value
 *      instead of boolean false.
 * @constructor
 */ function $29a0fbc74ee80fde$var$Parser(grammar, prefix, stopMap) {
    this._grammar = grammar;
    this._state = 'expectOperand';
    this._tree = null;
    this._exprStr = prefix || '';
    this._relative = false;
    this._stopMap = stopMap || {};
}
/**
 * Processes a new token into the AST and manages the transitions of the state
 * machine.
 * @param {{type: <string>}} token A token object, as provided by the
 *      {@link Lexer#tokenize} function.
 * @throws {Error} if a token is added when the Parser has been marked as
 *      complete by {@link #complete}, or if an unexpected token type is added.
 * @returns {boolean|*} the stopState value if this parser encountered a token
 *      in the stopState mapb; false if tokens can continue.
 */ $29a0fbc74ee80fde$var$Parser.prototype.addToken = function(token) {
    if (this._state == 'complete') throw new Error('Cannot add a new token to a completed Parser');
    var state = $29a0fbc74ee80fde$require$states[this._state], startExpr = this._exprStr;
    this._exprStr += token.raw;
    if (state.subHandler) {
        if (!this._subParser) this._startSubExpression(startExpr);
        var stopState = this._subParser.addToken(token);
        if (stopState) {
            this._endSubExpression();
            if (this._parentStop) return stopState;
            this._state = stopState;
        }
    } else if (state.tokenTypes[token.type]) {
        var typeOpts = state.tokenTypes[token.type], handleFunc = $838c7be357d8dcc3$exports[token.type];
        if (typeOpts.handler) handleFunc = typeOpts.handler;
        if (handleFunc) handleFunc.call(this, token);
        if (typeOpts.toState) this._state = typeOpts.toState;
    } else if (this._stopMap[token.type]) return this._stopMap[token.type];
    else throw new Error('Token ' + token.raw + ' (' + token.type + ') unexpected in expression: ' + this._exprStr);
    return false;
};
/**
 * Processes an array of tokens iteratively through the {@link #addToken}
 * function.
 * @param {Array<{type: <string>}>} tokens An array of tokens, as provided by
 *      the {@link Lexer#tokenize} function.
 */ $29a0fbc74ee80fde$var$Parser.prototype.addTokens = function(tokens) {
    tokens.forEach(this.addToken, this);
};
/**
 * Marks this Parser instance as completed and retrieves the full AST.
 * @returns {{}|null} a full expression tree, ready for evaluation by the
 *      {@link Evaluator#eval} function, or null if no tokens were passed to
 *      the parser before complete was called
 * @throws {Error} if the parser is not in a state where it's legal to end
 *      the expression, indicating that the expression is incomplete
 */ $29a0fbc74ee80fde$var$Parser.prototype.complete = function() {
    if (this._cursor && !$29a0fbc74ee80fde$require$states[this._state].completable) throw new Error('Unexpected end of expression: ' + this._exprStr);
    if (this._subParser) this._endSubExpression();
    this._state = 'complete';
    return this._cursor ? this._tree : null;
};
/**
 * Indicates whether the expression tree contains a relative path identifier.
 * @returns {boolean} true if a relative identifier exists; false otherwise.
 */ $29a0fbc74ee80fde$var$Parser.prototype.isRelative = function() {
    return this._relative;
};
/**
 * Ends a subexpression by completing the subParser and passing its result
 * to the subHandler configured in the current state.
 * @private
 */ $29a0fbc74ee80fde$var$Parser.prototype._endSubExpression = function() {
    $29a0fbc74ee80fde$require$states[this._state].subHandler.call(this, this._subParser.complete());
    this._subParser = null;
};
/**
 * Places a new tree node at the current position of the cursor (to the 'right'
 * property) and then advances the cursor to the new node. This function also
 * handles setting the parent of the new node.
 * @param {{type: <string>}} node A node to be added to the AST
 * @private
 */ $29a0fbc74ee80fde$var$Parser.prototype._placeAtCursor = function(node) {
    if (!this._cursor) this._tree = node;
    else {
        this._cursor.right = node;
        this._setParent(node, this._cursor);
    }
    this._cursor = node;
};
/**
 * Places a tree node before the current position of the cursor, replacing
 * the node that the cursor currently points to. This should only be called in
 * cases where the cursor is known to exist, and the provided node already
 * contains a pointer to what's at the cursor currently.
 * @param {{type: <string>}} node A node to be added to the AST
 * @private
 */ $29a0fbc74ee80fde$var$Parser.prototype._placeBeforeCursor = function(node) {
    this._cursor = this._cursor._parent;
    this._placeAtCursor(node);
};
/**
 * Sets the parent of a node by creating a non-enumerable _parent property
 * that points to the supplied parent argument.
 * @param {{type: <string>}} node A node of the AST on which to set a new
 *      parent
 * @param {{type: <string>}} parent An existing node of the AST to serve as the
 *      parent of the new node
 * @private
 */ $29a0fbc74ee80fde$var$Parser.prototype._setParent = function(node, parent) {
    Object.defineProperty(node, '_parent', {
        value: parent,
        writable: true
    });
};
/**
 * Prepares the Parser to accept a subexpression by (re)instantiating the
 * subParser.
 * @param {string} [exprStr] The expression string to prefix to the new Parser
 * @private
 */ $29a0fbc74ee80fde$var$Parser.prototype._startSubExpression = function(exprStr) {
    var endStates = $29a0fbc74ee80fde$require$states[this._state].endStates;
    if (!endStates) {
        this._parentStop = true;
        endStates = this._stopMap;
    }
    this._subParser = new $29a0fbc74ee80fde$var$Parser(this._grammar, exprStr, endStates);
};
$29a0fbc74ee80fde$exports = $29a0fbc74ee80fde$var$Parser;


/*
 * Jexl
 * Copyright (c) 2015 TechnologyAdvice
 */ /**
 * A map of all expression elements to their properties. Note that changes
 * here may require changes in the Lexer or Parser.
 * @type {{}}
 */ var $28a4971e4436c0af$export$7a5d735b2ab6389d;
$28a4971e4436c0af$export$7a5d735b2ab6389d = {
    '.': {
        type: 'dot'
    },
    '[': {
        type: 'openBracket'
    },
    ']': {
        type: 'closeBracket'
    },
    '|': {
        type: 'pipe'
    },
    '{': {
        type: 'openCurl'
    },
    '}': {
        type: 'closeCurl'
    },
    ':': {
        type: 'colon'
    },
    ',': {
        type: 'comma'
    },
    '(': {
        type: 'openParen'
    },
    ')': {
        type: 'closeParen'
    },
    '?': {
        type: 'question'
    },
    '+': {
        type: 'binaryOp',
        precedence: 30,
        eval: function(left, right) {
            return left + right;
        }
    },
    '-': {
        type: 'binaryOp',
        precedence: 30,
        eval: function(left, right) {
            return left - right;
        }
    },
    '*': {
        type: 'binaryOp',
        precedence: 40,
        eval: function(left, right) {
            return left * right;
        }
    },
    '/': {
        type: 'binaryOp',
        precedence: 40,
        eval: function(left, right) {
            return left / right;
        }
    },
    '//': {
        type: 'binaryOp',
        precedence: 40,
        eval: function(left, right) {
            return Math.floor(left / right);
        }
    },
    '%': {
        type: 'binaryOp',
        precedence: 50,
        eval: function(left, right) {
            return left % right;
        }
    },
    '^': {
        type: 'binaryOp',
        precedence: 50,
        eval: function(left, right) {
            return Math.pow(left, right);
        }
    },
    '==': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left == right;
        }
    },
    '!=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left != right;
        }
    },
    '>': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left > right;
        }
    },
    '>=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left >= right;
        }
    },
    '<': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left < right;
        }
    },
    '<=': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            return left <= right;
        }
    },
    '&&': {
        type: 'binaryOp',
        precedence: 10,
        eval: function(left, right) {
            return left && right;
        }
    },
    '||': {
        type: 'binaryOp',
        precedence: 10,
        eval: function(left, right) {
            return left || right;
        }
    },
    'in': {
        type: 'binaryOp',
        precedence: 20,
        eval: function(left, right) {
            if (typeof right === 'string') return right.indexOf(left) !== -1;
            if (Array.isArray(right)) return right.some(function(elem) {
                return elem == left;
            });
            return false;
        }
    },
    '!': {
        type: 'unaryOp',
        precedence: Infinity,
        eval: function(right) {
            return !right;
        }
    }
};


var $ba53bc9f95bb8c3b$require$defaultGrammar = $28a4971e4436c0af$export$7a5d735b2ab6389d;
/**
 * Jexl is the Javascript Expression Language, capable of parsing and
 * evaluating basic to complex expression strings, combined with advanced
 * xpath-like drilldown into native Javascript objects.
 * @constructor
 */ function $ba53bc9f95bb8c3b$var$Jexl() {
    this._customGrammar = null;
    this._lexer = null;
    this._transforms = {};
}
/**
 * Adds a binary operator to Jexl at the specified precedence. The higher the
 * precedence, the earlier the operator is applied in the order of operations.
 * For example, * has a higher precedence than +, because multiplication comes
 * before division.
 *
 * Please see grammar.js for a listing of all default operators and their
 * precedence values in order to choose the appropriate precedence for the
 * new operator.
 * @param {string} operator The operator string to be added
 * @param {number} precedence The operator's precedence
 * @param {function} fn A function to run to calculate the result. The function
 *      will be called with two arguments: left and right, denoting the values
 *      on either side of the operator. It should return either the resulting
 *      value, or a Promise that resolves with the resulting value.
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.addBinaryOp = function(operator, precedence, fn) {
    this._addGrammarElement(operator, {
        type: 'binaryOp',
        precedence: precedence,
        eval: fn
    });
};
/**
 * Adds a unary operator to Jexl. Unary operators are currently only supported
 * on the left side of the value on which it will operate.
 * @param {string} operator The operator string to be added
 * @param {function} fn A function to run to calculate the result. The function
 *      will be called with one argument: the literal value to the right of the
 *      operator. It should return either the resulting value, or a Promise
 *      that resolves with the resulting value.
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.addUnaryOp = function(operator, fn) {
    this._addGrammarElement(operator, {
        type: 'unaryOp',
        weight: Infinity,
        eval: fn
    });
};
/**
 * Adds or replaces a transform function in this Jexl instance.
 * @param {string} name The name of the transform function, as it will be used
 *      within Jexl expressions
 * @param {function} fn The function to be executed when this transform is
 *      invoked.  It will be provided with two arguments:
 *          - {*} value: The value to be transformed
 *          - {{}} args: The arguments for this transform
 *          - {function} cb: A callback function to be called with an error
 *            if the transform fails, or a null first argument and the
 *            transformed value as the second argument on success.
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.addTransform = function(name, fn) {
    this._transforms[name] = fn;
};
/**
 * Syntactic sugar for calling {@link #addTransform} repeatedly.  This function
 * accepts a map of one or more transform names to their transform function.
 * @param {{}} map A map of transform names to transform functions
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.addTransforms = function(map) {
    for(var key in map)if (map.hasOwnProperty(key)) this._transforms[key] = map[key];
};
/**
 * Retrieves a previously set transform function.
 * @param {string} name The name of the transform function
 * @returns {function} The transform function
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.getTransform = function(name) {
    return this._transforms[name];
};
/**
 * Evaluates a Jexl string within an optional context.
 * @param {string} expression The Jexl expression to be evaluated
 * @param {Object} [context] A mapping of variables to values, which will be
 *      made accessible to the Jexl expression when evaluating it
 * @param {function} [cb] An optional callback function to be executed when
 *      evaluation is complete.  It will be supplied with two arguments:
 *          - {Error|null} err: Present if an error occurred
 *          - {*} result: The result of the evaluation
 * @returns {Promise<*>} resolves with the result of the evaluation.  Note that
 *      if a callback is supplied, the returned promise will already have
 *      a '.catch' attached to it in order to pass the error to the callback.
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.eval = function(expression, context, cb) {
    if (typeof context === 'function') {
        cb = context;
        context = {};
    } else if (!context) context = {};
    var valPromise = this._eval(expression, context);
    if (cb) {
        // setTimeout is used for the callback to break out of the Promise's
        // try/catch in case the callback throws.
        var called = false;
        return valPromise.then(function(val) {
            called = true;
            setTimeout(cb.bind(null, null, val), 0);
        }).catch(function(err) {
            if (!called) setTimeout(cb.bind(null, err), 0);
        });
    }
    return valPromise;
};
/**
 * Removes a binary or unary operator from the Jexl grammar.
 * @param {string} operator The operator string to be removed
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype.removeOp = function(operator) {
    var grammar = this._getCustomGrammar();
    if (grammar[operator] && (grammar[operator].type == 'binaryOp' || grammar[operator].type == 'unaryOp')) {
        delete grammar[operator];
        this._lexer = null;
    }
};
/**
 * Adds an element to the grammar map used by this Jexl instance, cloning
 * the default grammar first if necessary.
 * @param {string} str The key string to be added
 * @param {{type: <string>}} obj A map of configuration options for this
 *      grammar element
 * @private
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype._addGrammarElement = function(str, obj) {
    var grammar = this._getCustomGrammar();
    grammar[str] = obj;
    this._lexer = null;
};
/**
 * Evaluates a Jexl string in the given context.
 * @param {string} exp The Jexl expression to be evaluated
 * @param {Object} [context] A mapping of variables to values, which will be
 *      made accessible to the Jexl expression when evaluating it
 * @returns {Promise<*>} resolves with the result of the evaluation.
 * @private
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype._eval = function(exp, context) {
    var self = this, grammar = this._getGrammar(), parser = new $29a0fbc74ee80fde$exports(grammar), evaluator = new $01f2eef3bb83b639$exports(grammar, this._transforms, context);
    return Promise.resolve().then(function() {
        parser.addTokens(self._getLexer().tokenize(exp));
        return evaluator.eval(parser.complete());
    });
};
/**
 * Gets the custom grammar object, creating it first if necessary. New custom
 * grammars are created by executing a shallow clone of the default grammar
 * map. The returned map is available to be changed.
 * @returns {{}} a customizable grammar map.
 * @private
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype._getCustomGrammar = function() {
    if (!this._customGrammar) {
        this._customGrammar = {};
        for(var key in $ba53bc9f95bb8c3b$require$defaultGrammar)if ($ba53bc9f95bb8c3b$require$defaultGrammar.hasOwnProperty(key)) this._customGrammar[key] = $ba53bc9f95bb8c3b$require$defaultGrammar[key];
    }
    return this._customGrammar;
};
/**
 * Gets the grammar map currently being used by Jexl; either the default map,
 * or a locally customized version. The returned map should never be changed
 * in any way.
 * @returns {{}} the grammar map currently in use.
 * @private
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype._getGrammar = function() {
    return this._customGrammar || $ba53bc9f95bb8c3b$require$defaultGrammar;
};
/**
 * Gets a Lexer instance as a singleton in reference to this Jexl instance.
 * @returns {Lexer} an instance of Lexer, initialized with a grammar
 *      appropriate to this Jexl instance.
 * @private
 */ $ba53bc9f95bb8c3b$var$Jexl.prototype._getLexer = function() {
    if (!this._lexer) this._lexer = new $5091fb442f2170a1$exports(this._getGrammar());
    return this._lexer;
};
$ba53bc9f95bb8c3b$exports = new $ba53bc9f95bb8c3b$var$Jexl();
$ba53bc9f95bb8c3b$exports.Jexl = $ba53bc9f95bb8c3b$var$Jexl;


const $53a6e6197f814737$var$TOKENS_WHITELIST = new Map([
    [
        "firefoxVersion",
        "version"
    ],
    [
        "localeLanguageCode",
        "locale"
    ],
    [
        "locale",
        "locale"
    ]
]);
function $53a6e6197f814737$var$parseTargetingExpression(expr) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ba53bc9f95bb8c3b$exports)))._getLexer().tokenize(expr);
}
function $53a6e6197f814737$export$17dda3e18f3bcb96(expr) {
    const tokens = $53a6e6197f814737$var$parseTargetingExpression(expr);
    const targetingTokens = {
        version: [],
        locale: []
    };
    for(let i = 0; i < tokens.length; i++)if ($53a6e6197f814737$var$TOKENS_WHITELIST.has(tokens[i].value)) {
        let value = `${tokens[i].value} ${tokens[i + 1].value}`;
        switch(tokens[i + 2].type){
            case "openBracket":
                {
                    let j = i + 3;
                    while(tokens[j].type !== "closeBracket" || j >= tokens.length)value = `${value} ${tokens[j++].value}`;
                }
            // TODO - check if this should fall through?
            default:
                value = `${value} ${tokens[i + 2].value}`;
        }
        targetingTokens[$53a6e6197f814737$var$TOKENS_WHITELIST.get(tokens[i].value)].push(value);
    }
    return targetingTokens;
}


var $19863b581f813eb3$export$8fe2e47226de1b42;
$19863b581f813eb3$export$8fe2e47226de1b42 = `-dB5UW_RSTable`;



const $d030695149e053dc$var$BUCKETS = {
    "What's New": {
        url: "https://firefox.settings.services.mozilla.com/v1/buckets/main/collections/whats-new-panel/records",
        additionalColumns: []
    },
    CFR: {
        url: "https://firefox.settings.services.mozilla.com/v1/buckets/main/collections/cfr/records",
        additionalColumns: [
            "frequency",
            "action",
            "url"
        ]
    }
};
const $d030695149e053dc$var$BUGZILLA = {
    "1597708": [
        "WHATS_NEW_BADGE_72",
        "WHATS_NEW_FINGERPRINTER_COUNTER_72",
        "WHATS_NEW_FINGERPRINTER_COUNTER_ALT",
        "WHATS_NEW_PERMISSION_PROMPT_72",
        "WHATS_NEW_PIP_72"
    ],
    "1599476": [
        "WHATS_NEW_BADGE_MOBILE_71",
        "WHATS_NEW_MOBILE_71",
        "WHATS_NEW_MOBILE_FEAT_1_71",
        "WHATS_NEW_MOBILE_FEAT_2_71",
        "WHATS_NEW_MOBILE_FEAT_2_71_NONFXA",
        "WHATS_NEW_MOBILE_FEAT_1_71_NONFXA",
        "WHATS_NEW_MOBILE_71_NONFXA"
    ],
    "1569349": [
        "SEND_TAB_CFR",
        "SEND_RECIPE_TAB_CFR",
        "PDF_URL_FFX_SEND",
        "BOOKMARK_SYNC_CFR"
    ]
};
const $d030695149e053dc$var$REDASH = {
    "https://sql.telemetry.mozilla.org/dashboard/messaging-system-what-s-new-panel": [
        "WHATS_NEW_BADGE_MOBILE_71",
        "WHATS_NEW_MOBILE_71",
        "WHATS_NEW_MOBILE_FEAT_1_71",
        "WHATS_NEW_MOBILE_FEAT_2_71",
        "WHATS_NEW_MOBILE_FEAT_2_71_NONFXA",
        "WHATS_NEW_MOBILE_FEAT_1_71_NONFXA",
        "WHATS_NEW_MOBILE_71_NONFXA",
        "WHATS_NEW_BADGE_72",
        "WHATS_NEW_FINGERPRINTER_COUNTER_72",
        "WHATS_NEW_FINGERPRINTER_COUNTER_ALT",
        "WHATS_NEW_PERMISSION_PROMPT_72",
        "WHATS_NEW_PIP_72"
    ],
    "https://sql.telemetry.mozilla.org/dashboard/activity-stream-cfr_1": [
        "YOUTUBE_ENHANCE_3_72",
        "GOOGLE_TRANSLATE_3_72",
        "FACEBOOK_CONTAINER_3_72",
        "PIN_TAB"
    ],
    "https://sql.telemetry.mozilla.org/dashboard/relationship-cfrs": [
        "SEND_TAB_CFR",
        "SEND_RECIPE_TAB_CFR",
        "PDF_URL_FFX_SEND",
        "SEND_TAB_CFR",
        "SAVE_LOGIN"
    ]
};
class $d030695149e053dc$export$2dc5b16b6affd770 extends $3KGP8.PureComponent {
    state;
    constructor(props){
        super(props);
        this.state = {
            messages: [],
            buckets: $d030695149e053dc$var$BUCKETS,
            selectedBucket: $d030695149e053dc$var$BUCKETS.CFR
        };
        this.bucketUpdate = this.bucketUpdate.bind(this);
        this.parseTargetingExpression = this.parseTargetingExpression.bind(this);
        this.fetchBugzillaMetadata = this.fetchBugzillaMetadata.bind(this);
        this._renderRSMessage = this._renderRSMessage.bind(this);
    }
    async fetchBugzillaMetadata(message) {
        const bugzillaId = Object.keys($d030695149e053dc$var$BUGZILLA).find((id)=>$d030695149e053dc$var$BUGZILLA[id].includes(message.id));
        const unknownStatus = {
            ...message,
            status: "unknown",
            bugzillaId: bugzillaId
        };
        if (!bugzillaId) return unknownStatus;
        const metadata = await fetch(`/api/bug/?id=${bugzillaId}`);
        if (metadata) return {
            ...message,
            status: (0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a).status(bugzillaId, metadata),
            bugzillaId: bugzillaId
        };
        return unknownStatus;
    }
    updateRSMessages(bkey) {
        fetch(`/remote-settings/?uri=${$d030695149e053dc$var$BUCKETS[bkey].url}`).then((response)=>response.json()).then((messages)=>messages.map(this.parseTargetingExpression)).then((messages)=>messages.map(this.fetchBugzillaMetadata)).then((messages)=>Promise.all(messages)).then((messages)=>this.setState({
                messages: messages,
                selectedBucket: $d030695149e053dc$var$BUCKETS[bkey]
            }));
    }
    bucketUpdate(el) {
        this.updateRSMessages(el.target.value);
    }
    groupSimilarTargeting(a, b) {
        let versionA = a.parsedTargetingExpression.version.join(" ").match(/\d/g);
        let versionB = b.parsedTargetingExpression.version.join(" ").match(/\d/g);
        if (!versionA) return -1;
        if (!versionB) return 1;
        versionA = versionA.join("");
        versionB = versionB.join("");
        return versionB - versionA;
    }
    parseTargetingExpression(m) {
        const parsedTargetingExpression = (0, $53a6e6197f814737$export$17dda3e18f3bcb96)(m.targeting);
        return {
            ...m,
            parsedTargetingExpression: parsedTargetingExpression
        };
    }
    componentDidMount() {
        this.updateRSMessages("CFR");
    }
    _renderAdditionalColumnHeaders() {
        return this.state.selectedBucket.additionalColumns.map((columnName, i)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                children: columnName
            }, i));
    }
    _renderAdditionalColumns(message) {
        return this.state.selectedBucket.additionalColumns.map((columnName, i)=>{
            switch(columnName){
                case "frequency":
                    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                        children: message.frequency ? message.frequency.lifetime : "Unlimited"
                    }, i);
                case "action":
                    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("td", {
                        children: [
                            " ",
                            message.content.buttons ? message.content.buttons.primary?.action?.type : "None",
                            " "
                        ]
                    }, i);
                case "url":
                    switch(message.template){
                        case "update_action":
                            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("td", {
                                children: [
                                    " ",
                                    message.content.action.data.url,
                                    " "
                                ]
                            }, i);
                        default:
                            return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                children: " n/a "
                            }, i);
                    }
                default:
                    return null;
            }
        });
    }
    _renderRSMessage(message) {
        const parsedTargeting = message.parsedTargetingExpression;
        const redashLink = Object.keys($d030695149e053dc$var$REDASH).find((key)=>$d030695149e053dc$var$REDASH[key].includes(message.id));
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: message.id
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: parsedTargeting.version.join(" ") || "All"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: parsedTargeting.locale.join(" ") || "All"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: message.bugzillaId ? (0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a).id(message.bugzillaId) : "None"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: message.status
                }),
                this._renderAdditionalColumns(message),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                    children: redashLink ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        href: redashLink,
                        children: "Dashboard"
                    }) : "n/a"
                })
            ]
        }, message.id);
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $19863b581f813eb3$export$8fe2e47226de1b42,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h1", {
                    children: "Active Remote Settings Messages"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                    children: [
                        "Select RS Bucket:\xa0",
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("select", {
                            onChange: this.bucketUpdate,
                            defaultValue: "CFR",
                            children: Object.keys(this.state.buckets).map((bkey)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("option", {
                                    value: bkey,
                                    children: bkey
                                }, bkey))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Message ID"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Version targeting"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Locale targeting"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Bugzilla"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Status"
                                    }),
                                    this._renderAdditionalColumnHeaders(),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                        children: "Redash"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("tbody", {
                            children: this.state.messages.map(this._renderRSMessage)
                        })
                    ]
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");


class $23eee7c45ba06d25$export$2b0b14514992aeb6 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    constructor(props){
        super(props);
        this.onPrefChange = this.onPrefChange.bind(this);
        this.onToggleCollapse = this.onToggleCollapse.bind(this);
        this.state = {
            priorityGuideOpen: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("priority_guide_open")
        };
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).on("priority_guide_open", this.onPrefChange);
    }
    onPrefChange({ name: name, newValue: newValue } = {}) {
        if (name === "priority_guide_open") this.setState({
            priorityGuideOpen: newValue
        });
    }
    onToggleCollapse() {
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set("priority_guide_open", !this.state.priorityGuideOpen);
    }
    render() {
        const priorityGuideOpen = this.state.priorityGuideOpen;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: priorityGuideOpen ? $7999b6d38c1a5546$export$7d47ec3dc429821 : $7999b6d38c1a5546$export$1e3e5379691483e7,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                        className: $7999b6d38c1a5546$export$3733ca50504b91b1,
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h2", {
                                className: $7999b6d38c1a5546$export$fb184b623420d9be,
                                children: "Legend"
                            }),
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                                className: $7999b6d38c1a5546$export$746dd974202ffffe,
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                                        children: "Priority"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$10b86557377497c4,
                                                children: "P1"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Current release"
                                            }),
                                            ": Required for the release currently in Firefox nightly or for uplift."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$9ede1655fa63ee0d,
                                                children: "P2"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Next release"
                                            }),
                                            ": Required for the next upcoming release."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$9ab2405854d25601,
                                                children: "P3"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Backlog"
                                            }),
                                            ": Not required for the next two releases. Choose from this list if all other bugs are completed."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$5e8e9074022ed083,
                                                children: "P5"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Deprioritized"
                                            }),
                                            ": Valid but not important enough to be assigned to an iteration (although we would accept patches)."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                                        children: "Severity"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$ede8042ddbb20f54,
                                                children: "S1"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Catastrophic"
                                            }),
                                            ": Blocks development/testing, may impact more than 25% of users, causes data loss, likely dot release driver, and no workaround available."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$88872d1f97e13ba9,
                                                children: "S2"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Serious"
                                            }),
                                            ": Major functionality/product severely impaired or a high impact issue and a satisfactory workaround does not exist."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$dc9368c5558c5766,
                                                children: "S3"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Normal"
                                            }),
                                            ": Blocks non-critical functionality and a work around exists."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$fba4cbb73d5fdb07,
                                                children: "S4"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Trivial"
                                            }),
                                            ": Minor significance, cosmetic issues, low or no impact to users."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$62070dfd506c2bdf,
                                                children: "N/A"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Not Applicable"
                                            }),
                                            ": The above definitions do not apply. This value is reserved for Tasks and Enhancements."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h3", {
                                        children: "Size"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            "The points field is an estimate of the bug",
                                            "'",
                                            "s complexity and required effort. T-shirt sizes visualize the points."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$92d98d0701d4531a,
                                                children: "SM"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Small"
                                            }),
                                            ": 1 or 2 points"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$f4de1c043ce6927,
                                                children: "MD"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Medium"
                                            }),
                                            ": 3 or 5 points"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$27ac7b32bf0e709e,
                                                children: "LG"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Large"
                                            }),
                                            ": 8 or 13 points"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                className: $7999b6d38c1a5546$export$abb3878d4b973569,
                                                children: "XL"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                children: "Extra Large"
                                            }),
                                            ": 15 or more points"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                    className: $7999b6d38c1a5546$export$eade479634cb5dc5,
                    type: "button",
                    role: "button",
                    onClick: this.onToggleCollapse,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                        className: priorityGuideOpen ? $7999b6d38c1a5546$export$2402f41b6d6f4b49 : $7999b6d38c1a5546$export$d20729ef1932bfeb
                    })
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");


var $aae65328bf3649b9$export$8402ea90de922ae;
var $aae65328bf3649b9$export$34e0f9847d4c02dd;
var $aae65328bf3649b9$export$ced6ed16dfd6a264;
var $aae65328bf3649b9$export$e52226b947a3aa22;
var $aae65328bf3649b9$export$7edd4a21fac8ce55;
var $aae65328bf3649b9$export$984281801d66c94d;
var $aae65328bf3649b9$export$1d10a718c817a09;
var $aae65328bf3649b9$export$d06d16b20ced9190;
var $aae65328bf3649b9$export$9a2dbef7a17e2e58;
var $aae65328bf3649b9$export$9852986a3ec5f6a0;
$aae65328bf3649b9$export$8402ea90de922ae = `TszvRa_bugList`;
$aae65328bf3649b9$export$34e0f9847d4c02dd = `TszvRa_container`;
$aae65328bf3649b9$export$ced6ed16dfd6a264 = `TszvRa_feature`;
$aae65328bf3649b9$export$e52226b947a3aa22 = `TszvRa_featureSummary`;
$aae65328bf3649b9$export$7edd4a21fac8ce55 = `TszvRa_h3`;
$aae65328bf3649b9$export$984281801d66c94d = `TszvRa_nextUrlButton`;
$aae65328bf3649b9$export$1d10a718c817a09 = `TszvRa_prevUrlButton`;
$aae65328bf3649b9$export$d06d16b20ced9190 = `TszvRa_resolved`;
$aae65328bf3649b9$export$9a2dbef7a17e2e58 = `TszvRa_summary`;
$aae65328bf3649b9$export$9852986a3ec5f6a0 = `TszvRa_table`;










const $503c4e56fb78e050$var$OPEN_BUG_URL = "https://bugzilla.mozilla.org/show_bug.cgi?id=";
// const columns = ["id", "summary", "last_change_time", "cf_fx_iteration"];
class $503c4e56fb78e050$var$ReleaseReportTab extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    render() {
        const release = this.props.release;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                    className: $aae65328bf3649b9$export$9a2dbef7a17e2e58,
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                            children: [
                                "Bugs in this release must have an iteration of",
                                " ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("code", {
                                        children: [
                                            release,
                                            ".x"
                                        ]
                                    })
                                }),
                                " ",
                                "to be counted towards the total and part of a prioritized feature. Note that resolved bugs other than ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                    children: "FIXED"
                                }),
                                " (e.g.",
                                " ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                    children: "DUPLICATE"
                                }),
                                ") are ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("em", {
                                    children: "not"
                                }),
                                " included."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                            children: [
                                "See ",
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                                    href: (0, $513e68b890b7ecb5$export$a4a067e700bf40e1),
                                    children: "this document"
                                }),
                                " for more information."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    children: this.props.loaded ? this.context.metas.filter((meta)=>meta.priority === "P1").map((meta)=>{
                        const bugs = this.props.bugs.filter((b)=>b.blocks.includes(meta.id));
                        if (!bugs.length) return null;
                        const completionPercentage = Math.round(bugs.filter((0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)).length / bugs.length * 100);
                        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                            className: $aae65328bf3649b9$export$ced6ed16dfd6a264,
                            children: [
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("h3", {
                                    className: $aae65328bf3649b9$export$7edd4a21fac8ce55,
                                    children: [
                                        meta.displayName,
                                        " (",
                                        completionPercentage,
                                        "% complete)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                                    className: $aae65328bf3649b9$export$e52226b947a3aa22,
                                    children: meta.description
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $c8445d06c2f62860$export$b0164dcf0f54812), {
                                    bugs: bugs,
                                    startDate: "2018-03-01",
                                    endDate: "2018-04-29"
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("ul", {
                                    className: $aae65328bf3649b9$export$8402ea90de922ae,
                                    children: bugs.map((bug)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
                                            className: (0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(bug) ? $aae65328bf3649b9$export$d06d16b20ced9190 : "",
                                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                                                href: $503c4e56fb78e050$var$OPEN_BUG_URL + bug.id,
                                                children: bug.summary
                                            })
                                        }, bug.id))
                                })
                            ]
                        }, meta.id);
                    }) : /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$3b0d6d7590275603), {})
                })
            ]
        });
    }
}
class $503c4e56fb78e050$var$ReleaseDatesTab extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    render() {
        const release = this.props.release;
        const allMilestones = new $503c4e56fb78e050$var$Milestones(this.context.iterations);
        const releaseMilestones = allMilestones.getReleaseMilestones(release);
        const nextURL = this.props.matchUrl.replace(/\/\d+/, "/" + $503c4e56fb78e050$var$Milestones.getNextRelease(release).toString() + "/dates");
        const prevURL = this.props.matchUrl.replace(/\/\d+/, "/" + $503c4e56fb78e050$var$Milestones.getPrevRelease(release).toString() + "/dates");
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $aae65328bf3649b9$export$9a2dbef7a17e2e58,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("p", {
                        children: [
                            "These are projected dates for the major milestones in Firefox",
                            " ",
                            release,
                            "."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                    className: $aae65328bf3649b9$export$1d10a718c817a09,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                        to: prevURL,
                        children: "<< Previous Release"
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                    className: $aae65328bf3649b9$export$984281801d66c94d,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                        to: nextURL,
                        children: "Next Release >>"
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $aae65328bf3649b9$export$9852986a3ec5f6a0,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("table", {
                        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                            children: "Milestone"
                                        }),
                                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("th", {
                                            children: "Date"
                                        })
                                    ]
                                }),
                                releaseMilestones.map((milestone)=>{
                                    const date = milestone.calculate();
                                    return date ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("strong", {
                                                    children: milestone.label
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("time", {
                                                    children: date.toLocaleString((0, $4b4b939aba8f1d15$exports.DateTime).DATE_HUGE)
                                                })
                                            })
                                        ]
                                    }, milestone.label) : null;
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
}
class $503c4e56fb78e050$export$5c9f1a428cbf3be9 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            bugs: [],
            loaded: false,
            awaitingNetwork: false
        };
    }
    async componentWillMount() {
        this._isMounted = true;
        const release = this.props.iteration;
        this.setState({
            loaded: false,
            awaitingNetwork: false
        });
        await this.context.qm.runCachedQueries({
            include_fields: [
                "id",
                "summary",
                "blocks",
                "status"
            ],
            iteration: release,
            resolution: [
                "---",
                "FIXED"
            ],
            custom: {
                blocked: this.context.metas.map((m)=>m.id)
            }
        }, ()=>this._isMounted, ({ rsp: { bugs: bugs }, awaitingNetwork: awaitingNetwork })=>this.setState({
                bugs: bugs,
                loaded: true,
                awaitingNetwork: awaitingNetwork
            }));
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const release = this.props.iteration;
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            className: $aae65328bf3649b9$export$34e0f9847d4c02dd,
            loaded: true,
            heading: `Firefox ${release}`,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ab5c293cf1af135b$export$b2539bed5023c21c), {
                    baseUrl: this.props.match.url,
                    config: [
                        {
                            path: "/dates",
                            label: "Date Table",
                            render: ()=>{
                                return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($503c4e56fb78e050$var$ReleaseDatesTab, {
                                    release: this.props.iteration,
                                    matchUrl: this.props.match.url
                                });
                            }
                        },
                        {
                            path: "",
                            label: "Release Report",
                            render: ()=>{
                                return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($503c4e56fb78e050$var$ReleaseReportTab, {
                                    loaded: this.state.loaded,
                                    bugs: this.state.bugs,
                                    release: this.props.iteration,
                                    matchUrl: this.props.match.url
                                });
                            }
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}
class $503c4e56fb78e050$var$Milestones {
    constructor(iterations){
        this.iterations = iterations;
    }
    static getNextRelease(release) {
        return parseInt(release) + 1;
    }
    static getPrevRelease(release) {
        return parseInt(release) - 1;
    }
    getReleaseMilestones(release) {
        const getEndDate = (milestone)=>{
            const endDate = this.iterations.byVersionString[milestone]?.endDate;
            return endDate ? (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(endDate) : null;
        };
        const getStartDate = (milestone)=>{
            const startDate = this.iterations.byVersionString[milestone]?.startDate;
            return startDate ? (0, $4b4b939aba8f1d15$exports.DateTime).fromISO(startDate) : null;
        };
        let RELEASE_MILESTONES = [
            {
                label: "Bug Breakdown",
                calculate () {
                    let prevRelease = $503c4e56fb78e050$var$Milestones.getPrevRelease(release);
                    return getEndDate(`${prevRelease}.4`)?.plus({
                        days: -2
                    });
                }
            },
            {
                label: `${release}.1`,
                calculate () {
                    return getStartDate(this.label);
                }
            },
            {
                label: "PI Request Due",
                calculate () {
                    return getEndDate(`${release}.1`)?.plus({
                        days: -2
                    });
                }
            },
            {
                label: `${release}.2`,
                calculate () {
                    return getStartDate(this.label);
                }
            },
            {
                label: "Tech Documentation Due",
                calculate () {
                    return getEndDate(`${release}.2`)?.plus({
                        days: -2
                    });
                }
            },
            {
                label: `${release}.3`,
                calculate () {
                    return getStartDate(this.label);
                }
            },
            {
                label: `${release}.4`,
                calculate () {
                    return getStartDate(this.label);
                }
            },
            {
                label: "Feature Complete",
                calculate () {
                    return getEndDate(`${release}.4`)?.plus({
                        weeks: -1,
                        days: -2
                    });
                }
            },
            {
                label: "Nightly Code Freeze",
                calculate () {
                    let endDate = getEndDate(`${release}.4`);
                    return endDate ? (0, $a2dbb61dc7ec7558$export$9ccfa5e1ff0207b4)(endDate) : null;
                }
            },
            {
                label: "Merge Day",
                calculate () {
                    const nextRelease = $503c4e56fb78e050$var$Milestones.getNextRelease(release);
                    return getStartDate(`${nextRelease}.1`);
                }
            },
            {
                label: "Release Day",
                calculate () {
                    const nextRelease = $503c4e56fb78e050$var$Milestones.getNextRelease(release);
                    return getStartDate(`${nextRelease}.1`)?.plus({
                        days: 1
                    });
                }
            }
        ];
        return RELEASE_MILESTONES;
    }
}




var $3KGP8 = parcelRequire("3KGP8");
function $17c3a23d2ad0dbd8$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $17c3a23d2ad0dbd8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039(obj);
}



function $071163a9e9f5c65c$export$2e2bcd8739ae039(input, hint) {
    if ((0, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $8485e377da143076$export$2e2bcd8739ae039(arg) {
    var key = (0, $071163a9e9f5c65c$export$2e2bcd8739ae039)(arg, "string");
    return (0, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $93ccf7577d1fdfc7$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $8485e377da143076$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $eae3700c4af93d39$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eae3700c4af93d39$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eae3700c4af93d39$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $93ccf7577d1fdfc7$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eae3700c4af93d39$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function $af909b51ee1b79a8$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $a3c3831b197f1588$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $787a87d4ce2c72dc$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c6cfd9e602c75747$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $787a87d4ce2c72dc$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $787a87d4ce2c72dc$export$2e2bcd8739ae039)(o, minLen);
}


function $4849bd795294bca5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $70df644cd666ebd0$export$2e2bcd8739ae039(arr, i) {
    return (0, $af909b51ee1b79a8$export$2e2bcd8739ae039)(arr) || (0, $a3c3831b197f1588$export$2e2bcd8739ae039)(arr, i) || (0, $c6cfd9e602c75747$export$2e2bcd8739ae039)(arr, i) || (0, $4849bd795294bca5$export$2e2bcd8739ae039)();
}



function $7d3f8e2e4d84853b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $459e61a6c17190dc$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $3KGP8 = parcelRequire("3KGP8");
var $fd5b92869f23fca1$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $fd5b92869f23fca1$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(_ref, $fd5b92869f23fca1$var$_excluded);
    var _useState = (0, $3KGP8.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $3KGP8.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $3KGP8.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $3KGP8.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $3KGP8.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $3KGP8.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $3KGP8.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $3KGP8 = parcelRequire("3KGP8");


function $01249f85e1979289$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $b6ca9f495673ea04$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $8485e377da143076$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $b6ca9f495673ea04$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $b6ca9f495673ea04$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6ca9f495673ea04$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $75c054cd1b3b4eb2$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0af70e7ac28e0ae3$export$2e2bcd8739ae039)(subClass, superClass);
}


function $ecb396d06c0e8ab0$export$2e2bcd8739ae039(o) {
    $ecb396d06c0e8ab0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ecb396d06c0e8ab0$export$2e2bcd8739ae039(o);
}


function $133b70ae703e1440$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $11a46346939f36a9$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $b7bad835c5458fdb$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $11a46346939f36a9$export$2e2bcd8739ae039)(self);
}


function $0eba1fba31bf123e$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $133b70ae703e1440$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $ecb396d06c0e8ab0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ecb396d06c0e8ab0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $b7bad835c5458fdb$export$2e2bcd8739ae039)(this, result);
    };
}



function $08a0bd03cb34f188$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $787a87d4ce2c72dc$export$2e2bcd8739ae039)(arr);
}


function $7c6154d50e10311c$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $6689f9051c66600f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5e2fe5bbdf9e923f$export$2e2bcd8739ae039(arr) {
    return (0, $08a0bd03cb34f188$export$2e2bcd8739ae039)(arr) || (0, $7c6154d50e10311c$export$2e2bcd8739ae039)(arr) || (0, $c6cfd9e602c75747$export$2e2bcd8739ae039)(arr) || (0, $6689f9051c66600f$export$2e2bcd8739ae039)();
}



var $3KGP8 = parcelRequire("3KGP8");



var $3KGP8 = parcelRequire("3KGP8");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $5d9fc1695a6d787d$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $5d9fc1695a6d787d$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $5d9fc1695a6d787d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5d9fc1695a6d787d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $5d9fc1695a6d787d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $b8f42386d031ea7b$export$71ad59f2e432cfe8 = "-ms-";
var $b8f42386d031ea7b$export$2c0f367103c8d01c = "-moz-";
var $b8f42386d031ea7b$export$39dfd62a25e0fe93 = "-webkit-";
var $b8f42386d031ea7b$export$a29989082612d0d9 = "comm";
var $b8f42386d031ea7b$export$aa3a2e812ca8570d = "rule";
var $b8f42386d031ea7b$export$527d108ccf083c2b = "decl";
var $b8f42386d031ea7b$export$d3d35020fa5b54f0 = "@page";
var $b8f42386d031ea7b$export$500415a86c544f73 = "@media";
var $b8f42386d031ea7b$export$a763edbf796b780a = "@import";
var $b8f42386d031ea7b$export$2790aeb8b4e5c826 = "@charset";
var $b8f42386d031ea7b$export$1cc683e23b84b133 = "@viewport";
var $b8f42386d031ea7b$export$9447a5efea57e862 = "@supports";
var $b8f42386d031ea7b$export$ef011b4e114b1fba = "@document";
var $b8f42386d031ea7b$export$6aad947bda0f3f46 = "@namespace";
var $b8f42386d031ea7b$export$b44a8529a35fcb60 = "@keyframes";
var $b8f42386d031ea7b$export$2c16de31893252e6 = "@font-face";
var $b8f42386d031ea7b$export$3d846dd52e150c6f = "@counter-style";
var $b8f42386d031ea7b$export$22314bfbb57653fe = "@font-feature-values";
var $b8f42386d031ea7b$export$2335f513bbd82c6d = Math.abs;
var $b8f42386d031ea7b$export$6788812c4e6611e6 = String.fromCharCode;
var $b8f42386d031ea7b$export$e6e34fd1f2686227 = Object.assign;
function $b8f42386d031ea7b$export$d6af199866bfb566(e, r) {
    return $b8f42386d031ea7b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $b8f42386d031ea7b$export$a9db5e087081082d(e, 0)) << 2 ^ $b8f42386d031ea7b$export$a9db5e087081082d(e, 1)) << 2 ^ $b8f42386d031ea7b$export$a9db5e087081082d(e, 2)) << 2 ^ $b8f42386d031ea7b$export$a9db5e087081082d(e, 3) : 0;
}
function $b8f42386d031ea7b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $b8f42386d031ea7b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $b8f42386d031ea7b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $b8f42386d031ea7b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $b8f42386d031ea7b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $b8f42386d031ea7b$export$36776f635604f274(e) {
    return e.length;
}
function $b8f42386d031ea7b$export$f9084667e487ed46(e) {
    return e.length;
}
function $b8f42386d031ea7b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $b8f42386d031ea7b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $b8f42386d031ea7b$export$53f1d5ea8de3d7c = 1;
var $b8f42386d031ea7b$export$4e0c71f277ca26b3 = 1;
var $b8f42386d031ea7b$export$f24224f1c91d8156 = 0;
var $b8f42386d031ea7b$export$5880b8b5730aff45 = 0;
var $b8f42386d031ea7b$export$c0306caf338ac095 = 0;
var $b8f42386d031ea7b$export$30a86d91af8ff6e6 = "";
function $b8f42386d031ea7b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $b8f42386d031ea7b$export$53f1d5ea8de3d7c,
        column: $b8f42386d031ea7b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $b8f42386d031ea7b$export$784d13d8ee351f07(e, r) {
    return $b8f42386d031ea7b$export$e6e34fd1f2686227($b8f42386d031ea7b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $b8f42386d031ea7b$export$eba6f6f03b0a92e7() {
    return $b8f42386d031ea7b$export$c0306caf338ac095;
}
function $b8f42386d031ea7b$export$232faf9add678146() {
    $b8f42386d031ea7b$export$c0306caf338ac095 = $b8f42386d031ea7b$export$5880b8b5730aff45 > 0 ? $b8f42386d031ea7b$export$a9db5e087081082d($b8f42386d031ea7b$export$30a86d91af8ff6e6, --$b8f42386d031ea7b$export$5880b8b5730aff45) : 0;
    if ($b8f42386d031ea7b$export$4e0c71f277ca26b3--, $b8f42386d031ea7b$export$c0306caf338ac095 === 10) $b8f42386d031ea7b$export$4e0c71f277ca26b3 = 1, $b8f42386d031ea7b$export$53f1d5ea8de3d7c--;
    return $b8f42386d031ea7b$export$c0306caf338ac095;
}
function $b8f42386d031ea7b$export$48cfd1e771a65c4f() {
    $b8f42386d031ea7b$export$c0306caf338ac095 = $b8f42386d031ea7b$export$5880b8b5730aff45 < $b8f42386d031ea7b$export$f24224f1c91d8156 ? $b8f42386d031ea7b$export$a9db5e087081082d($b8f42386d031ea7b$export$30a86d91af8ff6e6, $b8f42386d031ea7b$export$5880b8b5730aff45++) : 0;
    if ($b8f42386d031ea7b$export$4e0c71f277ca26b3++, $b8f42386d031ea7b$export$c0306caf338ac095 === 10) $b8f42386d031ea7b$export$4e0c71f277ca26b3 = 1, $b8f42386d031ea7b$export$53f1d5ea8de3d7c++;
    return $b8f42386d031ea7b$export$c0306caf338ac095;
}
function $b8f42386d031ea7b$export$4d3fb11e950abb9e() {
    return $b8f42386d031ea7b$export$a9db5e087081082d($b8f42386d031ea7b$export$30a86d91af8ff6e6, $b8f42386d031ea7b$export$5880b8b5730aff45);
}
function $b8f42386d031ea7b$export$e88cb2efb12ae807() {
    return $b8f42386d031ea7b$export$5880b8b5730aff45;
}
function $b8f42386d031ea7b$export$58adb3bec8346d0f(e, r) {
    return $b8f42386d031ea7b$export$2f35ab04d2335697($b8f42386d031ea7b$export$30a86d91af8ff6e6, e, r);
}
function $b8f42386d031ea7b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b8f42386d031ea7b$export$2de70f21292aac9e(e) {
    return $b8f42386d031ea7b$export$53f1d5ea8de3d7c = $b8f42386d031ea7b$export$4e0c71f277ca26b3 = 1, $b8f42386d031ea7b$export$f24224f1c91d8156 = $b8f42386d031ea7b$export$36776f635604f274($b8f42386d031ea7b$export$30a86d91af8ff6e6 = e), $b8f42386d031ea7b$export$5880b8b5730aff45 = 0, [];
}
function $b8f42386d031ea7b$export$45918ac1574455b1(e) {
    return $b8f42386d031ea7b$export$30a86d91af8ff6e6 = "", e;
}
function $b8f42386d031ea7b$export$410ac95b9ec204b8(e) {
    return $b8f42386d031ea7b$export$87c2784dc9fc4ab($b8f42386d031ea7b$export$58adb3bec8346d0f($b8f42386d031ea7b$export$5880b8b5730aff45 - 1, $b8f42386d031ea7b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $b8f42386d031ea7b$export$660b2ee2d4fb4eff(e) {
    return $b8f42386d031ea7b$export$45918ac1574455b1($b8f42386d031ea7b$export$5f8c09e3ae6f64e1($b8f42386d031ea7b$export$2de70f21292aac9e(e)));
}
function $b8f42386d031ea7b$export$7af1228ff777d175(e) {
    while($b8f42386d031ea7b$export$c0306caf338ac095 = $b8f42386d031ea7b$export$4d3fb11e950abb9e())if ($b8f42386d031ea7b$export$c0306caf338ac095 < 33) $b8f42386d031ea7b$export$48cfd1e771a65c4f();
    else break;
    return $b8f42386d031ea7b$export$9e1725a4cfeada27(e) > 2 || $b8f42386d031ea7b$export$9e1725a4cfeada27($b8f42386d031ea7b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $b8f42386d031ea7b$export$5f8c09e3ae6f64e1(e) {
    while($b8f42386d031ea7b$export$48cfd1e771a65c4f())switch($b8f42386d031ea7b$export$9e1725a4cfeada27($b8f42386d031ea7b$export$c0306caf338ac095)){
        case 0:
            $b8f42386d031ea7b$export$10d8903dec122b9d($b8f42386d031ea7b$export$c2ab62c7bf24634($b8f42386d031ea7b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $b8f42386d031ea7b$export$10d8903dec122b9d($b8f42386d031ea7b$export$410ac95b9ec204b8($b8f42386d031ea7b$export$c0306caf338ac095), e);
            break;
        default:
            $b8f42386d031ea7b$export$10d8903dec122b9d($b8f42386d031ea7b$export$6788812c4e6611e6($b8f42386d031ea7b$export$c0306caf338ac095), e);
    }
    return e;
}
function $b8f42386d031ea7b$export$955ba06d119e085e(e, r) {
    while(--r && $b8f42386d031ea7b$export$48cfd1e771a65c4f())if ($b8f42386d031ea7b$export$c0306caf338ac095 < 48 || $b8f42386d031ea7b$export$c0306caf338ac095 > 102 || $b8f42386d031ea7b$export$c0306caf338ac095 > 57 && $b8f42386d031ea7b$export$c0306caf338ac095 < 65 || $b8f42386d031ea7b$export$c0306caf338ac095 > 70 && $b8f42386d031ea7b$export$c0306caf338ac095 < 97) break;
    return $b8f42386d031ea7b$export$58adb3bec8346d0f(e, $b8f42386d031ea7b$export$e88cb2efb12ae807() + (r < 6 && $b8f42386d031ea7b$export$4d3fb11e950abb9e() == 32 && $b8f42386d031ea7b$export$48cfd1e771a65c4f() == 32));
}
function $b8f42386d031ea7b$export$c889f2fcc19dbf12(e) {
    while($b8f42386d031ea7b$export$48cfd1e771a65c4f())switch($b8f42386d031ea7b$export$c0306caf338ac095){
        case e:
            return $b8f42386d031ea7b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $b8f42386d031ea7b$export$c889f2fcc19dbf12($b8f42386d031ea7b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $b8f42386d031ea7b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $b8f42386d031ea7b$export$48cfd1e771a65c4f();
            break;
    }
    return $b8f42386d031ea7b$export$5880b8b5730aff45;
}
function $b8f42386d031ea7b$export$4254d4e2b3745c4c(e, r) {
    while($b8f42386d031ea7b$export$48cfd1e771a65c4f())if (e + $b8f42386d031ea7b$export$c0306caf338ac095 === 57) break;
    else if (e + $b8f42386d031ea7b$export$c0306caf338ac095 === 84 && $b8f42386d031ea7b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $b8f42386d031ea7b$export$58adb3bec8346d0f(r, $b8f42386d031ea7b$export$5880b8b5730aff45 - 1) + "*" + $b8f42386d031ea7b$export$6788812c4e6611e6(e === 47 ? e : $b8f42386d031ea7b$export$48cfd1e771a65c4f());
}
function $b8f42386d031ea7b$export$c2ab62c7bf24634(e) {
    while(!$b8f42386d031ea7b$export$9e1725a4cfeada27($b8f42386d031ea7b$export$4d3fb11e950abb9e()))$b8f42386d031ea7b$export$48cfd1e771a65c4f();
    return $b8f42386d031ea7b$export$58adb3bec8346d0f(e, $b8f42386d031ea7b$export$5880b8b5730aff45);
}
function $b8f42386d031ea7b$export$ef7acd7185315e22(e) {
    return $b8f42386d031ea7b$export$45918ac1574455b1($b8f42386d031ea7b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $b8f42386d031ea7b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $b8f42386d031ea7b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $b8f42386d031ea7b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $b8f42386d031ea7b$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($b8f42386d031ea7b$export$f8e21b1e77979a08(O += $b8f42386d031ea7b$export$77ad94ebf1c2b9ed($b8f42386d031ea7b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $b8f42386d031ea7b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $b8f42386d031ea7b$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $b8f42386d031ea7b$export$955ba06d119e085e($b8f42386d031ea7b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($b8f42386d031ea7b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $b8f42386d031ea7b$export$10d8903dec122b9d($b8f42386d031ea7b$export$4a34f930e789283c($b8f42386d031ea7b$export$4254d4e2b3745c4c($b8f42386d031ea7b$export$48cfd1e771a65c4f(), $b8f42386d031ea7b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $b8f42386d031ea7b$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $b8f42386d031ea7b$export$36776f635604f274(O) - l) $b8f42386d031ea7b$export$10d8903dec122b9d(p > 32 ? $b8f42386d031ea7b$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $b8f42386d031ea7b$export$f8483753829ec8f3($b8f42386d031ea7b$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $b8f42386d031ea7b$export$10d8903dec122b9d(y = $b8f42386d031ea7b$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $b8f42386d031ea7b$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $b8f42386d031ea7b$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $b8f42386d031ea7b$export$98e6a39c04603d36(e, y, y, n && $b8f42386d031ea7b$export$10d8903dec122b9d($b8f42386d031ea7b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $b8f42386d031ea7b$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $b8f42386d031ea7b$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $b8f42386d031ea7b$export$232faf9add678146() == 125) continue;
            }
            switch(O += $b8f42386d031ea7b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($b8f42386d031ea7b$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($b8f42386d031ea7b$export$4d3fb11e950abb9e() === 45) O += $b8f42386d031ea7b$export$410ac95b9ec204b8($b8f42386d031ea7b$export$48cfd1e771a65c4f());
                    v = $b8f42386d031ea7b$export$4d3fb11e950abb9e(), o = l = $b8f42386d031ea7b$export$36776f635604f274(g = O += $b8f42386d031ea7b$export$c2ab62c7bf24634($b8f42386d031ea7b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $b8f42386d031ea7b$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $b8f42386d031ea7b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $b8f42386d031ea7b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $b8f42386d031ea7b$export$2f35ab04d2335697(e, v + 1, v = $b8f42386d031ea7b$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $b8f42386d031ea7b$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $b8f42386d031ea7b$export$35059013cd4a06db(e, r, a, s === 0 ? $b8f42386d031ea7b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $b8f42386d031ea7b$export$4a34f930e789283c(e, r, a) {
    return $b8f42386d031ea7b$export$35059013cd4a06db(e, r, a, $b8f42386d031ea7b$export$a29989082612d0d9, $b8f42386d031ea7b$export$6788812c4e6611e6($b8f42386d031ea7b$export$eba6f6f03b0a92e7()), $b8f42386d031ea7b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $b8f42386d031ea7b$export$f8483753829ec8f3(e, r, a, n) {
    return $b8f42386d031ea7b$export$35059013cd4a06db(e, r, a, $b8f42386d031ea7b$export$527d108ccf083c2b, $b8f42386d031ea7b$export$2f35ab04d2335697(e, 0, n), $b8f42386d031ea7b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $b8f42386d031ea7b$export$82e9f45cca5ba907(n, c, s) {
    switch($b8f42386d031ea7b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $b8f42386d031ea7b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$2c0f367103c8d01c + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($b8f42386d031ea7b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "box-$1$2" + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "flex-item-" + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$b8f42386d031ea7b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "grid-row-" + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "flex-line-pack" + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "box-" + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $b8f42386d031ea7b$export$39dfd62a25e0fe93 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed($b8f42386d031ea7b$export$77ad94ebf1c2b9ed($b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed($b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "box-pack:$3" + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$b8f42386d031ea7b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "grid-column-align" + $b8f42386d031ea7b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $b8f42386d031ea7b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$b8f42386d031ea7b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$b8f42386d031ea7b$export$f8e21b1e77979a08(s, "span") ? $b8f42386d031ea7b$export$4659b591c19bdf3d(s, /\d+/) : +$b8f42386d031ea7b$export$4659b591c19bdf3d(s, /\d+/) - +$b8f42386d031ea7b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $b8f42386d031ea7b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $b8f42386d031ea7b$export$71ad59f2e432cfe8 + $b8f42386d031ea7b$export$77ad94ebf1c2b9ed($b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($b8f42386d031ea7b$export$36776f635604f274(n) - 1 - c > 6) switch($b8f42386d031ea7b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($b8f42386d031ea7b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $b8f42386d031ea7b$export$2c0f367103c8d01c + ($b8f42386d031ea7b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$b8f42386d031ea7b$export$f8e21b1e77979a08(n, "stretch") ? $b8f42386d031ea7b$export$82e9f45cca5ba907($b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $b8f42386d031ea7b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $b8f42386d031ea7b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($b8f42386d031ea7b$export$a9db5e087081082d(n, c + 6) === 121) return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, ":", ":" + $b8f42386d031ea7b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($b8f42386d031ea7b$export$a9db5e087081082d(n, $b8f42386d031ea7b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + ($b8f42386d031ea7b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, ":", ":" + $b8f42386d031ea7b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $b8f42386d031ea7b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $b8f42386d031ea7b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $b8f42386d031ea7b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $b8f42386d031ea7b$export$a763edbf796b780a:
        case $b8f42386d031ea7b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $b8f42386d031ea7b$export$a29989082612d0d9:
            return "";
        case $b8f42386d031ea7b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $b8f42386d031ea7b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $b8f42386d031ea7b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $b8f42386d031ea7b$export$36776f635604f274(a = $b8f42386d031ea7b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $b8f42386d031ea7b$export$5a7767152ae0305f(e) {
    var r = $b8f42386d031ea7b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $b8f42386d031ea7b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $b8f42386d031ea7b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $b8f42386d031ea7b$export$527d108ccf083c2b:
                n.return = $b8f42386d031ea7b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $b8f42386d031ea7b$export$b44a8529a35fcb60:
                return $b8f42386d031ea7b$export$dfdc1655ccc5b9cb([
                    $b8f42386d031ea7b$export$784d13d8ee351f07(n, {
                        value: $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $b8f42386d031ea7b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $b8f42386d031ea7b$export$aa3a2e812ca8570d:
                if (n.length) return $b8f42386d031ea7b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($b8f42386d031ea7b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $b8f42386d031ea7b$export$dfdc1655ccc5b9cb([
                                $b8f42386d031ea7b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $b8f42386d031ea7b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $b8f42386d031ea7b$export$dfdc1655ccc5b9cb([
                                $b8f42386d031ea7b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b8f42386d031ea7b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $b8f42386d031ea7b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b8f42386d031ea7b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $b8f42386d031ea7b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b8f42386d031ea7b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $b8f42386d031ea7b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $b8f42386d031ea7b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $b8f42386d031ea7b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $b8f42386d031ea7b$export$1be1fc439b849fdf($b8f42386d031ea7b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($b8f42386d031ea7b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $b8f42386d031ea7b$export$2f35ab04d2335697(r, 1, $b8f42386d031ea7b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $b8f42386d031ea7b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $b8f42386d031ea7b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $b8f42386d031ea7b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $6af24d90aba7488d$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $6af24d90aba7488d$export$2e2bcd8739ae039 = $6af24d90aba7488d$var$weakMemoize;


function $3b0722209285b73b$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $3b0722209285b73b$export$2e2bcd8739ae039 = $3b0722209285b73b$var$memoize;


var $3158d564e4aa3a61$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $b8f42386d031ea7b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $b8f42386d031ea7b$export$9e1725a4cfeada27)(character)) break;
        (0, $b8f42386d031ea7b$export$48cfd1e771a65c4f)();
    }
    return (0, $b8f42386d031ea7b$export$58adb3bec8346d0f)(begin, (0, $b8f42386d031ea7b$export$5880b8b5730aff45));
};
var $3158d564e4aa3a61$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $b8f42386d031ea7b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $b8f42386d031ea7b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $3158d564e4aa3a61$var$identifierWithPointTracking((0, $b8f42386d031ea7b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $b8f42386d031ea7b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $b8f42386d031ea7b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $b8f42386d031ea7b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $b8f42386d031ea7b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $3158d564e4aa3a61$var$getRules = function getRules(value, points) {
    return (0, $b8f42386d031ea7b$export$45918ac1574455b1)($3158d564e4aa3a61$var$toRules((0, $b8f42386d031ea7b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $3158d564e4aa3a61$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $3158d564e4aa3a61$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$3158d564e4aa3a61$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $3158d564e4aa3a61$var$fixedElements.set(element, true);
    var points = [];
    var rules = $3158d564e4aa3a61$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $3158d564e4aa3a61$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $3158d564e4aa3a61$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $3158d564e4aa3a61$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($3158d564e4aa3a61$var$ignoreFlag) > -1;
};
var $3158d564e4aa3a61$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? children[0].children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($3158d564e4aa3a61$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $3158d564e4aa3a61$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $3158d564e4aa3a61$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$3158d564e4aa3a61$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $3158d564e4aa3a61$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $3158d564e4aa3a61$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$3158d564e4aa3a61$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $3158d564e4aa3a61$var$nullifyElement(element);
    } else if ($3158d564e4aa3a61$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $3158d564e4aa3a61$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $3158d564e4aa3a61$var$prefix(value, length) {
    switch((0, $b8f42386d031ea7b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$2c0f367103c8d01c) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + 'box-' + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)((0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)((0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)((0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $b8f42386d031ea7b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $b8f42386d031ea7b$export$2c0f367103c8d01c) + ((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $b8f42386d031ea7b$export$f8e21b1e77979a08)(value, 'stretch') ? $3158d564e4aa3a61$var$prefix((0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, (0, $b8f42386d031ea7b$export$36776f635604f274)(value) - 3 - (~(0, $b8f42386d031ea7b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + ((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $b8f42386d031ea7b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + value + (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $3158d564e4aa3a61$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $b8f42386d031ea7b$export$527d108ccf083c2b:
                element["return"] = $3158d564e4aa3a61$var$prefix(element.value, element.length);
                break;
            case 0, $b8f42386d031ea7b$export$b44a8529a35fcb60:
                return (0, $b8f42386d031ea7b$export$dfdc1655ccc5b9cb)([
                    (0, $b8f42386d031ea7b$export$784d13d8ee351f07)(element, {
                        value: (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $b8f42386d031ea7b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $b8f42386d031ea7b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $b8f42386d031ea7b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $b8f42386d031ea7b$export$dfdc1655ccc5b9cb)([
                                (0, $b8f42386d031ea7b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $b8f42386d031ea7b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $b8f42386d031ea7b$export$dfdc1655ccc5b9cb)([
                                (0, $b8f42386d031ea7b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $b8f42386d031ea7b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $b8f42386d031ea7b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $b8f42386d031ea7b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $b8f42386d031ea7b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b8f42386d031ea7b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $b8f42386d031ea7b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $3158d564e4aa3a61$var$defaultStylisPlugins = [
    $3158d564e4aa3a61$var$prefixer
];
var $3158d564e4aa3a61$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $3158d564e4aa3a61$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $3158d564e4aa3a61$var$compat,
        $3158d564e4aa3a61$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $b8f42386d031ea7b$export$fac44ee5b035f737),
        (0, $b8f42386d031ea7b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b8f42386d031ea7b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $b8f42386d031ea7b$export$dfdc1655ccc5b9cb)((0, $b8f42386d031ea7b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $5d9fc1695a6d787d$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $3158d564e4aa3a61$export$2e2bcd8739ae039 = $3158d564e4aa3a61$var$createCache;



var $3KGP8 = parcelRequire("3KGP8");




// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2790fca91b2f01eb$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ba696a2641e01881$exports)))(targetComponent, sourceComponent);
};
var $2790fca91b2f01eb$export$2e2bcd8739ae039 = $2790fca91b2f01eb$var$hoistNonReactStatics;


var $d51ee36b2d8eb775$var$isBrowser = true;
function $d51ee36b2d8eb775$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d51ee36b2d8eb775$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d51ee36b2d8eb775$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d51ee36b2d8eb775$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d51ee36b2d8eb775$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $48271972dbfe5b8c$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $48271972dbfe5b8c$export$2e2bcd8739ae039 = $48271972dbfe5b8c$var$murmur2;


var $09659743a94fc5fc$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $09659743a94fc5fc$export$2e2bcd8739ae039 = $09659743a94fc5fc$var$unitlessKeys;



var $5fa5ccc1b989e380$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $5fa5ccc1b989e380$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $5fa5ccc1b989e380$var$hyphenateRegex = /[A-Z]|^ms/g;
var $5fa5ccc1b989e380$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $5fa5ccc1b989e380$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $5fa5ccc1b989e380$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $5fa5ccc1b989e380$var$processStyleName = /* #__PURE__ */ (0, $3b0722209285b73b$export$2e2bcd8739ae039)(function(styleName) {
    return $5fa5ccc1b989e380$var$isCustomProperty(styleName) ? styleName : styleName.replace($5fa5ccc1b989e380$var$hyphenateRegex, '-$&').toLowerCase();
});
var $5fa5ccc1b989e380$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($5fa5ccc1b989e380$var$animationRegex, function(match, p1, p2) {
                $5fa5ccc1b989e380$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $5fa5ccc1b989e380$var$cursor
                };
                return p1;
            });
    }
    if ((0, $09659743a94fc5fc$export$2e2bcd8739ae039)[key] !== 1 && !$5fa5ccc1b989e380$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $5fa5ccc1b989e380$var$contentValuePattern, $5fa5ccc1b989e380$var$contentValues, $5fa5ccc1b989e380$var$oldProcessStyleValue, $5fa5ccc1b989e380$var$msPattern, $5fa5ccc1b989e380$var$hyphenPattern, $5fa5ccc1b989e380$var$hyphenatedCache;
var $5fa5ccc1b989e380$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $5fa5ccc1b989e380$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $5fa5ccc1b989e380$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $5fa5ccc1b989e380$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $5fa5ccc1b989e380$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $5fa5ccc1b989e380$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $5fa5ccc1b989e380$var$cursor;
                var result = interpolation(mergedProps);
                $5fa5ccc1b989e380$var$cursor = previousCursor;
                return $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $5fa5ccc1b989e380$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($5fa5ccc1b989e380$var$isProcessableValue(value)) string += $5fa5ccc1b989e380$var$processStyleName(_key) + ":" + $5fa5ccc1b989e380$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($5fa5ccc1b989e380$var$isProcessableValue(value[_i])) string += $5fa5ccc1b989e380$var$processStyleName(_key) + ":" + $5fa5ccc1b989e380$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $5fa5ccc1b989e380$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $5fa5ccc1b989e380$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $5fa5ccc1b989e380$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $5fa5ccc1b989e380$var$cursor;
var $5fa5ccc1b989e380$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $5fa5ccc1b989e380$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $5fa5ccc1b989e380$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $5fa5ccc1b989e380$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $5fa5ccc1b989e380$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $48271972dbfe5b8c$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $5fa5ccc1b989e380$var$cursor
    };
};



var $3KGP8 = parcelRequire("3KGP8");
var $97693bf833000df2$var$syncFallback = function syncFallback(create) {
    return create();
};
var $97693bf833000df2$var$useInsertionEffect = $3KGP8.useInsertionEffect ? $3KGP8.useInsertionEffect : false;
var $97693bf833000df2$export$db21c7ffa21794e7 = $97693bf833000df2$var$useInsertionEffect || $97693bf833000df2$var$syncFallback;
var $97693bf833000df2$export$811a713a7276cb9d = $97693bf833000df2$var$useInsertionEffect || (0, $3KGP8.useLayoutEffect);


var $13e2ea967fc44b9d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $13e2ea967fc44b9d$var$EmotionCacheContext = /* #__PURE__ */ (0, $3KGP8.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3158d564e4aa3a61$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $13e2ea967fc44b9d$export$e7094788287c5e9b = $13e2ea967fc44b9d$var$EmotionCacheContext.Provider;
var $13e2ea967fc44b9d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3KGP8.useContext)($13e2ea967fc44b9d$var$EmotionCacheContext);
};
var $13e2ea967fc44b9d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $3KGP8.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3KGP8.useContext)($13e2ea967fc44b9d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $13e2ea967fc44b9d$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $3KGP8.createContext)({});
var $13e2ea967fc44b9d$export$3b14a55fb2447963 = function useTheme() {
    return (0, $3KGP8.useContext)($13e2ea967fc44b9d$export$971d5caa766a69d7);
};
var $13e2ea967fc44b9d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $13e2ea967fc44b9d$var$createCacheWithTheme = /* #__PURE__ */ (0, $6af24d90aba7488d$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $6af24d90aba7488d$export$2e2bcd8739ae039)(function(theme) {
        return $13e2ea967fc44b9d$var$getTheme(outerTheme, theme);
    });
});
var $13e2ea967fc44b9d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $3KGP8.useContext)($13e2ea967fc44b9d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $13e2ea967fc44b9d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $3KGP8.createElement)($13e2ea967fc44b9d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $13e2ea967fc44b9d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $3KGP8.useContext)($13e2ea967fc44b9d$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $3KGP8.createElement)(Component, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $3KGP8.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $2790fca91b2f01eb$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $13e2ea967fc44b9d$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $13e2ea967fc44b9d$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $13e2ea967fc44b9d$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $13e2ea967fc44b9d$var$getLastPart(match[1]);
    return undefined;
};
var $13e2ea967fc44b9d$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $13e2ea967fc44b9d$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $13e2ea967fc44b9d$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $13e2ea967fc44b9d$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($13e2ea967fc44b9d$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $13e2ea967fc44b9d$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $13e2ea967fc44b9d$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $13e2ea967fc44b9d$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $13e2ea967fc44b9d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($13e2ea967fc44b9d$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$13e2ea967fc44b9d$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $13e2ea967fc44b9d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $d51ee36b2d8eb775$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $97693bf833000df2$export$db21c7ffa21794e7)(function() {
        return (0, $d51ee36b2d8eb775$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $13e2ea967fc44b9d$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $13e2ea967fc44b9d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$13e2ea967fc44b9d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $d51ee36b2d8eb775$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $5fa5ccc1b989e380$export$6321afa313b251b5)(registeredStyles, undefined, (0, $3KGP8.useContext)($13e2ea967fc44b9d$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($13e2ea967fc44b9d$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $13e2ea967fc44b9d$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $3KGP8.createElement)((0, $3KGP8.Fragment), null, /*#__PURE__*/ (0, $3KGP8.createElement)($13e2ea967fc44b9d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ (0, $3KGP8.createElement)(WrappedComponent, newProps));
});


var $69f0d3386e39cc9b$exports = {};
function $69f0d3386e39cc9b$var$_extends() {
    $69f0d3386e39cc9b$exports = $69f0d3386e39cc9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $69f0d3386e39cc9b$exports.__esModule = true, $69f0d3386e39cc9b$exports["default"] = $69f0d3386e39cc9b$exports;
    return $69f0d3386e39cc9b$var$_extends.apply(this, arguments);
}
$69f0d3386e39cc9b$exports = $69f0d3386e39cc9b$var$_extends, $69f0d3386e39cc9b$exports.__esModule = true, $69f0d3386e39cc9b$exports["default"] = $69f0d3386e39cc9b$exports;








var $99e34d5c988ae95d$var$pkg = {
    name: "@emotion/react",
    version: "11.10.5",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.5",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.18.5",
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.5",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.5",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $99e34d5c988ae95d$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $13e2ea967fc44b9d$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $3KGP8.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $13e2ea967fc44b9d$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $13e2ea967fc44b9d$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $3KGP8.createElement).apply(null, createElementArgArray);
};
var $99e34d5c988ae95d$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $99e34d5c988ae95d$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $13e2ea967fc44b9d$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $5fa5ccc1b989e380$export$6321afa313b251b5)([
        styles
    ], undefined, (0, $3KGP8.useContext)((0, $13e2ea967fc44b9d$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $3KGP8.useRef)();
    (0, $97693bf833000df2$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $97693bf833000df2$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $d51ee36b2d8eb775$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $99e34d5c988ae95d$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $5fa5ccc1b989e380$export$6321afa313b251b5)(args);
}
var $99e34d5c988ae95d$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $99e34d5c988ae95d$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $99e34d5c988ae95d$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $99e34d5c988ae95d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $d51ee36b2d8eb775$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $99e34d5c988ae95d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $97693bf833000df2$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $d51ee36b2d8eb775$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $99e34d5c988ae95d$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $13e2ea967fc44b9d$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $5fa5ccc1b989e380$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $d51ee36b2d8eb775$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $99e34d5c988ae95d$var$merge(cache.registered, css, $99e34d5c988ae95d$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $3KGP8.useContext)((0, $13e2ea967fc44b9d$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $3KGP8.createElement)((0, $3KGP8.Fragment), null, /*#__PURE__*/ (0, $3KGP8.createElement)($99e34d5c988ae95d$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $99e34d5c988ae95d$var$isBrowser, $99e34d5c988ae95d$var$isTestEnv, $99e34d5c988ae95d$var$globalContext, $99e34d5c988ae95d$var$globalKey;





function $555e2bfa4d957dd0$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $3KGP8 = parcelRequire("3KGP8");

function $fd1cecc8dee39958$var$getAlignment(placement) {
    return placement.split('-')[1];
}
function $fd1cecc8dee39958$var$getLengthFromAxis(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $fd1cecc8dee39958$var$getSide(placement) {
    return placement.split('-')[0];
}
function $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].includes($fd1cecc8dee39958$var$getSide(placement)) ? 'x' : 'y';
}
function $fd1cecc8dee39958$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement);
    const length = $fd1cecc8dee39958$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $fd1cecc8dee39958$var$getSide(placement);
    const isVertical = mainAxis === 'x';
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($fd1cecc8dee39958$var$getAlignment(placement)){
        case 'start':
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $fd1cecc8dee39958$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    var _ref;
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $fd1cecc8dee39958$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $fd1cecc8dee39958$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $fd1cecc8dee39958$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $fd1cecc8dee39958$var$getSideObjectFromPadding(padding) {
    return typeof padding !== 'number' ? $fd1cecc8dee39958$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $fd1cecc8dee39958$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = middlewareArguments;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = options;
    const paddingObject = $fd1cecc8dee39958$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $fd1cecc8dee39958$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $fd1cecc8dee39958$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const $fd1cecc8dee39958$var$min = Math.min;
const $fd1cecc8dee39958$var$max = Math.max;
function $fd1cecc8dee39958$var$within(min$1, value, max$1) {
    return $fd1cecc8dee39958$var$max(min$1, $fd1cecc8dee39958$var$min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $fd1cecc8dee39958$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (middlewareArguments) {
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = options || {};
            const { x: x, y: y, placement: placement, rects: rects, platform: platform } = middlewareArguments;
            if (element == null) return {};
            const paddingObject = $fd1cecc8dee39958$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement);
            const length = $fd1cecc8dee39958$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const minProp = axis === 'y' ? 'top' : 'left';
            const maxProp = axis === 'y' ? 'bottom' : 'right';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
            if (clientSize === 0) clientSize = rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $fd1cecc8dee39958$var$within(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $fd1cecc8dee39958$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $fd1cecc8dee39958$var$sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const $fd1cecc8dee39958$var$allPlacements = /*#__PURE__*/ $fd1cecc8dee39958$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
const $fd1cecc8dee39958$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $fd1cecc8dee39958$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$fd1cecc8dee39958$var$oppositeSideMap[side]);
}
function $fd1cecc8dee39958$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $fd1cecc8dee39958$var$getAlignment(placement);
    const mainAxis = $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement);
    const length = $fd1cecc8dee39958$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $fd1cecc8dee39958$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $fd1cecc8dee39958$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $fd1cecc8dee39958$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $fd1cecc8dee39958$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$fd1cecc8dee39958$var$oppositeAlignmentMap[alignment]);
}
function $fd1cecc8dee39958$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$fd1cecc8dee39958$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$fd1cecc8dee39958$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$fd1cecc8dee39958$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $fd1cecc8dee39958$var$getAlignment(placement) === alignment || (autoAlignment ? $fd1cecc8dee39958$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $fd1cecc8dee39958$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsSortedByLe;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = middlewareArguments;
            const { alignment: alignment, allowedPlacements: allowedPlacements = $fd1cecc8dee39958$var$allPlacements, autoAlignment: autoAlignment = true, ...detectOverflowOptions } = options;
            const placements = alignment !== undefined || allowedPlacements === $fd1cecc8dee39958$var$allPlacements ? $fd1cecc8dee39958$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main, cross: cross } = $fd1cecc8dee39958$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$fd1cecc8dee39958$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b)=>a.overflows[0] - b.overflows[0]);
            const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find((_ref)=>{
                let { overflows: overflows } = _ref;
                return overflows.every((overflow)=>overflow <= 0);
            })) == null ? void 0 : _placementsSortedByLe.placement;
            const resetPlacement = placementThatFitsOnAllSides || placementsSortedByLeastOverflow[0].placement;
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $fd1cecc8dee39958$var$getExpandedPlacements(placement) {
    const oppositePlacement = $fd1cecc8dee39958$var$getOppositePlacement(placement);
    return [
        $fd1cecc8dee39958$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $fd1cecc8dee39958$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $fd1cecc8dee39958$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $fd1cecc8dee39958$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $fd1cecc8dee39958$var$getAlignment(placement);
    let list = $fd1cecc8dee39958$var$getSideList($fd1cecc8dee39958$var$getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($fd1cecc8dee39958$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */ const $fd1cecc8dee39958$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = options;
            const side = $fd1cecc8dee39958$var$getSide(placement);
            const isBasePlacement = $fd1cecc8dee39958$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $fd1cecc8dee39958$var$getOppositePlacement(initialPlacement)
            ] : $fd1cecc8dee39958$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...$fd1cecc8dee39958$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main, cross: cross } = $fd1cecc8dee39958$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = 'bottom';
                switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $fd1cecc8dee39958$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $fd1cecc8dee39958$var$isAnySideFullyClipped(overflow) {
    return $fd1cecc8dee39958$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $fd1cecc8dee39958$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (middlewareArguments) {
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = options;
            const { rects: rects } = middlewareArguments;
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $fd1cecc8dee39958$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $fd1cecc8dee39958$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $fd1cecc8dee39958$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $fd1cecc8dee39958$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $fd1cecc8dee39958$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = middlewareArguments;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = options;
            const fallback = $fd1cecc8dee39958$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                rect: rects.reference,
                offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
                strategy: strategy
            }) : rects.reference);
            const clientRects = await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || [];
            const paddingObject = $fd1cecc8dee39958$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ($fd1cecc8dee39958$var$getMainAxisFromPlacement(placement) === 'x') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $fd1cecc8dee39958$var$getSide(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $fd1cecc8dee39958$var$getSide(placement) === 'left';
                    const maxRight = $fd1cecc8dee39958$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $fd1cecc8dee39958$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
async function $fd1cecc8dee39958$var$convertValueToCoords(middlewareArguments, value) {
    const { placement: placement, platform: platform, elements: elements } = middlewareArguments;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $fd1cecc8dee39958$var$getSide(placement);
    const alignment = $fd1cecc8dee39958$var$getAlignment(placement);
    const isVertical = $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement) === 'x';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === 'function' ? value(middlewareArguments) : value;
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */ const $fd1cecc8dee39958$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: 'offset',
        options: value,
        async fn (middlewareArguments) {
            const { x: x, y: y } = middlewareArguments;
            const diffCoords = await $fd1cecc8dee39958$var$convertValueToCoords(middlewareArguments, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $fd1cecc8dee39958$var$getCrossAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $fd1cecc8dee39958$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (middlewareArguments) {
            const { x: x, y: y, placement: placement } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const mainAxis = $fd1cecc8dee39958$var$getMainAxisFromPlacement($fd1cecc8dee39958$var$getSide(placement));
            const crossAxis = $fd1cecc8dee39958$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $fd1cecc8dee39958$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $fd1cecc8dee39958$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...middlewareArguments,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $fd1cecc8dee39958$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (middlewareArguments) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = middlewareArguments;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $fd1cecc8dee39958$var$getMainAxisFromPlacement(placement);
            const crossAxis = $fd1cecc8dee39958$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === 'function' ? offset(middlewareArguments) : offset;
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes($fd1cecc8dee39958$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */ const $fd1cecc8dee39958$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = middlewareArguments;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = options;
            const overflow = await $fd1cecc8dee39958$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const side = $fd1cecc8dee39958$var$getSide(placement);
            const alignment = $fd1cecc8dee39958$var$getAlignment(placement);
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const xMin = $fd1cecc8dee39958$var$max(overflow.left, 0);
            const xMax = $fd1cecc8dee39958$var$max(overflow.right, 0);
            const yMin = $fd1cecc8dee39958$var$max(overflow.top, 0);
            const yMax = $fd1cecc8dee39958$var$max(overflow.bottom, 0);
            const dimensions = {
                availableHeight: rects.floating.height - ([
                    'left',
                    'right'
                ].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $fd1cecc8dee39958$var$max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                availableWidth: rects.floating.width - ([
                    'top',
                    'bottom'
                ].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $fd1cecc8dee39958$var$max(overflow.left, overflow.right)) : overflow[widthSide])
            };
            await apply({
                ...middlewareArguments,
                ...dimensions
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (rects.floating.width !== nextDimensions.width || rects.floating.height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};


function $5c4b48ba1f7bad64$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $5c4b48ba1f7bad64$var$getComputedStyle$1(element) {
    return $5c4b48ba1f7bad64$var$getWindow(element).getComputedStyle(element);
}
function $5c4b48ba1f7bad64$var$getNodeName(node) {
    return $5c4b48ba1f7bad64$var$isNode(node) ? (node.nodeName || '').toLowerCase() : '';
}
let $5c4b48ba1f7bad64$var$uaString;
function $5c4b48ba1f7bad64$var$getUAString() {
    if ($5c4b48ba1f7bad64$var$uaString) return $5c4b48ba1f7bad64$var$uaString;
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
        $5c4b48ba1f7bad64$var$uaString = uaData.brands.map((item)=>item.brand + "/" + item.version).join(' ');
        return $5c4b48ba1f7bad64$var$uaString;
    }
    return navigator.userAgent;
}
function $5c4b48ba1f7bad64$var$isHTMLElement(value) {
    return value instanceof $5c4b48ba1f7bad64$var$getWindow(value).HTMLElement;
}
function $5c4b48ba1f7bad64$var$isElement(value) {
    return value instanceof $5c4b48ba1f7bad64$var$getWindow(value).Element;
}
function $5c4b48ba1f7bad64$var$isNode(value) {
    return value instanceof $5c4b48ba1f7bad64$var$getWindow(value).Node;
}
function $5c4b48ba1f7bad64$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === 'undefined') return false;
    const OwnElement = $5c4b48ba1f7bad64$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $5c4b48ba1f7bad64$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $5c4b48ba1f7bad64$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $5c4b48ba1f7bad64$var$isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($5c4b48ba1f7bad64$var$getNodeName(element));
}
function $5c4b48ba1f7bad64$var$isContainingBlock(element) {
    // TODO: Try and use feature detection here instead
    const isFirefox = /firefox/i.test($5c4b48ba1f7bad64$var$getUAString());
    const css = $5c4b48ba1f7bad64$var$getComputedStyle$1(element);
    const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;
    // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (backdropFilter ? backdropFilter !== 'none' : false) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective'
    ].some((value)=>css.willChange.includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some(// TS 4.1 compat
    (value)=>{
        const contain = css.contain;
        return contain != null ? contain.includes(value) : false;
    });
}
function $5c4b48ba1f7bad64$var$isLayoutViewport() {
    // Not Safari
    return !/^((?!chrome|android).)*safari/i.test($5c4b48ba1f7bad64$var$getUAString());
// Feature detection for this fails in various ways
// • Always-visible scrollbar or not
// • Width of <html>, etc.
// const vV = win.visualViewport;
// return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}
function $5c4b48ba1f7bad64$var$isLastTraversableNode(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($5c4b48ba1f7bad64$var$getNodeName(node));
}
const $5c4b48ba1f7bad64$var$min = Math.min;
const $5c4b48ba1f7bad64$var$max = Math.max;
const $5c4b48ba1f7bad64$var$round = Math.round;
function $5c4b48ba1f7bad64$var$getCssDimensions(element) {
    const css = $5c4b48ba1f7bad64$var$getComputedStyle$1(element);
    let width = parseFloat(css.width);
    let height = parseFloat(css.height);
    const offsetWidth = element.offsetWidth;
    const offsetHeight = element.offsetHeight;
    const shouldFallback = $5c4b48ba1f7bad64$var$round(width) !== offsetWidth || $5c4b48ba1f7bad64$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        fallback: shouldFallback
    };
}
function $5c4b48ba1f7bad64$var$unwrapElement(element) {
    return !$5c4b48ba1f7bad64$var$isElement(element) ? element.contextElement : element;
}
const $5c4b48ba1f7bad64$var$FALLBACK_SCALE = {
    x: 1,
    y: 1
};
function $5c4b48ba1f7bad64$var$getScale(element) {
    const domElement = $5c4b48ba1f7bad64$var$unwrapElement(element);
    if (!$5c4b48ba1f7bad64$var$isHTMLElement(domElement)) return $5c4b48ba1f7bad64$var$FALLBACK_SCALE;
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, fallback: fallback } = $5c4b48ba1f7bad64$var$getCssDimensions(domElement);
    let x = (fallback ? $5c4b48ba1f7bad64$var$round(rect.width) : rect.width) / width;
    let y = (fallback ? $5c4b48ba1f7bad64$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
function $5c4b48ba1f7bad64$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $5c4b48ba1f7bad64$var$unwrapElement(element);
    let scale = $5c4b48ba1f7bad64$var$FALLBACK_SCALE;
    if (includeScale) {
        if (offsetParent) {
            if ($5c4b48ba1f7bad64$var$isElement(offsetParent)) scale = $5c4b48ba1f7bad64$var$getScale(offsetParent);
        } else scale = $5c4b48ba1f7bad64$var$getScale(element);
    }
    const win = domElement ? $5c4b48ba1f7bad64$var$getWindow(domElement) : window;
    const addVisualOffsets = !$5c4b48ba1f7bad64$var$isLayoutViewport() && isFixedStrategy;
    let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
    let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $5c4b48ba1f7bad64$var$getWindow(domElement);
        const offsetWin = offsetParent && $5c4b48ba1f7bad64$var$isElement(offsetParent) ? $5c4b48ba1f7bad64$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $5c4b48ba1f7bad64$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle(currentIFrame);
            iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += iframeRect.x;
            y += iframeRect.y;
            currentIFrame = $5c4b48ba1f7bad64$var$getWindow(currentIFrame).frameElement;
        }
    }
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $5c4b48ba1f7bad64$var$getDocumentElement(node) {
    return (($5c4b48ba1f7bad64$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $5c4b48ba1f7bad64$var$getNodeScroll(element) {
    if ($5c4b48ba1f7bad64$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $5c4b48ba1f7bad64$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $5c4b48ba1f7bad64$var$getBoundingClientRect($5c4b48ba1f7bad64$var$getDocumentElement(element)).left + $5c4b48ba1f7bad64$var$getNodeScroll(element).scrollLeft;
}
function $5c4b48ba1f7bad64$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $5c4b48ba1f7bad64$var$isHTMLElement(offsetParent);
    const documentElement = $5c4b48ba1f7bad64$var$getDocumentElement(offsetParent);
    const rect = $5c4b48ba1f7bad64$var$getBoundingClientRect(element, true, strategy === 'fixed', offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ($5c4b48ba1f7bad64$var$getNodeName(offsetParent) !== 'body' || $5c4b48ba1f7bad64$var$isOverflowElement(documentElement)) scroll = $5c4b48ba1f7bad64$var$getNodeScroll(offsetParent);
        if ($5c4b48ba1f7bad64$var$isHTMLElement(offsetParent)) {
            const offsetRect = $5c4b48ba1f7bad64$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $5c4b48ba1f7bad64$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $5c4b48ba1f7bad64$var$getParentNode(node) {
    if ($5c4b48ba1f7bad64$var$getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node
    node.assignedSlot || // DOM Element detected
    node.parentNode || // ShadowRoot detected
    ($5c4b48ba1f7bad64$var$isShadowRoot(node) ? node.host : null) || // Fallback
    $5c4b48ba1f7bad64$var$getDocumentElement(node);
    return $5c4b48ba1f7bad64$var$isShadowRoot(result) ? result.host : result;
}
function $5c4b48ba1f7bad64$var$getTrueOffsetParent(element) {
    if (!$5c4b48ba1f7bad64$var$isHTMLElement(element) || $5c4b48ba1f7bad64$var$getComputedStyle$1(element).position === 'fixed') return null;
    return element.offsetParent;
}
function $5c4b48ba1f7bad64$var$getContainingBlock(element) {
    let currentNode = $5c4b48ba1f7bad64$var$getParentNode(element);
    while($5c4b48ba1f7bad64$var$isHTMLElement(currentNode) && !$5c4b48ba1f7bad64$var$isLastTraversableNode(currentNode)){
        if ($5c4b48ba1f7bad64$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $5c4b48ba1f7bad64$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $5c4b48ba1f7bad64$var$getOffsetParent(element) {
    const window1 = $5c4b48ba1f7bad64$var$getWindow(element);
    let offsetParent = $5c4b48ba1f7bad64$var$getTrueOffsetParent(element);
    while(offsetParent && $5c4b48ba1f7bad64$var$isTableElement(offsetParent) && $5c4b48ba1f7bad64$var$getComputedStyle$1(offsetParent).position === 'static')offsetParent = $5c4b48ba1f7bad64$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($5c4b48ba1f7bad64$var$getNodeName(offsetParent) === 'html' || $5c4b48ba1f7bad64$var$getNodeName(offsetParent) === 'body' && $5c4b48ba1f7bad64$var$getComputedStyle$1(offsetParent).position === 'static' && !$5c4b48ba1f7bad64$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $5c4b48ba1f7bad64$var$getContainingBlock(element) || window1;
}
function $5c4b48ba1f7bad64$var$getDimensions(element) {
    return $5c4b48ba1f7bad64$var$getCssDimensions(element);
}
function $5c4b48ba1f7bad64$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $5c4b48ba1f7bad64$var$isHTMLElement(offsetParent);
    const documentElement = $5c4b48ba1f7bad64$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = {
        x: 1,
        y: 1
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ($5c4b48ba1f7bad64$var$getNodeName(offsetParent) !== 'body' || $5c4b48ba1f7bad64$var$isOverflowElement(documentElement)) scroll = $5c4b48ba1f7bad64$var$getNodeScroll(offsetParent);
        if ($5c4b48ba1f7bad64$var$isHTMLElement(offsetParent)) {
            const offsetRect = $5c4b48ba1f7bad64$var$getBoundingClientRect(offsetParent);
            scale = $5c4b48ba1f7bad64$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    // This doesn't appear to need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $5c4b48ba1f7bad64$var$getViewportRect(element, strategy) {
    const win = $5c4b48ba1f7bad64$var$getWindow(element);
    const html = $5c4b48ba1f7bad64$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const layoutViewport = $5c4b48ba1f7bad64$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $5c4b48ba1f7bad64$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    const html = $5c4b48ba1f7bad64$var$getDocumentElement(element);
    const scroll = $5c4b48ba1f7bad64$var$getNodeScroll(element);
    const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    const width = $5c4b48ba1f7bad64$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    const height = $5c4b48ba1f7bad64$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    let x = -scroll.scrollLeft + $5c4b48ba1f7bad64$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($5c4b48ba1f7bad64$var$getComputedStyle$1(body || html).direction === 'rtl') x += $5c4b48ba1f7bad64$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5c4b48ba1f7bad64$var$getNearestOverflowAncestor(node) {
    const parentNode = $5c4b48ba1f7bad64$var$getParentNode(node);
    if ($5c4b48ba1f7bad64$var$isLastTraversableNode(parentNode)) // @ts-ignore assume body is always available
    return node.ownerDocument.body;
    if ($5c4b48ba1f7bad64$var$isHTMLElement(parentNode) && $5c4b48ba1f7bad64$var$isOverflowElement(parentNode)) return parentNode;
    return $5c4b48ba1f7bad64$var$getNearestOverflowAncestor(parentNode);
}
function $5c4b48ba1f7bad64$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $5c4b48ba1f7bad64$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $5c4b48ba1f7bad64$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $5c4b48ba1f7bad64$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $5c4b48ba1f7bad64$export$3b57c1601291186b(scrollableAncestor));
}
// Returns the inner client rect, subtracting scrollbars if present
function $5c4b48ba1f7bad64$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $5c4b48ba1f7bad64$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $5c4b48ba1f7bad64$var$isHTMLElement(element) ? $5c4b48ba1f7bad64$var$getScale(element) : {
        x: 1,
        y: 1
    };
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $5c4b48ba1f7bad64$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    if (clippingAncestor === 'viewport') return (0, $fd1cecc8dee39958$export$ee05aea0aeecbad4)($5c4b48ba1f7bad64$var$getViewportRect(element, strategy));
    if ($5c4b48ba1f7bad64$var$isElement(clippingAncestor)) return $5c4b48ba1f7bad64$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    return (0, $fd1cecc8dee39958$export$ee05aea0aeecbad4)($5c4b48ba1f7bad64$var$getDocumentRect($5c4b48ba1f7bad64$var$getDocumentElement(element)));
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $5c4b48ba1f7bad64$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $5c4b48ba1f7bad64$export$3b57c1601291186b(element).filter((el)=>$5c4b48ba1f7bad64$var$isElement(el) && $5c4b48ba1f7bad64$var$getNodeName(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $5c4b48ba1f7bad64$var$getComputedStyle$1(element).position === 'fixed';
    let currentNode = elementIsFixed ? $5c4b48ba1f7bad64$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($5c4b48ba1f7bad64$var$isElement(currentNode) && !$5c4b48ba1f7bad64$var$isLastTraversableNode(currentNode)){
        const computedStyle = $5c4b48ba1f7bad64$var$getComputedStyle$1(currentNode);
        const containingBlock = $5c4b48ba1f7bad64$var$isContainingBlock(currentNode);
        const shouldDropCurrentNode = elementIsFixed ? !containingBlock && !currentContainingBlockComputedStyle : !containingBlock && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position);
        if (shouldDropCurrentNode) // Drop non-containing blocks
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $5c4b48ba1f7bad64$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors
function $5c4b48ba1f7bad64$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $5c4b48ba1f7bad64$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $5c4b48ba1f7bad64$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $5c4b48ba1f7bad64$var$max(rect.top, accRect.top);
        accRect.right = $5c4b48ba1f7bad64$var$min(rect.right, accRect.right);
        accRect.bottom = $5c4b48ba1f7bad64$var$min(rect.bottom, accRect.bottom);
        accRect.left = $5c4b48ba1f7bad64$var$max(rect.left, accRect.left);
        return accRect;
    }, $5c4b48ba1f7bad64$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
const $5c4b48ba1f7bad64$export$722a64dea1b767dc = {
    getClippingRect: $5c4b48ba1f7bad64$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $5c4b48ba1f7bad64$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $5c4b48ba1f7bad64$var$isElement,
    getDimensions: $5c4b48ba1f7bad64$var$getDimensions,
    getOffsetParent: $5c4b48ba1f7bad64$var$getOffsetParent,
    getDocumentElement: $5c4b48ba1f7bad64$var$getDocumentElement,
    getScale: $5c4b48ba1f7bad64$var$getScale,
    async getElementRects (_ref) {
        let { reference: reference, floating: floating, strategy: strategy } = _ref;
        const getOffsetParentFn = this.getOffsetParent || $5c4b48ba1f7bad64$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $5c4b48ba1f7bad64$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
            floating: {
                x: 0,
                y: 0,
                ...await getDimensionsFn(floating)
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$5c4b48ba1f7bad64$var$getComputedStyle$1(element).direction === 'rtl'
};
/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $5c4b48ba1f7bad64$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: _ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = true, animationFrame: animationFrame = false } = options;
    const ancestorScroll = _ancestorScroll && !animationFrame;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$5c4b48ba1f7bad64$var$isElement(reference) ? $5c4b48ba1f7bad64$export$3b57c1601291186b(reference) : reference.contextElement ? $5c4b48ba1f7bad64$export$3b57c1601291186b(reference.contextElement) : [],
        ...$5c4b48ba1f7bad64$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    let observer = null;
    if (elementResize) {
        let initialUpdate = true;
        observer = new ResizeObserver(()=>{
            if (!initialUpdate) update();
            initialUpdate = false;
        });
        $5c4b48ba1f7bad64$var$isElement(reference) && !animationFrame && observer.observe(reference);
        if (!$5c4b48ba1f7bad64$var$isElement(reference) && reference.contextElement && !animationFrame) observer.observe(reference.contextElement);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $5c4b48ba1f7bad64$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $5c4b48ba1f7bad64$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $5c4b48ba1f7bad64$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $5c4b48ba1f7bad64$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $fd1cecc8dee39958$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $3KGP8 = parcelRequire("3KGP8");
var $682535f973331a9e$var$index = (0, $3KGP8.useLayoutEffect);
var $682535f973331a9e$export$2e2bcd8739ae039 = $682535f973331a9e$var$index;


var $523aa44971902c9f$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $523aa44971902c9f$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $523aa44971902c9f$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $523aa44971902c9f$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($523aa44971902c9f$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $523aa44971902c9f$export$9bb611d729802a56 = function cleanValue(value) {
    if ($523aa44971902c9f$var$isArray(value)) return value.filter(Boolean);
    if ((0, $17c3a23d2ad0dbd8$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $523aa44971902c9f$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(props, $523aa44971902c9f$var$_excluded$3);
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $523aa44971902c9f$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $523aa44971902c9f$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $523aa44971902c9f$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $523aa44971902c9f$var$normalizedHeight(el) {
    if ($523aa44971902c9f$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $523aa44971902c9f$var$getScrollTop(el) {
    if ($523aa44971902c9f$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $523aa44971902c9f$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($523aa44971902c9f$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $523aa44971902c9f$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $523aa44971902c9f$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $523aa44971902c9f$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $523aa44971902c9f$export$3466f893ebf79586;
    var start = $523aa44971902c9f$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $523aa44971902c9f$var$easeOutCubic(currentTime, start, change, duration);
        $523aa44971902c9f$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $523aa44971902c9f$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $523aa44971902c9f$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $523aa44971902c9f$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $523aa44971902c9f$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $523aa44971902c9f$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $523aa44971902c9f$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $523aa44971902c9f$var$passiveOptionAccessed = false;
var $523aa44971902c9f$var$options = {
    get passive () {
        return $523aa44971902c9f$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $523aa44971902c9f$var$w = typeof window !== 'undefined' ? window : {};
if ($523aa44971902c9f$var$w.addEventListener && $523aa44971902c9f$var$w.removeEventListener) {
    $523aa44971902c9f$var$w.addEventListener('p', $523aa44971902c9f$export$3466f893ebf79586, $523aa44971902c9f$var$options);
    $523aa44971902c9f$var$w.removeEventListener('p', $523aa44971902c9f$export$3466f893ebf79586, false);
}
var $523aa44971902c9f$export$2408f22a0fab9ae5 = $523aa44971902c9f$var$passiveOptionAccessed;
function $523aa44971902c9f$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $523aa44971902c9f$var$isArray(arg) {
    return Array.isArray(arg);
}
function $523aa44971902c9f$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $523aa44971902c9f$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $523aa44971902c9f$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $523aa44971902c9f$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $523aa44971902c9f$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $523aa44971902c9f$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $523aa44971902c9f$var$normalizedHeight(scrollParent);
    var scrollTop = $523aa44971902c9f$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $523aa44971902c9f$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $523aa44971902c9f$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $523aa44971902c9f$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $523aa44971902c9f$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $523aa44971902c9f$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $523aa44971902c9f$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $523aa44971902c9f$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $523aa44971902c9f$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $93ccf7577d1fdfc7$export$2e2bcd8739ae039)(_objectSpread2, $523aa44971902c9f$var$alignToControl(placement), '100%'), (0, $93ccf7577d1fdfc7$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $93ccf7577d1fdfc7$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $93ccf7577d1fdfc7$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $523aa44971902c9f$var$PortalPlacementContext = /*#__PURE__*/ (0, $3KGP8.createContext)(null);
// NOTE: internal only
var $523aa44971902c9f$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $3KGP8.useContext)($523aa44971902c9f$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $3KGP8.useRef)(null);
    var _useState = (0, $3KGP8.useState)(maxMenuHeight), _useState2 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $3KGP8.useState)(null), _useState4 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $682535f973331a9e$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $523aa44971902c9f$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $523aa44971902c9f$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $523aa44971902c9f$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $523aa44971902c9f$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $523aa44971902c9f$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $523aa44971902c9f$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $523aa44971902c9f$export$3b14a55fb2447963 = $523aa44971902c9f$var$noticeCSS;
var $523aa44971902c9f$export$342063e11d6c3cad = $523aa44971902c9f$var$noticeCSS;
var $523aa44971902c9f$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$523aa44971902c9f$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $523aa44971902c9f$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$523aa44971902c9f$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $523aa44971902c9f$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $523aa44971902c9f$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $3KGP8.useRef)(null);
    var cleanupRef = (0, $3KGP8.useRef)(null);
    var _useState5 = (0, $3KGP8.useState)($523aa44971902c9f$var$coercePlacement(menuPlacement)), _useState6 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $3KGP8.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $3KGP8.useState)(null), _useState8 = (0, $70df644cd666ebd0$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $3KGP8.useCallback)(function() {
        if (!controlElement) return;
        var rect = $523aa44971902c9f$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $682535f973331a9e$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $3KGP8.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5c4b48ba1f7bad64$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $682535f973331a9e$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $3KGP8.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $523aa44971902c9f$var$getStyleProps((0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $03652cf8627f807b$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $523aa44971902c9f$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $523aa44971902c9f$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $523aa44971902c9f$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $523aa44971902c9f$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $523aa44971902c9f$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $523aa44971902c9f$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $523aa44971902c9f$var$_templateObject;
var $523aa44971902c9f$var$_excluded$2 = [
    "size"
];
function $523aa44971902c9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $523aa44971902c9f$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $523aa44971902c9f$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(_ref, $523aa44971902c9f$var$_excluded$2);
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("svg", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $523aa44971902c9f$var$_ref2
    }, props));
};
var $523aa44971902c9f$var$CrossIcon = function CrossIcon(props) {
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$Svg, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $523aa44971902c9f$var$DownChevron = function DownChevron(props) {
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$Svg, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $523aa44971902c9f$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $523aa44971902c9f$export$f1e1789686576879 = $523aa44971902c9f$var$baseCSS;
var $523aa44971902c9f$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$DownChevron, null));
};
var $523aa44971902c9f$export$407448d2b89b1813 = $523aa44971902c9f$var$baseCSS;
var $523aa44971902c9f$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $523aa44971902c9f$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $523aa44971902c9f$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("span", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, innerProps, $523aa44971902c9f$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $523aa44971902c9f$var$loadingDotAnimations = (0, $99e34d5c988ae95d$export$d25ddfdf17c3ad3e)($523aa44971902c9f$var$_templateObject || ($523aa44971902c9f$var$_templateObject = (0, $555e2bfa4d957dd0$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $523aa44971902c9f$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $523aa44971902c9f$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $99e34d5c988ae95d$export$dbf350e5966cf602)({
            animation: "".concat($523aa44971902c9f$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $523aa44971902c9f$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$523aa44971902c9f$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $523aa44971902c9f$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $523aa44971902c9f$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $523aa44971902c9f$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $523aa44971902c9f$var$_excluded$1 = [
    "data"
];
var $523aa44971902c9f$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $523aa44971902c9f$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)(Heading, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", null, children));
};
var $523aa44971902c9f$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $523aa44971902c9f$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $523aa44971902c9f$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(_cleanCommonProps, $523aa44971902c9f$var$_excluded$1);
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $523aa44971902c9f$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $523aa44971902c9f$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $523aa44971902c9f$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $523aa44971902c9f$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $523aa44971902c9f$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $523aa44971902c9f$var$spacingStyle)
};
var $523aa44971902c9f$var$inputStyle = function inputStyle(isHidden) {
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $523aa44971902c9f$var$spacingStyle);
};
var $523aa44971902c9f$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $523aa44971902c9f$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(_cleanCommonProps, $523aa44971902c9f$var$_excluded);
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("input", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $523aa44971902c9f$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $523aa44971902c9f$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $523aa44971902c9f$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $523aa44971902c9f$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $523aa44971902c9f$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $523aa44971902c9f$var$MultiValueContainer = $523aa44971902c9f$var$MultiValueGeneric;
var $523aa44971902c9f$var$MultiValueLabel = $523aa44971902c9f$var$MultiValueGeneric;
function $523aa44971902c9f$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($523aa44971902c9f$var$CrossIcon, {
        size: 14
    }));
}
var $523aa44971902c9f$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $523aa44971902c9f$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $523aa44971902c9f$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $523aa44971902c9f$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $523aa44971902c9f$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $523aa44971902c9f$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $523aa44971902c9f$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, $523aa44971902c9f$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $523aa44971902c9f$export$db3b6bfb95261072 = {
    ClearIndicator: $523aa44971902c9f$var$ClearIndicator,
    Control: $523aa44971902c9f$var$Control,
    DropdownIndicator: $523aa44971902c9f$var$DropdownIndicator,
    DownChevron: $523aa44971902c9f$var$DownChevron,
    CrossIcon: $523aa44971902c9f$var$CrossIcon,
    Group: $523aa44971902c9f$var$Group,
    GroupHeading: $523aa44971902c9f$var$GroupHeading,
    IndicatorsContainer: $523aa44971902c9f$var$IndicatorsContainer,
    IndicatorSeparator: $523aa44971902c9f$var$IndicatorSeparator,
    Input: $523aa44971902c9f$var$Input,
    LoadingIndicator: $523aa44971902c9f$var$LoadingIndicator,
    Menu: $523aa44971902c9f$var$Menu,
    MenuList: $523aa44971902c9f$var$MenuList,
    MenuPortal: $523aa44971902c9f$var$MenuPortal,
    LoadingMessage: $523aa44971902c9f$var$LoadingMessage,
    NoOptionsMessage: $523aa44971902c9f$var$NoOptionsMessage,
    MultiValue: $523aa44971902c9f$var$MultiValue,
    MultiValueContainer: $523aa44971902c9f$var$MultiValueContainer,
    MultiValueLabel: $523aa44971902c9f$var$MultiValueLabel,
    MultiValueRemove: $523aa44971902c9f$var$MultiValueRemove,
    Option: $523aa44971902c9f$var$Option,
    Placeholder: $523aa44971902c9f$var$Placeholder,
    SelectContainer: $523aa44971902c9f$var$SelectContainer,
    SingleValue: $523aa44971902c9f$var$SingleValue,
    ValueContainer: $523aa44971902c9f$var$ValueContainer
};
var $523aa44971902c9f$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $523aa44971902c9f$export$db3b6bfb95261072), props.components);
};



var $b45adaab188e65a0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $b45adaab188e65a0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($b45adaab188e65a0$var$safeIsNaN(first) && $b45adaab188e65a0$var$safeIsNaN(second)) return true;
    return false;
}
function $b45adaab188e65a0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$b45adaab188e65a0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $b45adaab188e65a0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $b45adaab188e65a0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $2e2f80ec86953b94$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $2e2f80ec86953b94$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $2e2f80ec86953b94$var$A11yText = function A11yText(props) {
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("span", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        css: $2e2f80ec86953b94$var$_ref
    }, props));
};
var $2e2f80ec86953b94$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $2e2f80ec86953b94$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $3KGP8.useMemo)(function() {
        return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $2e2f80ec86953b94$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $3KGP8.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $3KGP8.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $3KGP8.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $3KGP8.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)((0, $3KGP8.Fragment), null, (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)((0, $3KGP8.Fragment), null, (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($2e2f80ec86953b94$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)($2e2f80ec86953b94$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $2e2f80ec86953b94$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $2e2f80ec86953b94$var$anyDiacritic = new RegExp('[' + $2e2f80ec86953b94$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $2e2f80ec86953b94$var$diacriticToBase = {};
for(var $2e2f80ec86953b94$var$i = 0; $2e2f80ec86953b94$var$i < $2e2f80ec86953b94$var$diacritics.length; $2e2f80ec86953b94$var$i++){
    var $2e2f80ec86953b94$var$diacritic = $2e2f80ec86953b94$var$diacritics[$2e2f80ec86953b94$var$i];
    for(var $2e2f80ec86953b94$var$j = 0; $2e2f80ec86953b94$var$j < $2e2f80ec86953b94$var$diacritic.letters.length; $2e2f80ec86953b94$var$j++)$2e2f80ec86953b94$var$diacriticToBase[$2e2f80ec86953b94$var$diacritic.letters[$2e2f80ec86953b94$var$j]] = $2e2f80ec86953b94$var$diacritic.base;
}
var $2e2f80ec86953b94$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($2e2f80ec86953b94$var$anyDiacritic, function(match) {
        return $2e2f80ec86953b94$var$diacriticToBase[match];
    });
};
var $2e2f80ec86953b94$var$memoizedStripDiacriticsForInput = (0, $b45adaab188e65a0$export$2e2bcd8739ae039)($2e2f80ec86953b94$var$stripDiacritics);
var $2e2f80ec86953b94$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $2e2f80ec86953b94$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $2e2f80ec86953b94$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2e2f80ec86953b94$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $2e2f80ec86953b94$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $2e2f80ec86953b94$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2e2f80ec86953b94$var$memoizedStripDiacriticsForInput(input);
            candidate = $2e2f80ec86953b94$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $2e2f80ec86953b94$var$_excluded = [
    "innerRef"
];
function $2e2f80ec86953b94$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $7d3f8e2e4d84853b$export$2e2bcd8739ae039)(_ref, $2e2f80ec86953b94$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $523aa44971902c9f$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("input", (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $99e34d5c988ae95d$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $2e2f80ec86953b94$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $2e2f80ec86953b94$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $3KGP8.useRef)(false);
    var isTop = (0, $3KGP8.useRef)(false);
    var touchStart = (0, $3KGP8.useRef)(0);
    var scrollTarget = (0, $3KGP8.useRef)(null);
    var handleEventDelta = (0, $3KGP8.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $2e2f80ec86953b94$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $3KGP8.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $3KGP8.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $3KGP8.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $3KGP8.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $523aa44971902c9f$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $3KGP8.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $3KGP8.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $2e2f80ec86953b94$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $2e2f80ec86953b94$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $2e2f80ec86953b94$var$preventTouchMove(e) {
    e.preventDefault();
}
function $2e2f80ec86953b94$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $2e2f80ec86953b94$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $2e2f80ec86953b94$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $2e2f80ec86953b94$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $2e2f80ec86953b94$var$activeScrollLocks = 0;
var $2e2f80ec86953b94$var$listenerOptions = {
    capture: false,
    passive: false
};
function $2e2f80ec86953b94$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $3KGP8.useRef)({});
    var scrollTarget = (0, $3KGP8.useRef)(null);
    var addScrollLock = (0, $3KGP8.useCallback)(function(touchScrollTarget) {
        if (!$2e2f80ec86953b94$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $2e2f80ec86953b94$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $2e2f80ec86953b94$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($2e2f80ec86953b94$var$LOCK_STYLES).forEach(function(key) {
                var val = $2e2f80ec86953b94$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $2e2f80ec86953b94$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $2e2f80ec86953b94$var$preventTouchMove, $2e2f80ec86953b94$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $2e2f80ec86953b94$var$preventInertiaScroll, $2e2f80ec86953b94$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $2e2f80ec86953b94$var$allowTouchMove, $2e2f80ec86953b94$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $2e2f80ec86953b94$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $3KGP8.useCallback)(function(touchScrollTarget) {
        if (!$2e2f80ec86953b94$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $2e2f80ec86953b94$var$activeScrollLocks = Math.max($2e2f80ec86953b94$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $2e2f80ec86953b94$var$activeScrollLocks < 1) $2e2f80ec86953b94$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $2e2f80ec86953b94$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $2e2f80ec86953b94$var$preventTouchMove, $2e2f80ec86953b94$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $2e2f80ec86953b94$var$preventInertiaScroll, $2e2f80ec86953b94$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $2e2f80ec86953b94$var$allowTouchMove, $2e2f80ec86953b94$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $3KGP8.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $2e2f80ec86953b94$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2e2f80ec86953b94$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $2e2f80ec86953b94$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $2e2f80ec86953b94$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $2e2f80ec86953b94$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $2e2f80ec86953b94$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)((0, $3KGP8.Fragment), null, lockEnabled && (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("div", {
        onClick: $2e2f80ec86953b94$var$blurSelectInput,
        css: $2e2f80ec86953b94$var$_ref2$1
    }), children(targetRef));
}
function $2e2f80ec86953b94$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2e2f80ec86953b94$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $2e2f80ec86953b94$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $99e34d5c988ae95d$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $2e2f80ec86953b94$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $2e2f80ec86953b94$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $2e2f80ec86953b94$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $2e2f80ec86953b94$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $2e2f80ec86953b94$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $2e2f80ec86953b94$var$defaultStyles = {
    clearIndicator: (0, $523aa44971902c9f$export$407448d2b89b1813),
    container: (0, $523aa44971902c9f$export$8b22cf2602fb60ce),
    control: (0, $523aa44971902c9f$export$4368d992c4eafac0),
    dropdownIndicator: (0, $523aa44971902c9f$export$f1e1789686576879),
    group: (0, $523aa44971902c9f$export$39b482c5e57630a8),
    groupHeading: (0, $523aa44971902c9f$export$2d1720544b23b823),
    indicatorsContainer: (0, $523aa44971902c9f$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $523aa44971902c9f$export$dda1d9f60106f0e9),
    input: (0, $523aa44971902c9f$export$35e795649ee09318),
    loadingIndicator: (0, $523aa44971902c9f$export$882b5998b3b9117c),
    loadingMessage: (0, $523aa44971902c9f$export$342063e11d6c3cad),
    menu: (0, $523aa44971902c9f$export$953cecd6e717a553),
    menuList: (0, $523aa44971902c9f$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $523aa44971902c9f$export$ae1af26003f05816),
    multiValue: (0, $523aa44971902c9f$export$ffb5f4729a158638),
    multiValueLabel: (0, $523aa44971902c9f$export$9e5f44173e64f162),
    multiValueRemove: (0, $523aa44971902c9f$export$625550452a3fa3ec),
    noOptionsMessage: (0, $523aa44971902c9f$export$3b14a55fb2447963),
    option: (0, $523aa44971902c9f$export$90a7f3efeed30595),
    placeholder: (0, $523aa44971902c9f$export$efccba1c4a2ef57b),
    singleValue: (0, $523aa44971902c9f$export$d141bba7fdc215a3),
    valueContainer: (0, $523aa44971902c9f$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $2e2f80ec86953b94$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $2e2f80ec86953b94$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $2e2f80ec86953b94$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $2e2f80ec86953b94$var$baseUnit = 4;
// The minimum height of the control
var $2e2f80ec86953b94$var$controlHeight = 38;
// The amount of space between the control and menu */
var $2e2f80ec86953b94$var$menuGutter = $2e2f80ec86953b94$var$baseUnit * 2;
var $2e2f80ec86953b94$var$spacing = {
    baseUnit: $2e2f80ec86953b94$var$baseUnit,
    controlHeight: $2e2f80ec86953b94$var$controlHeight,
    menuGutter: $2e2f80ec86953b94$var$menuGutter
};
var $2e2f80ec86953b94$export$4368d992c4eafac0 = {
    borderRadius: $2e2f80ec86953b94$var$borderRadius,
    colors: $2e2f80ec86953b94$var$colors,
    spacing: $2e2f80ec86953b94$var$spacing
};
var $2e2f80ec86953b94$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $523aa44971902c9f$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $523aa44971902c9f$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $2e2f80ec86953b94$export$db3b6bfb95261072(),
    formatGroupLabel: $2e2f80ec86953b94$var$formatGroupLabel,
    getOptionLabel: $2e2f80ec86953b94$export$8b22cf2602fb60ce,
    getOptionValue: $2e2f80ec86953b94$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $2e2f80ec86953b94$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $523aa44971902c9f$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $2e2f80ec86953b94$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $2e2f80ec86953b94$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $2e2f80ec86953b94$var$_isOptionSelected(props, option, selectValue);
    var label = $2e2f80ec86953b94$var$getOptionLabel(props, option);
    var value = $2e2f80ec86953b94$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $2e2f80ec86953b94$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $2e2f80ec86953b94$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $2e2f80ec86953b94$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $2e2f80ec86953b94$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $2e2f80ec86953b94$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $523aa44971902c9f$export$2329c99376c9d0a4));
}
function $2e2f80ec86953b94$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $5e2fe5bbdf9e923f$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $2e2f80ec86953b94$var$buildFocusableOptions(props, selectValue) {
    return $2e2f80ec86953b94$var$buildFocusableOptionsFromCategorizedOptions($2e2f80ec86953b94$var$buildCategorizedOptions(props, selectValue));
}
function $2e2f80ec86953b94$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$2e2f80ec86953b94$var$shouldHideSelectedOptions(props) || !isSelected) && $2e2f80ec86953b94$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $2e2f80ec86953b94$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $2e2f80ec86953b94$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $2e2f80ec86953b94$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $2e2f80ec86953b94$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $2e2f80ec86953b94$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $2e2f80ec86953b94$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $2e2f80ec86953b94$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $2e2f80ec86953b94$var$getOptionValue(props, i) === candidate;
    });
}
function $2e2f80ec86953b94$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $2e2f80ec86953b94$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $2e2f80ec86953b94$var$instanceId = 1;
var $2e2f80ec86953b94$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $75c054cd1b3b4eb2$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $0eba1fba31bf123e$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $01249f85e1979289$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $523aa44971902c9f$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $523aa44971902c9f$export$ef35774e6d314e91)([].concat((0, $5e2fe5bbdf9e923f$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $523aa44971902c9f$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $523aa44971902c9f$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $523aa44971902c9f$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $523aa44971902c9f$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $523aa44971902c9f$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $523aa44971902c9f$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $2e2f80ec86953b94$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $2e2f80ec86953b94$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $2e2f80ec86953b94$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $523aa44971902c9f$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $2e2f80ec86953b94$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $2e2f80ec86953b94$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $523aa44971902c9f$export$7f8ddf7c7c20b3cd)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $2e2f80ec86953b94$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$2e2f80ec86953b94$var$instanceId);
        _this.state.selectValue = (0, $523aa44971902c9f$export$9bb611d729802a56)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $b6ca9f495673ea04$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $523aa44971902c9f$export$b4171a6734a65d42)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $523aa44971902c9f$export$b4171a6734a65d42)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $2e2f80ec86953b94$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($2e2f80ec86953b94$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, $2e2f80ec86953b94$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $2e2f80ec86953b94$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $2e2f80ec86953b94$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $2e2f80ec86953b94$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $3KGP8.createElement($2e2f80ec86953b94$var$DummyInput, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $523aa44971902c9f$export$3466f893ebf79586),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $3KGP8.createElement(Input, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $3KGP8.createElement(Placeholder, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $3KGP8.createElement(MultiValue, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $3KGP8.createElement(SingleValue, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3KGP8.createElement(ClearIndicator, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3KGP8.createElement(LoadingIndicator, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $3KGP8.createElement(IndicatorSeparator, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3KGP8.createElement(DropdownIndicator, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $3KGP8.createElement(Option, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $3KGP8.createElement(Group, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $3KGP8.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $3KGP8.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $3KGP8.createElement((0, $523aa44971902c9f$export$3a1a48c8f6ef640e), (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $3KGP8.createElement(Menu, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $3KGP8.createElement($2e2f80ec86953b94$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $3KGP8.createElement(MenuList, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $3KGP8.createElement(MenuPortal, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $3KGP8.createElement($2e2f80ec86953b94$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $3KGP8.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $3KGP8.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $3KGP8.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $3KGP8.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $3KGP8.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $3KGP8.createElement($2e2f80ec86953b94$var$LiveRegion, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $3KGP8.createElement(SelectContainer, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $3KGP8.createElement(Control, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $3KGP8.createElement(ValueContainer, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $3KGP8.createElement(IndicatorsContainer, (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $523aa44971902c9f$export$9bb611d729802a56)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $2e2f80ec86953b94$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $2e2f80ec86953b94$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $2e2f80ec86953b94$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $523aa44971902c9f$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)((0, $eae3700c4af93d39$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $3KGP8.Component));
$2e2f80ec86953b94$export$25ce5a424b770e84.defaultProps = $2e2f80ec86953b94$export$407448d2b89b1813;





var $d7ea282b47b122d8$exports = {};
var $5ac8ba42d72b7e4c$exports = {};
var $135f555a84bea16e$exports = {};
var $9eb4c37c2d1f4734$exports = {};
function $9eb4c37c2d1f4734$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9eb4c37c2d1f4734$exports = $9eb4c37c2d1f4734$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9eb4c37c2d1f4734$exports.__esModule = true, $9eb4c37c2d1f4734$exports["default"] = $9eb4c37c2d1f4734$exports, $9eb4c37c2d1f4734$var$_typeof(obj);
}
$9eb4c37c2d1f4734$exports = $9eb4c37c2d1f4734$var$_typeof, $9eb4c37c2d1f4734$exports.__esModule = true, $9eb4c37c2d1f4734$exports["default"] = $9eb4c37c2d1f4734$exports;


var $135f555a84bea16e$var$_typeof = $9eb4c37c2d1f4734$exports.default;
var $c878b866aa3a5313$exports = {};

var $c878b866aa3a5313$var$_typeof = $9eb4c37c2d1f4734$exports.default;
function $c878b866aa3a5313$var$_toPrimitive(input, hint) {
    if ($c878b866aa3a5313$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c878b866aa3a5313$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$c878b866aa3a5313$exports = $c878b866aa3a5313$var$_toPrimitive, $c878b866aa3a5313$exports.__esModule = true, $c878b866aa3a5313$exports["default"] = $c878b866aa3a5313$exports;


function $135f555a84bea16e$var$_toPropertyKey(arg) {
    var key = $c878b866aa3a5313$exports(arg, "string");
    return $135f555a84bea16e$var$_typeof(key) === "symbol" ? key : String(key);
}
$135f555a84bea16e$exports = $135f555a84bea16e$var$_toPropertyKey, $135f555a84bea16e$exports.__esModule = true, $135f555a84bea16e$exports["default"] = $135f555a84bea16e$exports;


function $5ac8ba42d72b7e4c$var$_defineProperty(obj, key, value) {
    key = $135f555a84bea16e$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$5ac8ba42d72b7e4c$exports = $5ac8ba42d72b7e4c$var$_defineProperty, $5ac8ba42d72b7e4c$exports.__esModule = true, $5ac8ba42d72b7e4c$exports["default"] = $5ac8ba42d72b7e4c$exports;


function $d7ea282b47b122d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d7ea282b47b122d8$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d7ea282b47b122d8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5ac8ba42d72b7e4c$exports(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d7ea282b47b122d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
$d7ea282b47b122d8$exports = $d7ea282b47b122d8$var$_objectSpread2, $d7ea282b47b122d8$exports.__esModule = true, $d7ea282b47b122d8$exports["default"] = $d7ea282b47b122d8$exports;


var $752547d6e9365ef4$exports = {};
var $4d259cc68e279445$exports = {};
function $4d259cc68e279445$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$4d259cc68e279445$exports = $4d259cc68e279445$var$_arrayWithHoles, $4d259cc68e279445$exports.__esModule = true, $4d259cc68e279445$exports["default"] = $4d259cc68e279445$exports;


var $6300befa0757d364$exports = {};
function $6300befa0757d364$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$6300befa0757d364$exports = $6300befa0757d364$var$_iterableToArrayLimit, $6300befa0757d364$exports.__esModule = true, $6300befa0757d364$exports["default"] = $6300befa0757d364$exports;


var $268756ee686f3cd0$exports = {};
var $005913fd29c2de7e$exports = {};
function $005913fd29c2de7e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$005913fd29c2de7e$exports = $005913fd29c2de7e$var$_arrayLikeToArray, $005913fd29c2de7e$exports.__esModule = true, $005913fd29c2de7e$exports["default"] = $005913fd29c2de7e$exports;


function $268756ee686f3cd0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $005913fd29c2de7e$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $005913fd29c2de7e$exports(o, minLen);
}
$268756ee686f3cd0$exports = $268756ee686f3cd0$var$_unsupportedIterableToArray, $268756ee686f3cd0$exports.__esModule = true, $268756ee686f3cd0$exports["default"] = $268756ee686f3cd0$exports;


var $50e98105ff62f377$exports = {};
function $50e98105ff62f377$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$50e98105ff62f377$exports = $50e98105ff62f377$var$_nonIterableRest, $50e98105ff62f377$exports.__esModule = true, $50e98105ff62f377$exports["default"] = $50e98105ff62f377$exports;


function $752547d6e9365ef4$var$_slicedToArray(arr, i) {
    return $4d259cc68e279445$exports(arr) || $6300befa0757d364$exports(arr, i) || $268756ee686f3cd0$exports(arr, i) || $50e98105ff62f377$exports();
}
$752547d6e9365ef4$exports = $752547d6e9365ef4$var$_slicedToArray, $752547d6e9365ef4$exports.__esModule = true, $752547d6e9365ef4$exports["default"] = $752547d6e9365ef4$exports;


var $bf9f0c33e8b59efc$exports = {};
var $ab2f2e60995a5063$exports = {};
function $ab2f2e60995a5063$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$ab2f2e60995a5063$exports = $ab2f2e60995a5063$var$_objectWithoutPropertiesLoose, $ab2f2e60995a5063$exports.__esModule = true, $ab2f2e60995a5063$exports["default"] = $ab2f2e60995a5063$exports;


function $bf9f0c33e8b59efc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ab2f2e60995a5063$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$bf9f0c33e8b59efc$exports = $bf9f0c33e8b59efc$var$_objectWithoutProperties, $bf9f0c33e8b59efc$exports.__esModule = true, $bf9f0c33e8b59efc$exports["default"] = $bf9f0c33e8b59efc$exports;


var $6a01bd05b3810501$exports = {};
function $6a01bd05b3810501$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$6a01bd05b3810501$exports = $6a01bd05b3810501$var$_classCallCheck, $6a01bd05b3810501$exports.__esModule = true, $6a01bd05b3810501$exports["default"] = $6a01bd05b3810501$exports;


var $df2889bc8a1646e3$exports = {};

function $df2889bc8a1646e3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $135f555a84bea16e$exports(descriptor.key), descriptor);
    }
}
function $df2889bc8a1646e3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df2889bc8a1646e3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df2889bc8a1646e3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$df2889bc8a1646e3$exports = $df2889bc8a1646e3$var$_createClass, $df2889bc8a1646e3$exports.__esModule = true, $df2889bc8a1646e3$exports["default"] = $df2889bc8a1646e3$exports;


var $f688f6284a3a5cea$exports = {};
var $43f2a3375734a424$exports = {};
function $43f2a3375734a424$var$_setPrototypeOf(o, p) {
    $43f2a3375734a424$exports = $43f2a3375734a424$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $43f2a3375734a424$exports.__esModule = true, $43f2a3375734a424$exports["default"] = $43f2a3375734a424$exports;
    return $43f2a3375734a424$var$_setPrototypeOf(o, p);
}
$43f2a3375734a424$exports = $43f2a3375734a424$var$_setPrototypeOf, $43f2a3375734a424$exports.__esModule = true, $43f2a3375734a424$exports["default"] = $43f2a3375734a424$exports;


function $f688f6284a3a5cea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $43f2a3375734a424$exports(subClass, superClass);
}
$f688f6284a3a5cea$exports = $f688f6284a3a5cea$var$_inherits, $f688f6284a3a5cea$exports.__esModule = true, $f688f6284a3a5cea$exports["default"] = $f688f6284a3a5cea$exports;


var $ae51736f5c9490d1$exports = {};
var $f1c3eaf30612a414$exports = {};
function $f1c3eaf30612a414$var$_getPrototypeOf(o) {
    $f1c3eaf30612a414$exports = $f1c3eaf30612a414$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $f1c3eaf30612a414$exports.__esModule = true, $f1c3eaf30612a414$exports["default"] = $f1c3eaf30612a414$exports;
    return $f1c3eaf30612a414$var$_getPrototypeOf(o);
}
$f1c3eaf30612a414$exports = $f1c3eaf30612a414$var$_getPrototypeOf, $f1c3eaf30612a414$exports.__esModule = true, $f1c3eaf30612a414$exports["default"] = $f1c3eaf30612a414$exports;


var $6d4421c339091e84$exports = {};
function $6d4421c339091e84$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$6d4421c339091e84$exports = $6d4421c339091e84$var$_isNativeReflectConstruct, $6d4421c339091e84$exports.__esModule = true, $6d4421c339091e84$exports["default"] = $6d4421c339091e84$exports;


var $ccec104764a273a2$exports = {};

var $ccec104764a273a2$var$_typeof = $9eb4c37c2d1f4734$exports.default;
var $91a2baa98e00615d$exports = {};
function $91a2baa98e00615d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$91a2baa98e00615d$exports = $91a2baa98e00615d$var$_assertThisInitialized, $91a2baa98e00615d$exports.__esModule = true, $91a2baa98e00615d$exports["default"] = $91a2baa98e00615d$exports;


function $ccec104764a273a2$var$_possibleConstructorReturn(self, call) {
    if (call && ($ccec104764a273a2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $91a2baa98e00615d$exports(self);
}
$ccec104764a273a2$exports = $ccec104764a273a2$var$_possibleConstructorReturn, $ccec104764a273a2$exports.__esModule = true, $ccec104764a273a2$exports["default"] = $ccec104764a273a2$exports;


function $ae51736f5c9490d1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6d4421c339091e84$exports();
    return function _createSuperInternal() {
        var Super = $f1c3eaf30612a414$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f1c3eaf30612a414$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ccec104764a273a2$exports(this, result);
    };
}
$ae51736f5c9490d1$exports = $ae51736f5c9490d1$var$_createSuper, $ae51736f5c9490d1$exports.__esModule = true, $ae51736f5c9490d1$exports["default"] = $ae51736f5c9490d1$exports;


var $72a97f5365178f8c$exports = {};
var $0777b83d3f888dfc$exports = {};

function $0777b83d3f888dfc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $005913fd29c2de7e$exports(arr);
}
$0777b83d3f888dfc$exports = $0777b83d3f888dfc$var$_arrayWithoutHoles, $0777b83d3f888dfc$exports.__esModule = true, $0777b83d3f888dfc$exports["default"] = $0777b83d3f888dfc$exports;


var $ab125607932dfeaa$exports = {};
function $ab125607932dfeaa$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$ab125607932dfeaa$exports = $ab125607932dfeaa$var$_iterableToArray, $ab125607932dfeaa$exports.__esModule = true, $ab125607932dfeaa$exports["default"] = $ab125607932dfeaa$exports;



var $ab397e50fd4cfb0d$exports = {};
function $ab397e50fd4cfb0d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$ab397e50fd4cfb0d$exports = $ab397e50fd4cfb0d$var$_nonIterableSpread, $ab397e50fd4cfb0d$exports.__esModule = true, $ab397e50fd4cfb0d$exports["default"] = $ab397e50fd4cfb0d$exports;


function $72a97f5365178f8c$var$_toConsumableArray(arr) {
    return $0777b83d3f888dfc$exports(arr) || $ab125607932dfeaa$exports(arr) || $268756ee686f3cd0$exports(arr) || $ab397e50fd4cfb0d$exports();
}
$72a97f5365178f8c$exports = $72a97f5365178f8c$var$_toConsumableArray, $72a97f5365178f8c$exports.__esModule = true, $72a97f5365178f8c$exports["default"] = $72a97f5365178f8c$exports;




var $09a6a41b3f59c69c$exports = {};
function $09a6a41b3f59c69c$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$09a6a41b3f59c69c$exports = $09a6a41b3f59c69c$var$_taggedTemplateLiteral, $09a6a41b3f59c69c$exports.__esModule = true, $09a6a41b3f59c69c$exports["default"] = $09a6a41b3f59c69c$exports;






var $985d523aae1f8463$var$StateManagedSelect = /*#__PURE__*/ (0, $3KGP8.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $fd5b92869f23fca1$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $3KGP8.createElement((0, $2e2f80ec86953b94$export$25ce5a424b770e84), (0, $1313c398ccc2c3ba$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $985d523aae1f8463$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $3KGP8.useMemo)(function() {
        return (0, $3158d564e4aa3a61$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $3KGP8.createElement((0, $13e2ea967fc44b9d$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};
var $985d523aae1f8463$export$2e2bcd8739ae039 = $985d523aae1f8463$var$StateManagedSelect;



const $6571d50a70561657$export$428c1a3c7db52ba7 = ({ iterations: iterations, currentIteration: currentIteration, match: match, history: history, ...props })=>{
    const context = (0, $3KGP8.useContext)((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const ref = (0, $3KGP8.useRef)(null);
    const getLabel = (0, $3KGP8.useCallback)((iteration)=>{
        let string = iteration;
        const { start: start, due: due } = context.iterations.getDatesForIteration(iteration);
        let startString = start.toFormat(start.year === due.year ? "LLL d" : "LLL d yyyy");
        let dueString = due.toFormat(start.month === due.month ? "d yyyy" : "LLL d yyyy");
        if (iteration === currentIteration) string += " (current)";
        string += ` - ${startString} - ${dueString}`;
        return string;
    }, [
        context.iterations,
        currentIteration
    ]);
    const options = (0, $3KGP8.useMemo)(()=>{
        return iterations.map((iteration)=>({
                value: iteration,
                label: getLabel(iteration)
            })).reverse();
    }, [
        getLabel,
        iterations
    ]);
    const initiallySelectedOption = (0, $3KGP8.useMemo)(()=>{
        let val = match.params.iteration;
        if (match.url === "/current_iteration") val = currentIteration;
        return options.find((option)=>option.value === val) || null;
    }, [
        currentIteration,
        match.params.iteration,
        match.url,
        options
    ]);
    // Placeholder should only show on non-iteration pages, where it should appear
    // as a dimmed-out option representing the current iteration.
    const placeholder = (0, $3KGP8.useMemo)(()=>options.find((option)=>option.value === currentIteration)?.label || "Select Iteration\u2026", [
        currentIteration,
        options
    ]);
    const handleChange = (0, $3KGP8.useCallback)((newValue)=>{
        const value = newValue?.value || "";
        // When the selected option changes, we want to redirect to the new
        // iteration (with push). So check if the selected option is different
        // from the matched iteration, counting "/current_iteration" as
        // "/iteration/:iteration" but redirecting to "/current_iteration".
        // If the selected option is different, redirect to the new iteration.
        // If the selected option is the same, do nothing.
        let path = "";
        switch(value){
            case currentIteration:
                path = match.url === "/current_iteration" ? "" : "/current_iteration";
                break;
            case match.params.iteration:
                break;
            default:
                path = `/iteration/${value}`;
        }
        if (path) history.push(path);
    }, [
        currentIteration,
        history,
        match.params.iteration,
        match.url
    ]);
    const handleMenuOpen = (0, $3KGP8.useCallback)(()=>{
        let { current: current } = ref;
        if (current && !current.state.selectValue.length) {
            current.setState({
                focusedOption: options.find((option)=>option.value === currentIteration) || null,
                focusedValue: null
            });
            requestAnimationFrame(()=>{
                current.focusedOptionRef?.scrollIntoView({
                    block: "nearest"
                });
            });
        }
    }, [
        currentIteration,
        options
    ]);
    const styles = (0, $3KGP8.useMemo)(()=>({
            valueContainer: (baseStyles, state)=>({
                    ...baseStyles,
                    cursor: state.isDisabled ? "default" : "text"
                }),
            placeholder: (baseStyles)=>({
                    ...baseStyles,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginLeft: "2px",
                    marginRight: "2px",
                    boxSizing: "border-box"
                })
        }), []);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $985d523aae1f8463$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        value: initiallySelectedOption,
        placeholder: placeholder,
        isSearchable: true,
        name: "iteration",
        options: options,
        onChange: handleChange,
        onMenuOpen: handleMenuOpen,
        menuPlacement: "auto",
        styles: styles
    });
};







var $3KGP8 = parcelRequire("3KGP8");





const $c545d19a340b3a28$var$COLUMNS = [
    "id",
    "type",
    "summary",
    "assigned_to",
    "priority",
    "cf_fx_iteration",
    "last_change_time"
];
function $c545d19a340b3a28$var$sortBugs(bugs) {
    return bugs.sort((a, b)=>{
        let priorityComparison = a.priority && b.priority && a.priority.localeCompare(b.priority);
        if (priorityComparison) return priorityComparison;
        let iterationComparison = 0;
        if (a.cf_fx_iteration != b.cf_fx_iteration) {
            let aIteration = parseFloat(a.cf_fx_iteration);
            let bIteration = parseFloat(b.cf_fx_iteration);
            if (isNaN(aIteration)) iterationComparison = Number(!isNaN(bIteration));
            else if (isNaN(bIteration)) iterationComparison = -1;
            else iterationComparison = aIteration - bIteration;
        }
        return iterationComparison || Date.parse(b.last_change_time) - Date.parse(a.last_change_time);
    });
}
const $c545d19a340b3a28$export$e21fa868b2d5ade6 = ()=>{
    const { qm: qm } = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useContext((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useMemo(()=>({
            include_fields: [
                "id",
                "summary",
                "assigned_to",
                "priority",
                "status",
                "keywords",
                "type",
                "component",
                "cf_fx_iteration",
                "last_change_time"
            ],
            rules: [
                {
                    key: "component",
                    operator: "anyexact",
                    value: "Messaging System"
                },
                {
                    operator: "OR",
                    rules: [
                        {
                            key: "priority",
                            operator: "equals",
                            value: "P1"
                        },
                        {
                            key: "priority",
                            operator: "equals",
                            value: "P2"
                        }
                    ]
                },
                {
                    rules: [
                        {
                            key: "assigned_to",
                            operator: "equals",
                            value: "nobody@mozilla.org"
                        }
                    ]
                },
                {
                    key: "keywords",
                    operator: "notsubstring",
                    value: "meta"
                }
            ]
        }), []);
    const state = (0, $2c41d67d00e46649$export$4cf511b178cc2057)({
        query: query,
        qm: qm
    });
    const sortedBugs = $c545d19a340b3a28$var$sortBugs(state.bugs);
    const isLoaded = state.status === "loaded";
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
        loaded: isLoaded,
        heading: "Unassigned P1/P2 Bugs",
        subHeading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
            children: [
                "This list includes unassigned P1 and P2 bugs in Messaging System ",
                "(",
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                    href: `https://bugzilla.mozilla.org/buglist.cgi?cmdtype=dorem&remaction=run&namedcmd=Messaging%20System%20Unassigned%20P1%2FP2&sharer_id=125983&list_id=16386089`,
                    children: "query"
                }),
                ")"
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                style: {
                    marginTop: "20px"
                },
                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                    compact: true,
                    subtitle: "Messaging System Unassigned P1/P2",
                    tags: true,
                    bulkEdit: true,
                    showHeaderIfEmpty: false,
                    bugs: sortedBugs,
                    columns: $c545d19a340b3a28$var$COLUMNS,
                    showResolved: false,
                    showResolvedOption: false,
                    visibleIfEmpty: false
                }, 0)
            }),
            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                hidden: !state.awaitingNetwork
            })
        ]
    });
};




var $3KGP8 = parcelRequire("3KGP8");
var $70c3c6a35392e780$export$aba86695643891f5;
var $70c3c6a35392e780$export$34e0f9847d4c02dd;
var $70c3c6a35392e780$export$8837f4fc672e936d;
var $70c3c6a35392e780$export$120ff0929b202a6d;
$70c3c6a35392e780$export$aba86695643891f5 = `fqNiWG_col`;
$70c3c6a35392e780$export$34e0f9847d4c02dd = `fqNiWG_container`;
$70c3c6a35392e780$export$8837f4fc672e936d = `fqNiWG_list`;
$70c3c6a35392e780$export$120ff0929b202a6d = `fqNiWG_row`;




class $adc27e9385696006$export$7d05e0deed78c249 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            bugzilla_email: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("bugzilla_email"),
            offline_debug: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("offline_debug"),
            disable_cache: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
        this.onPrefChange = this.onPrefChange.bind(this);
        for (const pref of [
            "bugzilla_email",
            "offline_debug",
            "disable_cache"
        ])(0, $043b576a557bdebf$export$7c82f09cb4abb8e8).on(pref, this.onPrefChange);
    }
    onInputChange(e) {
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set(e.target.name, e.target.value);
    }
    onCheckBoxChange(e) {
        (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set(e.target.name, e.target.checked);
    }
    onPrefChange({ name: name, newValue: newValue } = {}) {
        const newState = {};
        newState[name] = newValue;
        this.setState(newState);
    }
    // A button for testing iterations
    onIterationsCheck() {
        fetch("/api/iterations").then((rsp)=>rsp.json()).then((data)=>console.log(data));
    }
    componentWillMount() {
        this.setState({
            bugzilla_email: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("bugzilla_email"),
            offline_debug: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("offline_debug"),
            disable_cache: (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("disable_cache")
        });
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            className: $70c3c6a35392e780$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h1", {
                    children: "Settings"
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                    id: "prefs",
                    className: $70c3c6a35392e780$export$8837f4fc672e936d,
                    children: [
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                            className: $70c3c6a35392e780$export$120ff0929b202a6d,
                            children: [
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                                    className: $70c3c6a35392e780$export$aba86695643891f5,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("label", {
                                        htmlFor: "bugzilla_email",
                                        children: "Bugzilla Email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                                    className: $70c3c6a35392e780$export$aba86695643891f5,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                        type: "email",
                                        className: $1d79b97a34537ccf$export$4622d93046d5fd3d,
                                        name: "bugzilla_email",
                                        onChange: this.onInputChange,
                                        value: this.state.bugzilla_email
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
                            className: $70c3c6a35392e780$export$120ff0929b202a6d,
                            children: [
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                                    className: $70c3c6a35392e780$export$aba86695643891f5,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("label", {
                                        htmlFor: "disable_cache",
                                        children: "Disable cache"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                                    className: $70c3c6a35392e780$export$aba86695643891f5,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                        type: "checkbox",
                                        name: "disable_cache",
                                        onChange: this.onCheckBoxChange,
                                        checked: this.state.disable_cache
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                            className: $70c3c6a35392e780$export$120ff0929b202a6d,
                            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                                className: $70c3c6a35392e780$export$aba86695643891f5,
                                children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                                    className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                                    name: "iterations_check",
                                    onClick: this.onIterationsCheck,
                                    children: "Check iterations (logged in console)"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");
var $32063daffad3cc17$export$ebdd55c35e60288c;
var $32063daffad3cc17$export$8cc075c801fd6817;
var $32063daffad3cc17$export$5d3db8b116870b8c;
$32063daffad3cc17$export$ebdd55c35e60288c = `tVDHPW_detailsHeading`;
$32063daffad3cc17$export$8cc075c801fd6817 = `tVDHPW_spacer`;
$32063daffad3cc17$export$5d3db8b116870b8c = `tVDHPW_summaryLabel`;











const $26ee6f2f394927bb$var$displayColumns = [
    "ticket",
    "id",
    "type",
    "summary",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points"
];
const $26ee6f2f394927bb$var$includeFields = [
    "id",
    "type",
    "summary",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points",
    "assigned_to",
    "status",
    "component",
    "blocks",
    "flags",
    "keywords",
    "see_also",
    "whiteboard"
];
// sort bugs with "see also" fields first.
function $26ee6f2f394927bb$var$compareTicket(a, b) {
    if (a === b) return 0;
    if (a === "") return 1;
    if (b === "") return -1;
    return 0;
}
// sort bugs by points, descending.
function $26ee6f2f394927bb$var$comparePoints(a, b) {
    let computedPointsA = parseInt(a, 10);
    let computedPointsB = parseInt(b, 10);
    if (isNaN(computedPointsA)) computedPointsA = 0;
    if (isNaN(computedPointsB)) computedPointsB = 0;
    return computedPointsB - computedPointsA;
}
// sort bugs by priority, P1 to P5, then null.
function $26ee6f2f394927bb$var$comparePriority(a, b) {
    let computedPriorityA = a;
    let computedPriorityB = b;
    if (!a.startsWith("P")) computedPriorityA = "P6";
    if (!b.startsWith("P")) computedPriorityB = "P6";
    return computedPriorityA.localeCompare(computedPriorityB);
}
class $26ee6f2f394927bb$export$e40d2ac396b76af8 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            bugsByEngineer: [],
            showUnsized: false
        };
        this.onCheckShowUnsized = this.onCheckShowUnsized.bind(this);
    }
    async componentWillMount() {
        this._isMounted = true;
        await this.context.qm.runCachedQueries([
            {
                include_fields: $26ee6f2f394927bb$var$includeFields,
                resolution: "---",
                order: "cf_fx_points DESC, priority, changeddate DESC",
                rules: [
                    {
                        key: "assigned_to",
                        operator: "anyexact",
                        value: (0, $9e3325dd32f85aba$export$c957e9dafc0b7f8f).omc.join(",")
                    },
                    {
                        operator: "OR",
                        rules: [
                            {
                                key: "blocked",
                                operator: "anywordssubstr",
                                value: this.context.metas.map((m)=>m.id).join(",")
                            },
                            {
                                key: "component",
                                operator: "anyexact",
                                value: (0, $513e68b890b7ecb5$export$602c648fbe26557c).join(",")
                            }
                        ]
                    },
                    {
                        key: "cf_fx_iteration",
                        operator: "notequals",
                        value: "---"
                    }
                ]
            }
        ], ()=>this._isMounted, ({ rsp: [{ bugs: bugs }], awaitingNetwork: awaitingNetwork })=>{
            let bugsByEngineer = [];
            // put engineers in the alphabetic order they appear in the config, but
            // put the viewer first if they've set their bugzilla email in
            // SettingsView or MyBugs to an OMC engineer email.
            const email = (0, $043b576a557bdebf$export$7c82f09cb4abb8e8).get("bugzilla_email");
            if (email && (0, $9e3325dd32f85aba$export$c957e9dafc0b7f8f).omc.includes(email)) bugsByEngineer.push({
                engineer: email,
                bugs: [],
                user: this.context.teams.omc.find((e)=>[
                        e.name,
                        e.email
                    ].includes(email))
            });
            for (const engineer of (0, $9e3325dd32f85aba$export$c957e9dafc0b7f8f).omc){
                if (engineer === email) continue;
                let item = {
                    engineer: engineer,
                    bugs: [],
                    user: this.context.teams.omc.find((e)=>[
                            e.name,
                            e.email
                        ].includes(engineer))
                };
                bugsByEngineer.push(item);
            }
            for (const bug of bugs){
                let item = bugsByEngineer.find((e)=>e.engineer === bug.assigned_to);
                if (!item) continue;
                // only add the bug if it matches the current or last release.
                const bugRelease = bug.cf_fx_iteration.split(".")[0];
                if (parseInt(bugRelease, 10) > this.props.release || parseInt(bugRelease, 10) < this.props.release - 1) continue;
                // find the ticket from the See Also field, if it exists.
                let ticket = "";
                if (bug.see_also) for (const url of bug.see_also){
                    let match = url.match(/mozilla-hub.atlassian.net\/browse\/((?:OMC|FXE)-\d+)/);
                    if (match) {
                        ticket = match[1];
                        break;
                    }
                }
                bug.ticket = ticket;
                item.bugs.push(bug);
            }
            bugsByEngineer.forEach((item, index)=>{
                // if there are no bugs for this engineer, remove them from the list
                if (!item.bugs.length) {
                    bugsByEngineer.splice(index, 1);
                    return;
                }
                // sort bugs by see also field, then points, then by priority
                item.bugs.sort((a, b)=>$26ee6f2f394927bb$var$compareTicket(a.ticket, b.ticket) || $26ee6f2f394927bb$var$comparePoints(a.cf_fx_points, b.cf_fx_points) || $26ee6f2f394927bb$var$comparePriority(a.priority, b.priority));
            });
            this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                bugsByEngineer: bugsByEngineer
            });
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    onCheckShowUnsized(e) {
        this.setState({
            showUnsized: e.target.checked
        });
    }
    filterUnsized(bugs) {
        if (this.state.showUnsized) return bugs;
        return bugs.filter((bug)=>(0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a).cf_fx_points(bug.cf_fx_points));
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: "Engineering Allocation",
            subHeading: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
                children: "This list includes unresolved, sized bugs OMC engineers are working on for the current release."
            }),
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("div", {
                    className: $32063daffad3cc17$export$ebdd55c35e60288c,
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("details", {
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("summary", {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                        className: $32063daffad3cc17$export$5d3db8b116870b8c,
                                        children: "How to add bugs to this list"
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                        className: $32063daffad3cc17$export$8cc075c801fd6817
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("input", {
                                                type: "checkbox",
                                                onChange: this.onCheckShowUnsized,
                                                checked: this.state.showUnsized
                                            }),
                                            " ",
                                            "Show unsized bugs"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("li", {
                                        children: [
                                            "Add the Jira ticket URL to the bug's ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "See Also"
                                            }),
                                            " ",
                                            "field."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("li", {
                                        children: [
                                            "Add the ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "[omc]"
                                            }),
                                            " tag to the bug's",
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "Whiteboard"
                                            }),
                                            " field. If the ticket has multiple child bugs, skip this step. Adding this tag will cause the bug to be synced with the ticket, which you may not want if the ticket tracks multiple bugs."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("li", {
                                        children: [
                                            "Set the bug's ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "Points"
                                            }),
                                            " field to the approximate number of days required to complete the bug. See the",
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("button", {
                                                className: $7999b6d38c1a5546$export$39f706edf254b3b8,
                                                onClick: ()=>(0, $043b576a557bdebf$export$7c82f09cb4abb8e8).set("priority_guide_open", true),
                                                children: "Legend"
                                            }),
                                            " ",
                                            "for more information."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("li", {
                                        children: [
                                            "Please also add the Bugzilla link to the Jira ticket. Click the arrow button next to ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "Link Issue"
                                            }),
                                            " and select",
                                            " ",
                                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("code", {
                                                children: "Web Link"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                this.state.bugsByEngineer.map(({ engineer: engineer, bugs: bugs, user: user })=>{
                    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                        title: user?.real_name || engineer,
                        subtitle: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: `https://bugzilla.mozilla.org/user_profile?user_id=${user?.id}`,
                            children: engineer
                        }),
                        compact: true,
                        showResolvedOption: false,
                        visibleIfEmpty: false,
                        bulkEdit: false,
                        points: true,
                        tickets: true,
                        tags: false,
                        bugs: this.filterUnsized(bugs),
                        columns: $26ee6f2f394927bb$var$displayColumns
                    }, engineer);
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");





const $ba7dfbc67b1e25d8$var$displayColumns = [
    "id",
    "type",
    "summary",
    "assigned_to",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points"
];
const $ba7dfbc67b1e25d8$var$includeFields = [
    "id",
    "type",
    "summary",
    "cf_fx_iteration",
    "priority",
    "cf_fx_points",
    "assigned_to",
    "status",
    "component",
    "blocks",
    "flags",
    "keywords",
    "see_also",
    "whiteboard"
];
function $ba7dfbc67b1e25d8$var$comparePoints(a, b) {
    let computedPointsA = parseInt(a, 10);
    let computedPointsB = parseInt(b, 10);
    if (isNaN(computedPointsA)) computedPointsA = 0;
    if (isNaN(computedPointsB)) computedPointsB = 0;
    return computedPointsB - computedPointsA;
}
function $ba7dfbc67b1e25d8$var$comparePriority(a, b) {
    let computedPriorityA = a;
    let computedPriorityB = b;
    if (!a.startsWith("P")) computedPriorityA = "P6";
    if (!b.startsWith("P")) computedPriorityB = "P6";
    return computedPriorityA.localeCompare(computedPriorityB);
}
class $ba7dfbc67b1e25d8$export$2818aedda552280 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            awaitingNetwork: false,
            allJiraTickets: {},
            bugsByEngineer: {},
            showUnsized: false
        };
    }
    async componentWillMount() {
        this._isMounted = true;
        await this.context.qm.runCachedQueries([
            {
                include_fields: $ba7dfbc67b1e25d8$var$includeFields,
                resolution: "---",
                order: "cf_fx_points DESC, priority, changeddate DESC",
                rules: [
                    {
                        key: "keywords",
                        operator: "notsubstring",
                        value: "meta"
                    },
                    {
                        operator: "OR",
                        rules: [
                            {
                                key: "blocked",
                                operator: "anywordssubstr",
                                value: this.context.metas.map((m)=>m.id).join(",")
                            },
                            {
                                key: "component",
                                operator: "anyexact",
                                value: (0, $513e68b890b7ecb5$export$602c648fbe26557c).join(",")
                            }
                        ]
                    },
                    {
                        key: "cf_fx_iteration",
                        operator: "notequals",
                        value: "---"
                    },
                    {
                        key: "see_also",
                        operator: "substring",
                        value: "mozilla-hub.atlassian.net/browse/OMC-"
                    }
                ]
            }
        ], ()=>this._isMounted, ({ rsp: [{ bugs: bugs }], awaitingNetwork: awaitingNetwork })=>{
            let allJiraTickets = {};
            for (let bug of bugs){
                // take bugs from the current release
                const bugRelease = bug.cf_fx_iteration.split(".")[0];
                if (parseInt(bugRelease, 10) > this.props.release || parseInt(bugRelease, 10) < this.props.release - 1) continue;
                if (bug.see_also) for (const url of bug.see_also){
                    let ticket = url.match(/mozilla-hub.atlassian.net\/browse\/(OMC-\d+)/);
                    if (ticket) {
                        let jiraTicket = ticket[1];
                        bug.ticket = jiraTicket;
                        allJiraTickets[jiraTicket] = allJiraTickets[jiraTicket] || [];
                        allJiraTickets[jiraTicket].push(bug);
                    }
                }
            }
            for (const ticket of Object.keys(allJiraTickets))// sort bugs by points first, then by priority
            allJiraTickets[ticket].sort((a, b)=>$ba7dfbc67b1e25d8$var$comparePoints(a.cf_fx_points, b.cf_fx_points) || $ba7dfbc67b1e25d8$var$comparePriority(a.priority, b.priority));
            this.setState({
                loaded: true,
                awaitingNetwork: awaitingNetwork,
                allJiraTickets: allJiraTickets
            });
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $0ed3e0ab6aeadd3d$export$42a852a2b6b56249), {
            loaded: this.state.loaded,
            heading: "Jira Tickets",
            subHeading: "This list includes unresolved bugs linked to an OMC Jira ticket.",
            children: [
                Object.entries(this.state.allJiraTickets).map(([jiraTicket, bugs])=>{
                    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ac4eab3948a5d97f$export$d5b411913e724a3), {
                        title: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                            href: `https://mozilla-hub.atlassian.net/browse/${jiraTicket}`,
                            children: jiraTicket
                        }),
                        compact: true,
                        showResolvedOption: false,
                        visibleIfEmpty: false,
                        bulkEdit: true,
                        points: true,
                        tickets: false,
                        tags: false,
                        bugs: bugs,
                        columns: $ba7dfbc67b1e25d8$var$displayColumns
                    }, jiraTicket);
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $33e4d48c124e59db$export$39671f92c3fd7ff9), {
                    hidden: !this.state.awaitingNetwork
                })
            ]
        });
    }
}




var $3KGP8 = parcelRequire("3KGP8");


const $cb1d1fd8b2066fb8$var$containerStyle = {
    maxWidth: 900,
    margin: "0 auto",
    padding: "20px 40px",
    textAlign: "center"
};
class $cb1d1fd8b2066fb8$export$8c68b6013ae44ca6 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("div", {
            style: $cb1d1fd8b2066fb8$var$containerStyle,
            children: [
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("h1", {
                    children: this.props.header
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("p", {
                    children: this.props.subheader
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                    className: $1d79b97a34537ccf$export$41c1085b355ecc97,
                    to: this.props.buttonHref || "",
                    children: this.props.buttonText
                })
            ]
        });
    }
}


const $8c4e36c910131954$var$RouterNav = (0, $9e524724cfec6cf5$export$369b6b2b30582e8e)(({ routes: routes })=>{
    const context = (0, $3KGP8.useContext)((0, $78971ec0275a44e9$export$7feebea0001a7c34));
    const renderListItem = (0, $3KGP8.useCallback)((route, i)=>{
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $853ab30cd4ee4807$export$b0d92dbee9b5b60d), {
                activeClassName: $27babc10f87d9603$exports.active,
                className: $27babc10f87d9603$exports.navLink,
                to: route.routeProps ? route.routeProps.path : route.path,
                children: [
                    route.icon ? /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                        className: `${$27babc10f87d9603$exports.icon} ${$27babc10f87d9603$exports[`icon-${route.icon}`]}`
                    }) : null,
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                        children: route.label
                    })
                ]
            })
        }, i);
    }, []);
    const getListItem = (0, $3KGP8.useCallback)((route, i)=>{
        if (route.spacer) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
            className: $27babc10f87d9603$exports.spacer
        }, i);
        else if (route.header) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
            className: $27babc10f87d9603$exports.header,
            children: route.header
        }, i);
        else if (route.customRender) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
            children: route.customRender()
        }, i);
        return renderListItem(route, i);
    }, [
        renderListItem
    ]);
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("nav", {
        className: $27babc10f87d9603$exports.aside,
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("ul", {
            children: [
                routes.filter((route)=>!route.hidden).map(getListItem),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("a", {
                        className: $27babc10f87d9603$exports.navLink,
                        href: "https://github.com/mozilla/bugzy/issues/new/choose",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                className: `${$27babc10f87d9603$exports.icon} ${$27babc10f87d9603$exports["icon-report"]}`
                            }),
                            "Report an issue"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)("a", {
                        className: $27babc10f87d9603$exports.navLink,
                        onClick: context.refresh,
                        href: "#",
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                className: `${$27babc10f87d9603$exports.icon} ${$27babc10f87d9603$exports["icon-refresh"]}`
                            }),
                            "Refresh server caches"
                        ]
                    })
                })
            ]
        })
    });
});
class $8c4e36c910131954$export$55185c17a0fcbe46 extends (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).PureComponent {
    static contextType = (0, $78971ec0275a44e9$export$7feebea0001a7c34);
    getMetaLinks(component = "Messaging System") {
        return this.context.metas.filter((meta)=>meta.priority === "P1" && !(0, $0b7e4383cbab5ef0$export$fd24cdb006c73fde)(meta) && meta.component === component).sort((a, b)=>{
            if (a.priority < b.priority) return -1;
            if (a.priority > b.priority) return 1;
            return a.displayName.localeCompare(b.displayName);
        }).map((meta)=>({
                path: `/feature/${meta.id}`,
                label: meta.displayName
            }));
    }
    render() {
        const iterations = this.context.iterations.orderedVersionStrings;
        const currentIteration = this.context.iterations.getIteration();
        const release = currentIteration.number.split(".")[0];
        const prevRelease = release - 1;
        const metaLinks = this.getMetaLinks();
        const ROUTER_CONFIG = [
            {
                navOnly: true,
                customRender: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $853ab30cd4ee4807$export$b0d92dbee9b5b60d), {
                        activeClassName: null,
                        className: `${$27babc10f87d9603$exports.navLink} ${$27babc10f87d9603$exports.logo}`,
                        to: "/",
                        children: [
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                className: `${$27babc10f87d9603$exports.icon} ${$27babc10f87d9603$exports["icon-logo"]}`
                            }),
                            /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("span", {
                                children: "bugzy"
                            })
                        ]
                    })
            },
            {
                label: "Current Iteration",
                exact: false,
                icon: "calendar",
                routeProps: {
                    path: "/current_iteration",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $3df9deaf5e6870b1$export$6fc755757341c0b2), {
                            ...props,
                            iteration: currentIteration.number,
                            currentIteration: currentIteration
                        })
                }
            },
            {
                label: "Unassigned P1/P2",
                exact: false,
                icon: "hourglass",
                routeProps: {
                    path: "/unassigned",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $c545d19a340b3a28$export$e21fa868b2d5ade6), {})
                }
            },
            {
                label: `Uplifts`,
                icon: "up-arrow",
                routeProps: {
                    path: "/uplift",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $8dd9d99f7bbdb9e4$export$b56cde744afe1c2f), {
                            release: release,
                            prevRelease: prevRelease
                        })
                }
            },
            {
                label: "Iteration",
                exact: false,
                routeProps: {
                    path: "/iteration/:iteration",
                    render: (props)=>{
                        const { iteration: iteration } = props.match.params;
                        if (!iterations.includes(iteration)) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $cb1d1fd8b2066fb8$export$8c68b6013ae44ca6), {
                            header: "Invalid Route",
                            subheader: "The page you were looking for was not found.",
                            buttonText: "Current Iteration",
                            buttonHref: "/current_iteration"
                        });
                        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $3df9deaf5e6870b1$export$6fc755757341c0b2), {
                            ...props,
                            iteration: iteration,
                            currentIteration: currentIteration
                        });
                    }
                },
                hidden: true
            },
            {
                label: "Triage",
                exact: false,
                icon: "inbox",
                routeProps: {
                    path: "/triage",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $d6a74a25ebf7ed06$export$6658bd3e05b5e915), {
                            ...props
                        })
                }
            },
            {
                label: "Jira Tickets",
                icon: "jira",
                exact: false,
                routeProps: {
                    path: "/jira",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $ba7dfbc67b1e25d8$export$2818aedda552280), {
                            ...props,
                            release: release
                        })
                }
            },
            {
                label: "Engineering Allocation",
                icon: "capacity",
                exact: false,
                routeProps: {
                    path: "/allocation",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $26ee6f2f394927bb$export$e40d2ac396b76af8), {
                            ...props,
                            release: release
                        })
                }
            },
            {
                label: "Release Report",
                exact: false,
                icon: "graph",
                routeProps: {
                    path: "/release/:iteration",
                    render: (props)=>{
                        const { iteration: iteration } = props.match.params;
                        if (!iterations.includes(iteration)) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $cb1d1fd8b2066fb8$export$8c68b6013ae44ca6), {
                            header: "Invalid Route",
                            subheader: "The page you were looking for was not found.",
                            buttonText: "Current Iteration",
                            buttonHref: "/current_iteration"
                        });
                        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $503c4e56fb78e050$export$5c9f1a428cbf3be9), {
                            ...props,
                            iteration: iteration
                        });
                    }
                },
                hidden: true
            },
            {
                spacer: true
            },
            {
                header: "Select Iteration"
            },
            {
                icon: "calendar2",
                navOnly: true,
                customRender: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
                        path: [
                            "/current_iteration",
                            "/iteration/:iteration",
                            "*"
                        ],
                        render: ({ match: match, history: history })=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $6571d50a70561657$export$428c1a3c7db52ba7), {
                                match: match,
                                history: history,
                                "aria-label": "Select Iteration",
                                iterations: iterations,
                                currentIteration: currentIteration.number
                            })
                    })
            },
            {
                spacer: true
            },
            {
                label: "My Bugs",
                icon: "user",
                routeProps: {
                    path: "/my_bugs",
                    component: (0, $7090c432f17fd21a$export$2ea4ef6422f3fce1)
                }
            },
            {
                label: "General Triage",
                icon: "stethoscope",
                exact: false,
                routeProps: {
                    path: "/general_triage",
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $991c4555a0213f8e$export$fb975117edc21014), {
                            ...props
                        })
                }
            },
            {
                label: "Regression",
                icon: "warning",
                routeProps: {
                    path: "/regression",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $35982a04b075b92b$export$71a7b6ab8397c50f), {
                            title: "Regression",
                            query: {
                                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                                keywords: [
                                    "regression"
                                ],
                                resolution: "---",
                                order: "cf_fx_iteration DESC"
                            }
                        })
                }
            },
            {
                label: "All Features",
                icon: "balloons",
                routeProps: {
                    path: "/feature_list",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $4d45092a02c25e1e$export$aa18130def4b6cb4), {})
                }
            },
            {
                label: "RS Messages",
                icon: "graph",
                routeProps: {
                    path: "/rs-messages",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $d030695149e053dc$export$2dc5b16b6affd770), {})
                }
            },
            {
                label: "Feature",
                exact: false,
                routeProps: {
                    path: "/feature/:id/:component?/:displayName?",
                    render: (props)=>{
                        const { url: url, params: params } = props.match;
                        const { id: id, displayName: displayName, component: component } = params;
                        const metaId = Number(id);
                        const meta = this.context.metas.find((m)=>m.id === metaId);
                        if (!meta && !(displayName && component)) return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $cb1d1fd8b2066fb8$export$8c68b6013ae44ca6), {
                            header: "Invalid Route",
                            subheader: "The page you were looking for was not found.",
                            buttonText: "Current Iteration",
                            buttonHref: "/current_iteration"
                        });
                        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $1536f61a4f9de922$export$dd5fc6b424a32445), {
                            ...props,
                            url: url,
                            id: id,
                            displayName: displayName ? decodeURIComponent(displayName) : meta.displayName,
                            component: component || meta.component
                        });
                    }
                },
                hidden: true
            },
            {
                label: "No Feature",
                hidden: true,
                routeProps: {
                    path: "/no-feature",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $35982a04b075b92b$export$71a7b6ab8397c50f), {
                            title: "No Feature",
                            query: {
                                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                                resolution: "---",
                                custom: {
                                    blocked: {
                                        nowordssubstr: this.context.metas.map((m)=>m.id)
                                    },
                                    cf_fx_iteration: {
                                        notequals: "---"
                                    },
                                    keywords: {
                                        nowordssubstr: "meta"
                                    }
                                }
                            },
                            sort: (a, b)=>{
                                const iteration1 = (0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a).cf_fx_iteration(a.cf_fx_iteration);
                                const iteration2 = (0, $0fdb1d7dc66d0718$export$ad1734e9af69f92a).cf_fx_iteration(b.cf_fx_iteration);
                                if (iteration1 < iteration2) return -1;
                                if (iteration1 > iteration2) return 1;
                                if (a.priority < b.priority) return -1;
                                if (a.priority > b.priority) return 1;
                                return 0;
                            }
                        })
                }
            },
            {
                spacer: true
            },
            {
                header: `In-product Messaging \u{2013} Firefox ${release}`
            },
            ...metaLinks,
            {
                label: "Other bugs\u2026",
                routeProps: {
                    path: "/other",
                    exact: true,
                    render: (props)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $3dd8fa1ec54c5e13$export$65ff8390fe1d61cb), {
                            ...props,
                            components: [
                                "Messaging System"
                            ]
                        })
                }
            },
            {
                navOnly: true,
                customRender: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("a", {
                        className: $27babc10f87d9603$exports.navLink,
                        href: "https://bugzilla.mozilla.org/enter_bug.cgi?blocked=bugzy-epic&component=Messaging%20System&product=Firefox&keywords=meta&priority=P1&bug_type=task",
                        title: "Click to add a category, or file a bug in the Firefox::Messaging System component, add the keyword 'meta', add bugzy-epic to the Blockers field, and set the priority to P1.",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Add Category\u2026"
                    })
            },
            {
                label: "Metas",
                routeProps: {
                    path: "/metas",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $35982a04b075b92b$export$71a7b6ab8397c50f), {
                            title: "Metas",
                            query: {
                                component: (0, $513e68b890b7ecb5$export$602c648fbe26557c),
                                resolution: "---",
                                order: "changeddate DESC",
                                custom: {
                                    keywords: {
                                        substring: "meta"
                                    }
                                }
                            },
                            columns: [
                                "id",
                                "summary",
                                "priority",
                                "last_change_time"
                            ],
                            map: (bug)=>{
                                let displayName = (0, $418e2a80c8ccbbe6$export$775faba1c97e7d6d)(bug.summary);
                                if (displayName.match(/(^\[?QA)|(QA bug tracking)/)) return null;
                                let path = `/feature/${bug.id}`;
                                const meta = this.context.metas.find((m)=>m.id === bug.id);
                                if (!meta) path += `/${bug.component}/${encodeURIComponent(displayName)}`;
                                return {
                                    ...bug,
                                    keywords: bug.keywords.filter((k)=>k !== "meta"),
                                    summary: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$a6c7ac8248d6e38a), {
                                        to: path,
                                        children: displayName
                                    })
                                };
                            },
                            filter: (bug)=>bug,
                            sort: (a, b)=>{
                                if (a.priority === "--") return 1;
                                if (b.priority === "--") return -1;
                                if (a.priority < b.priority) return -1;
                                if (a.priority > b.priority) return 1;
                                return 0;
                            }
                        })
                }
            },
            {
                spacer: true
            },
            {
                label: "Settings",
                icon: "settings-circle",
                routeProps: {
                    path: "/settings",
                    component: (0, $adc27e9385696006$export$7d05e0deed78c249)
                },
                hidden: true
            },
            {
                label: "About Bugzy",
                icon: "info",
                routeProps: {
                    path: "/about",
                    component: (0, $4029e431cd9d99ab$export$1eb1323c9a3751ef)
                }
            },
            {
                hidden: true,
                routeProps: {
                    path: "*",
                    render: ()=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $cb1d1fd8b2066fb8$export$8c68b6013ae44ca6), {
                            header: "Invalid Route",
                            subheader: "The page you were looking for was not found.",
                            buttonText: "Current Iteration",
                            buttonHref: "/current_iteration"
                        })
                }
            }
        ];
        return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $853ab30cd4ee4807$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($8c4e36c910131954$var$RouterNav, {
                        routes: ROUTER_CONFIG
                    }),
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)("main", {
                        className: $27babc10f87d9603$exports.main,
                        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsxs)((0, $9e524724cfec6cf5$export$b5d5cf8927ab7262), {
                            children: [
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/",
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$2d8d895a0a0f636e), {
                                        to: "/current_iteration"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: `/iteration/${currentIteration.number}`,
                                    children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$2d8d895a0a0f636e), {
                                        to: "/current_iteration"
                                    })
                                }),
                                ROUTER_CONFIG.filter((route)=>route.routeProps && !route.navOnly).map((route, index)=>/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $9e524724cfec6cf5$export$e7b0ac011bb776c6), {
                                        exact: route.exact !== false,
                                        ...route.routeProps
                                    }, index))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $23eee7c45ba06d25$export$2b0b14514992aeb6), {})
                ]
            })
        });
    }
}


function $d3de8169d616cde4$var$makeQueryManager(iterations) {
    const [release] = iterations.getIteration().number.split(".");
    const prevRelease = parseInt(release) - 1;
    function postProcessFn(resp) {
        const bugs = resp.bugs && resp.bugs.map((bug)=>{
            if (`cf_status_firefox${release}` in bug) bug.cf_status_nightly = bug[`cf_status_firefox${release}`];
            if (`cf_status_firefox${prevRelease}` in bug) bug.cf_status_beta = bug[`cf_status_firefox${prevRelease}`];
            if (`cf_tracking_firefox${prevRelease}` in bug) bug.cf_tracking_beta = bug[`cf_tracking_firefox${prevRelease}`];
            return bug;
        });
        return Object.assign({}, resp, bugs);
    }
    return new (0, $0b7e4383cbab5ef0$export$b986383a50b53ea4)({
        postProcessFn: postProcessFn
    });
}
async function $d3de8169d616cde4$var$getContextProps() {
    const [metas, iterationsLookup, releases, teams] = await Promise.all([
        fetch("/api/metas").then((res)=>res.json()),
        fetch("/api/iterations").then((res)=>res.json()),
        fetch("/api/releases").then((res)=>res.json()),
        fetch("/api/teams").then((res)=>res.json())
    ]);
    const iterations = new (0, $a2dbb61dc7ec7558$export$8fbbba99755ddad)(iterationsLookup);
    const qm = $d3de8169d616cde4$var$makeQueryManager(iterations);
    return {
        metas: metas,
        iterations: iterations,
        qm: qm,
        releases: releases,
        teams: teams
    };
}
const $d3de8169d616cde4$var$App = (props)=>{
    const [metas, setMetas] = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useState(props.metas);
    const [iterations, setIterations] = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useState(props.iterations);
    const [qm, setQm] = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useState(props.qm);
    const [releases, setReleases] = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useState(props.releases);
    const [teams, setTeams] = (0, (/*@__PURE__*/$parcel$interopDefault($3KGP8))).useState(props.teams);
    const refresh = async ()=>{
        await fetch("/flush_server_caches");
        const newProps = await $d3de8169d616cde4$var$getContextProps();
        setMetas(newProps.metas);
        setIterations(newProps.iterations);
        setQm(newProps.qm);
        setReleases(newProps.releases);
        setTeams(newProps.teams);
    };
    return /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $78971ec0275a44e9$export$e514c39bb46f1923), {
        metas: metas,
        iterations: iterations,
        qm: qm,
        releases: releases,
        teams: teams,
        refresh: refresh,
        children: /*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)((0, $8c4e36c910131954$export$55185c17a0fcbe46), {})
    });
};
async function $d3de8169d616cde4$var$main() {
    const { metas: metas, iterations: iterations, qm: qm, releases: releases, teams: teams } = await $d3de8169d616cde4$var$getContextProps();
    const container = document.getElementById("root");
    const root = (0, $0e2dbbef9627a512$export$882461b6382ed46c)(container);
    root.render(/*#__PURE__*/ (0, $4c1de7c0601f7260$exports.jsx)($d3de8169d616cde4$var$App, {
        metas: metas,
        iterations: iterations,
        qm: qm,
        releases: releases,
        teams: teams
    }));
}
$d3de8169d616cde4$var$main();


//# sourceMappingURL=content.074947ad.js.map
